console.log('Rio JS v4.151.0');
!function() {
    var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {};
    function t(e) {
        return e && e.__esModule ? e.default : e
    }
    function n(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }
    function r(e, t, n) {
        Object.defineProperty(e, t, {
            get: n,
            enumerable: !0
        })
    }
    var i, o, a, s, l, c, u, d, p, f = {}, h = {}, m = !1;
    function v(e, t) {
        for (var n in t)
            e[n] = t[n];
        return e
    }
    function g(e) {
        var t = e.parentNode;
        t && t.removeChild(e)
    }
    function b(e, t, n) {
        var r, i, o, a = arguments, s = {};
        for (o in t)
            "key" == o ? r = t[o] : "ref" == o ? i = t[o] : s[o] = t[o];
        if (arguments.length > 3)
            for (n = [n],
            o = 3; o < arguments.length; o++)
                n.push(a[o]);
        if (null != n && (s.children = n),
        "function" == typeof e && null != e.defaultProps)
            for (o in e.defaultProps)
                void 0 === s[o] && (s[o] = e.defaultProps[o]);
        return y(e, s, r, i, null)
    }
    function y(e, t, n, r, i) {
        var a = {
            type: e,
            props: t,
            key: n,
            ref: r,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == i ? ++o.__v : i
        };
        return null != o.vnode && o.vnode(a),
        a
    }
    function w() {
        return {
            current: null
        }
    }
    function x(e) {
        return e.children
    }
    function _(e, t) {
        this.props = e,
        this.context = t
    }
    function C(e, t) {
        if (null == t)
            return e.__ ? C(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var n; t < e.__k.length; t++)
            if (null != (n = e.__k[t]) && null != n.__e)
                return n.__e;
        return "function" == typeof e.type ? C(e) : null
    }
    function S(e) {
        var t, n;
        if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null,
            t = 0; t < e.__k.length; t++)
                if (null != (n = e.__k[t]) && null != n.__e) {
                    e.__e = e.__c.base = n.__e;
                    break
                }
            return S(e)
        }
    }
    function E(e) {
        (!e.__d && (e.__d = !0) && a.push(e) && !k.__r++ || l !== o.debounceRendering) && ((l = o.debounceRendering) || s)(k)
    }
    function k() {
        for (var e; k.__r = a.length; )
            e = a.sort((function(e, t) {
                return e.__v.__b - t.__v.__b
            }
            )),
            a = [],
            e.some((function(e) {
                var t, n, r, i, o, a;
                e.__d && (o = (i = (t = e).__v).__e,
                (a = t.__P) && (n = [],
                (r = v({}, i)).__v = i.__v + 1,
                L(a, i, r, t.__n, void 0 !== a.ownerSVGElement, null != i.__h ? [o] : null, n, null == o ? C(i) : o, i.__h),
                D(n, i),
                i.__e != o && S(i)))
            }
            ))
    }
    function O(e, t, n, r, i, o, a, s, l, c) {
        var p, f, h, m, v, g, b, w = r && r.__k || d, _ = w.length;
        for (n.__k = [],
        p = 0; p < t.length; p++)
            if (null != (m = n.__k[p] = null == (m = t[p]) || "boolean" == typeof m ? null : "string" == typeof m || "number" == typeof m ? y(null, m, null, null, m) : Array.isArray(m) ? y(x, {
                children: m
            }, null, null, null) : m.__b > 0 ? y(m.type, m.props, m.key, null, m.__v) : m)) {
                if (m.__ = n,
                m.__b = n.__b + 1,
                null === (h = w[p]) || h && m.key == h.key && m.type === h.type)
                    w[p] = void 0;
                else
                    for (f = 0; f < _; f++) {
                        if ((h = w[f]) && m.key == h.key && m.type === h.type) {
                            w[f] = void 0;
                            break
                        }
                        h = null
                    }
                L(e, m, h = h || u, i, o, a, s, l, c),
                v = m.__e,
                (f = m.ref) && h.ref != f && (b || (b = []),
                h.ref && b.push(h.ref, null, m),
                b.push(f, m.__c || v, m)),
                null != v ? (null == g && (g = v),
                "function" == typeof m.type && null != m.__k && m.__k === h.__k ? m.__d = l = T(m, l, e) : l = R(e, m, h, w, v, l),
                c || "option" !== n.type ? "function" == typeof n.type && (n.__d = l) : e.value = "") : l && h.__e == l && l.parentNode != e && (l = C(h))
            }
        for (n.__e = g,
        p = _; p--; )
            null != w[p] && ("function" == typeof n.type && null != w[p].__e && w[p].__e == n.__d && (n.__d = C(r, p + 1)),
            W(w[p], w[p]));
        if (b)
            for (p = 0; p < b.length; p++)
                N(b[p], b[++p], b[++p])
    }
    function T(e, t, n) {
        var r, i;
        for (r = 0; r < e.__k.length; r++)
            (i = e.__k[r]) && (i.__ = e,
            t = "function" == typeof i.type ? T(i, t, n) : R(n, i, i, e.__k, i.__e, t));
        return t
    }
    function M(e, t) {
        return t = t || [],
        null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some((function(e) {
            M(e, t)
        }
        )) : t.push(e)),
        t
    }
    function R(e, t, n, r, i, o) {
        var a, s, l;
        if (void 0 !== t.__d)
            a = t.__d,
            t.__d = void 0;
        else if (null == n || i != o || null == i.parentNode)
            e: if (null == o || o.parentNode !== e)
                e.appendChild(i),
                a = null;
            else {
                for (s = o,
                l = 0; (s = s.nextSibling) && l < r.length; l += 2)
                    if (s == i)
                        break e;
                e.insertBefore(i, o),
                a = o
            }
        return void 0 !== a ? a : i.nextSibling
    }
    function P(e, t, n) {
        "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || p.test(t) ? n : n + "px"
    }
    function I(e, t, n, r, i) {
        var o;
        e: if ("style" === t)
            if ("string" == typeof n)
                e.style.cssText = n;
            else {
                if ("string" == typeof r && (e.style.cssText = r = ""),
                r)
                    for (t in r)
                        n && t in n || P(e.style, t, "");
                if (n)
                    for (t in n)
                        r && n[t] === r[t] || P(e.style, t, n[t])
            }
        else if ("o" === t[0] && "n" === t[1])
            o = t !== (t = t.replace(/Capture$/, "")),
            t = t.toLowerCase()in e ? t.toLowerCase().slice(2) : t.slice(2),
            e.l || (e.l = {}),
            e.l[t + o] = n,
            n ? r || e.addEventListener(t, o ? A : z, o) : e.removeEventListener(t, o ? A : z, o);
        else if ("dangerouslySetInnerHTML" !== t) {
            if (i)
                t = t.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
            else if ("href" !== t && "list" !== t && "form" !== t && "download" !== t && t in e)
                try {
                    e[t] = null == n ? "" : n;
                    break e
                } catch (e) {}
            "function" == typeof n || (null != n && (!1 !== n || "a" === t[0] && "r" === t[1]) ? e.setAttribute(t, n) : e.removeAttribute(t))
        }
    }
    function z(e) {
        this.l[e.type + !1](o.event ? o.event(e) : e)
    }
    function A(e) {
        this.l[e.type + !0](o.event ? o.event(e) : e)
    }
    function L(e, t, n, r, i, a, s, l, c) {
        var p, f, h, m, b, y, w, C, S, E, k, T = t.type;
        if (void 0 !== t.constructor)
            return null;
        null != n.__h && (c = n.__h,
        l = t.__e = n.__e,
        t.__h = null,
        a = [l]),
        (p = o.__b) && p(t);
        try {
            e: if ("function" == typeof T) {
                if (C = t.props,
                S = (p = T.contextType) && r[p.__c],
                E = p ? S ? S.props.value : p.__ : r,
                n.__c ? w = (f = t.__c = n.__c).__ = f.__E : ("prototype"in T && T.prototype.render ? t.__c = f = new T(C,E) : (t.__c = f = new _(C,E),
                f.constructor = T,
                f.render = F),
                S && S.sub(f),
                f.props = C,
                f.state || (f.state = {}),
                f.context = E,
                f.__n = r,
                h = f.__d = !0,
                f.__h = []),
                null == f.__s && (f.__s = f.state),
                null != T.getDerivedStateFromProps && (f.__s == f.state && (f.__s = v({}, f.__s)),
                v(f.__s, T.getDerivedStateFromProps(C, f.__s))),
                m = f.props,
                b = f.state,
                h)
                    null == T.getDerivedStateFromProps && null != f.componentWillMount && f.componentWillMount(),
                    null != f.componentDidMount && f.__h.push(f.componentDidMount);
                else {
                    if (null == T.getDerivedStateFromProps && C !== m && null != f.componentWillReceiveProps && f.componentWillReceiveProps(C, E),
                    !f.__e && null != f.shouldComponentUpdate && !1 === f.shouldComponentUpdate(C, f.__s, E) || t.__v === n.__v) {
                        f.props = C,
                        f.state = f.__s,
                        t.__v !== n.__v && (f.__d = !1),
                        f.__v = t,
                        t.__e = n.__e,
                        t.__k = n.__k,
                        f.__h.length && s.push(f);
                        break e
                    }
                    null != f.componentWillUpdate && f.componentWillUpdate(C, f.__s, E),
                    null != f.componentDidUpdate && f.__h.push((function() {
                        f.componentDidUpdate(m, b, y)
                    }
                    ))
                }
                f.context = E,
                f.props = C,
                f.state = f.__s,
                (p = o.__r) && p(t),
                f.__d = !1,
                f.__v = t,
                f.__P = e,
                p = f.render(f.props, f.state, f.context),
                f.state = f.__s,
                null != f.getChildContext && (r = v(v({}, r), f.getChildContext())),
                h || null == f.getSnapshotBeforeUpdate || (y = f.getSnapshotBeforeUpdate(m, b)),
                k = null != p && p.type === x && null == p.key ? p.props.children : p,
                O(e, Array.isArray(k) ? k : [k], t, n, r, i, a, s, l, c),
                f.base = t.__e,
                t.__h = null,
                f.__h.length && s.push(f),
                w && (f.__E = f.__ = null),
                f.__e = !1
            } else
                null == a && t.__v === n.__v ? (t.__k = n.__k,
                t.__e = n.__e) : t.__e = function(e, t, n, r, i, o, a, s) {
                    var l, c, p, f, h = n.props, m = t.props, v = t.type, b = 0;
                    if ("svg" === v && (i = !0),
                    null != o)
                        for (; b < o.length; b++)
                            if ((l = o[b]) && (l === e || (v ? l.localName == v : 3 == l.nodeType))) {
                                e = l,
                                o[b] = null;
                                break
                            }
                    if (null == e) {
                        if (null === v)
                            return document.createTextNode(m);
                        e = i ? document.createElementNS("http://www.w3.org/2000/svg", v) : document.createElement(v, m.is && m),
                        o = null,
                        s = !1
                    }
                    if (null === v)
                        h === m || s && e.data === m || (e.data = m);
                    else {
                        if (o = o && d.slice.call(e.childNodes),
                        c = (h = n.props || u).dangerouslySetInnerHTML,
                        p = m.dangerouslySetInnerHTML,
                        !s) {
                            if (null != o)
                                for (h = {},
                                f = 0; f < e.attributes.length; f++)
                                    h[e.attributes[f].name] = e.attributes[f].value;
                            (p || c) && (p && (c && p.__html == c.__html || p.__html === e.innerHTML) || (e.innerHTML = p && p.__html || ""))
                        }
                        if (function(e, t, n, r, i) {
                            var o;
                            for (o in n)
                                "children" === o || "key" === o || o in t || I(e, o, null, n[o], r);
                            for (o in t)
                                i && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || n[o] === t[o] || I(e, o, t[o], n[o], r)
                        }(e, m, h, i, s),
                        p)
                            t.__k = [];
                        else if (b = t.props.children,
                        O(e, Array.isArray(b) ? b : [b], t, n, r, i && "foreignObject" !== v, o, a, e.firstChild, s),
                        null != o)
                            for (b = o.length; b--; )
                                null != o[b] && g(o[b]);
                        s || ("value"in m && void 0 !== (b = m.value) && (b !== e.value || "progress" === v && !b) && I(e, "value", b, h.value, !1),
                        "checked"in m && void 0 !== (b = m.checked) && b !== e.checked && I(e, "checked", b, h.checked, !1))
                    }
                    return e
                }(n.__e, t, n, r, i, a, s, c);
            (p = o.diffed) && p(t)
        } catch (e) {
            t.__v = null,
            (c || null != a) && (t.__e = l,
            t.__h = !!c,
            a[a.indexOf(l)] = null),
            o.__e(e, t, n)
        }
    }
    function D(e, t) {
        o.__c && o.__c(t, e),
        e.some((function(t) {
            try {
                e = t.__h,
                t.__h = [],
                e.some((function(e) {
                    e.call(t)
                }
                ))
            } catch (e) {
                o.__e(e, t.__v)
            }
        }
        ))
    }
    function N(e, t, n) {
        try {
            "function" == typeof e ? e(t) : e.current = t
        } catch (e) {
            o.__e(e, n)
        }
    }
    function W(e, t, n) {
        var r, i, a;
        if (o.unmount && o.unmount(e),
        (r = e.ref) && (r.current && r.current !== e.__e || N(r, null, t)),
        n || "function" == typeof e.type || (n = null != (i = e.__e)),
        e.__e = e.__d = void 0,
        null != (r = e.__c)) {
            if (r.componentWillUnmount)
                try {
                    r.componentWillUnmount()
                } catch (e) {
                    o.__e(e, t)
                }
            r.base = r.__P = null
        }
        if (r = e.__k)
            for (a = 0; a < r.length; a++)
                r[a] && W(r[a], t, n);
        null != i && g(i)
    }
    function F(e, t, n) {
        return this.constructor(e, n)
    }
    function $(e, t, n) {
        var r, i, a;
        o.__ && o.__(e, t),
        i = (r = "function" == typeof n) ? null : n && n.__k || t.__k,
        a = [],
        L(t, e = (!r && n || t).__k = b(x, null, [e]), i || u, u, void 0 !== t.ownerSVGElement, !r && n ? [n] : i ? null : t.firstChild ? d.slice.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r),
        D(a, e)
    }
    function B(e, t) {
        $(e, t, B)
    }
    function j(e, t, n) {
        var r, i, o, a = arguments, s = v({}, e.props);
        for (o in t)
            "key" == o ? r = t[o] : "ref" == o ? i = t[o] : s[o] = t[o];
        if (arguments.length > 3)
            for (n = [n],
            o = 3; o < arguments.length; o++)
                n.push(a[o]);
        return null != n && (s.children = n),
        y(e.type, s, r || e.key, i || e.ref, null)
    }
    function H(e, t) {
        var n = {
            __c: t = "__cC" + c++,
            __: e,
            Consumer: function(e, t) {
                return e.children(t)
            },
            Provider: function(e) {
                var n, r;
                return this.getChildContext || (n = [],
                (r = {})[t] = this,
                this.getChildContext = function() {
                    return r
                }
                ,
                this.shouldComponentUpdate = function(e) {
                    this.props.value !== e.value && n.some(E)
                }
                ,
                this.sub = function(e) {
                    n.push(e);
                    var t = e.componentWillUnmount;
                    e.componentWillUnmount = function() {
                        n.splice(n.indexOf(e), 1),
                        t && t.call(e)
                    }
                }
                ),
                e.children
            }
        };
        return n.Provider.__ = n.Consumer.contextType = n
    }
    function V() {
        return m || (m = !0,
        i = {},
        u = {},
        d = [],
        p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
        o = {
            __e: function(e, t) {
                for (var n, r, i; t = t.__; )
                    if ((n = t.__c) && !n.__)
                        try {
                            if ((r = n.constructor) && null != r.getDerivedStateFromError && (n.setState(r.getDerivedStateFromError(e)),
                            i = n.__d),
                            null != n.componentDidCatch && (n.componentDidCatch(e),
                            i = n.__d),
                            i)
                                return n.__E = n
                        } catch (t) {
                            e = t
                        }
                throw e
            },
            __v: 0
        },
        function(e) {
            return null != e && void 0 === e.constructor
        }
        ,
        _.prototype.setState = function(e, t) {
            var n;
            n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v({}, this.state),
            "function" == typeof e && (e = e(v({}, n), this.props)),
            e && v(n, e),
            null != e && this.__v && (t && this.__h.push(t),
            E(this))
        }
        ,
        _.prototype.forceUpdate = function(e) {
            this.__v && (this.__e = !0,
            e && this.__h.push(e),
            E(this))
        }
        ,
        _.prototype.render = x,
        a = [],
        s = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout,
        k.__r = 0,
        c = 0,
        r(i, "options", (function() {
            return o
        }
        )),
        r(i, "toChildArray", (function() {
            return M
        }
        )),
        r(i, "createContext", (function() {
            return H
        }
        )),
        r(i, "cloneElement", (function() {
            return j
        }
        )),
        r(i, "Component", (function() {
            return _
        }
        )),
        r(i, "createRef", (function() {
            return w
        }
        )),
        r(i, "Fragment", (function() {
            return x
        }
        )),
        r(i, "createElement", (function() {
            return b
        }
        )),
        r(i, "hydrate", (function() {
            return B
        }
        )),
        r(i, "render", (function() {
            return $
        }
        ))),
        i
    }
    V();
    var q, U, G, Z = 0, K = [], Y = V().options.__b, X = V().options.__r, J = V().options.diffed, Q = V().options.__c, ee = V().options.unmount;
    function te(e, t) {
        V().options.__h && V().options.__h(U, e, Z || t),
        Z = 0;
        var n = U.__H || (U.__H = {
            __: [],
            __h: []
        });
        return e >= n.__.length && n.__.push({}),
        n.__[e]
    }
    function ne(e) {
        return Z = 1,
        re(we, e)
    }
    function re(e, t, n) {
        var r = te(q++, 2);
        return r.t = e,
        r.__c || (r.__ = [n ? n(t) : we(void 0, t), function(e) {
            var t = r.t(r.__[0], e);
            r.__[0] !== t && (r.__ = [t, r.__[1]],
            r.__c.setState({}))
        }
        ],
        r.__c = U),
        r.__
    }
    function ie(e, t) {
        var n = te(q++, 3);
        !V().options.__s && ye(n.__H, t) && (n.__ = e,
        n.__H = t,
        U.__H.__h.push(n))
    }
    function oe(e, t) {
        var n = te(q++, 4);
        !V().options.__s && ye(n.__H, t) && (n.__ = e,
        n.__H = t,
        U.__h.push(n))
    }
    function ae(e) {
        return Z = 5,
        le((function() {
            return {
                current: e
            }
        }
        ), [])
    }
    function se(e, t, n) {
        Z = 6,
        oe((function() {
            "function" == typeof e ? e(t()) : e && (e.current = t())
        }
        ), null == n ? n : n.concat(e))
    }
    function le(e, t) {
        var n = te(q++, 7);
        return ye(n.__H, t) && (n.__ = e(),
        n.__H = t,
        n.__h = e),
        n.__
    }
    function ce(e, t) {
        return Z = 8,
        le((function() {
            return e
        }
        ), t)
    }
    function ue(e) {
        var t = U.context[e.__c]
          , n = te(q++, 9);
        return n.__c = e,
        t ? (null == n.__ && (n.__ = !0,
        t.sub(U)),
        t.props.value) : e.__
    }
    function de(e, t) {
        V().options.useDebugValue && V().options.useDebugValue(t ? t(e) : e)
    }
    function pe(e) {
        var t = te(q++, 10)
          , n = ne();
        return t.__ = e,
        U.componentDidCatch || (U.componentDidCatch = function(e) {
            t.__ && t.__(e),
            n[1](e)
        }
        ),
        [n[0], function() {
            n[1](void 0)
        }
        ]
    }
    function fe() {
        K.forEach((function(e) {
            if (e.__P)
                try {
                    e.__H.__h.forEach(ge),
                    e.__H.__h.forEach(be),
                    e.__H.__h = []
                } catch (t) {
                    e.__H.__h = [],
                    V().options.__e(t, e.__v)
                }
        }
        )),
        K = []
    }
    V().options.__b = function(e) {
        U = null,
        Y && Y(e)
    }
    ,
    V().options.__r = function(e) {
        X && X(e),
        q = 0;
        var t = (U = e.__c).__H;
        t && (t.__h.forEach(ge),
        t.__h.forEach(be),
        t.__h = [])
    }
    ,
    V().options.diffed = function(e) {
        J && J(e);
        var t = e.__c;
        t && t.__H && t.__H.__h.length && (1 !== K.push(t) && G === V().options.requestAnimationFrame || ((G = V().options.requestAnimationFrame) || function(e) {
            var t, n = function() {
                clearTimeout(r),
                ve && cancelAnimationFrame(t),
                setTimeout(e)
            }, r = setTimeout(n, 100);
            ve && (t = requestAnimationFrame(n))
        }
        )(fe)),
        U = void 0
    }
    ,
    V().options.__c = function(e, t) {
        t.some((function(e) {
            try {
                e.__h.forEach(ge),
                e.__h = e.__h.filter((function(e) {
                    return !e.__ || be(e)
                }
                ))
            } catch (n) {
                t.some((function(e) {
                    e.__h && (e.__h = [])
                }
                )),
                t = [],
                V().options.__e(n, e.__v)
            }
        }
        )),
        Q && Q(e, t)
    }
    ,
    V().options.unmount = function(e) {
        ee && ee(e);
        var t = e.__c;
        if (t && t.__H)
            try {
                t.__H.__.forEach(ge)
            } catch (e) {
                V().options.__e(e, t.__v)
            }
    }
    ;
    var he, me, ve = "function" == typeof requestAnimationFrame;
    function ge(e) {
        var t = U;
        "function" == typeof e.__c && e.__c(),
        U = t
    }
    function be(e) {
        var t = U;
        e.__c = e.__(),
        U = t
    }
    function ye(e, t) {
        return !e || e.length !== t.length || t.some((function(t, n) {
            return t !== e[n]
        }
        ))
    }
    function we(e, t) {
        return "function" == typeof t ? t(e) : t
    }
    function xe(e, t) {
        for (var n in t)
            e[n] = t[n];
        return e
    }
    function _e(e, t) {
        for (var n in e)
            if ("__source" !== n && !(n in t))
                return !0;
        for (var r in t)
            if ("__source" !== r && e[r] !== t[r])
                return !0;
        return !1
    }
    function Ce(e) {
        this.props = e
    }
    function Se(e, t) {
        function n(e) {
            var n = this.props.ref
              , r = n == e.ref;
            return !r && n && (n.call ? n(null) : n.current = null),
            t ? !t(this.props, e) || !r : _e(this.props, e)
        }
        function r(t) {
            return this.shouldComponentUpdate = n,
            V().createElement(e, t)
        }
        return r.displayName = "Memo(" + (e.displayName || e.name) + ")",
        r.prototype.isReactComponent = !0,
        r.__f = !0,
        r
    }
    r(h, "useErrorBoundary", (function() {
        return pe
    }
    )),
    r(h, "useDebugValue", (function() {
        return de
    }
    )),
    r(h, "useContext", (function() {
        return ue
    }
    )),
    r(h, "useCallback", (function() {
        return ce
    }
    )),
    r(h, "useMemo", (function() {
        return le
    }
    )),
    r(h, "useImperativeHandle", (function() {
        return se
    }
    )),
    r(h, "useRef", (function() {
        return ae
    }
    )),
    r(h, "useLayoutEffect", (function() {
        return oe
    }
    )),
    r(h, "useEffect", (function() {
        return ie
    }
    )),
    r(h, "useReducer", (function() {
        return re
    }
    )),
    r(h, "useState", (function() {
        return ne
    }
    )),
    he = f,
    me = h,
    Object.keys(me).forEach((function(e) {
        "default" !== e && "__esModule" !== e && Object.defineProperty(he, e, {
            enumerable: !0,
            get: function() {
                return me[e]
            }
        })
    }
    )),
    V(),
    V(),
    r(f, "Component", (function() {
        return V().Component
    }
    )),
    r(f, "Fragment", (function() {
        return V().Fragment
    }
    )),
    r(f, "createRef", (function() {
        return V().createRef
    }
    )),
    r(f, "createContext", (function() {
        return V().createContext
    }
    )),
    r(f, "createElement", (function() {
        return V().createElement
    }
    )),
    (Ce.prototype = new (V().Component)).isPureReactComponent = !0,
    Ce.prototype.shouldComponentUpdate = function(e, t) {
        return _e(this.props, e) || _e(this.state, t)
    }
    ;
    var Ee = V().options.__b;
    V().options.__b = function(e) {
        e.type && e.type.__f && e.ref && (e.props.ref = e.ref,
        e.ref = null),
        Ee && Ee(e)
    }
    ;
    var ke = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
    function Oe(e) {
        function t(t, n) {
            var r = xe({}, t);
            return delete r.ref,
            e(r, (n = t.ref || n) && ("object" != typeof n || "current"in n) ? n : null)
        }
        return t.$$typeof = ke,
        t.render = t,
        t.prototype.isReactComponent = t.__f = !0,
        t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")",
        t
    }
    var Te = function(e, t) {
        return null == e ? null : V().toChildArray(V().toChildArray(e).map(t))
    }
      , Me = {
        map: Te,
        forEach: Te,
        count: function(e) {
            return e ? V().toChildArray(e).length : 0
        },
        only: function(e) {
            var t = V().toChildArray(e);
            if (1 !== t.length)
                throw "Children.only";
            return t[0]
        },
        toArray: V().toChildArray
    }
      , Re = V().options.__e;
    function Pe() {
        this.__u = 0,
        this.t = null,
        this.__b = null
    }
    function Ie(e) {
        var t = e.__.__c;
        return t && t.__e && t.__e(e)
    }
    function ze(e) {
        var t, n, r;
        function i(i) {
            if (t || (t = e()).then((function(e) {
                n = e.default || e
            }
            ), (function(e) {
                r = e
            }
            )),
            r)
                throw r;
            if (!n)
                throw t;
            return V().createElement(n, i)
        }
        return i.displayName = "Lazy",
        i.__f = !0,
        i
    }
    function Ae() {
        this.u = null,
        this.o = null
    }
    V().options.__e = function(e, t, n) {
        if (e.then)
            for (var r, i = t; i = i.__; )
                if ((r = i.__c) && r.__c)
                    return null == t.__e && (t.__e = n.__e,
                    t.__k = n.__k),
                    r.__c(e, t);
        Re(e, t, n)
    }
    ,
    (Pe.prototype = new (V().Component)).__c = function(e, t) {
        var n = t.__c
          , r = this;
        null == r.t && (r.t = []),
        r.t.push(n);
        var i = Ie(r.__v)
          , o = !1
          , a = function() {
            o || (o = !0,
            n.componentWillUnmount = n.__c,
            i ? i(s) : s())
        };
        n.__c = n.componentWillUnmount,
        n.componentWillUnmount = function() {
            a(),
            n.__c && n.__c()
        }
        ;
        var s = function() {
            if (!--r.__u) {
                if (r.state.__e) {
                    var e = r.state.__e;
                    r.__v.__k[0] = function e(t, n, r) {
                        return t && (t.__v = null,
                        t.__k = t.__k && t.__k.map((function(t) {
                            return e(t, n, r)
                        }
                        )),
                        t.__c && t.__c.__P === n && (t.__e && r.insertBefore(t.__e, t.__d),
                        t.__c.__e = !0,
                        t.__c.__P = r)),
                        t
                    }(e, e.__c.__P, e.__c.__O)
                }
                var t;
                for (r.setState({
                    __e: r.__b = null
                }); t = r.t.pop(); )
                    t.forceUpdate()
            }
        }
          , l = !0 === t.__h;
        r.__u++ || l || r.setState({
            __e: r.__b = r.__v.__k[0]
        }),
        e.then(a, a)
    }
    ,
    Pe.prototype.componentWillUnmount = function() {
        this.t = []
    }
    ,
    Pe.prototype.render = function(e, t) {
        if (this.__b) {
            if (this.__v.__k) {
                var n = document.createElement("div")
                  , r = this.__v.__k[0].__c;
                this.__v.__k[0] = function e(t, n, r) {
                    return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach((function(e) {
                        "function" == typeof e.__c && e.__c()
                    }
                    )),
                    t.__c.__H = null),
                    null != (t = xe({}, t)).__c && (t.__c.__P === r && (t.__c.__P = n),
                    t.__c = null),
                    t.__k = t.__k && t.__k.map((function(t) {
                        return e(t, n, r)
                    }
                    ))),
                    t
                }(this.__b, n, r.__O = r.__P)
            }
            this.__b = null
        }
        var i = t.__e && V().createElement(V().Fragment, null, e.fallback);
        return i && (i.__h = null),
        [V().createElement(V().Fragment, null, t.__e ? null : e.children), i]
    }
    ;
    var Le = function(e, t, n) {
        if (++n[1] === n[0] && e.o.delete(t),
        e.props.revealOrder && ("t" !== e.props.revealOrder[0] || !e.o.size))
            for (n = e.u; n; ) {
                for (; n.length > 3; )
                    n.pop()();
                if (n[1] < n[0])
                    break;
                e.u = n = n[2]
            }
    };
    function De(e) {
        return this.getChildContext = function() {
            return e.context
        }
        ,
        e.children
    }
    function Ne(e) {
        var t = this
          , n = e.i;
        t.componentWillUnmount = function() {
            V().render(null, t.l),
            t.l = null,
            t.i = null
        }
        ,
        t.i && t.i !== n && t.componentWillUnmount(),
        e.__v ? (t.l || (t.i = n,
        t.l = {
            nodeType: 1,
            parentNode: n,
            childNodes: [],
            appendChild: function(e) {
                this.childNodes.push(e),
                t.i.appendChild(e)
            },
            insertBefore: function(e, n) {
                this.childNodes.push(e),
                t.i.appendChild(e)
            },
            removeChild: function(e) {
                this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1),
                t.i.removeChild(e)
            }
        }),
        V().render(V().createElement(De, {
            context: t.context
        }, e.__v), t.l)) : t.l && t.componentWillUnmount()
    }
    function We(e, t) {
        return V().createElement(Ne, {
            __v: e,
            i: t
        })
    }
    (Ae.prototype = new (V().Component)).__e = function(e) {
        var t = this
          , n = Ie(t.__v)
          , r = t.o.get(e);
        return r[0]++,
        function(i) {
            var o = function() {
                t.props.revealOrder ? (r.push(i),
                Le(t, e, r)) : i()
            };
            n ? n(o) : o()
        }
    }
    ,
    Ae.prototype.render = function(e) {
        this.u = null,
        this.o = new Map;
        var t = V().toChildArray(e.children);
        e.revealOrder && "b" === e.revealOrder[0] && t.reverse();
        for (var n = t.length; n--; )
            this.o.set(t[n], this.u = [1, 0, this.u]);
        return e.children
    }
    ,
    Ae.prototype.componentDidUpdate = Ae.prototype.componentDidMount = function() {
        var e = this;
        this.o.forEach((function(t, n) {
            Le(e, n, t)
        }
        ))
    }
    ;
    var Fe = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103
      , $e = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/
      , Be = function(e) {
        return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(e)
    };
    function je(e, t, n) {
        return null == t.__k && (t.textContent = ""),
        V().render(e, t),
        "function" == typeof n && n(),
        e ? e.__c : null
    }
    function He(e, t, n) {
        return V().hydrate(e, t),
        "function" == typeof n && n(),
        e ? e.__c : null
    }
    V().Component.prototype.isReactComponent = {},
    ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach((function(e) {
        Object.defineProperty(V().Component.prototype, e, {
            configurable: !0,
            get: function() {
                return this["UNSAFE_" + e]
            },
            set: function(t) {
                Object.defineProperty(this, e, {
                    configurable: !0,
                    writable: !0,
                    value: t
                })
            }
        })
    }
    ));
    var Ve = V().options.event;
    function qe() {}
    function Ue() {
        return this.cancelBubble
    }
    function Ge() {
        return this.defaultPrevented
    }
    V().options.event = function(e) {
        return Ve && (e = Ve(e)),
        e.persist = qe,
        e.isPropagationStopped = Ue,
        e.isDefaultPrevented = Ge,
        e.nativeEvent = e
    }
    ;
    var Ze, Ke = {
        configurable: !0,
        get: function() {
            return this.class
        }
    }, Ye = V().options.vnode;
    V().options.vnode = function(e) {
        var t = e.type
          , n = e.props
          , r = n;
        if ("string" == typeof t) {
            for (var i in r = {},
            n) {
                var o = n[i];
                "value" === i && "defaultValue"in n && null == o || ("defaultValue" === i && "value"in n && null == n.value ? i = "value" : "download" === i && !0 === o ? o = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !Be(n.type) ? i = "oninput" : /^on(Ani|Tra|Tou|BeforeInp)/.test(i) ? i = i.toLowerCase() : $e.test(i) ? i = i.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === o && (o = void 0),
                r[i] = o)
            }
            "select" == t && r.multiple && Array.isArray(r.value) && (r.value = V().toChildArray(n.children).forEach((function(e) {
                e.props.selected = -1 != r.value.indexOf(e.props.value)
            }
            ))),
            "select" == t && null != r.defaultValue && (r.value = V().toChildArray(n.children).forEach((function(e) {
                e.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(e.props.value) : r.defaultValue == e.props.value
            }
            ))),
            e.props = r
        }
        t && n.class != n.className && (Ke.enumerable = "className"in n,
        null != n.className && (r.class = n.className),
        Object.defineProperty(r, "className", Ke)),
        e.$$typeof = Fe,
        Ye && Ye(e)
    }
    ;
    var Xe = V().options.__r;
    V().options.__r = function(e) {
        Xe && Xe(e),
        Ze = e.__c
    }
    ;
    var Je = {
        ReactCurrentDispatcher: {
            current: {
                readContext: function(e) {
                    return Ze.__n[e.__c].props.value
                }
            }
        }
    };
    function Qe(e, t) {
        return t()
    }
    var et = "object" == typeof performance && "function" == typeof performance.now ? performance.now.bind(performance) : function() {
        return Date.now()
    }
    ;
    function tt(e) {
        return V().createElement.bind(null, e)
    }
    function nt(e) {
        return !!e && e.$$typeof === Fe
    }
    function rt(e) {
        return nt(e) ? V().cloneElement.apply(null, arguments) : e
    }
    function it(e) {
        return !!e.__k && (V().render(null, e),
        !0)
    }
    function ot(e) {
        return e && (e.base || 1 === e.nodeType && e) || null
    }
    var at = function(e, t) {
        return e(t)
    }
      , st = V().Fragment
      , lt = {
        useState: ne,
        useReducer: re,
        useEffect: ie,
        useLayoutEffect: oe,
        useRef: ae,
        useImperativeHandle: se,
        useMemo: le,
        useCallback: ce,
        useContext: ue,
        useDebugValue: de,
        version: "16.8.0",
        Children: Me,
        render: je,
        hydrate: He,
        unmountComponentAtNode: it,
        createPortal: We,
        createElement: V().createElement,
        createContext: V().createContext,
        createFactory: tt,
        cloneElement: rt,
        createRef: V().createRef,
        Fragment: V().Fragment,
        isValidElement: nt,
        findDOMNode: ot,
        Component: V().Component,
        PureComponent: Ce,
        memo: Se,
        forwardRef: Oe,
        unstable_batchedUpdates: at,
        StrictMode: V().Fragment,
        Suspense: Pe,
        SuspenseList: Ae,
        lazy: ze,
        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: Je
    };
    r(f, "default", (function() {
        return lt
    }
    )),
    r(f, "unstable_now", (function() {
        return et
    }
    )),
    r(f, "unstable_runWithPriority", (function() {
        return Qe
    }
    )),
    r(f, "unstable_IdlePriority", (function() {
        return 5
    }
    )),
    r(f, "unstable_LowPriority", (function() {
        return 4
    }
    )),
    r(f, "unstable_NormalPriority", (function() {
        return 3
    }
    )),
    r(f, "unstable_UserBlockingPriority", (function() {
        return 2
    }
    )),
    r(f, "unstable_ImmediatePriority", (function() {
        return 1
    }
    )),
    r(f, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", (function() {
        return Je
    }
    )),
    r(f, "lazy", (function() {
        return ze
    }
    )),
    r(f, "SuspenseList", (function() {
        return Ae
    }
    )),
    r(f, "Suspense", (function() {
        return Pe
    }
    )),
    r(f, "StrictMode", (function() {
        return st
    }
    )),
    r(f, "unstable_batchedUpdates", (function() {
        return at
    }
    )),
    r(f, "forwardRef", (function() {
        return Oe
    }
    )),
    r(f, "memo", (function() {
        return Se
    }
    )),
    r(f, "PureComponent", (function() {
        return Ce
    }
    )),
    r(f, "findDOMNode", (function() {
        return ot
    }
    )),
    r(f, "isValidElement", (function() {
        return nt
    }
    )),
    r(f, "cloneElement", (function() {
        return rt
    }
    )),
    r(f, "createFactory", (function() {
        return tt
    }
    )),
    r(f, "createPortal", (function() {
        return We
    }
    )),
    r(f, "unmountComponentAtNode", (function() {
        return it
    }
    )),
    r(f, "hydrate", (function() {
        return He
    }
    )),
    r(f, "render", (function() {
        return je
    }
    )),
    r(f, "Children", (function() {
        return Me
    }
    )),
    r(f, "version", (function() {
        return "16.8.0"
    }
    )),
    n(f);
    var ct = {}
      , ut = {
        black: "#000",
        white: "#fff"
    }
      , dt = {
        50: "#ffebee",
        100: "#ffcdd2",
        200: "#ef9a9a",
        300: "#e57373",
        400: "#ef5350",
        500: "#f44336",
        600: "#e53935",
        700: "#d32f2f",
        800: "#c62828",
        900: "#b71c1c",
        A100: "#ff8a80",
        A200: "#ff5252",
        A400: "#ff1744",
        A700: "#d50000"
    }
      , pt = {
        50: "#fce4ec",
        100: "#f8bbd0",
        200: "#f48fb1",
        300: "#f06292",
        400: "#ec407a",
        500: "#e91e63",
        600: "#d81b60",
        700: "#c2185b",
        800: "#ad1457",
        900: "#880e4f",
        A100: "#ff80ab",
        A200: "#ff4081",
        A400: "#f50057",
        A700: "#c51162"
    }
      , ft = {
        50: "#f3e5f5",
        100: "#e1bee7",
        200: "#ce93d8",
        300: "#ba68c8",
        400: "#ab47bc",
        500: "#9c27b0",
        600: "#8e24aa",
        700: "#7b1fa2",
        800: "#6a1b9a",
        900: "#4a148c",
        A100: "#ea80fc",
        A200: "#e040fb",
        A400: "#d500f9",
        A700: "#aa00ff"
    }
      , ht = {
        50: "#ede7f6",
        100: "#d1c4e9",
        200: "#b39ddb",
        300: "#9575cd",
        400: "#7e57c2",
        500: "#673ab7",
        600: "#5e35b1",
        700: "#512da8",
        800: "#4527a0",
        900: "#311b92",
        A100: "#b388ff",
        A200: "#7c4dff",
        A400: "#651fff",
        A700: "#6200ea"
    }
      , mt = {
        50: "#e8eaf6",
        100: "#c5cae9",
        200: "#9fa8da",
        300: "#7986cb",
        400: "#5c6bc0",
        500: "#3f51b5",
        600: "#3949ab",
        700: "#303f9f",
        800: "#283593",
        900: "#1a237e",
        A100: "#8c9eff",
        A200: "#536dfe",
        A400: "#3d5afe",
        A700: "#304ffe"
    }
      , vt = {
        50: "#e3f2fd",
        100: "#bbdefb",
        200: "#90caf9",
        300: "#64b5f6",
        400: "#42a5f5",
        500: "#2196f3",
        600: "#1e88e5",
        700: "#1976d2",
        800: "#1565c0",
        900: "#0d47a1",
        A100: "#82b1ff",
        A200: "#448aff",
        A400: "#2979ff",
        A700: "#2962ff"
    }
      , gt = {
        50: "#e1f5fe",
        100: "#b3e5fc",
        200: "#81d4fa",
        300: "#4fc3f7",
        400: "#29b6f6",
        500: "#03a9f4",
        600: "#039be5",
        700: "#0288d1",
        800: "#0277bd",
        900: "#01579b",
        A100: "#80d8ff",
        A200: "#40c4ff",
        A400: "#00b0ff",
        A700: "#0091ea"
    }
      , bt = {
        50: "#e0f7fa",
        100: "#b2ebf2",
        200: "#80deea",
        300: "#4dd0e1",
        400: "#26c6da",
        500: "#00bcd4",
        600: "#00acc1",
        700: "#0097a7",
        800: "#00838f",
        900: "#006064",
        A100: "#84ffff",
        A200: "#18ffff",
        A400: "#00e5ff",
        A700: "#00b8d4"
    }
      , yt = {
        50: "#e0f2f1",
        100: "#b2dfdb",
        200: "#80cbc4",
        300: "#4db6ac",
        400: "#26a69a",
        500: "#009688",
        600: "#00897b",
        700: "#00796b",
        800: "#00695c",
        900: "#004d40",
        A100: "#a7ffeb",
        A200: "#64ffda",
        A400: "#1de9b6",
        A700: "#00bfa5"
    }
      , wt = {
        50: "#e8f5e9",
        100: "#c8e6c9",
        200: "#a5d6a7",
        300: "#81c784",
        400: "#66bb6a",
        500: "#4caf50",
        600: "#43a047",
        700: "#388e3c",
        800: "#2e7d32",
        900: "#1b5e20",
        A100: "#b9f6ca",
        A200: "#69f0ae",
        A400: "#00e676",
        A700: "#00c853"
    }
      , xt = {
        50: "#f1f8e9",
        100: "#dcedc8",
        200: "#c5e1a5",
        300: "#aed581",
        400: "#9ccc65",
        500: "#8bc34a",
        600: "#7cb342",
        700: "#689f38",
        800: "#558b2f",
        900: "#33691e",
        A100: "#ccff90",
        A200: "#b2ff59",
        A400: "#76ff03",
        A700: "#64dd17"
    }
      , _t = {
        50: "#f9fbe7",
        100: "#f0f4c3",
        200: "#e6ee9c",
        300: "#dce775",
        400: "#d4e157",
        500: "#cddc39",
        600: "#c0ca33",
        700: "#afb42b",
        800: "#9e9d24",
        900: "#827717",
        A100: "#f4ff81",
        A200: "#eeff41",
        A400: "#c6ff00",
        A700: "#aeea00"
    }
      , Ct = {
        50: "#fffde7",
        100: "#fff9c4",
        200: "#fff59d",
        300: "#fff176",
        400: "#ffee58",
        500: "#ffeb3b",
        600: "#fdd835",
        700: "#fbc02d",
        800: "#f9a825",
        900: "#f57f17",
        A100: "#ffff8d",
        A200: "#ffff00",
        A400: "#ffea00",
        A700: "#ffd600"
    }
      , St = {
        50: "#fff8e1",
        100: "#ffecb3",
        200: "#ffe082",
        300: "#ffd54f",
        400: "#ffca28",
        500: "#ffc107",
        600: "#ffb300",
        700: "#ffa000",
        800: "#ff8f00",
        900: "#ff6f00",
        A100: "#ffe57f",
        A200: "#ffd740",
        A400: "#ffc400",
        A700: "#ffab00"
    }
      , Et = {
        50: "#fff3e0",
        100: "#ffe0b2",
        200: "#ffcc80",
        300: "#ffb74d",
        400: "#ffa726",
        500: "#ff9800",
        600: "#fb8c00",
        700: "#f57c00",
        800: "#ef6c00",
        900: "#e65100",
        A100: "#ffd180",
        A200: "#ffab40",
        A400: "#ff9100",
        A700: "#ff6d00"
    }
      , kt = {
        50: "#fbe9e7",
        100: "#ffccbc",
        200: "#ffab91",
        300: "#ff8a65",
        400: "#ff7043",
        500: "#ff5722",
        600: "#f4511e",
        700: "#e64a19",
        800: "#d84315",
        900: "#bf360c",
        A100: "#ff9e80",
        A200: "#ff6e40",
        A400: "#ff3d00",
        A700: "#dd2c00"
    }
      , Ot = {
        50: "#efebe9",
        100: "#d7ccc8",
        200: "#bcaaa4",
        300: "#a1887f",
        400: "#8d6e63",
        500: "#795548",
        600: "#6d4c41",
        700: "#5d4037",
        800: "#4e342e",
        900: "#3e2723",
        A100: "#d7ccc8",
        A200: "#bcaaa4",
        A400: "#8d6e63",
        A700: "#5d4037"
    }
      , Tt = {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#eeeeee",
        300: "#e0e0e0",
        400: "#bdbdbd",
        500: "#9e9e9e",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
        A100: "#d5d5d5",
        A200: "#aaaaaa",
        A400: "#303030",
        A700: "#616161"
    }
      , Mt = {
        50: "#eceff1",
        100: "#cfd8dc",
        200: "#b0bec5",
        300: "#90a4ae",
        400: "#78909c",
        500: "#607d8b",
        600: "#546e7a",
        700: "#455a64",
        800: "#37474f",
        900: "#263238",
        A100: "#cfd8dc",
        A200: "#b0bec5",
        A400: "#78909c",
        A700: "#455a64"
    };
    r(ct, "common", (function() {
        return ut
    }
    )),
    r(ct, "red", (function() {
        return dt
    }
    )),
    r(ct, "pink", (function() {
        return pt
    }
    )),
    r(ct, "purple", (function() {
        return ft
    }
    )),
    r(ct, "deepPurple", (function() {
        return ht
    }
    )),
    r(ct, "indigo", (function() {
        return mt
    }
    )),
    r(ct, "blue", (function() {
        return vt
    }
    )),
    r(ct, "lightBlue", (function() {
        return gt
    }
    )),
    r(ct, "cyan", (function() {
        return bt
    }
    )),
    r(ct, "teal", (function() {
        return yt
    }
    )),
    r(ct, "green", (function() {
        return wt
    }
    )),
    r(ct, "lightGreen", (function() {
        return xt
    }
    )),
    r(ct, "lime", (function() {
        return _t
    }
    )),
    r(ct, "yellow", (function() {
        return Ct
    }
    )),
    r(ct, "amber", (function() {
        return St
    }
    )),
    r(ct, "orange", (function() {
        return Et
    }
    )),
    r(ct, "deepOrange", (function() {
        return kt
    }
    )),
    r(ct, "brown", (function() {
        return Ot
    }
    )),
    r(ct, "grey", (function() {
        return Tt
    }
    )),
    r(ct, "blueGrey", (function() {
        return Mt
    }
    ));
    var Rt = {};
    function Pt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0
          , n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        return Math.min(Math.max(t, e), n)
    }
    function It(e) {
        if (e.type)
            return e;
        if ("#" === e.charAt(0))
            return It(function(e) {
                e = e.substr(1);
                var t = new RegExp(".{1,".concat(e.length / 3, "}"),"g")
                  , n = e.match(t);
                return n && 1 === n[0].length && (n = n.map((function(e) {
                    return e + e
                }
                ))),
                n ? "rgb(".concat(n.map((function(e) {
                    return parseInt(e, 16)
                }
                )).join(", "), ")") : ""
            }(e));
        var t = e.indexOf("(")
          , n = e.substring(0, t);
        if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(n))
            throw new Error(["Material-UI: unsupported `".concat(e, "` color."), "We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."].join("\n"));
        var r = e.substring(t + 1, e.length - 1).split(",");
        return {
            type: n,
            values: r = r.map((function(e) {
                return parseFloat(e)
            }
            ))
        }
    }
    function zt(e) {
        var t = e.type
          , n = e.values;
        return -1 !== t.indexOf("rgb") ? n = n.map((function(e, t) {
            return t < 3 ? parseInt(e, 10) : e
        }
        )) : -1 !== t.indexOf("hsl") && (n[1] = "".concat(n[1], "%"),
        n[2] = "".concat(n[2], "%")),
        "".concat(t, "(").concat(n.join(", "), ")")
    }
    function At(e, t) {
        var n = Lt(e)
          , r = Lt(t);
        return (Math.max(n, r) + .05) / (Math.min(n, r) + .05)
    }
    function Lt(e) {
        var t = "hsl" === (e = It(e)).type ? It(function(e) {
            var t = (e = It(e)).values
              , n = t[0]
              , r = t[1] / 100
              , i = t[2] / 100
              , o = r * Math.min(i, 1 - i)
              , a = function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e + n / 30) % 12;
                return i - o * Math.max(Math.min(t - 3, 9 - t, 1), -1)
            }
              , s = "rgb"
              , l = [Math.round(255 * a(0)), Math.round(255 * a(8)), Math.round(255 * a(4))];
            return "hsla" === e.type && (s += "a",
            l.push(t[3])),
            zt({
                type: s,
                values: l
            })
        }(e)).values : e.values;
        return t = t.map((function(e) {
            return (e /= 255) <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)
        }
        )),
        Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3))
    }
    function Dt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .15;
        return Lt(e) > .5 ? Wt(e, t) : Ft(e, t)
    }
    function Nt(e, t) {
        return e = It(e),
        t = Pt(t),
        "rgb" !== e.type && "hsl" !== e.type || (e.type += "a"),
        e.values[3] = t,
        zt(e)
    }
    function Wt(e, t) {
        if (e = It(e),
        t = Pt(t),
        -1 !== e.type.indexOf("hsl"))
            e.values[2] *= 1 - t;
        else if (-1 !== e.type.indexOf("rgb"))
            for (var n = 0; n < 3; n += 1)
                e.values[n] *= 1 - t;
        return zt(e)
    }
    function Ft(e, t) {
        if (e = It(e),
        t = Pt(t),
        -1 !== e.type.indexOf("hsl"))
            e.values[2] += (100 - e.values[2]) * t;
        else if (-1 !== e.type.indexOf("rgb"))
            for (var n = 0; n < 3; n += 1)
                e.values[n] += (255 - e.values[n]) * t;
        return zt(e)
    }
    function $t(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function Bt(e, t) {
        if (null == e)
            return {};
        var n, r, i = {}, o = Object.keys(e);
        for (r = 0; r < o.length; r++)
            n = o[r],
            t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i
    }
    function jt(e, t) {
        if (null == e)
            return {};
        var n, r, i = Bt(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (r = 0; r < o.length; r++)
                n = o[r],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n])
        }
        return i
    }
    function Ht() {
        return (Ht = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ).apply(this, arguments)
    }
    r(Rt, "getContrastRatio", (function() {
        return At
    }
    )),
    r(Rt, "emphasize", (function() {
        return Dt
    }
    )),
    r(Rt, "fade", (function() {
        return Nt
    }
    )),
    r(Rt, "darken", (function() {
        return Wt
    }
    )),
    r(Rt, "lighten", (function() {
        return Ft
    }
    ));
    var Vt = Ht;
    function qt(e) {
        return (qt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        )(e)
    }
    var Ut = qt;
    function Gt(e) {
        return e && "object" === Ut(e) && !Array.isArray(e)
    }
    function Zt(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
            clone: !0
        }
          , r = n.clone ? Vt({}, e) : e;
        return Gt(e) && Gt(t) && Object.keys(t).forEach((function(i) {
            "__proto__" !== i && (Gt(t[i]) && i in e ? r[i] = Zt(e[i], t[i], n) : r[i] = t[i])
        }
        )),
        r
    }
    var Kt, Yt = !1;
    function Xt() {
        return Yt || (Yt = !0,
        Kt = {},
        "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
        Kt = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"),
        Kt
    }
    var Jt, Qt, en = !1;
    function tn() {}
    function nn() {}
    var rn = {}
      , on = t(rn = (en || (en = !0,
    Jt = {},
    Qt = Xt(),
    nn.resetWarningCache = tn,
    Jt = function() {
        function e(e, t, n, r, i, o) {
            if (o !== Qt) {
                var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw a.name = "Invariant Violation",
                a
            }
        }
        function t() {
            return e
        }
        e.isRequired = e;
        var n = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: nn,
            resetWarningCache: tn
        };
        return n.PropTypes = n,
        n
    }
    ),
    Jt)());
    var an = (on.element,
    function() {
        return null
    }
    );
    an.isRequired = (on.element.isRequired,
    function() {
        return null
    }
    );
    rn.elementType;
    var sn, ln, cn, un, dn, pn, fn, hn, mn, vn, gn, bn, yn, wn, xn, _n, Cn, Sn, En, kn, On, Tn, Mn, Rn, Pn, In, zn, An, Ln, Dn, Nn, Wn, Fn, $n, Bn, jn, Hn, Vn, qn, Un, Gn, Zn, Kn, Yn, Xn, Jn, Qn, er = !1;
    function tr(e) {
        if ("object" == typeof e && null !== e) {
            var t = e.$$typeof;
            switch (t) {
            case cn:
                switch (e = e.type) {
                case vn:
                case gn:
                case dn:
                case fn:
                case pn:
                case yn:
                    return e;
                default:
                    switch (e = e && e.$$typeof) {
                    case mn:
                    case bn:
                    case _n:
                    case xn:
                    case hn:
                        return e;
                    default:
                        return t
                    }
                }
            case un:
                return t
            }
        }
    }
    function nr(e) {
        return tr(e) === gn
    }
    var rr = {};
    er || (er = !0,
    sn = {},
    Object.defineProperty(sn, "__esModule", {
        value: !0
    }),
    ln = "function" == typeof Symbol && Symbol.for,
    cn = ln ? Symbol.for("react.element") : 60103,
    un = ln ? Symbol.for("react.portal") : 60106,
    dn = ln ? Symbol.for("react.fragment") : 60107,
    pn = ln ? Symbol.for("react.strict_mode") : 60108,
    fn = ln ? Symbol.for("react.profiler") : 60114,
    hn = ln ? Symbol.for("react.provider") : 60109,
    mn = ln ? Symbol.for("react.context") : 60110,
    vn = ln ? Symbol.for("react.async_mode") : 60111,
    gn = ln ? Symbol.for("react.concurrent_mode") : 60111,
    bn = ln ? Symbol.for("react.forward_ref") : 60112,
    yn = ln ? Symbol.for("react.suspense") : 60113,
    wn = ln ? Symbol.for("react.suspense_list") : 60120,
    xn = ln ? Symbol.for("react.memo") : 60115,
    _n = ln ? Symbol.for("react.lazy") : 60116,
    Cn = ln ? Symbol.for("react.fundamental") : 60117,
    Sn = ln ? Symbol.for("react.responder") : 60118,
    En = ln ? Symbol.for("react.scope") : 60119,
    kn = tr,
    sn.typeOf = kn,
    On = vn,
    sn.AsyncMode = On,
    Tn = gn,
    sn.ConcurrentMode = Tn,
    Mn = mn,
    sn.ContextConsumer = Mn,
    Rn = hn,
    sn.ContextProvider = Rn,
    Pn = cn,
    sn.Element = Pn,
    In = bn,
    sn.ForwardRef = In,
    zn = dn,
    sn.Fragment = zn,
    An = _n,
    sn.Lazy = An,
    Ln = xn,
    sn.Memo = Ln,
    Dn = un,
    sn.Portal = Dn,
    Nn = fn,
    sn.Profiler = Nn,
    Wn = pn,
    sn.StrictMode = Wn,
    Fn = yn,
    sn.Suspense = Fn,
    $n = function(e) {
        return "string" == typeof e || "function" == typeof e || e === dn || e === gn || e === fn || e === pn || e === yn || e === wn || "object" == typeof e && null !== e && (e.$$typeof === _n || e.$$typeof === xn || e.$$typeof === hn || e.$$typeof === mn || e.$$typeof === bn || e.$$typeof === Cn || e.$$typeof === Sn || e.$$typeof === En)
    }
    ,
    sn.isValidElementType = $n,
    Bn = function(e) {
        return nr(e) || tr(e) === vn
    }
    ,
    sn.isAsyncMode = Bn,
    jn = nr,
    sn.isConcurrentMode = jn,
    Hn = function(e) {
        return tr(e) === mn
    }
    ,
    sn.isContextConsumer = Hn,
    Vn = function(e) {
        return tr(e) === hn
    }
    ,
    sn.isContextProvider = Vn,
    qn = function(e) {
        return "object" == typeof e && null !== e && e.$$typeof === cn
    }
    ,
    sn.isElement = qn,
    Un = function(e) {
        return tr(e) === bn
    }
    ,
    sn.isForwardRef = Un,
    Gn = function(e) {
        return tr(e) === dn
    }
    ,
    sn.isFragment = Gn,
    Zn = function(e) {
        return tr(e) === _n
    }
    ,
    sn.isLazy = Zn,
    Kn = function(e) {
        return tr(e) === xn
    }
    ,
    sn.isMemo = Kn,
    Yn = function(e) {
        return tr(e) === un
    }
    ,
    sn.isPortal = Yn,
    Xn = function(e) {
        return tr(e) === fn
    }
    ,
    sn.isProfiler = Xn,
    Jn = function(e) {
        return tr(e) === pn
    }
    ,
    sn.isStrictMode = Jn,
    Qn = function(e) {
        return tr(e) === yn
    }
    ,
    sn.isSuspense = Qn),
    rr = sn;
    "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(),
    on.oneOfType([on.func, on.object]);
    var ir = ["xs", "sm", "md", "lg", "xl"];
    function or(e) {
        var t = e.values
          , n = void 0 === t ? {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920
        } : t
          , r = e.unit
          , i = void 0 === r ? "px" : r
          , o = e.step
          , a = void 0 === o ? 5 : o
          , s = jt(e, ["values", "unit", "step"]);
        function l(e) {
            var t = "number" == typeof n[e] ? n[e] : e;
            return "@media (min-width:".concat(t).concat(i, ")")
        }
        function c(e, t) {
            var r = ir.indexOf(t);
            return r === ir.length - 1 ? l(e) : "@media (min-width:".concat("number" == typeof n[e] ? n[e] : e).concat(i, ") and ") + "(max-width:".concat((-1 !== r && "number" == typeof n[ir[r + 1]] ? n[ir[r + 1]] : t) - a / 100).concat(i, ")")
        }
        return Vt({
            keys: ir,
            values: n,
            up: l,
            down: function(e) {
                var t = ir.indexOf(e) + 1
                  , r = n[ir[t]];
                return t === ir.length ? l("xs") : "@media (max-width:".concat(("number" == typeof r && t > 0 ? r : e) - a / 100).concat(i, ")")
            },
            between: c,
            only: function(e) {
                return c(e, e)
            },
            width: function(e) {
                return n[e]
            }
        }, s)
    }
    function ar(e, t, n) {
        var r;
        return Vt({
            gutters: function() {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return Vt({
                    paddingLeft: t(2),
                    paddingRight: t(2)
                }, n, $t({}, e.up("sm"), Vt({
                    paddingLeft: t(3),
                    paddingRight: t(3)
                }, n[e.up("sm")])))
            },
            toolbar: (r = {
                minHeight: 56
            },
            $t(r, "".concat(e.up("xs"), " and (orientation: landscape)"), {
                minHeight: 48
            }),
            $t(r, e.up("sm"), {
                minHeight: 64
            }),
            r)
        }, n)
    }
    var sr = {
        text: {
            primary: "rgba(0, 0, 0, 0.87)",
            secondary: "rgba(0, 0, 0, 0.54)",
            disabled: "rgba(0, 0, 0, 0.38)",
            hint: "rgba(0, 0, 0, 0.38)"
        },
        divider: "rgba(0, 0, 0, 0.12)",
        background: {
            paper: ut.white,
            default: Tt[50]
        },
        action: {
            active: "rgba(0, 0, 0, 0.54)",
            hover: "rgba(0, 0, 0, 0.04)",
            hoverOpacity: .04,
            selected: "rgba(0, 0, 0, 0.08)",
            selectedOpacity: .08,
            disabled: "rgba(0, 0, 0, 0.26)",
            disabledBackground: "rgba(0, 0, 0, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(0, 0, 0, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .12
        }
    }
      , lr = {
        text: {
            primary: ut.white,
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
            hint: "rgba(255, 255, 255, 0.5)",
            icon: "rgba(255, 255, 255, 0.5)"
        },
        divider: "rgba(255, 255, 255, 0.12)",
        background: {
            paper: Tt[800],
            default: "#303030"
        },
        action: {
            active: ut.white,
            hover: "rgba(255, 255, 255, 0.08)",
            hoverOpacity: .08,
            selected: "rgba(255, 255, 255, 0.16)",
            selectedOpacity: .16,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .24
        }
    };
    function cr(e, t, n, r) {
        e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : "light" === t ? e.light = Ft(e.main, r) : "dark" === t && (e.dark = Wt(e.main, 1.5 * r)))
    }
    function ur(e) {
        var t = e.primary
          , n = void 0 === t ? {
            light: mt[300],
            main: mt[500],
            dark: mt[700]
        } : t
          , r = e.secondary
          , i = void 0 === r ? {
            light: pt.A200,
            main: pt.A400,
            dark: pt.A700
        } : r
          , o = e.error
          , a = void 0 === o ? {
            light: dt[300],
            main: dt[500],
            dark: dt[700]
        } : o
          , s = e.warning
          , l = void 0 === s ? {
            light: Et[300],
            main: Et[500],
            dark: Et[700]
        } : s
          , c = e.info
          , u = void 0 === c ? {
            light: vt[300],
            main: vt[500],
            dark: vt[700]
        } : c
          , d = e.success
          , p = void 0 === d ? {
            light: wt[300],
            main: wt[500],
            dark: wt[700]
        } : d
          , f = e.type
          , h = void 0 === f ? "light" : f
          , m = e.contrastThreshold
          , v = void 0 === m ? 3 : m
          , g = e.tonalOffset
          , b = void 0 === g ? .2 : g
          , y = jt(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
        function w(e) {
            if (!e)
                throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(e, ")."));
            var t = At(e, lr.text.primary) >= v ? lr.text.primary : sr.text.primary;
            return t
        }
        function x(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500
              , n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 300
              , r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 700;
            return !(e = Vt({}, e)).main && e[t] && (e.main = e[t]),
            cr(e, "light", n, b),
            cr(e, "dark", r, b),
            e.contrastText || (e.contrastText = w(e.main)),
            e
        }
        var _ = {
            dark: lr,
            light: sr
        };
        return Zt(Vt({
            common: ut,
            type: h,
            primary: x(n),
            secondary: x(i, "A400", "A200", "A700"),
            error: x(a),
            warning: x(l),
            info: x(u),
            success: x(p),
            grey: Tt,
            contrastThreshold: v,
            getContrastText: w,
            augmentColor: x,
            tonalOffset: b
        }, _[h]), y)
    }
    function dr(e) {
        return Math.round(1e5 * e) / 1e5
    }
    var pr = {
        textTransform: "uppercase"
    }
      , fr = '"Roboto", "Helvetica", "Arial", sans-serif';
    function hr(e, t) {
        var n = "function" == typeof t ? t(e) : t
          , r = n.fontFamily
          , i = void 0 === r ? fr : r
          , o = n.fontSize
          , a = void 0 === o ? 14 : o
          , s = n.fontWeightLight
          , l = void 0 === s ? 300 : s
          , c = n.fontWeightRegular
          , u = void 0 === c ? 400 : c
          , d = n.fontWeightMedium
          , p = void 0 === d ? 500 : d
          , f = n.fontWeightBold
          , h = void 0 === f ? 700 : f
          , m = n.htmlFontSize
          , v = void 0 === m ? 16 : m
          , g = n.allVariants
          , b = n.pxToRem
          , y = jt(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
        var w = a / 14
          , x = b || function(e) {
            return "".concat(e / v * w, "rem")
        }
          , _ = function(e, t, n, r, o) {
            return Vt({
                fontFamily: i,
                fontWeight: e,
                fontSize: x(t),
                lineHeight: n
            }, i === fr ? {
                letterSpacing: "".concat(dr(r / t), "em")
            } : {}, {}, o, {}, g)
        }
          , C = {
            h1: _(l, 96, 1.167, -1.5),
            h2: _(l, 60, 1.2, -.5),
            h3: _(u, 48, 1.167, 0),
            h4: _(u, 34, 1.235, .25),
            h5: _(u, 24, 1.334, 0),
            h6: _(p, 20, 1.6, .15),
            subtitle1: _(u, 16, 1.75, .15),
            subtitle2: _(p, 14, 1.57, .1),
            body1: _(u, 16, 1.5, .15),
            body2: _(u, 14, 1.43, .15),
            button: _(p, 14, 1.75, .4, pr),
            caption: _(u, 12, 1.66, .4),
            overline: _(u, 12, 2.66, 1, pr)
        };
        return Zt(Vt({
            htmlFontSize: v,
            pxToRem: x,
            round: dr,
            fontFamily: i,
            fontSize: a,
            fontWeightLight: l,
            fontWeightRegular: u,
            fontWeightMedium: p,
            fontWeightBold: h
        }, C), y, {
            clone: !1
        })
    }
    function mr() {
        return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(.2, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(.14, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(.12, ")")].join(",")
    }
    var vr = ["none", mr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), mr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), mr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), mr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), mr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), mr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), mr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), mr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), mr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), mr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), mr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), mr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), mr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), mr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), mr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), mr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), mr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), mr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), mr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), mr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), mr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), mr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), mr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), mr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)]
      , gr = {
        borderRadius: 4
    };
    function br() {
        var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8;
        if (t.mui)
            return t;
        e = "function" == typeof t ? t : function(e) {
            return t * e
        }
        ;
        var n = function() {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            return 0 === n.length ? e(1) : 1 === n.length ? e(n[0]) : n.map((function(t) {
                var n = e(t);
                return "number" == typeof n ? "".concat(n, "px") : n
            }
            )).join(" ")
        };
        return Object.defineProperty(n, "unit", {
            get: function() {
                return t
            }
        }),
        n.mui = !0,
        n
    }
    var yr = {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    }
      , wr = {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195
    };
    function xr(e) {
        return "".concat(Math.round(e), "ms")
    }
    var _r = {
        easing: yr,
        duration: wr,
        create: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["all"]
              , t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
              , n = t.duration
              , r = void 0 === n ? wr.standard : n
              , i = t.easing
              , o = void 0 === i ? yr.easeInOut : i
              , a = t.delay
              , s = void 0 === a ? 0 : a;
            jt(t, ["duration", "easing", "delay"]);
            return (Array.isArray(e) ? e : [e]).map((function(e) {
                return "".concat(e, " ").concat("string" == typeof r ? r : xr(r), " ").concat(o, " ").concat("string" == typeof s ? s : xr(s))
            }
            )).join(",")
        },
        getAutoHeightDuration: function(e) {
            if (!e)
                return 0;
            var t = e / 36;
            return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5))
        }
    };
    r({}, "default", (function() {
        return _r
    }
    ));
    var Cr = {
        mobileStepper: 1e3,
        speedDial: 1050,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500
    };
    function Sr() {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.breakpoints, n = void 0 === t ? {} : t, r = e.mixins, i = void 0 === r ? {} : r, o = e.palette, a = void 0 === o ? {} : o, s = e.spacing, l = e.typography, c = void 0 === l ? {} : l, u = jt(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = ur(a), p = or(n), f = br(s), h = Zt({
            breakpoints: p,
            direction: "ltr",
            mixins: ar(p, f, i),
            overrides: {},
            palette: d,
            props: {},
            shadows: vr,
            typography: hr(d, c),
            spacing: f,
            shape: gr,
            transitions: _r,
            zIndex: Cr
        }, u), m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++)
            v[g - 1] = arguments[g];
        return h = v.reduce((function(e, t) {
            return Zt(e, t)
        }
        ), h)
    }
    function Er(e) {
        var t = e.theme
          , n = e.name
          , r = e.props;
        if (!t || !t.props || !t.props[n])
            return r;
        var i, o = t.props[n];
        for (i in o)
            void 0 === r[i] && (r[i] = o[i]);
        return r
    }
    var kr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e
    }
    : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    }
      , Or = "object" === ("undefined" == typeof window ? "undefined" : kr(window)) && "object" === ("undefined" == typeof document ? "undefined" : kr(document)) && 9 === document.nodeType;
    function Tr(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function Mr(e, t, n) {
        return t && Tr(e.prototype, t),
        n && Tr(e, n),
        e
    }
    function Rr(e, t) {
        e.prototype = Object.create(t.prototype),
        e.prototype.constructor = e,
        e.__proto__ = t
    }
    function Pr(e) {
        if (void 0 === e)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }
    var Ir = {}.constructor;
    function zr(e) {
        if (null == e || "object" != typeof e)
            return e;
        if (Array.isArray(e))
            return e.map(zr);
        if (e.constructor !== Ir)
            return e;
        var t = {};
        for (var n in e)
            t[n] = zr(e[n]);
        return t
    }
    function Ar(e, t, n) {
        void 0 === e && (e = "unnamed");
        var r = n.jss
          , i = zr(t)
          , o = r.plugins.onCreateRule(e, i, n);
        return o || (e[0],
        null)
    }
    var Lr = function(e, t) {
        for (var n = "", r = 0; r < e.length && "!important" !== e[r]; r++)
            n && (n += t),
            n += e[r];
        return n
    };
    function Dr(e, t) {
        if (void 0 === t && (t = !1),
        !Array.isArray(e))
            return e;
        var n = "";
        if (Array.isArray(e[0]))
            for (var r = 0; r < e.length && "!important" !== e[r]; r++)
                n && (n += ", "),
                n += Lr(e[r], " ");
        else
            n = Lr(e, ", ");
        return t || "!important" !== e[e.length - 1] || (n += " !important"),
        n
    }
    function Nr(e, t) {
        for (var n = "", r = 0; r < t; r++)
            n += "  ";
        return n + e
    }
    function Wr(e, t, n) {
        void 0 === n && (n = {});
        var r = "";
        if (!t)
            return r;
        var i = n.indent
          , o = void 0 === i ? 0 : i
          , a = t.fallbacks;
        if (e && o++,
        a)
            if (Array.isArray(a))
                for (var s = 0; s < a.length; s++) {
                    var l = a[s];
                    for (var c in l) {
                        var u = l[c];
                        null != u && (r && (r += "\n"),
                        r += "" + Nr(c + ": " + Dr(u) + ";", o))
                    }
                }
            else
                for (var d in a) {
                    var p = a[d];
                    null != p && (r && (r += "\n"),
                    r += "" + Nr(d + ": " + Dr(p) + ";", o))
                }
        for (var f in t) {
            var h = t[f];
            null != h && "fallbacks" !== f && (r && (r += "\n"),
            r += "" + Nr(f + ": " + Dr(h) + ";", o))
        }
        return (r || n.allowEmpty) && e ? (r && (r = "\n" + r + "\n"),
        Nr(e + " {" + r, --o) + Nr("}", o)) : r
    }
    var Fr = /([[\].#*$><+~=|^:(),"'`\s])/g
      , $r = "undefined" != typeof CSS && CSS.escape
      , Br = function(e) {
        return $r ? $r(e) : e.replace(Fr, "\\$1")
    }
      , jr = function() {
        function e(e, t, n) {
            this.type = "style",
            this.key = void 0,
            this.isProcessed = !1,
            this.style = void 0,
            this.renderer = void 0,
            this.renderable = void 0,
            this.options = void 0;
            var r = n.sheet
              , i = n.Renderer;
            this.key = e,
            this.options = n,
            this.style = t,
            r ? this.renderer = r.renderer : i && (this.renderer = new i)
        }
        return e.prototype.prop = function(e, t, n) {
            if (void 0 === t)
                return this.style[e];
            var r = !!n && n.force;
            if (!r && this.style[e] === t)
                return this;
            var i = t;
            n && !1 === n.process || (i = this.options.jss.plugins.onChangeValue(t, e, this));
            var o = null == i || !1 === i
              , a = e in this.style;
            if (o && !a && !r)
                return this;
            var s = o && a;
            if (s ? delete this.style[e] : this.style[e] = i,
            this.renderable && this.renderer)
                return s ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, i),
                this;
            var l = this.options.sheet;
            return l && l.attached,
            this
        }
        ,
        e
    }()
      , Hr = function(e) {
        function t(t, n, r) {
            var i;
            (i = e.call(this, t, n, r) || this).selectorText = void 0,
            i.id = void 0,
            i.renderable = void 0;
            var o = r.selector
              , a = r.scoped
              , s = r.sheet
              , l = r.generateId;
            return o ? i.selectorText = o : !1 !== a && (i.id = l(Pr(Pr(i)), s),
            i.selectorText = "." + Br(i.id)),
            i
        }
        Rr(t, e);
        var n = t.prototype;
        return n.applyTo = function(e) {
            var t = this.renderer;
            if (t) {
                var n = this.toJSON();
                for (var r in n)
                    t.setProperty(e, r, n[r])
            }
            return this
        }
        ,
        n.toJSON = function() {
            var e = {};
            for (var t in this.style) {
                var n = this.style[t];
                "object" != typeof n ? e[t] = n : Array.isArray(n) && (e[t] = Dr(n))
            }
            return e
        }
        ,
        n.toString = function(e) {
            var t = this.options.sheet
              , n = !!t && t.options.link ? Vt({}, e, {
                allowEmpty: !0
            }) : e;
            return Wr(this.selectorText, this.style, n)
        }
        ,
        Mr(t, [{
            key: "selector",
            set: function(e) {
                if (e !== this.selectorText) {
                    this.selectorText = e;
                    var t = this.renderer
                      , n = this.renderable;
                    if (n && t)
                        t.setSelector(n, e) || t.replaceRule(n, this)
                }
            },
            get: function() {
                return this.selectorText
            }
        }]),
        t
    }(jr)
      , Vr = {
        onCreateRule: function(e, t, n) {
            return "@" === e[0] || n.parent && "keyframes" === n.parent.type ? null : new Hr(e,t,n)
        }
    }
      , qr = {
        indent: 1,
        children: !0
    }
      , Ur = /@([\w-]+)/
      , Gr = function() {
        function e(e, t, n) {
            this.type = "conditional",
            this.at = void 0,
            this.key = void 0,
            this.query = void 0,
            this.rules = void 0,
            this.options = void 0,
            this.isProcessed = !1,
            this.renderable = void 0,
            this.key = e,
            this.query = n.name;
            var r = e.match(Ur);
            for (var i in this.at = r ? r[1] : "unknown",
            this.options = n,
            this.rules = new mi(Vt({}, n, {
                parent: this
            })),
            t)
                this.rules.add(i, t[i]);
            this.rules.process()
        }
        var t = e.prototype;
        return t.getRule = function(e) {
            return this.rules.get(e)
        }
        ,
        t.indexOf = function(e) {
            return this.rules.indexOf(e)
        }
        ,
        t.addRule = function(e, t, n) {
            var r = this.rules.add(e, t, n);
            return r ? (this.options.jss.plugins.onProcessRule(r),
            r) : null
        }
        ,
        t.toString = function(e) {
            if (void 0 === e && (e = qr),
            null == e.indent && (e.indent = qr.indent),
            null == e.children && (e.children = qr.children),
            !1 === e.children)
                return this.query + " {}";
            var t = this.rules.toString(e);
            return t ? this.query + " {\n" + t + "\n}" : ""
        }
        ,
        e
    }()
      , Zr = /@media|@supports\s+/
      , Kr = {
        onCreateRule: function(e, t, n) {
            return Zr.test(e) ? new Gr(e,t,n) : null
        }
    }
      , Yr = {
        indent: 1,
        children: !0
    }
      , Xr = /@keyframes\s+([\w-]+)/
      , Jr = function() {
        function e(e, t, n) {
            this.type = "keyframes",
            this.at = "@keyframes",
            this.key = void 0,
            this.name = void 0,
            this.id = void 0,
            this.rules = void 0,
            this.options = void 0,
            this.isProcessed = !1,
            this.renderable = void 0;
            var r = e.match(Xr);
            r && r[1] ? this.name = r[1] : this.name = "noname",
            this.key = this.type + "-" + this.name,
            this.options = n;
            var i = n.scoped
              , o = n.sheet
              , a = n.generateId;
            for (var s in this.id = !1 === i ? this.name : Br(a(this, o)),
            this.rules = new mi(Vt({}, n, {
                parent: this
            })),
            t)
                this.rules.add(s, t[s], Vt({}, n, {
                    parent: this
                }));
            this.rules.process()
        }
        return e.prototype.toString = function(e) {
            if (void 0 === e && (e = Yr),
            null == e.indent && (e.indent = Yr.indent),
            null == e.children && (e.children = Yr.children),
            !1 === e.children)
                return this.at + " " + this.id + " {}";
            var t = this.rules.toString(e);
            return t && (t = "\n" + t + "\n"),
            this.at + " " + this.id + " {" + t + "}"
        }
        ,
        e
    }()
      , Qr = /@keyframes\s+/
      , ei = /\$([\w-]+)/g
      , ti = function(e, t) {
        return "string" == typeof e ? e.replace(ei, (function(e, n) {
            return n in t ? t[n] : e
        }
        )) : e
    }
      , ni = function(e, t, n) {
        var r = e[t]
          , i = ti(r, n);
        i !== r && (e[t] = i)
    }
      , ri = {
        onCreateRule: function(e, t, n) {
            return "string" == typeof e && Qr.test(e) ? new Jr(e,t,n) : null
        },
        onProcessStyle: function(e, t, n) {
            return "style" === t.type && n ? ("animation-name"in e && ni(e, "animation-name", n.keyframes),
            "animation"in e && ni(e, "animation", n.keyframes),
            e) : e
        },
        onChangeValue: function(e, t, n) {
            var r = n.options.sheet;
            if (!r)
                return e;
            switch (t) {
            case "animation":
            case "animation-name":
                return ti(e, r.keyframes);
            default:
                return e
            }
        }
    }
      , ii = function(e) {
        function t() {
            for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++)
                r[i] = arguments[i];
            return (t = e.call.apply(e, [this].concat(r)) || this).renderable = void 0,
            t
        }
        return Rr(t, e),
        t.prototype.toString = function(e) {
            var t = this.options.sheet
              , n = !!t && t.options.link ? Vt({}, e, {
                allowEmpty: !0
            }) : e;
            return Wr(this.key, this.style, n)
        }
        ,
        t
    }(jr)
      , oi = {
        onCreateRule: function(e, t, n) {
            return n.parent && "keyframes" === n.parent.type ? new ii(e,t,n) : null
        }
    }
      , ai = function() {
        function e(e, t, n) {
            this.type = "font-face",
            this.at = "@font-face",
            this.key = void 0,
            this.style = void 0,
            this.options = void 0,
            this.isProcessed = !1,
            this.renderable = void 0,
            this.key = e,
            this.style = t,
            this.options = n
        }
        return e.prototype.toString = function(e) {
            if (Array.isArray(this.style)) {
                for (var t = "", n = 0; n < this.style.length; n++)
                    t += Wr(this.key, this.style[n]),
                    this.style[n + 1] && (t += "\n");
                return t
            }
            return Wr(this.key, this.style, e)
        }
        ,
        e
    }()
      , si = {
        onCreateRule: function(e, t, n) {
            return "@font-face" === e ? new ai(e,t,n) : null
        }
    }
      , li = function() {
        function e(e, t, n) {
            this.type = "viewport",
            this.at = "@viewport",
            this.key = void 0,
            this.style = void 0,
            this.options = void 0,
            this.isProcessed = !1,
            this.renderable = void 0,
            this.key = e,
            this.style = t,
            this.options = n
        }
        return e.prototype.toString = function(e) {
            return Wr(this.key, this.style, e)
        }
        ,
        e
    }()
      , ci = {
        onCreateRule: function(e, t, n) {
            return "@viewport" === e || "@-ms-viewport" === e ? new li(e,t,n) : null
        }
    }
      , ui = function() {
        function e(e, t, n) {
            this.type = "simple",
            this.key = void 0,
            this.value = void 0,
            this.options = void 0,
            this.isProcessed = !1,
            this.renderable = void 0,
            this.key = e,
            this.value = t,
            this.options = n
        }
        return e.prototype.toString = function(e) {
            if (Array.isArray(this.value)) {
                for (var t = "", n = 0; n < this.value.length; n++)
                    t += this.key + " " + this.value[n] + ";",
                    this.value[n + 1] && (t += "\n");
                return t
            }
            return this.key + " " + this.value + ";"
        }
        ,
        e
    }()
      , di = {
        "@charset": !0,
        "@import": !0,
        "@namespace": !0
    }
      , pi = [Vr, Kr, ri, oi, si, ci, {
        onCreateRule: function(e, t, n) {
            return e in di ? new ui(e,t,n) : null
        }
    }]
      , fi = {
        process: !0
    }
      , hi = {
        force: !0,
        process: !0
    }
      , mi = function() {
        function e(e) {
            this.map = {},
            this.raw = {},
            this.index = [],
            this.counter = 0,
            this.options = void 0,
            this.classes = void 0,
            this.keyframes = void 0,
            this.options = e,
            this.classes = e.classes,
            this.keyframes = e.keyframes
        }
        var t = e.prototype;
        return t.add = function(e, t, n) {
            var r = this.options
              , i = r.parent
              , o = r.sheet
              , a = r.jss
              , s = r.Renderer
              , l = r.generateId
              , c = r.scoped
              , u = Vt({
                classes: this.classes,
                parent: i,
                sheet: o,
                jss: a,
                Renderer: s,
                generateId: l,
                scoped: c,
                name: e
            }, n)
              , d = e;
            e in this.raw && (d = e + "-d" + this.counter++),
            this.raw[d] = t,
            d in this.classes && (u.selector = "." + Br(this.classes[d]));
            var p = Ar(d, t, u);
            if (!p)
                return null;
            this.register(p);
            var f = void 0 === u.index ? this.index.length : u.index;
            return this.index.splice(f, 0, p),
            p
        }
        ,
        t.get = function(e) {
            return this.map[e]
        }
        ,
        t.remove = function(e) {
            this.unregister(e),
            delete this.raw[e.key],
            this.index.splice(this.index.indexOf(e), 1)
        }
        ,
        t.indexOf = function(e) {
            return this.index.indexOf(e)
        }
        ,
        t.process = function() {
            var e = this.options.jss.plugins;
            this.index.slice(0).forEach(e.onProcessRule, e)
        }
        ,
        t.register = function(e) {
            this.map[e.key] = e,
            e instanceof Hr ? (this.map[e.selector] = e,
            e.id && (this.classes[e.key] = e.id)) : e instanceof Jr && this.keyframes && (this.keyframes[e.name] = e.id)
        }
        ,
        t.unregister = function(e) {
            delete this.map[e.key],
            e instanceof Hr ? (delete this.map[e.selector],
            delete this.classes[e.key]) : e instanceof Jr && delete this.keyframes[e.name]
        }
        ,
        t.update = function() {
            var e, t, n;
            if ("string" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (e = arguments.length <= 0 ? void 0 : arguments[0],
            t = arguments.length <= 1 ? void 0 : arguments[1],
            n = arguments.length <= 2 ? void 0 : arguments[2]) : (t = arguments.length <= 0 ? void 0 : arguments[0],
            n = arguments.length <= 1 ? void 0 : arguments[1],
            e = null),
            e)
                this.updateOne(this.map[e], t, n);
            else
                for (var r = 0; r < this.index.length; r++)
                    this.updateOne(this.index[r], t, n)
        }
        ,
        t.updateOne = function(t, n, r) {
            void 0 === r && (r = fi);
            var i = this.options
              , o = i.jss.plugins
              , a = i.sheet;
            if (t.rules instanceof e)
                t.rules.update(n, r);
            else {
                var s = t
                  , l = s.style;
                if (o.onUpdate(n, t, a, r),
                r.process && l && l !== s.style) {
                    for (var c in o.onProcessStyle(s.style, s, a),
                    s.style) {
                        var u = s.style[c];
                        u !== l[c] && s.prop(c, u, hi)
                    }
                    for (var d in l) {
                        var p = s.style[d]
                          , f = l[d];
                        null == p && p !== f && s.prop(d, null, hi)
                    }
                }
            }
        }
        ,
        t.toString = function(e) {
            for (var t = "", n = this.options.sheet, r = !!n && n.options.link, i = 0; i < this.index.length; i++) {
                var o = this.index[i].toString(e);
                (o || r) && (t && (t += "\n"),
                t += o)
            }
            return t
        }
        ,
        e
    }()
      , vi = function() {
        function e(e, t) {
            for (var n in this.options = void 0,
            this.deployed = void 0,
            this.attached = void 0,
            this.rules = void 0,
            this.renderer = void 0,
            this.classes = void 0,
            this.keyframes = void 0,
            this.queue = void 0,
            this.attached = !1,
            this.deployed = !1,
            this.classes = {},
            this.keyframes = {},
            this.options = Vt({}, t, {
                sheet: this,
                parent: this,
                classes: this.classes,
                keyframes: this.keyframes
            }),
            t.Renderer && (this.renderer = new t.Renderer(this)),
            this.rules = new mi(this.options),
            e)
                this.rules.add(n, e[n]);
            this.rules.process()
        }
        var t = e.prototype;
        return t.attach = function() {
            return this.attached || (this.renderer && this.renderer.attach(),
            this.attached = !0,
            this.deployed || this.deploy()),
            this
        }
        ,
        t.detach = function() {
            return this.attached ? (this.renderer && this.renderer.detach(),
            this.attached = !1,
            this) : this
        }
        ,
        t.addRule = function(e, t, n) {
            var r = this.queue;
            this.attached && !r && (this.queue = []);
            var i = this.rules.add(e, t, n);
            return i ? (this.options.jss.plugins.onProcessRule(i),
            this.attached ? this.deployed ? (r ? r.push(i) : (this.insertRule(i),
            this.queue && (this.queue.forEach(this.insertRule, this),
            this.queue = void 0)),
            i) : i : (this.deployed = !1,
            i)) : null
        }
        ,
        t.insertRule = function(e) {
            this.renderer && this.renderer.insertRule(e)
        }
        ,
        t.addRules = function(e, t) {
            var n = [];
            for (var r in e) {
                var i = this.addRule(r, e[r], t);
                i && n.push(i)
            }
            return n
        }
        ,
        t.getRule = function(e) {
            return this.rules.get(e)
        }
        ,
        t.deleteRule = function(e) {
            var t = "object" == typeof e ? e : this.rules.get(e);
            return !!t && (this.rules.remove(t),
            !(this.attached && t.renderable && this.renderer) || this.renderer.deleteRule(t.renderable))
        }
        ,
        t.indexOf = function(e) {
            return this.rules.indexOf(e)
        }
        ,
        t.deploy = function() {
            return this.renderer && this.renderer.deploy(),
            this.deployed = !0,
            this
        }
        ,
        t.update = function() {
            var e;
            return (e = this.rules).update.apply(e, arguments),
            this
        }
        ,
        t.updateOne = function(e, t, n) {
            return this.rules.updateOne(e, t, n),
            this
        }
        ,
        t.toString = function(e) {
            return this.rules.toString(e)
        }
        ,
        e
    }()
      , gi = function() {
        function e() {
            this.plugins = {
                internal: [],
                external: []
            },
            this.registry = void 0
        }
        var t = e.prototype;
        return t.onCreateRule = function(e, t, n) {
            for (var r = 0; r < this.registry.onCreateRule.length; r++) {
                var i = this.registry.onCreateRule[r](e, t, n);
                if (i)
                    return i
            }
            return null
        }
        ,
        t.onProcessRule = function(e) {
            if (!e.isProcessed) {
                for (var t = e.options.sheet, n = 0; n < this.registry.onProcessRule.length; n++)
                    this.registry.onProcessRule[n](e, t);
                e.style && this.onProcessStyle(e.style, e, t),
                e.isProcessed = !0
            }
        }
        ,
        t.onProcessStyle = function(e, t, n) {
            for (var r = 0; r < this.registry.onProcessStyle.length; r++)
                t.style = this.registry.onProcessStyle[r](t.style, t, n)
        }
        ,
        t.onProcessSheet = function(e) {
            for (var t = 0; t < this.registry.onProcessSheet.length; t++)
                this.registry.onProcessSheet[t](e)
        }
        ,
        t.onUpdate = function(e, t, n, r) {
            for (var i = 0; i < this.registry.onUpdate.length; i++)
                this.registry.onUpdate[i](e, t, n, r)
        }
        ,
        t.onChangeValue = function(e, t, n) {
            for (var r = e, i = 0; i < this.registry.onChangeValue.length; i++)
                r = this.registry.onChangeValue[i](r, t, n);
            return r
        }
        ,
        t.use = function(e, t) {
            void 0 === t && (t = {
                queue: "external"
            });
            var n = this.plugins[t.queue];
            -1 === n.indexOf(e) && (n.push(e),
            this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce((function(e, t) {
                for (var n in t)
                    n in e && e[n].push(t[n]);
                return e
            }
            ), {
                onCreateRule: [],
                onProcessRule: [],
                onProcessStyle: [],
                onProcessSheet: [],
                onChangeValue: [],
                onUpdate: []
            }))
        }
        ,
        e
    }()
      , bi = new (function() {
        function e() {
            this.registry = []
        }
        var t = e.prototype;
        return t.add = function(e) {
            var t = this.registry
              , n = e.options.index;
            if (-1 === t.indexOf(e))
                if (0 === t.length || n >= this.index)
                    t.push(e);
                else
                    for (var r = 0; r < t.length; r++)
                        if (t[r].options.index > n)
                            return void t.splice(r, 0, e)
        }
        ,
        t.reset = function() {
            this.registry = []
        }
        ,
        t.remove = function(e) {
            var t = this.registry.indexOf(e);
            this.registry.splice(t, 1)
        }
        ,
        t.toString = function(e) {
            for (var t = void 0 === e ? {} : e, n = t.attached, r = Bt(t, ["attached"]), i = "", o = 0; o < this.registry.length; o++) {
                var a = this.registry[o];
                null != n && a.attached !== n || (i && (i += "\n"),
                i += a.toString(r))
            }
            return i
        }
        ,
        Mr(e, [{
            key: "index",
            get: function() {
                return 0 === this.registry.length ? 0 : this.registry[this.registry.length - 1].options.index
            }
        }]),
        e
    }())
      , yi = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    null == yi["2f1acc6c3a606b082e5eef5e54414ffb"] && (yi["2f1acc6c3a606b082e5eef5e54414ffb"] = 0);
    var wi = yi["2f1acc6c3a606b082e5eef5e54414ffb"]++
      , xi = function(e) {
        void 0 === e && (e = {});
        var t = 0;
        return function(n, r) {
            t += 1;
            var i = ""
              , o = "";
            return r && (r.options.classNamePrefix && (o = r.options.classNamePrefix),
            null != r.options.jss.id && (i = String(r.options.jss.id))),
            e.minify ? "" + (o || "c") + wi + i + t : o + n.key + "-" + wi + (i ? "-" + i : "") + "-" + t
        }
    }
      , _i = function(e) {
        var t;
        return function() {
            return t || (t = e()),
            t
        }
    };
    function Ci(e, t) {
        try {
            return e.attributeStyleMap ? e.attributeStyleMap.get(t) : e.style.getPropertyValue(t)
        } catch (e) {
            return ""
        }
    }
    function Si(e, t, n) {
        try {
            var r = n;
            if (Array.isArray(n) && (r = Dr(n, !0),
            "!important" === n[n.length - 1]))
                return e.style.setProperty(t, r, "important"),
                !0;
            e.attributeStyleMap ? e.attributeStyleMap.set(t, r) : e.style.setProperty(t, r)
        } catch (e) {
            return !1
        }
        return !0
    }
    function Ei(e, t) {
        try {
            e.attributeStyleMap ? e.attributeStyleMap.delete(t) : e.style.removeProperty(t)
        } catch (e) {}
    }
    function ki(e, t) {
        return e.selectorText = t,
        e.selectorText === t
    }
    var Oi = _i((function() {
        return document.querySelector("head")
    }
    ));
    function Ti(e) {
        var t = bi.registry;
        if (t.length > 0) {
            var n = function(e, t) {
                for (var n = 0; n < e.length; n++) {
                    var r = e[n];
                    if (r.attached && r.options.index > t.index && r.options.insertionPoint === t.insertionPoint)
                        return r
                }
                return null
            }(t, e);
            if (n && n.renderer)
                return {
                    parent: n.renderer.element.parentNode,
                    node: n.renderer.element
                };
            if ((n = function(e, t) {
                for (var n = e.length - 1; n >= 0; n--) {
                    var r = e[n];
                    if (r.attached && r.options.insertionPoint === t.insertionPoint)
                        return r
                }
                return null
            }(t, e)) && n.renderer)
                return {
                    parent: n.renderer.element.parentNode,
                    node: n.renderer.element.nextSibling
                }
        }
        var r = e.insertionPoint;
        if (r && "string" == typeof r) {
            var i = function(e) {
                for (var t = Oi(), n = 0; n < t.childNodes.length; n++) {
                    var r = t.childNodes[n];
                    if (8 === r.nodeType && r.nodeValue.trim() === e)
                        return r
                }
                return null
            }(r);
            if (i)
                return {
                    parent: i.parentNode,
                    node: i.nextSibling
                }
        }
        return !1
    }
    var Mi = _i((function() {
        var e = document.querySelector('meta[property="csp-nonce"]');
        return e ? e.getAttribute("content") : null
    }
    ))
      , Ri = function(e, t, n) {
        var r = e.cssRules.length;
        (void 0 === n || n > r) && (n = r);
        try {
            if ("insertRule"in e)
                e.insertRule(t, n);
            else if ("appendRule"in e) {
                e.appendRule(t)
            }
        } catch (e) {
            return !1
        }
        return e.cssRules[n]
    }
      , Pi = function() {
        function e(e) {
            this.getPropertyValue = Ci,
            this.setProperty = Si,
            this.removeProperty = Ei,
            this.setSelector = ki,
            this.element = void 0,
            this.sheet = void 0,
            this.hasInsertedRules = !1,
            e && bi.add(e),
            this.sheet = e;
            var t, n = this.sheet ? this.sheet.options : {}, r = n.media, i = n.meta, o = n.element;
            this.element = o || ((t = document.createElement("style")).textContent = "\n",
            t),
            this.element.setAttribute("data-jss", ""),
            r && this.element.setAttribute("media", r),
            i && this.element.setAttribute("data-meta", i);
            var a = Mi();
            a && this.element.setAttribute("nonce", a)
        }
        var t = e.prototype;
        return t.attach = function() {
            if (!this.element.parentNode && this.sheet) {
                !function(e, t) {
                    var n = t.insertionPoint
                      , r = Ti(t);
                    if (!1 !== r && r.parent)
                        r.parent.insertBefore(e, r.node);
                    else if (n && "number" == typeof n.nodeType) {
                        var i = n
                          , o = i.parentNode;
                        o && o.insertBefore(e, i.nextSibling)
                    } else
                        Oi().appendChild(e)
                }(this.element, this.sheet.options);
                var e = Boolean(this.sheet && this.sheet.deployed);
                this.hasInsertedRules && e && (this.hasInsertedRules = !1,
                this.deploy())
            }
        }
        ,
        t.detach = function() {
            var e = this.element.parentNode;
            e && e.removeChild(this.element)
        }
        ,
        t.deploy = function() {
            var e = this.sheet;
            e && (e.options.link ? this.insertRules(e.rules) : this.element.textContent = "\n" + e.toString() + "\n")
        }
        ,
        t.insertRules = function(e, t) {
            for (var n = 0; n < e.index.length; n++)
                this.insertRule(e.index[n], n, t)
        }
        ,
        t.insertRule = function(e, t, n) {
            if (void 0 === n && (n = this.element.sheet),
            e.rules) {
                var r = e
                  , i = n;
                return ("conditional" !== e.type && "keyframes" !== e.type || !1 !== (i = Ri(n, r.toString({
                    children: !1
                }), t))) && (this.insertRules(r.rules, i),
                i)
            }
            if (e.renderable && e.renderable.parentStyleSheet === this.element.sheet)
                return e.renderable;
            var o = e.toString();
            if (!o)
                return !1;
            var a = Ri(n, o, t);
            return !1 !== a && (this.hasInsertedRules = !0,
            e.renderable = a,
            a)
        }
        ,
        t.deleteRule = function(e) {
            var t = this.element.sheet
              , n = this.indexOf(e);
            return -1 !== n && (t.deleteRule(n),
            !0)
        }
        ,
        t.indexOf = function(e) {
            for (var t = this.element.sheet.cssRules, n = 0; n < t.length; n++)
                if (e === t[n])
                    return n;
            return -1
        }
        ,
        t.replaceRule = function(e, t) {
            var n = this.indexOf(e);
            return -1 !== n && (this.element.sheet.deleteRule(n),
            this.insertRule(t, n))
        }
        ,
        t.getRules = function() {
            return this.element.sheet.cssRules
        }
        ,
        e
    }()
      , Ii = 0
      , zi = function() {
        function e(e) {
            this.id = Ii++,
            this.version = "10.0.4",
            this.plugins = new gi,
            this.options = {
                id: {
                    minify: !1
                },
                createGenerateId: xi,
                Renderer: Or ? Pi : null,
                plugins: []
            },
            this.generateId = xi({
                minify: !1
            });
            for (var t = 0; t < pi.length; t++)
                this.plugins.use(pi[t], {
                    queue: "internal"
                });
            this.setup(e)
        }
        var t = e.prototype;
        return t.setup = function(e) {
            return void 0 === e && (e = {}),
            e.createGenerateId && (this.options.createGenerateId = e.createGenerateId),
            e.id && (this.options.id = Vt({}, this.options.id, e.id)),
            (e.createGenerateId || e.id) && (this.generateId = this.options.createGenerateId(this.options.id)),
            null != e.insertionPoint && (this.options.insertionPoint = e.insertionPoint),
            "Renderer"in e && (this.options.Renderer = e.Renderer),
            e.plugins && this.use.apply(this, e.plugins),
            this
        }
        ,
        t.createStyleSheet = function(e, t) {
            void 0 === t && (t = {});
            var n = t.index;
            "number" != typeof n && (n = 0 === bi.index ? 0 : bi.index + 1);
            var r = new vi(e,Vt({}, t, {
                jss: this,
                generateId: t.generateId || this.generateId,
                insertionPoint: this.options.insertionPoint,
                Renderer: this.options.Renderer,
                index: n
            }));
            return this.plugins.onProcessSheet(r),
            r
        }
        ,
        t.removeStyleSheet = function(e) {
            return e.detach(),
            bi.remove(e),
            this
        }
        ,
        t.createRule = function(e, t, n) {
            if (void 0 === t && (t = {}),
            void 0 === n && (n = {}),
            "object" == typeof e)
                return this.createRule(void 0, e, t);
            var r = Vt({}, n, {
                name: e,
                jss: this,
                Renderer: this.options.Renderer
            });
            r.generateId || (r.generateId = this.generateId),
            r.classes || (r.classes = {}),
            r.keyframes || (r.keyframes = {});
            var i = Ar(e, t, r);
            return i && this.plugins.onProcessRule(i),
            i
        }
        ,
        t.use = function() {
            for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            return n.forEach((function(t) {
                e.plugins.use(t)
            }
            )),
            this
        }
        ,
        e
    }();
    function Ai(e) {
        var t = null;
        for (var n in e) {
            var r = e[n]
              , i = typeof r;
            if ("function" === i)
                t || (t = {}),
                t[n] = r;
            else if ("object" === i && null !== r && !Array.isArray(r)) {
                var o = Ai(r);
                o && (t || (t = {}),
                t[n] = o)
            }
        }
        return t
    }
    var Li = "undefined" != typeof CSS && CSS && "number"in CSS
      , Di = function(e) {
        return new zi(e)
    };
    /**
  * A better abstraction over CSS.
  *
  * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
  * @website https://github.com/cssinjs/jss
  * @license MIT
  */
    Di();
    function Ni() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
          , t = e.baseClasses
          , n = e.newClasses;
        e.Component;
        if (!n)
            return t;
        var r = Vt({}, t);
        return Object.keys(n).forEach((function(e) {
            n[e] && (r[e] = "".concat(t[e], " ").concat(n[e]))
        }
        )),
        r
    }
    var Wi = function(e, t, n, r) {
        var i = e.get(t);
        i || (i = new Map,
        e.set(t, i)),
        i.set(n, r)
    }
      , Fi = function(e, t, n) {
        var r = e.get(t);
        return r ? r.get(n) : void 0
    }
      , $i = function(e, t, n) {
        e.get(t).delete(n)
    }
      , Bi = lt.createContext(null);
    function ji() {
        return lt.useContext(Bi)
    }
    var Hi = "function" == typeof Symbol && Symbol.for ? Symbol.for("mui.nested") : "__THEME_NESTED__"
      , Vi = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
    var qi = Date.now()
      , Ui = "fnValues" + qi
      , Gi = "fnStyle" + ++qi;
    var Zi = "@global"
      , Ki = "@global "
      , Yi = function() {
        function e(e, t, n) {
            for (var r in this.type = "global",
            this.at = Zi,
            this.rules = void 0,
            this.options = void 0,
            this.key = void 0,
            this.isProcessed = !1,
            this.key = e,
            this.options = n,
            this.rules = new mi(Vt({}, n, {
                parent: this
            })),
            t)
                this.rules.add(r, t[r]);
            this.rules.process()
        }
        var t = e.prototype;
        return t.getRule = function(e) {
            return this.rules.get(e)
        }
        ,
        t.addRule = function(e, t, n) {
            var r = this.rules.add(e, t, n);
            return this.options.jss.plugins.onProcessRule(r),
            r
        }
        ,
        t.indexOf = function(e) {
            return this.rules.indexOf(e)
        }
        ,
        t.toString = function() {
            return this.rules.toString()
        }
        ,
        e
    }()
      , Xi = function() {
        function e(e, t, n) {
            this.type = "global",
            this.at = Zi,
            this.options = void 0,
            this.rule = void 0,
            this.isProcessed = !1,
            this.key = void 0,
            this.key = e,
            this.options = n;
            var r = e.substr(Ki.length);
            this.rule = n.jss.createRule(r, t, Vt({}, n, {
                parent: this
            }))
        }
        return e.prototype.toString = function(e) {
            return this.rule ? this.rule.toString(e) : ""
        }
        ,
        e
    }()
      , Ji = /\s*,\s*/g;
    function Qi(e, t) {
        for (var n = e.split(Ji), r = "", i = 0; i < n.length; i++)
            r += t + " " + n[i].trim(),
            n[i + 1] && (r += ", ");
        return r
    }
    function eo() {
        return {
            onCreateRule: function(e, t, n) {
                if (!e)
                    return null;
                if (e === Zi)
                    return new Yi(e,t,n);
                if ("@" === e[0] && e.substr(0, Ki.length) === Ki)
                    return new Xi(e,t,n);
                var r = n.parent;
                return r && ("global" === r.type || r.options.parent && "global" === r.options.parent.type) && (n.scoped = !1),
                !1 === n.scoped && (n.selector = e),
                null
            },
            onProcessRule: function(e) {
                "style" === e.type && (function(e) {
                    var t = e.options
                      , n = e.style
                      , r = n ? n["@global"] : null;
                    if (r) {
                        for (var i in r)
                            t.sheet.addRule(i, r[i], Vt({}, t, {
                                selector: Qi(i, e.selector)
                            }));
                        delete n["@global"]
                    }
                }(e),
                function(e) {
                    var t = e.options
                      , n = e.style;
                    for (var r in n)
                        if ("@" === r[0] && r.substr(0, Zi.length) === Zi) {
                            var i = Qi(r.substr(Zi.length), e.selector);
                            t.sheet.addRule(i, n[r], Vt({}, t, {
                                selector: i
                            })),
                            delete n[r]
                        }
                }(e))
            }
        }
    }
    var to = /\s*,\s*/g
      , no = /&/g
      , ro = /\$([\w-]+)/g;
    function io() {
        function e(e, t) {
            return function(n, r) {
                var i = e.getRule(r) || t && t.getRule(r);
                return i ? (i = i).selector : r
            }
        }
        function t(e, t) {
            for (var n = t.split(to), r = e.split(to), i = "", o = 0; o < n.length; o++)
                for (var a = n[o], s = 0; s < r.length; s++) {
                    var l = r[s];
                    i && (i += ", "),
                    i += -1 !== l.indexOf("&") ? l.replace(no, a) : a + " " + l
                }
            return i
        }
        function n(e, t, n) {
            if (n)
                return Vt({}, n, {
                    index: n.index + 1
                });
            var r = e.options.nestingLevel;
            r = void 0 === r ? 1 : r + 1;
            var i = Vt({}, e.options, {
                nestingLevel: r,
                index: t.indexOf(e) + 1
            });
            return delete i.name,
            i
        }
        return {
            onProcessStyle: function(r, i, o) {
                if ("style" !== i.type)
                    return r;
                var a, s, l = i, c = l.options.parent;
                for (var u in r) {
                    var d = -1 !== u.indexOf("&")
                      , p = "@" === u[0];
                    if (d || p) {
                        if (a = n(l, c, a),
                        d) {
                            var f = t(u, l.selector);
                            s || (s = e(c, o)),
                            f = f.replace(ro, s),
                            c.addRule(f, r[u], Vt({}, a, {
                                selector: f
                            }))
                        } else
                            p && c.addRule(u, {}, a).addRule(l.key, r[u], {
                                selector: l.selector
                            });
                        delete r[u]
                    }
                }
                return r
            }
        }
    }
    var oo = /[A-Z]/g
      , ao = /^ms-/
      , so = {};
    function lo(e) {
        return "-" + e.toLowerCase()
    }
    function co(e) {
        if (so.hasOwnProperty(e))
            return so[e];
        var t = e.replace(oo, lo);
        return so[e] = ao.test(t) ? "-" + t : t
    }
    function uo(e) {
        var t = {};
        for (var n in e) {
            t[0 === n.indexOf("--") ? n : co(n)] = e[n]
        }
        return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(uo) : t.fallbacks = uo(e.fallbacks)),
        t
    }
    var po = Li && CSS ? CSS.px : "px"
      , fo = Li && CSS ? CSS.ms : "ms"
      , ho = Li && CSS ? CSS.percent : "%";
    function mo(e) {
        var t = /(-[a-z])/g
          , n = function(e) {
            return e[1].toUpperCase()
        }
          , r = {};
        for (var i in e)
            r[i] = e[i],
            r[i.replace(t, n)] = e[i];
        return r
    }
    var vo = mo({
        "animation-delay": fo,
        "animation-duration": fo,
        "background-position": po,
        "background-position-x": po,
        "background-position-y": po,
        "background-size": po,
        border: po,
        "border-bottom": po,
        "border-bottom-left-radius": po,
        "border-bottom-right-radius": po,
        "border-bottom-width": po,
        "border-left": po,
        "border-left-width": po,
        "border-radius": po,
        "border-right": po,
        "border-right-width": po,
        "border-top": po,
        "border-top-left-radius": po,
        "border-top-right-radius": po,
        "border-top-width": po,
        "border-width": po,
        margin: po,
        "margin-bottom": po,
        "margin-left": po,
        "margin-right": po,
        "margin-top": po,
        padding: po,
        "padding-bottom": po,
        "padding-left": po,
        "padding-right": po,
        "padding-top": po,
        "mask-position-x": po,
        "mask-position-y": po,
        "mask-size": po,
        height: po,
        width: po,
        "min-height": po,
        "max-height": po,
        "min-width": po,
        "max-width": po,
        bottom: po,
        left: po,
        top: po,
        right: po,
        "box-shadow": po,
        "text-shadow": po,
        "column-gap": po,
        "column-rule": po,
        "column-rule-width": po,
        "column-width": po,
        "font-size": po,
        "font-size-delta": po,
        "letter-spacing": po,
        "text-indent": po,
        "text-stroke": po,
        "text-stroke-width": po,
        "word-spacing": po,
        motion: po,
        "motion-offset": po,
        outline: po,
        "outline-offset": po,
        "outline-width": po,
        perspective: po,
        "perspective-origin-x": ho,
        "perspective-origin-y": ho,
        "transform-origin": ho,
        "transform-origin-x": ho,
        "transform-origin-y": ho,
        "transform-origin-z": ho,
        "transition-delay": fo,
        "transition-duration": fo,
        "vertical-align": po,
        "flex-basis": po,
        "shape-margin": po,
        size: po,
        grid: po,
        "grid-gap": po,
        "grid-row-gap": po,
        "grid-column-gap": po,
        "grid-template-rows": po,
        "grid-template-columns": po,
        "grid-auto-rows": po,
        "grid-auto-columns": po,
        "box-shadow-x": po,
        "box-shadow-y": po,
        "box-shadow-blur": po,
        "box-shadow-spread": po,
        "font-line-height": po,
        "text-shadow-x": po,
        "text-shadow-y": po,
        "text-shadow-blur": po
    });
    function go(e, t, n) {
        if (!t)
            return t;
        if (Array.isArray(t))
            for (var r = 0; r < t.length; r++)
                t[r] = go(e, t[r], n);
        else if ("object" == typeof t)
            if ("fallbacks" === e)
                for (var i in t)
                    t[i] = go(i, t[i], n);
            else
                for (var o in t)
                    t[o] = go(e + "-" + o, t[o], n);
        else if ("number" == typeof t)
            return n[e] ? "" + t + n[e] : vo[e] ? "function" == typeof vo[e] ? vo[e](t).toString() : "" + t + vo[e] : t.toString();
        return t
    }
    function bo(e) {
        void 0 === e && (e = {});
        var t = mo(e);
        return {
            onProcessStyle: function(e, n) {
                if ("style" !== n.type)
                    return e;
                for (var r in e)
                    e[r] = go(r, e[r], t);
                return e
            },
            onChangeValue: function(e, n) {
                return go(n, e, t)
            }
        }
    }
    function yo(e) {
        return function(e) {
            if (Array.isArray(e)) {
                for (var t = 0, n = new Array(e.length); t < e.length; t++)
                    n[t] = e[t];
                return n
            }
        }(e) || function(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))
                return Array.from(e)
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance")
        }()
    }
    var wo = ""
      , xo = ""
      , _o = ""
      , Co = Or && "ontouchstart"in document.documentElement;
    if (Or) {
        var So = {
            Moz: "-moz-",
            ms: "-ms-",
            O: "-o-",
            Webkit: "-webkit-"
        }
          , Eo = document.createElement("p").style;
        for (var ko in So)
            if (ko + "Transform"in Eo) {
                wo = ko,
                xo = So[ko];
                break
            }
        "Webkit" === wo && "msHyphens"in Eo && (wo = "ms",
        xo = So.ms,
        "edge"),
        "Webkit" === wo && "-apple-trailing-word"in Eo && (_o = "apple")
    }
    var Oo = wo
      , To = xo
      , Mo = _o
      , Ro = Co;
    var Po = {
        noPrefill: ["appearance"],
        supportedProperty: function(e) {
            return "appearance" === e && ("ms" === Oo ? "-webkit-" + e : To + e)
        }
    }
      , Io = {
        noPrefill: ["color-adjust"],
        supportedProperty: function(e) {
            return "color-adjust" === e && ("Webkit" === Oo ? To + "print-" + e : e)
        }
    }
      , zo = /[-\s]+(.)?/g;
    function Ao(e, t) {
        return t ? t.toUpperCase() : ""
    }
    function Lo(e) {
        return e.replace(zo, Ao)
    }
    function Do(e) {
        return Lo("-" + e)
    }
    var No, Wo = {
        noPrefill: ["mask"],
        supportedProperty: function(e, t) {
            if (!/^mask/.test(e))
                return !1;
            if ("Webkit" === Oo) {
                var n = "mask-image";
                if (Lo(n)in t)
                    return e;
                if (Oo + Do(n)in t)
                    return To + e
            }
            return e
        }
    }, Fo = {
        noPrefill: ["text-orientation"],
        supportedProperty: function(e) {
            return "text-orientation" === e && ("apple" !== Mo || Ro ? e : To + e)
        }
    }, $o = {
        noPrefill: ["transform"],
        supportedProperty: function(e, t, n) {
            return "transform" === e && (n.transform ? e : To + e)
        }
    }, Bo = {
        noPrefill: ["transition"],
        supportedProperty: function(e, t, n) {
            return "transition" === e && (n.transition ? e : To + e)
        }
    }, jo = {
        noPrefill: ["writing-mode"],
        supportedProperty: function(e) {
            return "writing-mode" === e && ("Webkit" === Oo || "ms" === Oo ? To + e : e)
        }
    }, Ho = {
        noPrefill: ["user-select"],
        supportedProperty: function(e) {
            return "user-select" === e && ("Moz" === Oo || "ms" === Oo || "apple" === Mo ? To + e : e)
        }
    }, Vo = {
        supportedProperty: function(e, t) {
            return !!/^break-/.test(e) && ("Webkit" === Oo ? "WebkitColumn" + Do(e)in t && To + "column-" + e : "Moz" === Oo && ("page" + Do(e)in t && "page-" + e))
        }
    }, qo = {
        supportedProperty: function(e, t) {
            if (!/^(border|margin|padding)-inline/.test(e))
                return !1;
            if ("Moz" === Oo)
                return e;
            var n = e.replace("-inline", "");
            return Oo + Do(n)in t && To + n
        }
    }, Uo = {
        supportedProperty: function(e, t) {
            return Lo(e)in t && e
        }
    }, Go = {
        supportedProperty: function(e, t) {
            var n = Do(e);
            return "-" === e[0] || "-" === e[0] && "-" === e[1] ? e : Oo + n in t ? To + e : "Webkit" !== Oo && "Webkit" + n in t && "-webkit-" + e
        }
    }, Zo = {
        supportedProperty: function(e) {
            return "scroll-snap" === e.substring(0, 11) && ("ms" === Oo ? "" + To + e : e)
        }
    }, Ko = {
        supportedProperty: function(e) {
            return "overscroll-behavior" === e && ("ms" === Oo ? To + "scroll-chaining" : e)
        }
    }, Yo = {
        "flex-grow": "flex-positive",
        "flex-shrink": "flex-negative",
        "flex-basis": "flex-preferred-size",
        "justify-content": "flex-pack",
        order: "flex-order",
        "align-items": "flex-align",
        "align-content": "flex-line-pack"
    }, Xo = {
        supportedProperty: function(e, t) {
            var n = Yo[e];
            return !!n && (Oo + Do(n)in t && To + n)
        }
    }, Jo = {
        flex: "box-flex",
        "flex-grow": "box-flex",
        "flex-direction": ["box-orient", "box-direction"],
        order: "box-ordinal-group",
        "align-items": "box-align",
        "flex-flow": ["box-orient", "box-direction"],
        "justify-content": "box-pack"
    }, Qo = Object.keys(Jo), ea = function(e) {
        return To + e
    }, ta = [Po, Io, Wo, Fo, $o, Bo, jo, Ho, Vo, qo, Uo, Go, Zo, Ko, Xo, {
        supportedProperty: function(e, t, n) {
            var r = n.multiple;
            if (Qo.indexOf(e) > -1) {
                var i = Jo[e];
                if (!Array.isArray(i))
                    return Oo + Do(i)in t && To + i;
                if (!r)
                    return !1;
                for (var o = 0; o < i.length; o++)
                    if (!(Oo + Do(i[0])in t))
                        return !1;
                return i.map(ea)
            }
            return !1
        }
    }], na = ta.filter((function(e) {
        return e.supportedProperty
    }
    )).map((function(e) {
        return e.supportedProperty
    }
    )), ra = ta.filter((function(e) {
        return e.noPrefill
    }
    )).reduce((function(e, t) {
        return e.push.apply(e, yo(t.noPrefill)),
        e
    }
    ), []), ia = {};
    if (Or) {
        No = document.createElement("p");
        var oa = window.getComputedStyle(document.documentElement, "");
        for (var aa in oa)
            isNaN(aa) || (ia[oa[aa]] = oa[aa]);
        ra.forEach((function(e) {
            return delete ia[e]
        }
        ))
    }
    function sa(e, t) {
        if (void 0 === t && (t = {}),
        !No)
            return e;
        if (null != ia[e])
            return ia[e];
        "transition" !== e && "transform" !== e || (t[e] = e in No.style);
        for (var n = 0; n < na.length && (ia[e] = na[n](e, No.style, t),
        !ia[e]); n++)
            ;
        try {
            No.style[e] = ""
        } catch (e) {
            return !1
        }
        return ia[e]
    }
    var la, ca = {}, ua = {
        transition: 1,
        "transition-property": 1,
        "-webkit-transition": 1,
        "-webkit-transition-property": 1
    }, da = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
    function pa(e, t, n) {
        if ("var" === t)
            return "var";
        if ("all" === t)
            return "all";
        if ("all" === n)
            return ", all";
        var r = t ? sa(t) : ", " + sa(n);
        return r || (t || n)
    }
    function fa(e, t) {
        var n = t;
        if (!la || "content" === e)
            return t;
        if ("string" != typeof n || !isNaN(parseInt(n, 10)))
            return n;
        var r = e + n;
        if (null != ca[r])
            return ca[r];
        try {
            la.style[e] = n
        } catch (e) {
            return ca[r] = !1,
            !1
        }
        if (ua[e])
            n = n.replace(da, pa);
        else if ("" === la.style[e] && ("-ms-flex" === (n = To + n) && (la.style[e] = "-ms-flexbox"),
        la.style[e] = n,
        "" === la.style[e]))
            return ca[r] = !1,
            !1;
        return la.style[e] = "",
        ca[r] = n,
        ca[r]
    }
    function ha() {
        function e(t) {
            for (var n in t) {
                var r = t[n];
                if ("fallbacks" === n && Array.isArray(r))
                    t[n] = r.map(e);
                else {
                    var i = !1
                      , o = sa(n);
                    o && o !== n && (i = !0);
                    var a = !1
                      , s = fa(o, Dr(r));
                    s && s !== r && (a = !0),
                    (i || a) && (i && delete t[n],
                    t[o || n] = s || r)
                }
            }
            return t
        }
        return {
            onProcessRule: function(e) {
                if ("keyframes" === e.type) {
                    var t = e;
                    t.at = "-" === (n = t.at)[1] || "ms" === Oo ? n : "@" + To + "keyframes" + n.substr(10)
                }
                var n
            },
            onProcessStyle: function(t, n) {
                return "style" !== n.type ? t : e(t)
            },
            onChangeValue: function(e, t) {
                return fa(t, Dr(e)) || e
            }
        }
    }
    function ma() {
        return {
            plugins: [{
                onCreateRule: function(e, t, n) {
                    if ("function" != typeof t)
                        return null;
                    var r = Ar(e, {}, n);
                    return r[Gi] = t,
                    r
                },
                onProcessStyle: function(e, t) {
                    if (Ui in t || Gi in t)
                        return e;
                    var n = {};
                    for (var r in e) {
                        var i = e[r];
                        "function" == typeof i && (delete e[r],
                        n[r] = i)
                    }
                    return t[Ui] = n,
                    e
                },
                onUpdate: function(e, t, n, r) {
                    var i = t
                      , o = i[Gi];
                    o && (i.style = o(e) || {});
                    var a = i[Ui];
                    if (a)
                        for (var s in a)
                            i.prop(s, a[s](e), r)
                }
            }, eo(), io(), {
                onProcessStyle: function(e) {
                    if (Array.isArray(e)) {
                        for (var t = 0; t < e.length; t++)
                            e[t] = uo(e[t]);
                        return e
                    }
                    return uo(e)
                },
                onChangeValue: function(e, t, n) {
                    if (0 === t.indexOf("--"))
                        return e;
                    var r = co(t);
                    return t === r ? e : (n.prop(r, e),
                    null)
                }
            }, bo(), "undefined" == typeof window ? null : ha(), (e = function(e, t) {
                return e.length === t.length ? e > t ? 1 : -1 : e.length - t.length
            }
            ,
            {
                onProcessStyle: function(t, n) {
                    if ("style" !== n.type)
                        return t;
                    for (var r = {}, i = Object.keys(t).sort(e), o = 0; o < i.length; o++)
                        r[i[o]] = t[i[o]];
                    return r
                }
            })]
        };
        var e
    }
    Or && (la = document.createElement("p"));
    var va = Di(ma())
      , ga = {
        disableGeneration: !1,
        generateClassName: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
              , t = e.disableGlobal
              , n = void 0 !== t && t
              , r = e.productionPrefix
              , i = void 0 === r ? "pwzrjss" : r
              , o = e.seed
              , a = void 0 === o ? "" : o
              , s = "" === a ? "" : "".concat(a, "-")
              , l = 0;
            return function(e, t) {
                l += 1;
                var r = t.options.name;
                if (r && 0 === r.indexOf("Pwzr") && !t.options.link && !n) {
                    if (-1 !== Vi.indexOf(e.key))
                        return "Pwzr-".concat(e.key);
                    var o = "".concat(s).concat(r, "-").concat(e.key);
                    return t.options.theme[Hi] && "" === a ? "".concat(o, "-").concat(l) : o
                }
                return "".concat(s).concat(i).concat(l)
            }
        }(),
        jss: va,
        sheetsCache: null,
        sheetsManager: new Map,
        sheetsRegistry: null
    }
      , ba = lt.createContext(ga);
    r({}, "StylesContext", (function() {
        return ba
    }
    ));
    var ya = -1e9;
    function wa() {
        return ya += 1
    }
    var xa = {};
    function _a(e) {
        var t = "function" == typeof e;
        return {
            create: function(n, r) {
                var i;
                try {
                    i = t ? e(n) : e
                } catch (e) {
                    throw e
                }
                if (!r || !n.overrides || !n.overrides[r])
                    return i;
                var o = n.overrides[r]
                  , a = Vt({}, i);
                return Object.keys(o).forEach((function(e) {
                    a[e] = Zt(a[e], o[e])
                }
                )),
                a
            },
            options: {}
        }
    }
    function Ca(e, t, n) {
        var r = e.state;
        if (e.stylesOptions.disableGeneration)
            return t || {};
        r.cacheClasses || (r.cacheClasses = {
            value: null,
            lastProp: null,
            lastJSS: {}
        });
        var i = !1;
        return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes,
        i = !0),
        t !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = t,
        i = !0),
        i && (r.cacheClasses.value = Ni({
            baseClasses: r.cacheClasses.lastJSS,
            newClasses: t,
            Component: n
        })),
        r.cacheClasses.value
    }
    function Sa(e, t) {
        var n = e.state
          , r = e.theme
          , i = e.stylesOptions
          , o = e.stylesCreator
          , a = e.name;
        if (!i.disableGeneration) {
            var s = Fi(i.sheetsManager, o, r);
            s || (s = {
                refs: 0,
                staticSheet: null,
                dynamicStyles: null
            },
            Wi(i.sheetsManager, o, r, s));
            var l = Vt({}, o.options, {}, i, {
                theme: r,
                flip: "boolean" == typeof i.flip ? i.flip : "rtl" === r.direction
            });
            l.generateId = l.serverGenerateClassName || l.generateClassName;
            var c = i.sheetsRegistry;
            if (0 === s.refs) {
                var u;
                i.sheetsCache && (u = Fi(i.sheetsCache, o, r));
                var d = o.create(r, a);
                u || ((u = i.jss.createStyleSheet(d, Vt({
                    link: !1
                }, l))).attach(),
                i.sheetsCache && Wi(i.sheetsCache, o, r, u)),
                c && c.add(u),
                s.staticSheet = u,
                s.dynamicStyles = Ai(d)
            }
            if (s.dynamicStyles) {
                var p = i.jss.createStyleSheet(s.dynamicStyles, Vt({
                    link: !0
                }, l));
                p.update(t),
                p.attach(),
                n.dynamicSheet = p,
                n.classes = Ni({
                    baseClasses: s.staticSheet.classes,
                    newClasses: p.classes
                }),
                c && c.add(p)
            } else
                n.classes = s.staticSheet.classes;
            s.refs += 1
        }
    }
    function Ea(e, t) {
        var n = e.state;
        n.dynamicSheet && n.dynamicSheet.update(t)
    }
    function ka(e) {
        var t = e.state
          , n = e.theme
          , r = e.stylesOptions
          , i = e.stylesCreator;
        if (!r.disableGeneration) {
            var o = Fi(r.sheetsManager, i, n);
            o.refs -= 1;
            var a = r.sheetsRegistry;
            0 === o.refs && ($i(r.sheetsManager, i, n),
            r.jss.removeStyleSheet(o.staticSheet),
            a && a.remove(o.staticSheet)),
            t.dynamicSheet && (r.jss.removeStyleSheet(t.dynamicSheet),
            a && a.remove(t.dynamicSheet))
        }
    }
    function Oa(e, t) {
        var n, r = lt.useRef([]), i = lt.useMemo((function() {
            return {}
        }
        ), t);
        r.current !== i && (r.current = i,
        n = e()),
        lt.useEffect((function() {
            return function() {
                n && n()
            }
        }
        ), [i])
    }
    function Ta(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
          , n = t.name
          , r = t.classNamePrefix
          , i = t.Component
          , o = t.defaultTheme
          , a = void 0 === o ? xa : o
          , s = jt(t, ["name", "classNamePrefix", "Component", "defaultTheme"])
          , l = _a(e)
          , c = n || r || "makeStyles";
        return l.options = {
            index: wa(),
            name: n,
            meta: c,
            classNamePrefix: c
        },
        function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
              , t = ji() || a
              , r = Vt({}, lt.useContext(ba), {}, s)
              , o = lt.useRef()
              , c = lt.useRef();
            return Oa((function() {
                var i = {
                    name: n,
                    state: {},
                    stylesCreator: l,
                    stylesOptions: r,
                    theme: t
                };
                return Sa(i, e),
                c.current = !1,
                o.current = i,
                function() {
                    ka(i)
                }
            }
            ), [t, l]),
            lt.useEffect((function() {
                c.current && Ea(o.current, e),
                c.current = !0
            }
            )),
            Ca(o.current, e.classes, i)
        }
    }
    function Ma(e) {
        var t, n, r = "";
        if (e)
            if ("object" == typeof e)
                if (e.push)
                    for (t = 0; t < e.length; t++)
                        e[t] && (n = Ma(e[t])) && (r && (r += " "),
                        r += n);
                else
                    for (t in e)
                        e[t] && (n = Ma(t)) && (r && (r += " "),
                        r += n);
            else
                "boolean" == typeof e || e.call || (r && (r += " "),
                r += e);
        return r
    }
    var Ra = function() {
        for (var e, t = 0, n = ""; t < arguments.length; )
            (e = Ma(arguments[t++])) && (n && (n += " "),
            n += e);
        return n
    }
      , Pa = {
        childContextTypes: !0,
        contextType: !0,
        contextTypes: !0,
        defaultProps: !0,
        displayName: !0,
        getDefaultProps: !0,
        getDerivedStateFromError: !0,
        getDerivedStateFromProps: !0,
        mixins: !0,
        propTypes: !0,
        type: !0
    }
      , Ia = {
        name: !0,
        length: !0,
        prototype: !0,
        caller: !0,
        callee: !0,
        arguments: !0,
        arity: !0
    }
      , za = {
        $$typeof: !0,
        compare: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0,
        type: !0
    }
      , Aa = {};
    function La(e) {
        return rr.isMemo(e) ? za : Aa[e.$$typeof] || Pa
    }
    Aa[rr.ForwardRef] = {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
    },
    Aa[rr.Memo] = za;
    var Da = Object.defineProperty
      , Na = Object.getOwnPropertyNames
      , Wa = Object.getOwnPropertySymbols
      , Fa = Object.getOwnPropertyDescriptor
      , $a = Object.getPrototypeOf
      , Ba = Object.prototype;
    var ja = t((function e(t, n, r) {
        if ("string" != typeof n) {
            if (Ba) {
                var i = $a(n);
                i && i !== Ba && e(t, i, r)
            }
            var o = Na(n);
            Wa && (o = o.concat(Wa(n)));
            for (var a = La(t), s = La(n), l = 0; l < o.length; ++l) {
                var c = o[l];
                if (!(Ia[c] || r && r[c] || s && s[c] || a && a[c])) {
                    var u = Fa(n, c);
                    try {
                        Da(t, c, u)
                    } catch (e) {}
                }
            }
        }
        return t
    }
    ));
    function Ha(e, t) {
        var n = {};
        return Object.keys(e).forEach((function(r) {
            -1 === t.indexOf(r) && (n[r] = e[r])
        }
        )),
        n
    }
    function Va(e) {
        var t = e.children
          , n = e.theme
          , r = ji();
        var i = lt.useMemo((function() {
            var e = null === r ? n : function(e, t) {
                if ("function" == typeof t) {
                    return t(e)
                }
                return Vt({}, e, {}, t)
            }(r, n);
            return null != e && (e[Hi] = null !== r),
            e
        }
        ), [n, r]);
        return lt.createElement(Bi.Provider, {
            value: i
        }, t)
    }
    var qa = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return function(n) {
            var r = t.defaultTheme
              , i = t.withTheme
              , o = void 0 !== i && i
              , a = t.name
              , s = jt(t, ["defaultTheme", "withTheme", "name"]);
            var l = a
              , c = Ta(e, Vt({
                defaultTheme: r,
                Component: n,
                name: a || n.displayName,
                classNamePrefix: l
            }, s))
              , u = lt.forwardRef((function(e, t) {
                e.classes;
                var i, s = e.innerRef, l = jt(e, ["classes", "innerRef"]), u = c(e), d = l;
                return ("string" == typeof a || o) && (i = ji() || r,
                a && (d = Er({
                    theme: i,
                    name: a,
                    props: l
                })),
                o && !d.theme && (d.theme = i)),
                lt.createElement(n, Vt({
                    ref: s || t,
                    classes: u
                }, d))
            }
            ));
            return u.defaultProps = n.defaultProps,
            ja(u, n),
            u
        }
    }
      , Ua = Sr();
    function Ga(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Ta(e, Vt({
            defaultTheme: Ua
        }, t))
    }
    function Za() {
        return ji() || Ua
    }
    function Ka(e, t) {
        return qa(e, Vt({
            defaultTheme: Ua
        }, t))
    }
    function Ya(e, t) {
        return t ? Zt(e, t, {
            clone: !1
        }) : e
    }
    var Xa = {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    }
      , Ja = {
        keys: ["xs", "sm", "md", "lg", "xl"],
        up: function(e) {
            return "@media (min-width:".concat(Xa[e], "px)")
        }
    };
    function Qa(e, t, n) {
        if (Array.isArray(t)) {
            var r = e.theme.breakpoints || Ja;
            return t.reduce((function(e, i, o) {
                return e[r.up(r.keys[o])] = n(t[o]),
                e
            }
            ), {})
        }
        if ("object" === Ut(t)) {
            var i = e.theme.breakpoints || Ja;
            return Object.keys(t).reduce((function(e, r) {
                return e[i.up(r)] = n(t[r]),
                e
            }
            ), {})
        }
        return n(t)
    }
    function es(e, t) {
        return t && "string" == typeof t ? t.split(".").reduce((function(e, t) {
            return e && e[t] ? e[t] : null
        }
        ), e) : null
    }
    function ts(e) {
        var t = e.prop
          , n = e.cssProperty
          , r = void 0 === n ? e.prop : n
          , i = e.themeKey
          , o = e.transform
          , a = function(e) {
            if (null == e[t])
                return null;
            var n = e[t]
              , a = es(e.theme, i) || {};
            return Qa(e, n, (function(e) {
                var t;
                return "function" == typeof a ? t = a(e) : Array.isArray(a) ? t = a[e] || e : (t = es(a, e) || e,
                o && (t = o(t))),
                !1 === r ? t : $t({}, r, t)
            }
            ))
        };
        return a.propTypes = {},
        a.filterProps = [t],
        a
    }
    function ns() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
        var r = function(e) {
            return t.reduce((function(t, n) {
                var r = n(e);
                return r ? Ya(t, r) : t
            }
            ), {})
        };
        return r.propTypes = {},
        r.filterProps = t.reduce((function(e, t) {
            return e.concat(t.filterProps)
        }
        ), []),
        r
    }
    function rs(e) {
        return "number" != typeof e ? e : "".concat(e, "px solid")
    }
    var is = ns(ts({
        prop: "border",
        themeKey: "borders",
        transform: rs
    }), ts({
        prop: "borderTop",
        themeKey: "borders",
        transform: rs
    }), ts({
        prop: "borderRight",
        themeKey: "borders",
        transform: rs
    }), ts({
        prop: "borderBottom",
        themeKey: "borders",
        transform: rs
    }), ts({
        prop: "borderLeft",
        themeKey: "borders",
        transform: rs
    }), ts({
        prop: "borderColor",
        themeKey: "palette"
    }), ts({
        prop: "borderRadius",
        themeKey: "shape"
    }));
    var os = ns(ts({
        prop: "displayPrint",
        cssProperty: !1,
        transform: function(e) {
            return {
                "@media print": {
                    display: e
                }
            }
        }
    }), ts({
        prop: "display"
    }), ts({
        prop: "overflow"
    }), ts({
        prop: "textOverflow"
    }), ts({
        prop: "visibility"
    }), ts({
        prop: "whiteSpace"
    }))
      , as = ns(ts({
        prop: "flexBasis"
    }), ts({
        prop: "flexDirection"
    }), ts({
        prop: "flexWrap"
    }), ts({
        prop: "justifyContent"
    }), ts({
        prop: "alignItems"
    }), ts({
        prop: "alignContent"
    }), ts({
        prop: "order"
    }), ts({
        prop: "flex"
    }), ts({
        prop: "flexGrow"
    }), ts({
        prop: "flexShrink"
    }), ts({
        prop: "alignSelf"
    }), ts({
        prop: "justifyItems"
    }), ts({
        prop: "justifySelf"
    }))
      , ss = ns(ts({
        prop: "gridGap"
    }), ts({
        prop: "gridColumnGap"
    }), ts({
        prop: "gridRowGap"
    }), ts({
        prop: "gridColumn"
    }), ts({
        prop: "gridRow"
    }), ts({
        prop: "gridAutoFlow"
    }), ts({
        prop: "gridAutoColumns"
    }), ts({
        prop: "gridAutoRows"
    }), ts({
        prop: "gridTemplateColumns"
    }), ts({
        prop: "gridTemplateRows"
    }), ts({
        prop: "gridTemplateAreas"
    }), ts({
        prop: "gridArea"
    }))
      , ls = ns(ts({
        prop: "color",
        themeKey: "palette"
    }), ts({
        prop: "bgcolor",
        cssProperty: "backgroundColor",
        themeKey: "palette"
    }))
      , cs = ns(ts({
        prop: "position"
    }), ts({
        prop: "zIndex",
        themeKey: "zIndex"
    }), ts({
        prop: "top"
    }), ts({
        prop: "right"
    }), ts({
        prop: "bottom"
    }), ts({
        prop: "left"
    }))
      , us = ts({
        prop: "boxShadow",
        themeKey: "shadows"
    });
    function ds(e) {
        return e <= 1 ? "".concat(100 * e, "%") : e
    }
    var ps = ts({
        prop: "width",
        transform: ds
    })
      , fs = ts({
        prop: "maxWidth",
        transform: ds
    })
      , hs = ts({
        prop: "minWidth",
        transform: ds
    })
      , ms = ts({
        prop: "height",
        transform: ds
    })
      , vs = ts({
        prop: "maxHeight",
        transform: ds
    })
      , gs = ts({
        prop: "minHeight",
        transform: ds
    })
      , bs = (ts({
        prop: "size",
        cssProperty: "width",
        transform: ds
    }),
    ts({
        prop: "size",
        cssProperty: "height",
        transform: ds
    }),
    ns(ps, fs, hs, ms, vs, gs, ts({
        prop: "boxSizing"
    })));
    function ys(e, t) {
        return function(e) {
            if (Array.isArray(e))
                return e
        }(e) || function(e, t) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
                var n = []
                  , r = !0
                  , i = !1
                  , o = void 0;
                try {
                    for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value),
                    !t || n.length !== t); r = !0)
                        ;
                } catch (e) {
                    i = !0,
                    o = e
                } finally {
                    try {
                        r || null == s.return || s.return()
                    } finally {
                        if (i)
                            throw o
                    }
                }
                return n
            }
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance")
        }()
    }
    var ws, xs, _s = {
        m: "margin",
        p: "padding"
    }, Cs = {
        t: "Top",
        r: "Right",
        b: "Bottom",
        l: "Left",
        x: ["Left", "Right"],
        y: ["Top", "Bottom"]
    }, Ss = {
        marginX: "mx",
        marginY: "my",
        paddingX: "px",
        paddingY: "py"
    }, Es = (ws = function(e) {
        if (e.length > 2) {
            if (!Ss[e])
                return [e];
            e = Ss[e]
        }
        var t = ys(e.split(""), 2)
          , n = t[0]
          , r = t[1]
          , i = _s[n]
          , o = Cs[r] || "";
        return Array.isArray(o) ? o.map((function(e) {
            return i + e
        }
        )) : [i + o]
    }
    ,
    xs = {},
    function(e) {
        return void 0 === xs[e] && (xs[e] = ws(e)),
        xs[e]
    }
    ), ks = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
    function Os(e, t) {
        return function(n) {
            return e.reduce((function(e, r) {
                return e[r] = function(e, t) {
                    if ("string" == typeof t)
                        return t;
                    var n = e(Math.abs(t));
                    return t >= 0 ? n : "number" == typeof n ? -n : "-".concat(n)
                }(t, n),
                e
            }
            ), {})
        }
    }
    function Ts(e) {
        var t = function(e) {
            var t = e.spacing || 8;
            return "number" == typeof t ? function(e) {
                return t * e
            }
            : Array.isArray(t) ? function(e) {
                return t[e]
            }
            : "function" == typeof t ? t : function() {}
        }(e.theme);
        return Object.keys(e).map((function(n) {
            if (-1 === ks.indexOf(n))
                return null;
            var r = Os(Es(n), t)
              , i = e[n];
            return Qa(e, i, r)
        }
        )).reduce(Ya, {})
    }
    Ts.propTypes = {},
    Ts.filterProps = ks;
    var Ms, Rs, Ps, Is = ns(ts({
        prop: "fontFamily",
        themeKey: "typography"
    }), ts({
        prop: "fontSize",
        themeKey: "typography"
    }), ts({
        prop: "fontStyle",
        themeKey: "typography"
    }), ts({
        prop: "fontWeight",
        themeKey: "typography"
    }), ts({
        prop: "letterSpacing"
    }), ts({
        prop: "lineHeight"
    }), ts({
        prop: "textAlign"
    })), zs = (Ms = ns(is, os, as, ss, cs, ls, us, bs, Ts, Is),
    (Rs = function(e) {
        var t = Ms(e);
        return e.css ? Vt({}, Ya(t, Ms(Vt({
            theme: e.theme
        }, e.css))), {}, function(e, t) {
            var n = {};
            return Object.keys(e).forEach((function(r) {
                -1 === t.indexOf(r) && (n[r] = e[r])
            }
            )),
            n
        }(e.css, [Ms.filterProps])) : t
    }
    ).propTypes = {},
    Rs.filterProps = ["css"].concat(yo(Ms.filterProps)),
    Rs), As = (Ps = function(e) {
        return function(t) {
            var n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = r.name, o = jt(r, ["name"]), a = i, s = Ta("function" == typeof t ? function(e) {
                return {
                    root: function(n) {
                        return t(Vt({
                            theme: e
                        }, n))
                    }
                }
            }
            : {
                root: t
            }, Vt({
                Component: e,
                name: i || e.displayName,
                classNamePrefix: a
            }, o));
            t.filterProps && (n = t.filterProps,
            delete t.filterProps),
            t.propTypes && (t.propTypes,
            delete t.propTypes);
            var l = lt.forwardRef((function(t, r) {
                var i = t.children
                  , o = t.className
                  , a = t.clone
                  , l = t.component
                  , c = jt(t, ["children", "className", "clone", "component"])
                  , u = s(t)
                  , d = Ra(u.root, o)
                  , p = c;
                if (n && (p = Ha(p, n)),
                a)
                    return lt.cloneElement(i, Vt({
                        className: Ra(i.props.className, d)
                    }, p));
                if ("function" == typeof i)
                    return i(Vt({
                        className: d
                    }, p));
                var f = l || e;
                return lt.createElement(f, Vt({
                    ref: r,
                    className: d
                }, p), i)
            }
            ));
            return ja(l, e),
            l
        }
    }("div"),
    function(e, t) {
        return Ps(e, Vt({
            defaultTheme: Ua
        }, t))
    }
    )(zs, {
        name: "PwzrBox"
    });
    function Ls(e, t) {
        "function" == typeof e ? e(t) : e && (e.current = t)
    }
    function Ds(e, t) {
        return lt.useMemo((function() {
            return null == e && null == t ? null : function(n) {
                Ls(e, n),
                Ls(t, n)
            }
        }
        ), [e, t])
    }
    var Ns = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect;
    function Ws(e) {
        var t = lt.useRef(e);
        return Ns((function() {
            t.current = e
        }
        )),
        lt.useCallback((function() {
            return t.current.apply(void 0, arguments)
        }
        ), [])
    }
    var Fs = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect;
    function $s(e) {
        var t = e.children
          , n = e.defer
          , r = void 0 !== n && n
          , i = e.fallback
          , o = void 0 === i ? null : i
          , a = lt.useState(!1)
          , s = a[0]
          , l = a[1];
        return Fs((function() {
            r || l(!0)
        }
        ), [r]),
        lt.useEffect((function() {
            r && l(!0)
        }
        ), [r]),
        lt.createElement(lt.Fragment, null, s ? t : o)
    }
    var Bs = !0
      , js = !1
      , Hs = null
      , Vs = {
        text: !0,
        search: !0,
        url: !0,
        tel: !0,
        email: !0,
        password: !0,
        number: !0,
        date: !0,
        month: !0,
        week: !0,
        time: !0,
        datetime: !0,
        "datetime-local": !0
    };
    function qs(e) {
        e.metaKey || e.altKey || e.ctrlKey || (Bs = !0)
    }
    function Us() {
        Bs = !1
    }
    function Gs() {
        "hidden" === this.visibilityState && js && (Bs = !0)
    }
    function Zs(e) {
        var t, n, r, i = e.target;
        try {
            return i.matches(":focus-visible")
        } catch (e) {}
        return Bs || (n = (t = i).type,
        !("INPUT" !== (r = t.tagName) || !Vs[n] || t.readOnly) || "TEXTAREA" === r && !t.readOnly || !!t.isContentEditable)
    }
    function Ks() {
        js = !0,
        window.clearTimeout(Hs),
        Hs = window.setTimeout((function() {
            js = !1
        }
        ), 100)
    }
    function Ys() {
        return {
            isFocusVisible: Zs,
            onBlurVisible: Ks,
            ref: lt.useCallback((function(e) {
                var t, n = lt.findDOMNode(e);
                null != n && ((t = n.ownerDocument).addEventListener("keydown", qs, !0),
                t.addEventListener("mousedown", Us, !0),
                t.addEventListener("pointerdown", Us, !0),
                t.addEventListener("touchstart", Us, !0),
                t.addEventListener("visibilitychange", Gs, !0))
            }
            ), [])
        }
    }
    var Xs = lt.createContext(null);
    function Js(e, t) {
        var n = Object.create(null);
        return e && Me.map(e, (function(e) {
            return e
        }
        )).forEach((function(e) {
            n[e.key] = function(e) {
                return t && nt(e) ? t(e) : e
            }(e)
        }
        )),
        n
    }
    function Qs(e, t, n) {
        return null != n[t] ? n[t] : e.props[t]
    }
    function el(e, t, n) {
        var r = Js(e.children)
          , i = function(e, t) {
            function n(n) {
                return n in t ? t[n] : e[n]
            }
            e = e || {},
            t = t || {};
            var r, i = Object.create(null), o = [];
            for (var a in e)
                a in t ? o.length && (i[a] = o,
                o = []) : o.push(a);
            var s = {};
            for (var l in t) {
                if (i[l])
                    for (r = 0; r < i[l].length; r++) {
                        var c = i[l][r];
                        s[i[l][r]] = n(c)
                    }
                s[l] = n(l)
            }
            for (r = 0; r < o.length; r++)
                s[o[r]] = n(o[r]);
            return s
        }(t, r);
        return Object.keys(i).forEach((function(o) {
            var a = i[o];
            if (nt(a)) {
                var s = o in t
                  , l = o in r
                  , c = t[o]
                  , u = nt(c) && !c.props.in;
                !l || s && !u ? l || !s || u ? l && s && nt(c) && (i[o] = rt(a, {
                    onExited: n.bind(null, a),
                    in: c.props.in,
                    exit: Qs(a, "exit", e),
                    enter: Qs(a, "enter", e)
                })) : i[o] = rt(a, {
                    in: !1
                }) : i[o] = rt(a, {
                    onExited: n.bind(null, a),
                    in: !0,
                    exit: Qs(a, "exit", e),
                    enter: Qs(a, "enter", e)
                })
            }
        }
        )),
        i
    }
    var tl = Object.values || function(e) {
        return Object.keys(e).map((function(t) {
            return e[t]
        }
        ))
    }
      , nl = function(e) {
        function t(t, n) {
            var r, i = (r = e.call(this, t, n) || this).handleExited.bind(Pr(Pr(r)));
            return r.state = {
                contextValue: {
                    isMounting: !0
                },
                handleExited: i,
                firstRender: !0
            },
            r
        }
        Rr(t, e);
        var n = t.prototype;
        return n.componentDidMount = function() {
            this.mounted = !0,
            this.setState({
                contextValue: {
                    isMounting: !1
                }
            })
        }
        ,
        n.componentWillUnmount = function() {
            this.mounted = !1
        }
        ,
        t.getDerivedStateFromProps = function(e, t) {
            var n, r, i = t.children, o = t.handleExited;
            return {
                children: t.firstRender ? (n = e,
                r = o,
                Js(n.children, (function(e) {
                    return rt(e, {
                        onExited: r.bind(null, e),
                        in: !0,
                        appear: Qs(e, "appear", n),
                        enter: Qs(e, "enter", n),
                        exit: Qs(e, "exit", n)
                    })
                }
                ))) : el(e, i, o),
                firstRender: !1
            }
        }
        ,
        n.handleExited = function(e, t) {
            var n = Js(this.props.children);
            e.key in n || (e.props.onExited && e.props.onExited(t),
            this.mounted && this.setState((function(t) {
                var n = Vt({}, t.children);
                return delete n[e.key],
                {
                    children: n
                }
            }
            )))
        }
        ,
        n.render = function() {
            var e = this.props
              , t = e.component
              , n = e.childFactory
              , r = Bt(e, ["component", "childFactory"])
              , i = this.state.contextValue
              , o = tl(this.state.children).map(n);
            return delete r.appear,
            delete r.enter,
            delete r.exit,
            null === t ? lt.createElement(Xs.Provider, {
                value: i
            }, o) : lt.createElement(Xs.Provider, {
                value: i
            }, lt.createElement(t, r, o))
        }
        ,
        t
    }(lt.Component);
    nl.propTypes = {},
    nl.defaultProps = {
        component: "div",
        childFactory: function(e) {
            return e
        }
    };
    var rl = !1
      , il = "unmounted"
      , ol = "exited"
      , al = "entering"
      , sl = "entered"
      , ll = "exiting"
      , cl = function(e) {
        function t(t, n) {
            var r;
            r = e.call(this, t, n) || this;
            var i, o = n && !n.isMounting ? t.enter : t.appear;
            return r.appearStatus = null,
            t.in ? o ? (i = ol,
            r.appearStatus = al) : i = sl : i = t.unmountOnExit || t.mountOnEnter ? il : ol,
            r.state = {
                status: i
            },
            r.nextCallback = null,
            r
        }
        Rr(t, e),
        t.getDerivedStateFromProps = function(e, t) {
            return e.in && t.status === il ? {
                status: ol
            } : null
        }
        ;
        var n = t.prototype;
        return n.componentDidMount = function() {
            this.updateStatus(!0, this.appearStatus)
        }
        ,
        n.componentDidUpdate = function(e) {
            var t = null;
            if (e !== this.props) {
                var n = this.state.status;
                this.props.in ? n !== al && n !== sl && (t = al) : n !== al && n !== sl || (t = ll)
            }
            this.updateStatus(!1, t)
        }
        ,
        n.componentWillUnmount = function() {
            this.cancelNextCallback()
        }
        ,
        n.getTimeouts = function() {
            var e, t, n, r = this.props.timeout;
            return e = t = n = r,
            null != r && "number" != typeof r && (e = r.exit,
            t = r.enter,
            n = void 0 !== r.appear ? r.appear : t),
            {
                exit: e,
                enter: t,
                appear: n
            }
        }
        ,
        n.updateStatus = function(e, t) {
            if (void 0 === e && (e = !1),
            null !== t) {
                this.cancelNextCallback();
                var n = lt.findDOMNode(this);
                t === al ? this.performEnter(n, e) : this.performExit(n)
            } else
                this.props.unmountOnExit && this.state.status === ol && this.setState({
                    status: il
                })
        }
        ,
        n.performEnter = function(e, t) {
            var n = this
              , r = this.props.enter
              , i = this.context ? this.context.isMounting : t
              , o = this.getTimeouts()
              , a = i ? o.appear : o.enter;
            !t && !r || rl ? this.safeSetState({
                status: sl
            }, (function() {
                n.props.onEntered(e)
            }
            )) : (this.props.onEnter(e, i),
            this.safeSetState({
                status: al
            }, (function() {
                n.props.onEntering(e, i),
                n.onTransitionEnd(e, a, (function() {
                    n.safeSetState({
                        status: sl
                    }, (function() {
                        n.props.onEntered(e, i)
                    }
                    ))
                }
                ))
            }
            )))
        }
        ,
        n.performExit = function(e) {
            var t = this
              , n = this.props.exit
              , r = this.getTimeouts();
            n && !rl ? (this.props.onExit(e),
            this.safeSetState({
                status: ll
            }, (function() {
                t.props.onExiting(e),
                t.onTransitionEnd(e, r.exit, (function() {
                    t.safeSetState({
                        status: ol
                    }, (function() {
                        t.props.onExited(e)
                    }
                    ))
                }
                ))
            }
            ))) : this.safeSetState({
                status: ol
            }, (function() {
                t.props.onExited(e)
            }
            ))
        }
        ,
        n.cancelNextCallback = function() {
            null !== this.nextCallback && (this.nextCallback.cancel(),
            this.nextCallback = null)
        }
        ,
        n.safeSetState = function(e, t) {
            t = this.setNextCallback(t),
            this.setState(e, t)
        }
        ,
        n.setNextCallback = function(e) {
            var t = this
              , n = !0;
            return this.nextCallback = function(r) {
                n && (n = !1,
                t.nextCallback = null,
                e(r))
            }
            ,
            this.nextCallback.cancel = function() {
                n = !1
            }
            ,
            this.nextCallback
        }
        ,
        n.onTransitionEnd = function(e, t, n) {
            this.setNextCallback(n);
            var r = null == t && !this.props.addEndListener;
            e && !r ? (this.props.addEndListener && this.props.addEndListener(e, this.nextCallback),
            null != t && setTimeout(this.nextCallback, t)) : setTimeout(this.nextCallback, 0)
        }
        ,
        n.render = function() {
            var e = this.state.status;
            if (e === il)
                return null;
            var t = this.props
              , n = t.children
              , r = Bt(t, ["children"]);
            if (delete r.in,
            delete r.mountOnEnter,
            delete r.unmountOnExit,
            delete r.appear,
            delete r.enter,
            delete r.exit,
            delete r.timeout,
            delete r.addEndListener,
            delete r.onEnter,
            delete r.onEntering,
            delete r.onEntered,
            delete r.onExit,
            delete r.onExiting,
            delete r.onExited,
            "function" == typeof n)
                return lt.createElement(Xs.Provider, {
                    value: null
                }, n(e, r));
            var i = lt.Children.only(n);
            return lt.createElement(Xs.Provider, {
                value: null
            }, lt.cloneElement(i, r))
        }
        ,
        t
    }(lt.Component);
    function ul() {}
    cl.contextType = Xs,
    cl.propTypes = {},
    cl.defaultProps = {
        in: !1,
        mountOnEnter: !1,
        unmountOnExit: !1,
        appear: !1,
        enter: !0,
        exit: !0,
        onEnter: ul,
        onEntering: ul,
        onEntered: ul,
        onExit: ul,
        onExiting: ul,
        onExited: ul
    },
    cl.UNMOUNTED = 0,
    cl.EXITED = 1,
    cl.ENTERING = 2,
    cl.ENTERED = 3,
    cl.EXITING = 4;
    var dl = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect;
    function pl(e) {
        var t = e.classes
          , n = e.pulsate
          , r = void 0 !== n && n
          , i = e.rippleX
          , o = e.rippleY
          , a = e.rippleSize
          , s = e.in
          , l = e.onExited
          , c = void 0 === l ? function() {}
        : l
          , u = e.timeout
          , d = lt.useState(!1)
          , p = d[0]
          , f = d[1]
          , h = Ra(t.ripple, t.rippleVisible, r && t.ripplePulsate)
          , m = {
            width: a,
            height: a,
            top: -a / 2 + o,
            left: -a / 2 + i
        }
          , v = Ra(t.child, p && t.childLeaving, r && t.childPulsate)
          , g = Ws(c);
        return dl((function() {
            if (!s) {
                f(!0);
                var e = setTimeout(g, u);
                return function() {
                    clearTimeout(e)
                }
            }
        }
        ), [g, s, u]),
        lt.createElement("span", {
            className: h,
            style: m
        }, lt.createElement("span", {
            className: v
        }))
    }
    var fl = lt.forwardRef((function(e, t) {
        var n = e.center
          , r = void 0 !== n && n
          , i = e.classes
          , o = e.className
          , a = jt(e, ["center", "classes", "className"])
          , s = lt.useState([])
          , l = s[0]
          , c = s[1]
          , u = lt.useRef(0)
          , d = lt.useRef(null);
        lt.useEffect((function() {
            d.current && (d.current(),
            d.current = null)
        }
        ), [l]);
        var p = lt.useRef(!1)
          , f = lt.useRef(null)
          , h = lt.useRef(null)
          , m = lt.useRef(null);
        lt.useEffect((function() {
            return function() {
                clearTimeout(f.current)
            }
        }
        ), []);
        var v = lt.useCallback((function(e) {
            var t = e.pulsate
              , n = e.rippleX
              , r = e.rippleY
              , o = e.rippleSize
              , a = e.cb;
            c((function(e) {
                return [].concat(yo(e), [lt.createElement(pl, {
                    key: u.current,
                    classes: i,
                    timeout: 550,
                    pulsate: t,
                    rippleX: n,
                    rippleY: r,
                    rippleSize: o
                })])
            }
            )),
            u.current += 1,
            d.current = a
        }
        ), [i])
          , g = lt.useCallback((function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
              , t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
              , n = arguments.length > 2 ? arguments[2] : void 0
              , i = t.pulsate
              , o = void 0 !== i && i
              , a = t.center
              , s = void 0 === a ? r || t.pulsate : a
              , l = t.fakeElement
              , c = void 0 !== l && l;
            if ("mousedown" === e.type && p.current)
                p.current = !1;
            else {
                "touchstart" === e.type && (p.current = !0);
                var u, d, g, b = c ? null : m.current, y = b ? b.getBoundingClientRect() : {
                    width: 0,
                    height: 0,
                    left: 0,
                    top: 0
                };
                if (s || 0 === e.clientX && 0 === e.clientY || !e.clientX && !e.touches)
                    u = Math.round(y.width / 2),
                    d = Math.round(y.height / 2);
                else {
                    var w = e.clientX ? e.clientX : e.touches[0].clientX
                      , x = e.clientY ? e.clientY : e.touches[0].clientY;
                    u = Math.round(w - y.left),
                    d = Math.round(x - y.top)
                }
                if (s)
                    (g = Math.sqrt((2 * Math.pow(y.width, 2) + Math.pow(y.height, 2)) / 3)) % 2 == 0 && (g += 1);
                else {
                    var _ = 2 * Math.max(Math.abs((b ? b.clientWidth : 0) - u), u) + 2
                      , C = 2 * Math.max(Math.abs((b ? b.clientHeight : 0) - d), d) + 2;
                    g = Math.sqrt(Math.pow(_, 2) + Math.pow(C, 2))
                }
                e.touches ? null === h.current && (h.current = function() {
                    v({
                        pulsate: o,
                        rippleX: u,
                        rippleY: d,
                        rippleSize: g,
                        cb: n
                    })
                }
                ,
                f.current = setTimeout((function() {
                    h.current && (h.current(),
                    h.current = null)
                }
                ), 80)) : v({
                    pulsate: o,
                    rippleX: u,
                    rippleY: d,
                    rippleSize: g,
                    cb: n
                })
            }
        }
        ), [r, v])
          , b = lt.useCallback((function() {
            g({}, {
                pulsate: !0
            })
        }
        ), [g])
          , y = lt.useCallback((function(e, t) {
            if (clearTimeout(f.current),
            "touchend" === e.type && h.current)
                return e.persist(),
                h.current(),
                h.current = null,
                void (f.current = setTimeout((function() {
                    y(e, t)
                }
                )));
            h.current = null,
            c((function(e) {
                return e.length > 0 ? e.slice(1) : e
            }
            )),
            d.current = t
        }
        ), []);
        return lt.useImperativeHandle(t, (function() {
            return {
                pulsate: b,
                start: g,
                stop: y
            }
        }
        ), [b, g, y]),
        lt.createElement("span", Vt({
            className: Ra(i.root, o),
            ref: m
        }, a), lt.createElement(nl, {
            component: null,
            exit: !0
        }, l))
    }
    ))
      , hl = Ka((function(e) {
        return {
            root: {
                overflow: "hidden",
                pointerEvents: "none",
                position: "absolute",
                zIndex: 0,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                borderRadius: "inherit"
            },
            ripple: {
                opacity: 0,
                position: "absolute"
            },
            rippleVisible: {
                opacity: .3,
                transform: "scale(1)",
                animation: "$enter ".concat(550, "ms ").concat(e.transitions.easing.easeInOut)
            },
            ripplePulsate: {
                animationDuration: "".concat(e.transitions.duration.shorter, "ms")
            },
            child: {
                opacity: 1,
                display: "block",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                backgroundColor: "currentColor"
            },
            childLeaving: {
                opacity: 0,
                animation: "$exit ".concat(550, "ms ").concat(e.transitions.easing.easeInOut)
            },
            childPulsate: {
                position: "absolute",
                left: 0,
                top: 0,
                animation: "$pulsate 2500ms ".concat(e.transitions.easing.easeInOut, " 200ms infinite")
            },
            "@keyframes enter": {
                "0%": {
                    transform: "scale(0)",
                    opacity: .1
                },
                "100%": {
                    transform: "scale(1)",
                    opacity: .3
                }
            },
            "@keyframes exit": {
                "0%": {
                    opacity: 1
                },
                "100%": {
                    opacity: 0
                }
            },
            "@keyframes pulsate": {
                "0%": {
                    transform: "scale(1)"
                },
                "50%": {
                    transform: "scale(0.92)"
                },
                "100%": {
                    transform: "scale(1)"
                }
            }
        }
    }
    ), {
        flip: !1,
        name: "PwzrTouchRipple"
    })(lt.memo(fl))
      , ml = lt.forwardRef((function(e, t) {
        var n = e.action
          , r = e.buttonRef
          , i = e.centerRipple
          , o = void 0 !== i && i
          , a = e.children
          , s = e.classes
          , l = e.className
          , c = e.component
          , u = void 0 === c ? "button" : c
          , d = e.disabled
          , p = void 0 !== d && d
          , f = e.disableRipple
          , h = void 0 !== f && f
          , m = e.disableTouchRipple
          , v = void 0 !== m && m
          , g = e.focusRipple
          , b = void 0 !== g && g
          , y = e.focusVisibleClassName
          , w = e.onBlur
          , x = e.onClick
          , _ = e.onFocus
          , C = e.onFocusVisible
          , S = e.onKeyDown
          , E = e.onKeyUp
          , k = e.onMouseDown
          , O = e.onMouseLeave
          , T = e.onMouseUp
          , M = e.onTouchEnd
          , R = e.onTouchMove
          , P = e.onTouchStart
          , I = e.onDragLeave
          , z = e.tabIndex
          , A = void 0 === z ? 0 : z
          , L = e.TouchRippleProps
          , D = e.type
          , N = void 0 === D ? "button" : D
          , W = jt(e, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"])
          , F = lt.useRef(null);
        var $ = lt.useRef(null)
          , B = lt.useState(!1)
          , j = B[0]
          , H = B[1];
        p && j && H(!1);
        var V = Ys()
          , q = V.isFocusVisible
          , U = V.onBlurVisible
          , G = V.ref;
        function Z(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : v;
            return Ws((function(r) {
                return t && t(r),
                !n && $.current && $.current[e](r),
                !0
            }
            ))
        }
        lt.useImperativeHandle(n, (function() {
            return {
                focusVisible: function() {
                    H(!0),
                    F.current.focus()
                }
            }
        }
        ), []),
        lt.useEffect((function() {
            j && b && !h && $.current.pulsate()
        }
        ), [h, b, j]);
        var K = Z("start", k)
          , Y = Z("stop", I)
          , X = Z("stop", T)
          , J = Z("stop", (function(e) {
            j && e.preventDefault(),
            O && O(e)
        }
        ))
          , Q = Z("start", P)
          , ee = Z("stop", M)
          , te = Z("stop", R)
          , ne = Z("stop", (function(e) {
            j && (U(e),
            H(!1)),
            w && w(e)
        }
        ), !1)
          , re = Ws((function(e) {
            p || (F.current || (F.current = e.currentTarget),
            q(e) && (H(!0),
            C && C(e)),
            _ && _(e))
        }
        ))
          , ie = function() {
            var e = lt.findDOMNode(F.current);
            return u && "button" !== u && !("A" === e.tagName && e.href)
        }
          , oe = lt.useRef(!1)
          , ae = Ws((function(e) {
            b && !oe.current && j && $.current && " " === e.key && (oe.current = !0,
            e.persist(),
            $.current.stop(e, (function() {
                $.current.start(e)
            }
            ))),
            S && S(e),
            e.target === e.currentTarget && ie() && "Enter" === e.key && (e.preventDefault(),
            x && x(e))
        }
        ))
          , se = Ws((function(e) {
            b && " " === e.key && $.current && j && !e.defaultPrevented && (oe.current = !1,
            e.persist(),
            $.current.stop(e, (function() {
                $.current.pulsate(e)
            }
            ))),
            E && E(e),
            e.target === e.currentTarget && ie() && " " === e.key && !e.defaultPrevented && (e.preventDefault(),
            x && x(e))
        }
        ))
          , le = u;
        "button" === le && W.href && (le = "a");
        var ce = {};
        "button" === le ? (ce.type = N,
        ce.disabled = p) : ("a" === le && W.href || (ce.role = "button"),
        ce["aria-disabled"] = p);
        var ue = Ds(r, t)
          , de = Ds(G, F)
          , pe = Ds(ue, de);
        return lt.createElement(le, Vt({
            className: Ra(s.root, l, j && [s.focusVisible, y], p && s.disabled),
            onBlur: ne,
            onClick: x,
            onFocus: re,
            onKeyDown: ae,
            onKeyUp: se,
            onMouseDown: K,
            onMouseLeave: J,
            onMouseUp: X,
            onDragLeave: Y,
            onTouchEnd: ee,
            onTouchMove: te,
            onTouchStart: Q,
            ref: pe,
            tabIndex: p ? -1 : A
        }, ce, W), a, h || p ? null : lt.createElement($s, null, lt.createElement(hl, Vt({
            ref: $,
            center: o
        }, L))))
    }
    ))
      , vl = Ka({
        root: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            WebkitTapHighlightColor: "transparent",
            backgroundColor: "transparent",
            outline: 0,
            border: 0,
            margin: 0,
            borderRadius: 0,
            padding: 0,
            cursor: "pointer",
            userSelect: "none",
            verticalAlign: "middle",
            "-moz-appearance": "none",
            "-webkit-appearance": "none",
            textDecoration: "none",
            color: "inherit",
            "&::-moz-focus-inner": {
                borderStyle: "none"
            },
            "&$disabled": {
                pointerEvents: "none",
                cursor: "default"
            }
        },
        disabled: {},
        focusVisible: {}
    }, {
        name: "PwzrButtonBase"
    })(ml);
    function gl(e) {
        return e.charAt(0).toUpperCase() + e.slice(1)
    }
    var bl = lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.classes
          , i = e.className
          , o = e.color
          , a = void 0 === o ? "default" : o
          , s = e.component
          , l = void 0 === s ? "button" : s
          , c = e.disabled
          , u = void 0 !== c && c
          , d = e.disableElevation
          , p = void 0 !== d && d
          , f = e.disableFocusRipple
          , h = void 0 !== f && f
          , m = e.endIcon
          , v = e.focusVisibleClassName
          , g = e.fullWidth
          , b = void 0 !== g && g
          , y = e.size
          , w = void 0 === y ? "medium" : y
          , x = e.startIcon
          , _ = e.type
          , C = void 0 === _ ? "button" : _
          , S = e.variant
          , E = void 0 === S ? "text" : S
          , k = jt(e, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"])
          , O = x && lt.createElement("span", {
            className: Ra(r.startIcon, r["iconSize".concat(gl(w))])
        }, x)
          , T = m && lt.createElement("span", {
            className: Ra(r.endIcon, r["iconSize".concat(gl(w))])
        }, m);
        return lt.createElement(vl, Vt({
            className: Ra(r.root, r[E], i, "inherit" === a ? r.colorInherit : "default" !== a && r["".concat(E).concat(gl(a))], "medium" !== w && [r["".concat(E, "Size").concat(gl(w))], r["size".concat(gl(w))]], p && r.disableElevation, u && r.disabled, b && r.fullWidth),
            component: l,
            disabled: u,
            focusRipple: !h,
            focusVisibleClassName: Ra(r.focusVisible, v),
            ref: t,
            type: C
        }, k), lt.createElement("span", {
            className: r.label
        }, O, n, T))
    }
    ))
      , yl = Ka((function(e) {
        return {
            root: Vt({}, e.typography.button, {
                boxSizing: "border-box",
                minWidth: 64,
                padding: "6px 16px",
                borderRadius: e.shape.borderRadius,
                color: e.palette.text.primary,
                transition: e.transitions.create(["background-color", "box-shadow", "border"], {
                    duration: e.transitions.duration.short
                }),
                "&:hover": {
                    textDecoration: "none",
                    backgroundColor: Nt(e.palette.text.primary, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    },
                    "&$disabled": {
                        backgroundColor: "transparent"
                    }
                },
                "&$disabled": {
                    color: e.palette.action.disabled
                }
            }),
            label: {
                width: "100%",
                display: "inherit",
                alignItems: "inherit",
                justifyContent: "inherit"
            },
            text: {
                padding: "6px 8px"
            },
            textPrimary: {
                color: e.palette.primary.main,
                "&:hover": {
                    backgroundColor: Nt(e.palette.primary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            textSecondary: {
                color: e.palette.secondary.main,
                "&:hover": {
                    backgroundColor: Nt(e.palette.secondary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            outlined: {
                padding: "5px 15px",
                border: "1px solid ".concat("light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
                "&$disabled": {
                    border: "1px solid ".concat(e.palette.action.disabledBackground)
                }
            },
            outlinedPrimary: {
                color: e.palette.primary.main,
                border: "1px solid ".concat(Nt(e.palette.primary.main, .5)),
                "&:hover": {
                    border: "1px solid ".concat(e.palette.primary.main),
                    backgroundColor: Nt(e.palette.primary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            outlinedSecondary: {
                color: e.palette.secondary.main,
                border: "1px solid ".concat(Nt(e.palette.secondary.main, .5)),
                "&:hover": {
                    border: "1px solid ".concat(e.palette.secondary.main),
                    backgroundColor: Nt(e.palette.secondary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                },
                "&$disabled": {
                    border: "1px solid ".concat(e.palette.action.disabled)
                }
            },
            contained: {
                color: e.palette.getContrastText(e.palette.grey[300]),
                backgroundColor: e.palette.grey[300],
                boxShadow: e.shadows[2],
                "&:hover": {
                    backgroundColor: e.palette.grey.A100,
                    boxShadow: e.shadows[4],
                    "@media (hover: none)": {
                        boxShadow: e.shadows[2],
                        backgroundColor: e.palette.grey[300]
                    },
                    "&$disabled": {
                        backgroundColor: e.palette.action.disabledBackground
                    }
                },
                "&$focusVisible": {
                    boxShadow: e.shadows[6]
                },
                "&:active": {
                    boxShadow: e.shadows[8]
                },
                "&$disabled": {
                    color: e.palette.action.disabled,
                    boxShadow: e.shadows[0],
                    backgroundColor: e.palette.action.disabledBackground
                }
            },
            containedPrimary: {
                color: e.palette.primary.contrastText,
                backgroundColor: e.palette.primary.main,
                "&:hover": {
                    backgroundColor: e.palette.primary.dark,
                    "@media (hover: none)": {
                        backgroundColor: e.palette.primary.main
                    }
                }
            },
            containedSecondary: {
                color: e.palette.secondary.contrastText,
                backgroundColor: e.palette.secondary.main,
                "&:hover": {
                    backgroundColor: e.palette.secondary.dark,
                    "@media (hover: none)": {
                        backgroundColor: e.palette.secondary.main
                    }
                }
            },
            disableElevation: {
                boxShadow: "none",
                "&:hover": {
                    boxShadow: "none"
                },
                "&$focusVisible": {
                    boxShadow: "none"
                },
                "&:active": {
                    boxShadow: "none"
                },
                "&$disabled": {
                    boxShadow: "none"
                }
            },
            focusVisible: {},
            disabled: {},
            colorInherit: {
                color: "inherit",
                borderColor: "currentColor"
            },
            textSizeSmall: {
                padding: "4px 5px",
                fontSize: e.typography.pxToRem(13)
            },
            textSizeLarge: {
                padding: "8px 11px",
                fontSize: e.typography.pxToRem(15)
            },
            outlinedSizeSmall: {
                padding: "3px 9px",
                fontSize: e.typography.pxToRem(13)
            },
            outlinedSizeLarge: {
                padding: "7px 21px",
                fontSize: e.typography.pxToRem(15)
            },
            containedSizeSmall: {
                padding: "4px 10px",
                fontSize: e.typography.pxToRem(13)
            },
            containedSizeLarge: {
                padding: "8px 22px",
                fontSize: e.typography.pxToRem(15)
            },
            sizeSmall: {},
            sizeLarge: {},
            fullWidth: {
                width: "100%"
            },
            startIcon: {
                display: "inherit",
                marginRight: 8,
                marginLeft: -4,
                "&$iconSizeSmall": {
                    marginLeft: -2
                }
            },
            endIcon: {
                display: "inherit",
                marginRight: -4,
                marginLeft: 8,
                "&$iconSizeSmall": {
                    marginRight: -2
                }
            },
            iconSizeSmall: {
                "& > *:first-child": {
                    fontSize: 18
                }
            },
            iconSizeMedium: {
                "& > *:first-child": {
                    fontSize: 20
                }
            },
            iconSizeLarge: {
                "& > *:first-child": {
                    fontSize: 22
                }
            }
        }
    }
    ), {
        name: "PwzrButton"
    })(bl)
      , wl = {}
      , xl = lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.classes
          , i = e.className
          , o = e.color
          , a = void 0 === o ? "inherit" : o
          , s = e.component
          , l = void 0 === s ? "svg" : s
          , c = e.fontSize
          , u = void 0 === c ? "default" : c
          , d = e.htmlColor
          , p = e.titleAccess
          , f = e.viewBox
          , h = void 0 === f ? "0 0 24 24" : f
          , m = jt(e, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
        return lt.createElement(l, Vt({
            className: Ra(r.root, i, "inherit" !== a && r["color".concat(gl(a))], "default" !== u && r["fontSize".concat(gl(u))]),
            focusable: "false",
            viewBox: h,
            color: d,
            "aria-hidden": p ? void 0 : "true",
            role: p ? "img" : "presentation",
            ref: t
        }, m), n, p ? lt.createElement("title", null, p) : null)
    }
    ));
    xl.muiName = "SvgIcon";
    var _l = Ka((function(e) {
        return {
            root: {
                userSelect: "none",
                width: "1em",
                height: "1em",
                display: "inline-block",
                fill: "currentColor",
                flexShrink: 0,
                fontSize: e.typography.pxToRem(24),
                transition: e.transitions.create("fill", {
                    duration: e.transitions.duration.shorter
                })
            },
            colorPrimary: {
                color: e.palette.primary.main
            },
            colorSecondary: {
                color: e.palette.secondary.main
            },
            colorAction: {
                color: e.palette.action.active
            },
            colorError: {
                color: e.palette.error.main
            },
            colorDisabled: {
                color: e.palette.action.disabled
            },
            fontSizeInherit: {
                fontSize: "inherit"
            },
            fontSizeSmall: {
                fontSize: e.typography.pxToRem(20)
            },
            fontSizeLarge: {
                fontSize: e.typography.pxToRem(35)
            }
        }
    }
    ), {
        name: "PwzrSvgIcon"
    })(xl);
    function Cl(e, t) {
        var n = lt.memo(lt.forwardRef((function(t, n) {
            return lt.createElement(_l, Vt({}, t, {
                ref: n
            }), e)
        }
        )));
        return n.muiName = _l.muiName,
        n
    }
    r(wl, "default", (function() {
        return _l
    }
    )),
    n(wl);
    var Sl = Cl(lt.createElement("path", {
        d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
    }));
    var El = lt.forwardRef((function(e, t) {
        var n = e.avatar
          , r = e.classes
          , i = e.className
          , o = e.clickable
          , a = e.color
          , s = void 0 === a ? "default" : a
          , l = e.component
          , c = e.deleteIcon
          , u = e.disabled
          , d = void 0 !== u && u
          , p = e.icon
          , f = e.label
          , h = e.onClick
          , m = e.onDelete
          , v = e.onKeyUp
          , g = e.size
          , b = void 0 === g ? "medium" : g
          , y = e.variant
          , w = void 0 === y ? "default" : y
          , x = jt(e, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyUp", "size", "variant"])
          , _ = lt.useRef(null)
          , C = Ds(_, t)
          , S = function(e) {
            e.stopPropagation(),
            m && m(e)
        }
          , E = !(!1 === o || !h) || o
          , k = "small" === b
          , O = l || (E ? vl : "div")
          , T = O === vl ? {
            component: "div"
        } : {}
          , M = null;
        if (m) {
            var R = Ra("default" !== s && ("default" === w ? r["deleteIconColor".concat(gl(s))] : r["deleteIconOutlinedColor".concat(gl(s))]), k && r.deleteIconSmall);
            M = c && lt.isValidElement(c) ? lt.cloneElement(c, {
                className: Ra(c.props.className, r.deleteIcon, R),
                onClick: S
            }) : lt.createElement(Sl, {
                className: Ra(r.deleteIcon, R),
                onClick: S
            })
        }
        var P = null;
        n && lt.isValidElement(n) && (P = lt.cloneElement(n, {
            className: Ra(r.avatar, n.props.className, k && r.avatarSmall, "default" !== s && r["avatarColor".concat(gl(s))])
        }));
        var I = null;
        return p && lt.isValidElement(p) && (I = lt.cloneElement(p, {
            className: Ra(r.icon, p.props.className, k && r.iconSmall, "default" !== s && r["iconColor".concat(gl(s))])
        })),
        lt.createElement(O, Vt({
            role: E || m ? "button" : void 0,
            className: Ra(r.root, i, "default" !== s && [r["color".concat(gl(s))], E && r["clickableColor".concat(gl(s))], m && r["deletableColor".concat(gl(s))]], "default" !== w && [r.outlined, {
                primary: r.outlinedPrimary,
                secondary: r.outlinedSecondary
            }[s]], d && r.disabled, k && r.sizeSmall, E && r.clickable, m && r.deletable),
            "aria-disabled": !!d || void 0,
            tabIndex: E || m ? 0 : void 0,
            onClick: h,
            onKeyUp: function(e) {
                if (v && v(e),
                e.currentTarget === e.target) {
                    var t = e.key;
                    !m || "Backspace" !== t && "Delete" !== t ? "Escape" === t && _.current && _.current.blur() : m(e)
                }
            },
            ref: C
        }, T, x), P || I, lt.createElement("span", {
            className: Ra(r.label, k && r.labelSmall)
        }, f), M)
    }
    ))
      , kl = (Ka((function(e) {
        var t = "light" === e.palette.type ? e.palette.grey[300] : e.palette.grey[700]
          , n = Nt(e.palette.text.primary, .26);
        return {
            root: {
                fontFamily: e.typography.fontFamily,
                fontSize: e.typography.pxToRem(13),
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: 32,
                color: e.palette.getContrastText(t),
                backgroundColor: t,
                borderRadius: 16,
                whiteSpace: "nowrap",
                transition: e.transitions.create(["background-color", "box-shadow"]),
                cursor: "default",
                outline: 0,
                textDecoration: "none",
                border: "none",
                padding: 0,
                verticalAlign: "middle",
                boxSizing: "border-box",
                "&$disabled": {
                    opacity: .5,
                    pointerEvents: "none"
                },
                "& $avatar": {
                    marginLeft: 5,
                    marginRight: -6,
                    width: 24,
                    height: 24,
                    color: "light" === e.palette.type ? e.palette.grey[700] : e.palette.grey[300],
                    fontSize: e.typography.pxToRem(12)
                },
                "& $avatarColorPrimary": {
                    color: e.palette.primary.contrastText,
                    backgroundColor: e.palette.primary.dark
                },
                "& $avatarColorSecondary": {
                    color: e.palette.secondary.contrastText,
                    backgroundColor: e.palette.secondary.dark
                },
                "& $avatarSmall": {
                    marginLeft: 4,
                    marginRight: -4,
                    width: 18,
                    height: 18,
                    fontSize: e.typography.pxToRem(10)
                }
            },
            sizeSmall: {
                height: 24
            },
            colorPrimary: {
                backgroundColor: e.palette.primary.main,
                color: e.palette.primary.contrastText
            },
            colorSecondary: {
                backgroundColor: e.palette.secondary.main,
                color: e.palette.secondary.contrastText
            },
            disabled: {},
            clickable: {
                userSelect: "none",
                WebkitTapHighlightColor: "transparent",
                cursor: "pointer",
                "&:hover, &:focus": {
                    backgroundColor: Dt(t, .08)
                },
                "&:active": {
                    boxShadow: e.shadows[1]
                }
            },
            clickableColorPrimary: {
                "&:hover, &:focus": {
                    backgroundColor: Dt(e.palette.primary.main, .08)
                }
            },
            clickableColorSecondary: {
                "&:hover, &:focus": {
                    backgroundColor: Dt(e.palette.secondary.main, .08)
                }
            },
            deletable: {
                "&:focus": {
                    backgroundColor: Dt(t, .08)
                }
            },
            deletableColorPrimary: {
                "&:focus": {
                    backgroundColor: Dt(e.palette.primary.main, .2)
                }
            },
            deletableColorSecondary: {
                "&:focus": {
                    backgroundColor: Dt(e.palette.secondary.main, .2)
                }
            },
            outlined: {
                backgroundColor: "transparent",
                border: "1px solid ".concat("light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
                "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                    backgroundColor: Nt(e.palette.text.primary, e.palette.action.hoverOpacity)
                },
                "& $avatar": {
                    marginLeft: 4
                },
                "& $avatarSmall": {
                    marginLeft: 2
                },
                "& $icon": {
                    marginLeft: 4
                },
                "& $iconSmall": {
                    marginLeft: 2
                },
                "& $deleteIcon": {
                    marginRight: 5
                },
                "& $deleteIconSmall": {
                    marginRight: 3
                }
            },
            outlinedPrimary: {
                color: e.palette.primary.main,
                border: "1px solid ".concat(e.palette.primary.main),
                "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                    backgroundColor: Nt(e.palette.primary.main, e.palette.action.hoverOpacity)
                }
            },
            outlinedSecondary: {
                color: e.palette.secondary.main,
                border: "1px solid ".concat(e.palette.secondary.main),
                "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                    backgroundColor: Nt(e.palette.secondary.main, e.palette.action.hoverOpacity)
                }
            },
            avatar: {},
            avatarSmall: {},
            avatarColorPrimary: {},
            avatarColorSecondary: {},
            icon: {
                color: "light" === e.palette.type ? e.palette.grey[700] : e.palette.grey[300],
                marginLeft: 5,
                marginRight: -6
            },
            iconSmall: {
                width: 18,
                height: 18,
                marginLeft: 4,
                marginRight: -4
            },
            iconColorPrimary: {
                color: "inherit"
            },
            iconColorSecondary: {
                color: "inherit"
            },
            label: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                paddingLeft: 12,
                paddingRight: 12,
                whiteSpace: "nowrap"
            },
            labelSmall: {
                paddingLeft: 8,
                paddingRight: 8
            },
            deleteIcon: {
                WebkitTapHighlightColor: "transparent",
                color: n,
                height: 22,
                width: 22,
                cursor: "pointer",
                margin: "0 5px 0 -6px",
                "&:hover": {
                    color: Nt(n, .4)
                }
            },
            deleteIconSmall: {
                height: 16,
                width: 16,
                marginRight: 4,
                marginLeft: -4
            },
            deleteIconColorPrimary: {
                color: Nt(e.palette.primary.contrastText, .7),
                "&:hover, &:active": {
                    color: e.palette.primary.contrastText
                }
            },
            deleteIconColorSecondary: {
                color: Nt(e.palette.secondary.contrastText, .7),
                "&:hover, &:active": {
                    color: e.palette.secondary.contrastText
                }
            },
            deleteIconOutlinedColorPrimary: {
                color: Nt(e.palette.primary.main, .7),
                "&:hover, &:active": {
                    color: e.palette.primary.main
                }
            },
            deleteIconOutlinedColorSecondary: {
                color: Nt(e.palette.secondary.main, .7),
                "&:hover, &:active": {
                    color: e.palette.secondary.main
                }
            }
        }
    }
    ), {
        name: "PwzrChip"
    })(El),
    {
        h1: "h1",
        h2: "h2",
        h3: "h3",
        h4: "h4",
        h5: "h5",
        h6: "h6",
        subtitle1: "h6",
        subtitle2: "h6",
        body1: "p",
        body2: "p"
    })
      , Ol = lt.forwardRef((function(e, t) {
        var n = e.align
          , r = void 0 === n ? "inherit" : n
          , i = e.classes
          , o = e.className
          , a = e.color
          , s = void 0 === a ? "initial" : a
          , l = e.component
          , c = e.display
          , u = void 0 === c ? "initial" : c
          , d = e.gutterBottom
          , p = void 0 !== d && d
          , f = e.noWrap
          , h = void 0 !== f && f
          , m = e.paragraph
          , v = void 0 !== m && m
          , g = e.variant
          , b = void 0 === g ? "body1" : g
          , y = e.variantMapping
          , w = void 0 === y ? kl : y
          , x = jt(e, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"])
          , _ = l || (v ? "p" : w[b] || kl[b]) || "span";
        return lt.createElement(_, Vt({
            className: Ra(i.root, o, "inherit" !== b && i[b], "initial" !== s && i["color".concat(gl(s))], h && i.noWrap, p && i.gutterBottom, v && i.paragraph, "inherit" !== r && i["align".concat(gl(r))], "initial" !== u && i["display".concat(gl(u))]),
            ref: t
        }, x))
    }
    ))
      , Tl = Ka((function(e) {
        return {
            root: {
                margin: 0
            },
            body2: e.typography.body2,
            body1: e.typography.body1,
            caption: e.typography.caption,
            button: e.typography.button,
            h1: e.typography.h1,
            h2: e.typography.h2,
            h3: e.typography.h3,
            h4: e.typography.h4,
            h5: e.typography.h5,
            h6: e.typography.h6,
            subtitle1: e.typography.subtitle1,
            subtitle2: e.typography.subtitle2,
            overline: e.typography.overline,
            srOnly: {
                position: "absolute",
                height: 1,
                width: 1,
                overflow: "hidden"
            },
            alignLeft: {
                textAlign: "left"
            },
            alignCenter: {
                textAlign: "center"
            },
            alignRight: {
                textAlign: "right"
            },
            alignJustify: {
                textAlign: "justify"
            },
            noWrap: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            },
            gutterBottom: {
                marginBottom: "0.35em"
            },
            paragraph: {
                marginBottom: 16
            },
            colorInherit: {
                color: "inherit"
            },
            colorPrimary: {
                color: e.palette.primary.main
            },
            colorSecondary: {
                color: e.palette.secondary.main
            },
            colorTextPrimary: {
                color: e.palette.text.primary
            },
            colorTextSecondary: {
                color: e.palette.text.secondary
            },
            colorError: {
                color: e.palette.error.main
            },
            displayInline: {
                display: "inline"
            },
            displayBlock: {
                display: "block"
            }
        }
    }
    ), {
        name: "PwzrTypography"
    })(Ol)
      , Ml = lt.forwardRef((function(e, t) {
        return lt.createElement(Tl, Vt({
            component: "p",
            variant: "body1",
            color: "textSecondary",
            ref: t
        }, e))
    }
    ))
      , Rl = (Ka({
        root: {
            marginBottom: 12
        }
    }, {
        name: "PwzrDialogContentText"
    })(Ml),
    lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.classes
          , i = e.className
          , o = e.disableTypography
          , a = void 0 !== o && o
          , s = jt(e, ["children", "classes", "className", "disableTypography"]);
        return lt.createElement("div", Vt({
            className: Ra(r.root, i),
            ref: t
        }, s), a ? n : lt.createElement(Tl, {
            component: "h2",
            variant: "h6"
        }, n))
    }
    )));
    Ka({
        root: {
            margin: 0,
            padding: "16px 24px",
            flex: "0 0 auto"
        }
    }, {
        name: "PwzrDialogTitle"
    })(Rl);
    function Pl(e) {
        var t = e.props
          , n = e.states
          , r = e.muiFormControl;
        return n.reduce((function(e, n) {
            return e[n] = t[n],
            r && void 0 === t[n] && (e[n] = r[n]),
            e
        }
        ), {})
    }
    var Il = lt.createContext();
    function zl() {
        return lt.useContext(Il)
    }
    var Al = lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.classes
          , i = e.className
          , o = (e.color,
        e.component)
          , a = void 0 === o ? "label" : o
          , s = (e.disabled,
        e.error,
        e.filled,
        e.focused,
        e.required,
        jt(e, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]))
          , l = Pl({
            props: e,
            muiFormControl: zl(),
            states: ["color", "required", "focused", "disabled", "error", "filled"]
        });
        return lt.createElement(a, Vt({
            className: Ra(r.root, r["color".concat(gl(l.color || "primary"))], i, l.disabled && r.disabled, l.error && r.error, l.filled && r.filled, l.focused && r.focused, l.required && r.required),
            ref: t
        }, s), n, l.required && lt.createElement("span", {
            className: Ra(r.asterisk, l.error && r.error)
        }, " ", "*"))
    }
    ))
      , Ll = Ka((function(e) {
        return {
            root: Vt({
                color: e.palette.text.secondary
            }, e.typography.body1, {
                lineHeight: 1,
                padding: 0,
                "&$focused": {
                    color: e.palette.primary.main
                },
                "&$disabled": {
                    color: e.palette.text.disabled
                },
                "&$error": {
                    color: e.palette.error.main
                }
            }),
            colorSecondary: {
                "&$focused": {
                    color: e.palette.secondary.main
                }
            },
            focused: {},
            disabled: {},
            error: {},
            filled: {},
            required: {},
            asterisk: {
                "&$error": {
                    color: e.palette.error.main
                }
            }
        }
    }
    ), {
        name: "PwzrFormLabel"
    })(Al);
    var Dl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      , Nl = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    function Wl(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1
          , n = parseFloat(e);
        return "".concat(n / t).concat(String(e).replace(String(n), "") || "px")
    }
    var Fl = lt.forwardRef((function(e, t) {
        var n = e.alignContent
          , r = void 0 === n ? "stretch" : n
          , i = e.alignItems
          , o = void 0 === i ? "stretch" : i
          , a = e.classes
          , s = e.className
          , l = e.component
          , c = void 0 === l ? "div" : l
          , u = e.container
          , d = void 0 !== u && u
          , p = e.direction
          , f = void 0 === p ? "row" : p
          , h = e.item
          , m = void 0 !== h && h
          , v = e.justify
          , g = void 0 === v ? "flex-start" : v
          , b = e.lg
          , y = void 0 !== b && b
          , w = e.md
          , x = void 0 !== w && w
          , _ = e.sm
          , C = void 0 !== _ && _
          , S = e.spacing
          , E = void 0 === S ? 0 : S
          , k = e.wrap
          , O = void 0 === k ? "wrap" : k
          , T = e.xl
          , M = void 0 !== T && T
          , R = e.xs
          , P = void 0 !== R && R
          , I = e.zeroMinWidth
          , z = void 0 !== I && I
          , A = jt(e, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"])
          , L = Ra(a.root, s, d && [a.container, 0 !== E && a["spacing-xs-".concat(String(E))]], m && a.item, z && a.zeroMinWidth, "row" !== f && a["direction-xs-".concat(String(f))], "wrap" !== O && a["wrap-xs-".concat(String(O))], "stretch" !== o && a["align-items-xs-".concat(String(o))], "stretch" !== r && a["align-content-xs-".concat(String(r))], "flex-start" !== g && a["justify-xs-".concat(String(g))], !1 !== P && a["grid-xs-".concat(String(P))], !1 !== C && a["grid-sm-".concat(String(C))], !1 !== x && a["grid-md-".concat(String(x))], !1 !== y && a["grid-lg-".concat(String(y))], !1 !== M && a["grid-xl-".concat(String(M))]);
        return lt.createElement(c, Vt({
            className: L,
            ref: t
        }, A))
    }
    ))
      , $l = Ka((function(e) {
        return Vt({
            root: {},
            container: {
                boxSizing: "border-box",
                display: "flex",
                flexWrap: "wrap",
                width: "100%"
            },
            item: {
                boxSizing: "border-box",
                margin: "0"
            },
            zeroMinWidth: {
                minWidth: 0
            },
            "direction-xs-column": {
                flexDirection: "column"
            },
            "direction-xs-column-reverse": {
                flexDirection: "column-reverse"
            },
            "direction-xs-row-reverse": {
                flexDirection: "row-reverse"
            },
            "wrap-xs-nowrap": {
                flexWrap: "nowrap"
            },
            "wrap-xs-wrap-reverse": {
                flexWrap: "wrap-reverse"
            },
            "align-items-xs-center": {
                alignItems: "center"
            },
            "align-items-xs-flex-start": {
                alignItems: "flex-start"
            },
            "align-items-xs-flex-end": {
                alignItems: "flex-end"
            },
            "align-items-xs-baseline": {
                alignItems: "baseline"
            },
            "align-content-xs-center": {
                alignContent: "center"
            },
            "align-content-xs-flex-start": {
                alignContent: "flex-start"
            },
            "align-content-xs-flex-end": {
                alignContent: "flex-end"
            },
            "align-content-xs-space-between": {
                alignContent: "space-between"
            },
            "align-content-xs-space-around": {
                alignContent: "space-around"
            },
            "justify-xs-center": {
                justifyContent: "center"
            },
            "justify-xs-flex-end": {
                justifyContent: "flex-end"
            },
            "justify-xs-space-between": {
                justifyContent: "space-between"
            },
            "justify-xs-space-around": {
                justifyContent: "space-around"
            },
            "justify-xs-space-evenly": {
                justifyContent: "space-evenly"
            }
        }, function(e, t) {
            var n = {};
            return Dl.forEach((function(r) {
                var i = e.spacing(r);
                0 !== i && (n["spacing-".concat(t, "-").concat(r)] = {
                    margin: "-".concat(Wl(i, 2)),
                    width: "calc(100% + ".concat(Wl(i), ")"),
                    "& > $item": {
                        padding: Wl(i, 2)
                    }
                })
            }
            )),
            n
        }(e, "xs"), {}, e.breakpoints.keys.reduce((function(t, n) {
            return function(e, t, n) {
                var r = {};
                Nl.forEach((function(e) {
                    var t = "grid-".concat(n, "-").concat(e);
                    if (!0 !== e)
                        if ("auto" !== e) {
                            var i = "".concat(Math.round(e / 12 * 1e8) / 1e6, "%");
                            r[t] = {
                                flexBasis: i,
                                flexGrow: 0,
                                maxWidth: i
                            }
                        } else
                            r[t] = {
                                flexBasis: "auto",
                                flexGrow: 0,
                                maxWidth: "none"
                            };
                    else
                        r[t] = {
                            flexBasis: 0,
                            flexGrow: 1,
                            maxWidth: "100%"
                        }
                }
                )),
                "xs" === n ? Vt(e, r) : e[t.breakpoints.up(n)] = r
            }(t, e, n),
            t
        }
        ), {}))
    }
    ), {
        name: "PwzrGrid"
    })(Fl)
      , Bl = lt.forwardRef((function(e, t) {
        var n = e.edge
          , r = void 0 !== n && n
          , i = e.children
          , o = e.classes
          , a = e.className
          , s = e.color
          , l = void 0 === s ? "default" : s
          , c = e.disabled
          , u = void 0 !== c && c
          , d = e.disableFocusRipple
          , p = void 0 !== d && d
          , f = e.size
          , h = void 0 === f ? "medium" : f
          , m = jt(e, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
        return lt.createElement(vl, Vt({
            className: Ra(o.root, a, "default" !== l && o["color".concat(gl(l))], u && o.disabled, "small" === h && o["size".concat(gl(h))], {
                start: o.edgeStart,
                end: o.edgeEnd
            }[r]),
            centerRipple: !0,
            focusRipple: !p,
            disabled: u,
            ref: t
        }, m), lt.createElement("span", {
            className: o.label
        }, i))
    }
    ))
      , jl = Ka((function(e) {
        return {
            root: {
                textAlign: "center",
                flex: "0 0 auto",
                fontSize: e.typography.pxToRem(24),
                padding: 12,
                borderRadius: "50%",
                overflow: "visible",
                color: e.palette.action.active,
                transition: e.transitions.create("background-color", {
                    duration: e.transitions.duration.shortest
                }),
                "&:hover": {
                    backgroundColor: Nt(e.palette.action.active, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                },
                "&$disabled": {
                    backgroundColor: "transparent",
                    color: e.palette.action.disabled
                }
            },
            edgeStart: {
                marginLeft: -12,
                "$sizeSmall&": {
                    marginLeft: -3
                }
            },
            edgeEnd: {
                marginRight: -12,
                "$sizeSmall&": {
                    marginRight: -3
                }
            },
            colorInherit: {
                color: "inherit"
            },
            colorPrimary: {
                color: e.palette.primary.main,
                "&:hover": {
                    backgroundColor: Nt(e.palette.primary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            colorSecondary: {
                color: e.palette.secondary.main,
                "&:hover": {
                    backgroundColor: Nt(e.palette.secondary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            disabled: {},
            sizeSmall: {
                padding: 3,
                fontSize: e.typography.pxToRem(18)
            },
            label: {
                width: "100%",
                display: "flex",
                alignItems: "inherit",
                justifyContent: "inherit"
            }
        }
    }
    ), {
        name: "PwzrIconButton"
    })(Bl)
      , Hl = lt.forwardRef((function(e, t) {
        var n = e.classes
          , r = e.className
          , i = e.color
          , o = void 0 === i ? "primary" : i
          , a = e.component
          , s = void 0 === a ? "a" : a
          , l = e.onBlur
          , c = e.onFocus
          , u = e.TypographyClasses
          , d = e.underline
          , p = void 0 === d ? "hover" : d
          , f = e.variant
          , h = void 0 === f ? "inherit" : f
          , m = jt(e, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"])
          , v = Ys()
          , g = v.isFocusVisible
          , b = v.onBlurVisible
          , y = v.ref
          , w = lt.useState(!1)
          , x = w[0]
          , _ = w[1]
          , C = Ds(t, y);
        return lt.createElement(Tl, Vt({
            className: Ra(n.root, n["underline".concat(gl(p))], r, x && n.focusVisible, "button" === s && n.button),
            classes: u,
            color: o,
            component: s,
            onBlur: function(e) {
                x && (b(),
                _(!1)),
                l && l(e)
            },
            onFocus: function(e) {
                g(e) && _(!0),
                c && c(e)
            },
            ref: C,
            variant: h
        }, m))
    }
    ))
      , Vl = Ka({
        root: {},
        underlineNone: {
            textDecoration: "none"
        },
        underlineHover: {
            textDecoration: "none",
            "&:hover": {
                textDecoration: "underline"
            }
        },
        underlineAlways: {
            textDecoration: "underline"
        },
        button: {
            position: "relative",
            WebkitTapHighlightColor: "transparent",
            backgroundColor: "transparent",
            outline: 0,
            border: 0,
            margin: 0,
            borderRadius: 0,
            padding: 0,
            cursor: "pointer",
            userSelect: "none",
            verticalAlign: "middle",
            "-moz-appearance": "none",
            "-webkit-appearance": "none",
            "&::-moz-focus-inner": {
                borderStyle: "none"
            },
            "&$focusVisible": {
                outline: "auto"
            }
        },
        focusVisible: {}
    }, {
        name: "PwzrLink"
    })(Hl);
    function ql(e, t) {
        return lt.isValidElement(e) && -1 !== t.indexOf(e.type.muiName)
    }
    var Ul = lt.createContext({});
    var Gl = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect
      , Zl = lt.forwardRef((function(e, t) {
        var n = e.alignItems
          , r = void 0 === n ? "center" : n
          , i = e.autoFocus
          , o = void 0 !== i && i
          , a = e.button
          , s = void 0 !== a && a
          , l = e.children
          , c = e.classes
          , u = e.className
          , d = e.component
          , p = e.ContainerComponent
          , f = void 0 === p ? "li" : p
          , h = e.ContainerProps
          , m = (h = void 0 === h ? {} : h).className
          , v = jt(h, ["className"])
          , g = e.dense
          , b = void 0 !== g && g
          , y = e.disabled
          , w = void 0 !== y && y
          , x = e.disableGutters
          , _ = void 0 !== x && x
          , C = e.divider
          , S = void 0 !== C && C
          , E = e.focusVisibleClassName
          , k = e.selected
          , O = void 0 !== k && k
          , T = jt(e, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"])
          , M = lt.useContext(Ul)
          , R = {
            dense: b || M.dense || !1,
            alignItems: r
        }
          , P = lt.useRef(null);
        Gl((function() {
            o && P.current && P.current.focus()
        }
        ), [o]);
        var I = lt.Children.toArray(l)
          , z = I.length && ql(I[I.length - 1], ["ListItemSecondaryAction"])
          , A = Ds(lt.useCallback((function(e) {
            P.current = lt.findDOMNode(e)
        }
        ), []), t)
          , L = Vt({
            className: Ra(c.root, u, R.dense && c.dense, !_ && c.gutters, S && c.divider, w && c.disabled, s && c.button, "center" !== r && c.alignItemsFlexStart, z && c.secondaryAction, O && c.selected),
            disabled: w
        }, T)
          , D = d || "li";
        return s && (L.component = d || "div",
        L.focusVisibleClassName = Ra(c.focusVisible, E),
        D = vl),
        z ? (D = L.component || d ? D : "div",
        "li" === f && ("li" === D ? D = "div" : "li" === L.component && (L.component = "div")),
        lt.createElement(Ul.Provider, {
            value: R
        }, lt.createElement(f, Vt({
            className: Ra(c.container, m),
            ref: A
        }, v), lt.createElement(D, L, I), I.pop()))) : lt.createElement(Ul.Provider, {
            value: R
        }, lt.createElement(D, Vt({
            ref: A
        }, L), I))
    }
    ))
      , Kl = Ka((function(e) {
        return {
            root: {
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                position: "relative",
                textDecoration: "none",
                width: "100%",
                boxSizing: "border-box",
                textAlign: "left",
                paddingTop: 8,
                paddingBottom: 8,
                "&$focusVisible": {
                    backgroundColor: e.palette.action.selected
                },
                "&$selected, &$selected:hover": {
                    backgroundColor: e.palette.action.selected
                },
                "&$disabled": {
                    opacity: .5
                }
            },
            container: {
                position: "relative"
            },
            focusVisible: {},
            dense: {
                paddingTop: 4,
                paddingBottom: 4
            },
            alignItemsFlexStart: {
                alignItems: "flex-start"
            },
            disabled: {},
            divider: {
                borderBottom: "1px solid ".concat(e.palette.divider),
                backgroundClip: "padding-box"
            },
            gutters: {
                paddingLeft: 16,
                paddingRight: 16
            },
            button: {
                transition: e.transitions.create("background-color", {
                    duration: e.transitions.duration.shortest
                }),
                "&:hover": {
                    textDecoration: "none",
                    backgroundColor: e.palette.action.hover,
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            secondaryAction: {
                paddingRight: 48
            },
            selected: {}
        }
    }
    ), {
        name: "PwzrListItem"
    })(Zl)
      , Yl = lt.forwardRef((function(e, t) {
        var n, r = e.classes, i = e.className, o = e.component, a = void 0 === o ? "li" : o, s = e.disableGutters, l = void 0 !== s && s, c = e.role, u = void 0 === c ? "menuitem" : c, d = e.selected, p = e.tabIndex, f = jt(e, ["classes", "className", "component", "disableGutters", "role", "selected", "tabIndex"]);
        return e.disabled || (n = void 0 !== p ? p : -1),
        lt.createElement(Kl, Vt({
            button: !0,
            role: u,
            tabIndex: n,
            component: a,
            selected: d,
            disableGutters: l,
            classes: {
                dense: r.dense
            },
            className: Ra(r.root, i, d && r.selected, !l && r.gutters),
            ref: t
        }, f))
    }
    ))
      , Xl = Ka((function(e) {
        return {
            root: Vt({}, e.typography.body1, $t({
                minHeight: 48,
                paddingTop: 6,
                paddingBottom: 6,
                boxSizing: "border-box",
                width: "auto",
                overflow: "hidden",
                whiteSpace: "nowrap"
            }, e.breakpoints.up("sm"), {
                minHeight: "auto"
            })),
            gutters: {},
            selected: {},
            dense: Vt({}, e.typography.body2, {
                minHeight: "auto"
            })
        }
    }
    ), {
        name: "PwzrMenuItem"
    })(Yl);
    function Jl(e) {
        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 166;
        function r() {
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
                i[o] = arguments[o];
            var a = this
              , s = function() {
                e.apply(a, i)
            };
            clearTimeout(t),
            t = setTimeout(s, n)
        }
        return r.clear = function() {
            clearTimeout(t)
        }
        ,
        r
    }
    function Ql(e) {
        return e && e.ownerDocument || document
    }
    function ec(e) {
        return Ql(e).defaultView || window
    }
    function tc() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
        return t.reduce((function(e, t) {
            return null == t ? e : function() {
                for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
                    r[i] = arguments[i];
                e.apply(this, r),
                t.apply(this, r)
            }
        }
        ), (function() {}
        ))
    }
    var nc = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect
      , rc = lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.container
          , i = e.disablePortal
          , o = void 0 !== i && i
          , a = e.onRendered
          , s = lt.useState(null)
          , l = s[0]
          , c = s[1]
          , u = Ds(lt.isValidElement(n) ? n.ref : null, t);
        return nc((function() {
            o || c(function(e) {
                return e = "function" == typeof e ? e() : e,
                lt.findDOMNode(e)
            }(r) || document.body)
        }
        ), [r, o]),
        nc((function() {
            if (l && !o)
                return Ls(t, l),
                function() {
                    Ls(t, null)
                }
        }
        ), [t, l, o]),
        nc((function() {
            a && (l || o) && a()
        }
        ), [a, l, o]),
        o ? lt.isValidElement(n) ? lt.cloneElement(n, {
            ref: u
        }) : n : l ? lt.createPortal(n, l) : l
    }
    ));
    function ic() {
        var e = document.createElement("div");
        e.style.width = "99px",
        e.style.height = "99px",
        e.style.position = "absolute",
        e.style.top = "-9999px",
        e.style.overflow = "scroll",
        document.body.appendChild(e);
        var t = e.offsetWidth - e.clientWidth;
        return document.body.removeChild(e),
        t
    }
    function oc(e, t) {
        t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden")
    }
    function ac(e) {
        return parseInt(window.getComputedStyle(e)["padding-right"], 10) || 0
    }
    function sc(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : []
          , i = arguments.length > 4 ? arguments[4] : void 0
          , o = [t, n].concat(yo(r))
          , a = ["TEMPLATE", "SCRIPT", "STYLE"];
        [].forEach.call(e.children, (function(e) {
            1 === e.nodeType && -1 === o.indexOf(e) && -1 === a.indexOf(e.tagName) && oc(e, i)
        }
        ))
    }
    function lc(e, t) {
        var n = -1;
        return e.some((function(e, r) {
            return !!t(e) && (n = r,
            !0)
        }
        )),
        n
    }
    function cc(e, t) {
        var n, r = [], i = [], o = e.container;
        if (!t.disableScrollLock) {
            if (function(e) {
                var t = Ql(e);
                return t.body === e ? ec(t).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight
            }(o)) {
                var a = ic();
                r.push({
                    value: o.style.paddingRight,
                    key: "padding-right",
                    el: o
                }),
                o.style["padding-right"] = "".concat(ac(o) + a, "px"),
                n = Ql(o).querySelectorAll(".mui-fixed"),
                [].forEach.call(n, (function(e) {
                    i.push(e.style.paddingRight),
                    e.style.paddingRight = "".concat(ac(e) + a, "px")
                }
                ))
            }
            var s = o.parentElement
              , l = "HTML" === s.nodeName && "scroll" === window.getComputedStyle(s)["overflow-y"] ? s : o;
            r.push({
                value: l.style.overflow,
                key: "overflow",
                el: l
            }),
            l.style.overflow = "hidden"
        }
        return function() {
            n && [].forEach.call(n, (function(e, t) {
                i[t] ? e.style.paddingRight = i[t] : e.style.removeProperty("padding-right")
            }
            )),
            r.forEach((function(e) {
                var t = e.value
                  , n = e.el
                  , r = e.key;
                t ? n.style.setProperty(r, t) : n.style.removeProperty(r)
            }
            ))
        }
    }
    var uc = function() {
        function e() {
            !function(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }(this, e),
            this.modals = [],
            this.containers = []
        }
        return Mr(e, [{
            key: "add",
            value: function(e, t) {
                var n = this.modals.indexOf(e);
                if (-1 !== n)
                    return n;
                n = this.modals.length,
                this.modals.push(e),
                e.modalRef && oc(e.modalRef, !1);
                var r = function(e) {
                    var t = [];
                    return [].forEach.call(e.children, (function(e) {
                        e.getAttribute && "true" === e.getAttribute("aria-hidden") && t.push(e)
                    }
                    )),
                    t
                }(t);
                sc(t, e.mountNode, e.modalRef, r, !0);
                var i = lc(this.containers, (function(e) {
                    return e.container === t
                }
                ));
                return -1 !== i ? (this.containers[i].modals.push(e),
                n) : (this.containers.push({
                    modals: [e],
                    container: t,
                    restore: null,
                    hiddenSiblingNodes: r
                }),
                n)
            }
        }, {
            key: "mount",
            value: function(e, t) {
                var n = lc(this.containers, (function(t) {
                    return -1 !== t.modals.indexOf(e)
                }
                ))
                  , r = this.containers[n];
                r.restore || (r.restore = cc(r, t))
            }
        }, {
            key: "remove",
            value: function(e) {
                var t = this.modals.indexOf(e);
                if (-1 === t)
                    return t;
                var n = lc(this.containers, (function(t) {
                    return -1 !== t.modals.indexOf(e)
                }
                ))
                  , r = this.containers[n];
                if (r.modals.splice(r.modals.indexOf(e), 1),
                this.modals.splice(t, 1),
                0 === r.modals.length)
                    r.restore && r.restore(),
                    e.modalRef && oc(e.modalRef, !0),
                    sc(r.container, e.mountNode, e.modalRef, r.hiddenSiblingNodes, !1),
                    this.containers.splice(n, 1);
                else {
                    var i = r.modals[r.modals.length - 1];
                    i.modalRef && oc(i.modalRef, !1)
                }
                return t
            }
        }, {
            key: "isTopModal",
            value: function(e) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === e
            }
        }]),
        e
    }();
    function dc(e) {
        var t = e.children
          , n = e.disableAutoFocus
          , r = void 0 !== n && n
          , i = e.disableEnforceFocus
          , o = void 0 !== i && i
          , a = e.disableRestoreFocus
          , s = void 0 !== a && a
          , l = e.getDoc
          , c = e.isEnabled
          , u = e.open
          , d = lt.useRef()
          , p = lt.useRef(null)
          , f = lt.useRef(null)
          , h = lt.useRef()
          , m = lt.useRef(null)
          , v = lt.useCallback((function(e) {
            m.current = lt.findDOMNode(e)
        }
        ), [])
          , g = Ds(t.ref, v);
        return lt.useMemo((function() {
            u && "undefined" != typeof window && (h.current = l().activeElement)
        }
        ), [u]),
        lt.useEffect((function() {
            if (u) {
                var e = Ql(m.current);
                r || !m.current || m.current.contains(e.activeElement) || (m.current.hasAttribute("tabIndex") || m.current.setAttribute("tabIndex", -1),
                m.current.focus());
                var t = function() {
                    o || !c() || d.current ? d.current = !1 : m.current && !m.current.contains(e.activeElement) && m.current.focus()
                }
                  , n = function(t) {
                    !o && c() && 9 === t.keyCode && e.activeElement === m.current && (d.current = !0,
                    t.shiftKey ? f.current.focus() : p.current.focus())
                };
                e.addEventListener("focus", t, !0),
                e.addEventListener("keydown", n, !0);
                var i = setInterval((function() {
                    t()
                }
                ), 50);
                return function() {
                    clearInterval(i),
                    e.removeEventListener("focus", t, !0),
                    e.removeEventListener("keydown", n, !0),
                    s || (h.current && h.current.focus && h.current.focus(),
                    h.current = null)
                }
            }
        }
        ), [r, o, s, c, u]),
        lt.createElement(lt.Fragment, null, lt.createElement("div", {
            tabIndex: 0,
            ref: p,
            "data-test": "sentinelStart"
        }), lt.cloneElement(t, {
            ref: g
        }), lt.createElement("div", {
            tabIndex: 0,
            ref: f,
            "data-test": "sentinelEnd"
        }))
    }
    var pc = {
        root: {
            zIndex: -1,
            position: "fixed",
            right: 0,
            bottom: 0,
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            WebkitTapHighlightColor: "transparent"
        },
        invisible: {
            backgroundColor: "transparent"
        }
    }
      , fc = lt.forwardRef((function(e, t) {
        var n = e.invisible
          , r = void 0 !== n && n
          , i = e.open
          , o = jt(e, ["invisible", "open"]);
        return i ? lt.createElement("div", Vt({
            "aria-hidden": !0,
            ref: t
        }, o, {
            style: Vt({}, pc.root, {}, r ? pc.invisible : {}, {}, o.style)
        })) : null
    }
    ));
    var hc = new uc
      , mc = lt.forwardRef((function(e, t) {
        var n = ji()
          , r = Er({
            name: "PwzrModal",
            props: Vt({}, e),
            theme: n
        })
          , i = r.BackdropComponent
          , o = void 0 === i ? fc : i
          , a = r.BackdropProps
          , s = r.children
          , l = r.closeAfterTransition
          , c = void 0 !== l && l
          , u = r.container
          , d = r.disableAutoFocus
          , p = void 0 !== d && d
          , f = r.disableBackdropClick
          , h = void 0 !== f && f
          , m = r.disableEnforceFocus
          , v = void 0 !== m && m
          , g = r.disableEscapeKeyDown
          , b = void 0 !== g && g
          , y = r.disablePortal
          , w = void 0 !== y && y
          , x = r.disableRestoreFocus
          , _ = void 0 !== x && x
          , C = r.disableScrollLock
          , S = void 0 !== C && C
          , E = r.hideBackdrop
          , k = void 0 !== E && E
          , O = r.keepMounted
          , T = void 0 !== O && O
          , M = r.manager
          , R = void 0 === M ? hc : M
          , P = r.onBackdropClick
          , I = r.onClose
          , z = r.onEscapeKeyDown
          , A = r.onRendered
          , L = r.open
          , D = jt(r, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"])
          , N = lt.useState(!0)
          , W = N[0]
          , F = N[1]
          , $ = lt.useRef({})
          , B = lt.useRef(null)
          , j = lt.useRef(null)
          , H = Ds(j, t)
          , V = function(e) {
            return !!e.children && e.children.props.hasOwnProperty("in")
        }(r)
          , q = function() {
            return Ql(B.current)
        }
          , U = function() {
            return $.current.modalRef = j.current,
            $.current.mountNode = B.current,
            $.current
        }
          , G = function() {
            R.mount(U(), {
                disableScrollLock: S
            }),
            j.current.scrollTop = 0
        }
          , Z = Ws((function() {
            var e = function(e) {
                return e = "function" == typeof e ? e() : e,
                lt.findDOMNode(e)
            }(u) || q().body;
            R.add(U(), e),
            j.current && G()
        }
        ))
          , K = lt.useCallback((function() {
            return R.isTopModal(U())
        }
        ), [R])
          , Y = Ws((function(e) {
            B.current = e,
            e && (A && A(),
            L && K() ? G() : oc(j.current, !0))
        }
        ))
          , X = lt.useCallback((function() {
            R.remove(U())
        }
        ), [R]);
        if (lt.useEffect((function() {
            return function() {
                X()
            }
        }
        ), [X]),
        lt.useEffect((function() {
            L ? Z() : V && c || X()
        }
        ), [L, X, V, c, Z]),
        !T && !L && (!V || W))
            return null;
        var J = function(e) {
            return {
                root: {
                    position: "fixed",
                    zIndex: e.zIndex.modal,
                    right: 0,
                    bottom: 0,
                    top: 0,
                    left: 0
                },
                hidden: {
                    visibility: "hidden"
                }
            }
        }(n || {
            zIndex: Cr
        })
          , Q = {};
        return void 0 === s.props.tabIndex && (Q.tabIndex = s.props.tabIndex || "-1"),
        V && (Q.onEnter = tc((function() {
            F(!1)
        }
        ), s.props.onEnter),
        Q.onExited = tc((function() {
            F(!0),
            c && X()
        }
        ), s.props.onExited)),
        lt.createElement(rc, {
            ref: Y,
            container: u,
            disablePortal: w
        }, lt.createElement("div", Vt({
            ref: H,
            onKeyDown: function(e) {
                "Escape" === e.key && K() && (e.stopPropagation(),
                z && z(e),
                !b && I && I(e, "escapeKeyDown"))
            },
            role: "presentation"
        }, D, {
            style: Vt({}, J.root, {}, !L && W ? J.hidden : {}, {}, D.style)
        }), k ? null : lt.createElement(o, Vt({
            open: L,
            onClick: function(e) {
                e.target === e.currentTarget && (P && P(e),
                !h && I && I(e, "backdropClick"))
            }
        }, a)), lt.createElement(dc, {
            disableEnforceFocus: v,
            disableAutoFocus: p,
            disableRestoreFocus: _,
            getDoc: q,
            isEnabled: K,
            open: L
        }, lt.cloneElement(s, Q))))
    }
    ));
    function vc(e, t) {
        var n = e.timeout
          , r = e.style
          , i = void 0 === r ? {} : r;
        return {
            duration: i.transitionDuration || "number" == typeof n ? n : n[t.mode] || 0,
            delay: i.transitionDelay
        }
    }
    function gc(e) {
        return "scale(".concat(e, ", ").concat(Math.pow(e, 2), ")")
    }
    var bc = {
        entering: {
            opacity: 1,
            transform: gc(1)
        },
        entered: {
            opacity: 1,
            transform: "none"
        }
    }
      , yc = lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.in
          , i = e.onEnter
          , o = e.onExit
          , a = e.style
          , s = e.timeout
          , l = void 0 === s ? "auto" : s
          , c = jt(e, ["children", "in", "onEnter", "onExit", "style", "timeout"])
          , u = lt.useRef()
          , d = lt.useRef()
          , p = Ds(n.ref, t)
          , f = Za();
        return lt.useEffect((function() {
            return function() {
                clearTimeout(u.current)
            }
        }
        ), []),
        lt.createElement(cl, Vt({
            appear: !0,
            in: r,
            onEnter: function(e, t) {
                !function(e) {
                    e.scrollTop
                }(e);
                var n, r = vc({
                    style: a,
                    timeout: l
                }, {
                    mode: "enter"
                }), o = r.duration, s = r.delay;
                "auto" === l ? (n = f.transitions.getAutoHeightDuration(e.clientHeight),
                d.current = n) : n = o,
                e.style.transition = [f.transitions.create("opacity", {
                    duration: n,
                    delay: s
                }), f.transitions.create("transform", {
                    duration: .666 * n,
                    delay: s
                })].join(","),
                i && i(e, t)
            },
            onExit: function(e) {
                var t, n = vc({
                    style: a,
                    timeout: l
                }, {
                    mode: "exit"
                }), r = n.duration, i = n.delay;
                "auto" === l ? (t = f.transitions.getAutoHeightDuration(e.clientHeight),
                d.current = t) : t = r,
                e.style.transition = [f.transitions.create("opacity", {
                    duration: t,
                    delay: i
                }), f.transitions.create("transform", {
                    duration: .666 * t,
                    delay: i || .333 * t
                })].join(","),
                e.style.opacity = "0",
                e.style.transform = gc(.75),
                o && o(e)
            },
            addEndListener: function(e, t) {
                "auto" === l && (u.current = setTimeout(t, d.current || 0))
            },
            timeout: "auto" === l ? null : l
        }, c), (function(e, t) {
            return lt.cloneElement(n, Vt({
                style: Vt({
                    opacity: 0,
                    transform: gc(.75),
                    visibility: "exited" !== e || r ? void 0 : "hidden"
                }, bc[e], {}, a, {}, n.props.style),
                ref: p
            }, t))
        }
        ))
    }
    ));
    yc.muiSupportAuto = !0;
    var wc = lt.forwardRef((function(e, t) {
        var n = e.classes
          , r = e.className
          , i = e.component
          , o = void 0 === i ? "div" : i
          , a = e.square
          , s = void 0 !== a && a
          , l = e.elevation
          , c = void 0 === l ? 1 : l
          , u = e.variant
          , d = void 0 === u ? "elevation" : u
          , p = jt(e, ["classes", "className", "component", "square", "elevation", "variant"]);
        return lt.createElement(o, Vt({
            className: Ra(n.root, r, "outlined" === d ? n.outlined : n["elevation".concat(c)], !s && n.rounded),
            ref: t
        }, p))
    }
    ))
      , xc = Ka((function(e) {
        var t = {};
        return e.shadows.forEach((function(e, n) {
            t["elevation".concat(n)] = {
                boxShadow: e
            }
        }
        )),
        Vt({
            root: {
                backgroundColor: e.palette.background.paper,
                color: e.palette.text.primary,
                transition: e.transitions.create("box-shadow")
            },
            rounded: {
                borderRadius: e.shape.borderRadius
            },
            outlined: {
                border: "1px solid ".concat(e.palette.divider)
            }
        }, t)
    }
    ), {
        name: "PwzrPaper"
    })(wc);
    function _c(e, t) {
        var n = 0;
        return "number" == typeof t ? n = t : "center" === t ? n = e.height / 2 : "bottom" === t && (n = e.height),
        n
    }
    function Cc(e, t) {
        var n = 0;
        return "number" == typeof t ? n = t : "center" === t ? n = e.width / 2 : "right" === t && (n = e.width),
        n
    }
    function Sc(e) {
        return [e.horizontal, e.vertical].map((function(e) {
            return "number" == typeof e ? "".concat(e, "px") : e
        }
        )).join(" ")
    }
    function Ec(e) {
        return "function" == typeof e ? e() : e
    }
    var kc = lt.forwardRef((function(e, t) {
        var n = e.action
          , r = e.anchorEl
          , i = e.anchorOrigin
          , o = void 0 === i ? {
            vertical: "top",
            horizontal: "left"
        } : i
          , a = e.anchorPosition
          , s = e.anchorReference
          , l = void 0 === s ? "anchorEl" : s
          , c = e.children
          , u = e.classes
          , d = e.className
          , p = e.container
          , f = e.elevation
          , h = void 0 === f ? 8 : f
          , m = e.getContentAnchorEl
          , v = e.marginThreshold
          , g = void 0 === v ? 16 : v
          , b = e.onEnter
          , y = e.onEntered
          , w = e.onEntering
          , x = e.onExit
          , _ = e.onExited
          , C = e.onExiting
          , S = e.open
          , E = e.PaperProps
          , k = void 0 === E ? {} : E
          , O = e.transformOrigin
          , T = void 0 === O ? {
            vertical: "top",
            horizontal: "left"
        } : O
          , M = e.TransitionComponent
          , R = void 0 === M ? yc : M
          , P = e.transitionDuration
          , I = void 0 === P ? "auto" : P
          , z = e.TransitionProps
          , A = void 0 === z ? {} : z
          , L = jt(e, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"])
          , D = lt.useRef()
          , N = lt.useCallback((function(e) {
            if ("anchorPosition" === l)
                return a;
            var t = Ec(r)
              , n = t instanceof ec(t).Element ? t : Ql(D.current).body
              , i = n.getBoundingClientRect()
              , s = 0 === e ? o.vertical : "center";
            return {
                top: i.top + _c(i, s),
                left: i.left + Cc(i, o.horizontal)
            }
        }
        ), [r, o.horizontal, o.vertical, a, l])
          , W = lt.useCallback((function(e) {
            var t = 0;
            if (m && "anchorEl" === l) {
                var n = m(e);
                if (n && e.contains(n)) {
                    var r = function(e, t) {
                        for (var n = t, r = 0; n && n !== e; )
                            r += (n = n.parentElement).scrollTop;
                        return r
                    }(e, n);
                    t = n.offsetTop + n.clientHeight / 2 - r || 0
                }
                0
            }
            return t
        }
        ), [o.vertical, l, m])
          , F = lt.useCallback((function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            return {
                vertical: _c(e, T.vertical) + t,
                horizontal: Cc(e, T.horizontal)
            }
        }
        ), [T.horizontal, T.vertical])
          , $ = lt.useCallback((function(e) {
            var t = W(e)
              , n = {
                width: e.offsetWidth,
                height: e.offsetHeight
            }
              , i = F(n, t);
            if ("none" === l)
                return {
                    top: null,
                    left: null,
                    transformOrigin: Sc(i)
                };
            var o = N(t)
              , a = o.top - i.vertical
              , s = o.left - i.horizontal
              , c = a + n.height
              , u = s + n.width
              , d = ec(Ec(r))
              , p = d.innerHeight - g
              , f = d.innerWidth - g;
            if (a < g) {
                var h = a - g;
                a -= h,
                i.vertical += h
            } else if (c > p) {
                var m = c - p;
                a -= m,
                i.vertical += m
            }
            if (s < g) {
                var v = s - g;
                s -= v,
                i.horizontal += v
            } else if (u > f) {
                var b = u - f;
                s -= b,
                i.horizontal += b
            }
            return {
                top: "".concat(Math.round(a), "px"),
                left: "".concat(Math.round(s), "px"),
                transformOrigin: Sc(i)
            }
        }
        ), [r, l, N, W, F, g])
          , B = lt.useCallback((function() {
            var e = D.current;
            if (e) {
                var t = $(e);
                null !== t.top && (e.style.top = t.top),
                null !== t.left && (e.style.left = t.left),
                e.style.transformOrigin = t.transformOrigin
            }
        }
        ), [$])
          , j = lt.useCallback((function(e) {
            D.current = lt.findDOMNode(e)
        }
        ), []);
        lt.useEffect((function() {
            S && B()
        }
        )),
        lt.useImperativeHandle(n, (function() {
            return S ? {
                updatePosition: function() {
                    B()
                }
            } : null
        }
        ), [S, B]),
        lt.useEffect((function() {
            if (S) {
                var e = Jl((function() {
                    B()
                }
                ));
                return window.addEventListener("resize", e),
                function() {
                    e.clear(),
                    window.removeEventListener("rezise", e)
                }
            }
        }
        ), [S, B]);
        var H = I;
        "auto" !== I || R.muiSupportAuto || (H = void 0);
        var V = p || (r ? Ql(Ec(r)).body : void 0);
        return lt.createElement(mc, Vt({
            container: V,
            open: S,
            ref: t,
            BackdropProps: {
                invisible: !0
            },
            className: Ra(u.root, d)
        }, L), lt.createElement(R, Vt({
            appear: !0,
            in: S,
            onEnter: b,
            onEntered: y,
            onExit: x,
            onExited: _,
            onExiting: C,
            timeout: H
        }, A, {
            onEntering: tc((function(e, t) {
                w && w(e, t),
                B()
            }
            ), A.onEntering)
        }), lt.createElement(xc, Vt({
            elevation: h,
            ref: j
        }, k, {
            className: Ra(u.paper, k.className)
        }), c)))
    }
    ))
      , Oc = Ka({
        root: {},
        paper: {
            position: "absolute",
            overflowY: "auto",
            overflowX: "hidden",
            minWidth: 16,
            minHeight: 16,
            maxWidth: "calc(100% - 32px)",
            maxHeight: "calc(100% - 32px)",
            outline: 0
        }
    }, {
        name: "PwzrPopover"
    })(kc)
      , Tc = lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.classes
          , i = e.className
          , o = e.component
          , a = void 0 === o ? "ul" : o
          , s = e.dense
          , l = void 0 !== s && s
          , c = e.disablePadding
          , u = void 0 !== c && c
          , d = e.subheader
          , p = jt(e, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"])
          , f = lt.useMemo((function() {
            return {
                dense: l
            }
        }
        ), [l]);
        return lt.createElement(Ul.Provider, {
            value: f
        }, lt.createElement(a, Vt({
            className: Ra(r.root, i, l && r.dense, !u && r.padding, d && r.subheader),
            ref: t
        }, p), d, n))
    }
    ))
      , Mc = Ka({
        root: {
            listStyle: "none",
            margin: 0,
            padding: 0,
            position: "relative"
        },
        padding: {
            paddingTop: 8,
            paddingBottom: 8
        },
        dense: {},
        subheader: {
            paddingTop: 0
        }
    }, {
        name: "PwzrList"
    })(Tc);
    function Rc(e, t, n) {
        return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild
    }
    function Pc(e, t, n) {
        return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild
    }
    function Ic(e, t) {
        if (void 0 === t)
            return !0;
        var n = e.innerText;
        return void 0 === n && (n = e.textContent),
        0 !== (n = n.trim().toLowerCase()).length && (t.repeating ? n[0] === t.keys[0] : 0 === n.indexOf(t.keys.join("")))
    }
    function zc(e, t, n, r, i) {
        for (var o = !1, a = r(e, t, !!t && n); a; ) {
            if (a === e.firstChild) {
                if (o)
                    return !1;
                o = !0
            }
            if (a.hasAttribute("tabindex") && !a.disabled && "true" !== a.getAttribute("aria-disabled") && Ic(a, i))
                return a.focus(),
                !0;
            a = r(e, a, n)
        }
        return !1
    }
    var Ac = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect
      , Lc = lt.forwardRef((function(e, t) {
        var n = e.actions
          , r = e.autoFocus
          , i = void 0 !== r && r
          , o = e.autoFocusItem
          , a = void 0 !== o && o
          , s = e.children
          , l = e.className
          , c = e.onKeyDown
          , u = e.disableListWrap
          , d = void 0 !== u && u
          , p = e.variant
          , f = void 0 === p ? "selectedMenu" : p
          , h = jt(e, ["actions", "autoFocus", "autoFocusItem", "children", "className", "onKeyDown", "disableListWrap", "variant"])
          , m = lt.useRef(null)
          , v = lt.useRef({
            keys: [],
            repeating: !0,
            previousKeyMatched: !0,
            lastTime: null
        });
        Ac((function() {
            i && m.current.focus()
        }
        ), [i]),
        lt.useImperativeHandle(n, (function() {
            return {
                adjustStyleForScrollbar: function(e, t) {
                    var n = !m.current.style.width;
                    if (e.clientHeight < m.current.clientHeight && n) {
                        var r = "".concat(ic(), "px");
                        m.current.style["rtl" === t.direction ? "paddingLeft" : "paddingRight"] = r,
                        m.current.style.width = "calc(100% + ".concat(r, ")")
                    }
                    return m.current
                }
            }
        }
        ), []);
        var g = Ds(lt.useCallback((function(e) {
            m.current = lt.findDOMNode(e)
        }
        ), []), t)
          , b = -1;
        lt.Children.forEach(s, (function(e, t) {
            lt.isValidElement(e) && (e.props.disabled || ("selectedMenu" === f && e.props.selected || -1 === b) && (b = t))
        }
        ));
        var y = lt.Children.map(s, (function(e, t) {
            if (t === b) {
                var n = {};
                if (a && (n.autoFocus = !0),
                void 0 === e.props.tabIndex && "selectedMenu" === f && (n.tabIndex = 0),
                null !== n)
                    return lt.cloneElement(e, n)
            }
            return e
        }
        ));
        return lt.createElement(Mc, Vt({
            role: "menu",
            ref: g,
            className: l,
            onKeyDown: function(e) {
                var t = m.current
                  , n = e.key
                  , r = Ql(t).activeElement;
                if ("ArrowDown" === n)
                    e.preventDefault(),
                    zc(t, r, d, Rc);
                else if ("ArrowUp" === n)
                    e.preventDefault(),
                    zc(t, r, d, Pc);
                else if ("Home" === n)
                    e.preventDefault(),
                    zc(t, null, d, Rc);
                else if ("End" === n)
                    e.preventDefault(),
                    zc(t, null, d, Pc);
                else if (1 === n.length) {
                    var i = v.current
                      , o = n.toLowerCase()
                      , a = performance.now();
                    i.keys.length > 0 && (a - i.lastTime > 500 ? (i.keys = [],
                    i.repeating = !0,
                    i.previousKeyMatched = !0) : i.repeating && o !== i.keys[0] && (i.repeating = !1)),
                    i.lastTime = a,
                    i.keys.push(o);
                    var s = r && !i.repeating && Ic(r, i);
                    i.previousKeyMatched && (s || zc(t, r, !1, Rc, i)) ? e.preventDefault() : i.previousKeyMatched = !1
                }
                c && c(e)
            },
            tabIndex: i ? 0 : -1
        }, h), y)
    }
    ))
      , Dc = {
        vertical: "top",
        horizontal: "right"
    }
      , Nc = {
        vertical: "top",
        horizontal: "left"
    }
      , Wc = lt.forwardRef((function(e, t) {
        var n = e.autoFocus
          , r = void 0 === n || n
          , i = e.children
          , o = e.classes
          , a = e.disableAutoFocusItem
          , s = void 0 !== a && a
          , l = e.MenuListProps
          , c = void 0 === l ? {} : l
          , u = e.onClose
          , d = e.onEntering
          , p = e.open
          , f = e.PaperProps
          , h = void 0 === f ? {} : f
          , m = e.PopoverClasses
          , v = e.transitionDuration
          , g = void 0 === v ? "auto" : v
          , b = e.variant
          , y = void 0 === b ? "selectedMenu" : b
          , w = jt(e, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"])
          , x = Za()
          , _ = r && !s && p
          , C = lt.useRef(null)
          , S = lt.useRef(null)
          , E = -1;
        lt.Children.map(i, (function(e, t) {
            lt.isValidElement(e) && (e.props.disabled || ("menu" !== y && e.props.selected || -1 === E) && (E = t))
        }
        ));
        var k = lt.Children.map(i, (function(e, t) {
            return t === E ? lt.cloneElement(e, {
                ref: function(t) {
                    S.current = lt.findDOMNode(t),
                    Ls(e.ref, t)
                }
            }) : e
        }
        ));
        return lt.createElement(Oc, Vt({
            getContentAnchorEl: function() {
                return S.current
            },
            classes: m,
            onClose: u,
            onEntering: function(e, t) {
                C.current && C.current.adjustStyleForScrollbar(e, x),
                d && d(e, t)
            },
            anchorOrigin: "rtl" === x.direction ? Dc : Nc,
            transformOrigin: "rtl" === x.direction ? Dc : Nc,
            PaperProps: Vt({}, h, {
                classes: Vt({}, h.classes, {
                    root: o.paper
                })
            }),
            open: p,
            ref: t,
            transitionDuration: g
        }, w), lt.createElement(Lc, Vt({
            onKeyDown: function(e) {
                "Tab" === e.key && (e.preventDefault(),
                u && u(e, "tabKeyDown"))
            },
            actions: C,
            autoFocus: r && (-1 === E || s),
            autoFocusItem: _,
            variant: y
        }, c, {
            className: Ra(o.list, c.className)
        }), k))
    }
    ))
      , Fc = Ka({
        paper: {
            maxHeight: "calc(100% - 96px)",
            WebkitOverflowScrolling: "touch"
        },
        list: {
            outline: 0
        }
    }, {
        name: "PwzrMenu"
    })(Wc);
    function $c(e) {
        return null != e && !(Array.isArray(e) && 0 === e.length)
    }
    function Bc(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return e && ($c(e.value) && "" !== e.value || t && $c(e.defaultValue) && "" !== e.defaultValue)
    }
    function jc(e) {
        var t = e.controlled
          , n = e.default
          , r = (e.name,
        lt.useRef(void 0 !== t).current)
          , i = lt.useState(n)
          , o = i[0]
          , a = i[1];
        return [r ? t : o, lt.useCallback((function(e) {
            r || a(e)
        }
        ), [])]
    }
    function Hc(e, t) {
        return "object" === Ut(t) && null !== t ? e === t : String(e) === String(t)
    }
    var Vc = lt.forwardRef((function(e, t) {
        var n = e.autoFocus
          , r = e.autoWidth
          , i = e.children
          , o = e.classes
          , a = e.className
          , s = e.defaultValue
          , l = e.disabled
          , c = e.displayEmpty
          , u = e.IconComponent
          , d = e.inputRef
          , p = e.labelId
          , f = e.MenuProps
          , h = void 0 === f ? {} : f
          , m = e.multiple
          , v = e.name
          , g = e.onBlur
          , b = e.onChange
          , y = e.onClose
          , w = e.onFocus
          , x = e.onOpen
          , _ = e.open
          , C = e.readOnly
          , S = e.renderValue
          , E = (e.required,
        e.SelectDisplayProps)
          , k = void 0 === E ? {} : E
          , O = e.tabIndex
          , T = (e.type,
        e.value)
          , M = e.variant
          , R = void 0 === M ? "standard" : M
          , P = jt(e, ["autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"])
          , I = ys(jc({
            controlled: T,
            default: s,
            name: "SelectInput"
        }), 2)
          , z = I[0]
          , A = I[1]
          , L = lt.useRef(null)
          , D = lt.useState(null)
          , N = D[0]
          , W = D[1]
          , F = lt.useRef(null != _).current
          , $ = lt.useState()
          , B = $[0]
          , j = $[1]
          , H = lt.useState(!1)
          , V = H[0]
          , q = H[1]
          , U = Ds(t, d);
        lt.useImperativeHandle(U, (function() {
            return {
                focus: function() {
                    N.focus()
                },
                node: L.current,
                value: z
            }
        }
        ), [N, z]),
        lt.useEffect((function() {
            n && N && N.focus()
        }
        ), [n, N]);
        var G, Z, K = function(e, t) {
            e ? x && x(t) : y && y(t),
            F || (j(r ? null : N.clientWidth),
            q(e))
        }, Y = function(e) {
            return function(t) {
                var n;
                if (m || K(!1, t),
                m) {
                    n = Array.isArray(z) ? yo(z) : [];
                    var r = z.indexOf(e.props.value);
                    -1 === r ? n.push(e.props.value) : n.splice(r, 1)
                } else
                    n = e.props.value;
                A(n),
                b && (t.persist(),
                Object.defineProperty(t, "target", {
                    writable: !0,
                    value: {
                        value: n,
                        name: v
                    }
                }),
                b(t, e))
            }
        }, X = null !== N && (F ? _ : V);
        delete P["aria-invalid"];
        var J = []
          , Q = !1;
        (Bc({
            value: z
        }) || c) && (S ? G = S(z) : Q = !0);
        var ee = lt.Children.map(i, (function(e) {
            if (!lt.isValidElement(e))
                return null;
            var t;
            if (m) {
                if (!Array.isArray(z))
                    throw new Error("Material-UI: the `value` prop must be an array when using the `Select` component with `multiple`.");
                (t = z.some((function(t) {
                    return Hc(t, e.props.value)
                }
                ))) && Q && J.push(e.props.children)
            } else
                (t = Hc(z, e.props.value)) && Q && (Z = e.props.children);
            return t && !0,
            lt.cloneElement(e, {
                "aria-selected": t ? "true" : void 0,
                onClick: Y(e),
                onKeyUp: function(t) {
                    " " === t.key && t.preventDefault();
                    var n = e.props.onKeyUp;
                    "function" == typeof n && n(t)
                },
                role: "option",
                selected: t,
                value: void 0,
                "data-value": e.props.value
            })
        }
        ));
        Q && (G = m ? J.join(", ") : Z);
        var te, ne = B;
        !r && F && N && (ne = N.clientWidth),
        te = void 0 !== O ? O : l ? null : 0;
        var re = k.id || (v ? "mui-component-select-".concat(v) : void 0);
        return lt.createElement(lt.Fragment, null, lt.createElement("div", Vt({
            className: Ra(o.root, o.select, o.selectMenu, o[R], a, l && o.disabled),
            ref: W,
            tabIndex: te,
            role: "button",
            "aria-expanded": X ? "true" : void 0,
            "aria-labelledby": "".concat(p || "", " ").concat(re || ""),
            "aria-haspopup": "listbox",
            onKeyDown: function(e) {
                if (!C) {
                    -1 !== [" ", "ArrowUp", "ArrowDown", "Enter"].indexOf(e.key) && (e.preventDefault(),
                    K(!0, e))
                }
            },
            onMouseDown: l || C ? null : function(e) {
                0 === e.button && (e.preventDefault(),
                N.focus(),
                K(!0, e))
            }
            ,
            onBlur: function(e) {
                !X && g && (e.persist(),
                Object.defineProperty(e, "target", {
                    writable: !0,
                    value: {
                        value: z,
                        name: v
                    }
                }),
                g(e))
            },
            onFocus: w
        }, k, {
            id: re
        }), function(e) {
            return null == e || "string" == typeof e && !e.trim()
        }(G) ? lt.createElement("span", {
            dangerouslySetInnerHTML: {
                __html: "&#8203;"
            }
        }) : G), lt.createElement("input", Vt({
            value: Array.isArray(z) ? z.join(",") : z,
            name: v,
            ref: L,
            type: "hidden",
            autoFocus: n
        }, P)), lt.createElement(u, {
            className: Ra(o.icon, o["icon".concat(gl(R))], X && o.iconOpen)
        }), lt.createElement(Fc, Vt({
            id: "menu-".concat(v || ""),
            anchorEl: N,
            open: X,
            onClose: function(e) {
                K(!1, e)
            }
        }, h, {
            MenuListProps: Vt({
                "aria-labelledby": p,
                role: "listbox",
                disableListWrap: !0
            }, h.MenuListProps),
            PaperProps: Vt({}, h.PaperProps, {
                style: Vt({
                    minWidth: ne
                }, null != h.PaperProps ? h.PaperProps.style : null)
            })
        }), ee))
    }
    ))
      , qc = Cl(lt.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));
    function Uc(e, t) {
        return parseInt(e[t], 10) || 0
    }
    var Gc = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect
      , Zc = {
        visibility: "hidden",
        position: "absolute",
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        transform: "translateZ(0)"
    }
      , Kc = lt.forwardRef((function(e, t) {
        var n = e.onChange
          , r = e.rows
          , i = e.rowsMax
          , o = e.rowsMin
          , a = void 0 === o ? 1 : o
          , s = e.style
          , l = e.value
          , c = jt(e, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"])
          , u = r || a
          , d = lt.useRef(null != l).current
          , p = lt.useRef(null)
          , f = Ds(t, p)
          , h = lt.useRef(null)
          , m = lt.useState({})
          , v = m[0]
          , g = m[1]
          , b = lt.useCallback((function() {
            var t = p.current
              , n = window.getComputedStyle(t)
              , r = h.current;
            r.style.width = n.width,
            r.value = t.value || e.placeholder || "x";
            var o = n["box-sizing"]
              , a = Uc(n, "padding-bottom") + Uc(n, "padding-top")
              , s = Uc(n, "border-bottom-width") + Uc(n, "border-top-width")
              , l = r.scrollHeight - a;
            r.value = "x";
            var c = r.scrollHeight - a
              , d = l;
            u && (d = Math.max(Number(u) * c, d)),
            i && (d = Math.min(Number(i) * c, d));
            var f = (d = Math.max(d, c)) + ("border-box" === o ? a + s : 0)
              , m = Math.abs(d - l) <= 1;
            g((function(e) {
                return f > 0 && Math.abs((e.outerHeightStyle || 0) - f) > 1 || e.overflow !== m ? {
                    overflow: m,
                    outerHeightStyle: f
                } : e
            }
            ))
        }
        ), [i, u, e.placeholder]);
        lt.useEffect((function() {
            var e = Jl((function() {
                b()
            }
            ));
            return window.addEventListener("resize", e),
            function() {
                e.clear(),
                window.removeEventListener("resize", e)
            }
        }
        ), [b]),
        Gc((function() {
            b()
        }
        ));
        return lt.createElement(lt.Fragment, null, lt.createElement("textarea", Vt({
            value: l,
            onChange: function(e) {
                d || b(),
                n && n(e)
            },
            ref: f,
            rows: u,
            style: Vt({
                height: v.outerHeightStyle,
                overflow: v.overflow ? "hidden" : null
            }, s)
        }, c)), lt.createElement("textarea", {
            "aria-hidden": !0,
            className: e.className,
            readOnly: !0,
            ref: h,
            tabIndex: -1,
            style: Vt({}, Zc, {}, s)
        }))
    }
    ))
      , Yc = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect
      , Xc = lt.forwardRef((function(e, t) {
        var n = e["aria-describedby"]
          , r = e.autoComplete
          , i = e.autoFocus
          , o = e.classes
          , a = e.className
          , s = (e.color,
        e.defaultValue)
          , l = e.disabled
          , c = e.endAdornment
          , u = (e.error,
        e.fullWidth)
          , d = void 0 !== u && u
          , p = e.id
          , f = e.inputComponent
          , h = void 0 === f ? "input" : f
          , m = e.inputProps
          , v = void 0 === m ? {} : m
          , g = e.inputRef
          , b = (e.margin,
        e.multiline)
          , y = void 0 !== b && b
          , w = e.name
          , x = e.onBlur
          , _ = e.onChange
          , C = e.onClick
          , S = e.onFocus
          , E = e.onKeyDown
          , k = e.onKeyUp
          , O = e.placeholder
          , T = e.readOnly
          , M = e.renderSuffix
          , R = e.rows
          , P = e.rowsMax
          , I = e.rowsMin
          , z = e.startAdornment
          , A = e.type
          , L = void 0 === A ? "text" : A
          , D = e.value
          , N = jt(e, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"])
          , W = null != v.value ? v.value : D
          , F = lt.useRef(null != W).current
          , $ = lt.useRef()
          , B = lt.useCallback((function(e) {
            0
        }
        ), [])
          , j = Ds(v.ref, B)
          , H = Ds(g, j)
          , V = Ds($, H)
          , q = lt.useState(!1)
          , U = q[0]
          , G = q[1]
          , Z = lt.useContext(Il);
        var K = Pl({
            props: e,
            muiFormControl: Z,
            states: ["color", "disabled", "error", "hiddenLabel", "margin", "required", "filled"]
        });
        K.focused = Z ? Z.focused : U,
        lt.useEffect((function() {
            !Z && l && U && (G(!1),
            x && x())
        }
        ), [Z, l, U, x]);
        var Y = Z && Z.onFilled
          , X = Z && Z.onEmpty
          , J = lt.useCallback((function(e) {
            Bc(e) ? Y && Y() : X && X()
        }
        ), [Y, X]);
        Yc((function() {
            F && J({
                value: W
            })
        }
        ), [W, J, F]);
        lt.useEffect((function() {
            J($.current)
        }
        ), []);
        var Q = h
          , ee = Vt({}, v, {
            ref: V
        });
        "string" != typeof Q ? ee = Vt({
            inputRef: V,
            type: L
        }, ee, {
            ref: null
        }) : y ? !R || P || I ? (ee = Vt({
            rows: R,
            rowsMax: P
        }, ee),
        Q = Kc) : Q = "textarea" : ee = Vt({
            type: L
        }, ee);
        return lt.useEffect((function() {
            Z && Z.setAdornedStart(Boolean(z))
        }
        ), [Z, z]),
        lt.createElement("div", Vt({
            className: Ra(o.root, o["color".concat(gl(K.color || "primary"))], a, K.disabled && o.disabled, K.error && o.error, d && o.fullWidth, K.focused && o.focused, Z && o.formControl, y && o.multiline, z && o.adornedStart, c && o.adornedEnd, "dense" === K.margin && o.marginDense),
            onClick: function(e) {
                $.current && e.currentTarget === e.target && $.current.focus(),
                C && C(e)
            },
            ref: t
        }, N), z, lt.createElement(Il.Provider, {
            value: null
        }, lt.createElement(Q, Vt({
            "aria-invalid": K.error,
            "aria-describedby": n,
            autoComplete: r,
            autoFocus: i,
            defaultValue: s,
            disabled: K.disabled,
            id: p,
            onAnimationStart: function(e) {
                J("mui-auto-fill-cancel" === e.animationName ? $.current : {
                    value: "x"
                })
            },
            name: w,
            placeholder: O,
            readOnly: T,
            required: K.required,
            rows: R,
            value: W,
            onKeyDown: E,
            onKeyUp: k
        }, ee, {
            className: Ra(o.input, v.className, K.disabled && o.disabled, y && o.inputMultiline, K.hiddenLabel && o.inputHiddenLabel, z && o.inputAdornedStart, c && o.inputAdornedEnd, "search" === L && o.inputTypeSearch, "dense" === K.margin && o.inputMarginDense),
            onBlur: function(e) {
                x && x(e),
                v.onBlur && v.onBlur(e),
                Z && Z.onBlur ? Z.onBlur(e) : G(!1)
            },
            onChange: function(e) {
                if (!F) {
                    var t = e.target || $.current;
                    if (null == t)
                        throw new TypeError("Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info.");
                    J({
                        value: t.value
                    })
                }
                for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
                    r[i - 1] = arguments[i];
                v.onChange && v.onChange.apply(v, [e].concat(r)),
                _ && _.apply(void 0, [e].concat(r))
            },
            onFocus: function(e) {
                K.disabled ? e.stopPropagation() : (S && S(e),
                v.onFocus && v.onFocus(e),
                Z && Z.onFocus ? Z.onFocus(e) : G(!0))
            }
        }))), c, M ? M(Vt({}, K, {
            startAdornment: z
        })) : null)
    }
    ))
      , Jc = Ka((function(e) {
        var t = "light" === e.palette.type
          , n = {
            color: "currentColor",
            opacity: t ? .42 : .5,
            transition: e.transitions.create("opacity", {
                duration: e.transitions.duration.shorter
            })
        }
          , r = {
            opacity: "0 !important"
        }
          , i = {
            opacity: t ? .42 : .5
        };
        return {
            "@global": {
                "@keyframes mui-auto-fill": {
                    from: {}
                },
                "@keyframes mui-auto-fill-cancel": {
                    from: {}
                }
            },
            root: Vt({}, e.typography.body1, {
                color: e.palette.text.primary,
                lineHeight: "1.1875em",
                boxSizing: "border-box",
                position: "relative",
                cursor: "text",
                display: "inline-flex",
                alignItems: "center",
                "&$disabled": {
                    color: e.palette.text.disabled,
                    cursor: "default"
                }
            }),
            formControl: {},
            focused: {},
            disabled: {},
            adornedStart: {},
            adornedEnd: {},
            error: {},
            marginDense: {},
            multiline: {
                padding: "".concat(6, "px 0 ").concat(7, "px"),
                "&$marginDense": {
                    paddingTop: 3
                }
            },
            colorSecondary: {},
            fullWidth: {
                width: "100%"
            },
            input: {
                font: "inherit",
                color: "currentColor",
                padding: "".concat(6, "px 0 ").concat(7, "px"),
                border: 0,
                boxSizing: "content-box",
                background: "none",
                height: "1.1875em",
                margin: 0,
                WebkitTapHighlightColor: "transparent",
                display: "block",
                minWidth: 0,
                width: "100%",
                animationName: "mui-auto-fill-cancel",
                "&::-webkit-input-placeholder": n,
                "&::-moz-placeholder": n,
                "&:-ms-input-placeholder": n,
                "&::-ms-input-placeholder": n,
                "&:focus": {
                    outline: 0
                },
                "&:invalid": {
                    boxShadow: "none"
                },
                "&::-webkit-search-decoration": {
                    "-webkit-appearance": "none"
                },
                "label[data-shrink=false] + $formControl &": {
                    "&::-webkit-input-placeholder": r,
                    "&::-moz-placeholder": r,
                    "&:-ms-input-placeholder": r,
                    "&::-ms-input-placeholder": r,
                    "&:focus::-webkit-input-placeholder": i,
                    "&:focus::-moz-placeholder": i,
                    "&:focus:-ms-input-placeholder": i,
                    "&:focus::-ms-input-placeholder": i
                },
                "&$disabled": {
                    opacity: 1
                },
                "&:-webkit-autofill": {
                    animationDuration: "5000s",
                    animationName: "mui-auto-fill"
                }
            },
            inputMarginDense: {
                paddingTop: 3
            },
            inputMultiline: {
                height: "auto",
                resize: "none",
                padding: 0
            },
            inputTypeSearch: {
                "-moz-appearance": "textfield",
                "-webkit-appearance": "textfield"
            },
            inputAdornedStart: {},
            inputAdornedEnd: {},
            inputHiddenLabel: {}
        }
    }
    ), {
        name: "PwzrInputBase"
    })(Xc)
      , Qc = lt.forwardRef((function(e, t) {
        var n = e.disableUnderline
          , r = e.classes
          , i = e.fullWidth
          , o = void 0 !== i && i
          , a = e.inputComponent
          , s = void 0 === a ? "input" : a
          , l = e.multiline
          , c = void 0 !== l && l
          , u = e.type
          , d = void 0 === u ? "text" : u
          , p = jt(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
        return lt.createElement(Jc, Vt({
            classes: Vt({}, r, {
                root: Ra(r.root, !n && r.underline),
                underline: null
            }),
            fullWidth: o,
            inputComponent: s,
            multiline: c,
            ref: t,
            type: d
        }, p))
    }
    ));
    Qc.muiName = "Input";
    var eu = Ka((function(e) {
        var t = "light" === e.palette.type ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
        return {
            root: {
                position: "relative"
            },
            formControl: {
                "label + &": {
                    marginTop: 16
                }
            },
            focused: {},
            disabled: {},
            colorSecondary: {
                "&$underline:after": {
                    borderBottomColor: e.palette.secondary.main
                }
            },
            underline: {
                "&:after": {
                    borderBottom: "2px solid ".concat(e.palette.primary.main),
                    left: 0,
                    bottom: 0,
                    content: '""',
                    position: "absolute",
                    right: 0,
                    transform: "scaleX(0)",
                    transition: e.transitions.create("transform", {
                        duration: e.transitions.duration.shorter,
                        easing: e.transitions.easing.easeOut
                    }),
                    pointerEvents: "none"
                },
                "&$focused:after": {
                    transform: "scaleX(1)"
                },
                "&$error:after": {
                    borderBottomColor: e.palette.error.main,
                    transform: "scaleX(1)"
                },
                "&:before": {
                    borderBottom: "1px solid ".concat(t),
                    left: 0,
                    bottom: 0,
                    content: '"\\00a0"',
                    position: "absolute",
                    right: 0,
                    transition: e.transitions.create("border-bottom-color", {
                        duration: e.transitions.duration.shorter
                    }),
                    pointerEvents: "none"
                },
                "&:hover:not($disabled):before": {
                    borderBottom: "2px solid ".concat(e.palette.text.primary),
                    "@media (hover: none)": {
                        borderBottom: "1px solid ".concat(t)
                    }
                },
                "&$disabled:before": {
                    borderBottomStyle: "dotted"
                }
            },
            error: {},
            marginDense: {},
            multiline: {},
            fullWidth: {},
            input: {},
            inputMarginDense: {},
            inputMultiline: {},
            inputTypeSearch: {}
        }
    }
    ), {
        name: "PwzrInput"
    })(Qc)
      , tu = lt.forwardRef((function(e, t) {
        var n = e.classes
          , r = e.className
          , i = e.disabled
          , o = e.IconComponent
          , a = e.inputRef
          , s = e.variant
          , l = void 0 === s ? "standard" : s
          , c = jt(e, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
        return lt.createElement(lt.Fragment, null, lt.createElement("select", Vt({
            className: Ra(n.root, n.select, n[l], r, i && n.disabled),
            disabled: i,
            ref: a || t
        }, c)), e.multiple ? null : lt.createElement(o, {
            className: Ra(n.icon, n["icon".concat(gl(l))])
        }))
    }
    ))
      , nu = function(e) {
        return {
            root: {},
            select: {
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                userSelect: "none",
                borderRadius: 0,
                minWidth: 16,
                cursor: "pointer",
                "&:focus": {
                    backgroundColor: "light" === e.palette.type ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                    borderRadius: 0
                },
                "&::-ms-expand": {
                    display: "none"
                },
                "&$disabled": {
                    cursor: "default"
                },
                "&[multiple]": {
                    height: "auto"
                },
                "&:not([multiple]) option, &:not([multiple]) optgroup": {
                    backgroundColor: e.palette.background.paper
                },
                "&&": {
                    paddingRight: 24
                }
            },
            filled: {
                "&&": {
                    paddingRight: 32
                }
            },
            outlined: {
                borderRadius: e.shape.borderRadius,
                "&&": {
                    paddingRight: 32
                }
            },
            selectMenu: {
                height: "auto",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden"
            },
            disabled: {},
            icon: {
                position: "absolute",
                right: 0,
                top: "calc(50% - 12px)",
                color: e.palette.action.active,
                pointerEvents: "none"
            },
            iconOpen: {
                transform: "rotate(180deg)"
            },
            iconFilled: {
                right: 7
            },
            iconOutlined: {
                right: 7
            }
        }
    }
      , ru = lt.createElement(eu, null)
      , iu = lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.classes
          , i = e.IconComponent
          , o = void 0 === i ? qc : i
          , a = e.input
          , s = void 0 === a ? ru : a
          , l = e.inputProps
          , c = (e.variant,
        jt(e, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]))
          , u = Pl({
            props: e,
            muiFormControl: zl(),
            states: ["variant"]
        });
        return lt.cloneElement(s, Vt({
            inputComponent: tu,
            inputProps: Vt({
                children: n,
                classes: r,
                IconComponent: o,
                variant: u.variant,
                type: void 0
            }, l, {}, s ? s.props.inputProps : {}),
            ref: t
        }, c))
    }
    ));
    iu.muiName = "Select";
    Ka(nu, {
        name: "PwzrNativeSelect"
    })(iu);
    var ou = lt.forwardRef((function(e, t) {
        var n = e.disableUnderline
          , r = e.classes
          , i = e.fullWidth
          , o = void 0 !== i && i
          , a = e.inputComponent
          , s = void 0 === a ? "input" : a
          , l = e.multiline
          , c = void 0 !== l && l
          , u = e.type
          , d = void 0 === u ? "text" : u
          , p = jt(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
        return lt.createElement(Jc, Vt({
            classes: Vt({}, r, {
                root: Ra(r.root, !n && r.underline),
                underline: null
            }),
            fullWidth: o,
            inputComponent: s,
            multiline: c,
            ref: t,
            type: d
        }, p))
    }
    ));
    ou.muiName = "Input";
    var au = Ka((function(e) {
        var t = "light" === e.palette.type
          , n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)"
          , r = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
        return {
            root: {
                position: "relative",
                backgroundColor: r,
                borderTopLeftRadius: e.shape.borderRadius,
                borderTopRightRadius: e.shape.borderRadius,
                transition: e.transitions.create("background-color", {
                    duration: e.transitions.duration.shorter,
                    easing: e.transitions.easing.easeOut
                }),
                "&:hover": {
                    backgroundColor: t ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                    "@media (hover: none)": {
                        backgroundColor: r
                    }
                },
                "&$focused": {
                    backgroundColor: t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
                },
                "&$disabled": {
                    backgroundColor: t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
                }
            },
            colorSecondary: {
                "&$underline:after": {
                    borderBottomColor: e.palette.secondary.main
                }
            },
            underline: {
                "&:after": {
                    borderBottom: "2px solid ".concat(e.palette.primary.main),
                    left: 0,
                    bottom: 0,
                    content: '""',
                    position: "absolute",
                    right: 0,
                    transform: "scaleX(0)",
                    transition: e.transitions.create("transform", {
                        duration: e.transitions.duration.shorter,
                        easing: e.transitions.easing.easeOut
                    }),
                    pointerEvents: "none"
                },
                "&$focused:after": {
                    transform: "scaleX(1)"
                },
                "&$error:after": {
                    borderBottomColor: e.palette.error.main,
                    transform: "scaleX(1)"
                },
                "&:before": {
                    borderBottom: "1px solid ".concat(n),
                    left: 0,
                    bottom: 0,
                    content: '"\\00a0"',
                    position: "absolute",
                    right: 0,
                    transition: e.transitions.create("border-bottom-color", {
                        duration: e.transitions.duration.shorter
                    }),
                    pointerEvents: "none"
                },
                "&:hover:before": {
                    borderBottom: "1px solid ".concat(e.palette.text.primary)
                },
                "&$disabled:before": {
                    borderBottomStyle: "dotted"
                }
            },
            focused: {},
            disabled: {},
            adornedStart: {
                paddingLeft: 12
            },
            adornedEnd: {
                paddingRight: 12
            },
            error: {},
            marginDense: {},
            multiline: {
                padding: "27px 12px 10px",
                "&$marginDense": {
                    paddingTop: 23,
                    paddingBottom: 6
                }
            },
            input: {
                padding: "27px 12px 10px",
                "&:-webkit-autofill": {
                    WebkitBoxShadow: "dark" === e.palette.type ? "0 0 0 100px #266798 inset" : null,
                    WebkitTextFillColor: "dark" === e.palette.type ? "#fff" : null,
                    borderTopLeftRadius: "inherit",
                    borderTopRightRadius: "inherit"
                }
            },
            inputMarginDense: {
                paddingTop: 23,
                paddingBottom: 6
            },
            inputHiddenLabel: {
                paddingTop: 18,
                paddingBottom: 19,
                "&$inputMarginDense": {
                    paddingTop: 10,
                    paddingBottom: 11
                }
            },
            inputMultiline: {
                padding: 0
            },
            inputAdornedStart: {
                paddingLeft: 0
            },
            inputAdornedEnd: {
                paddingRight: 0
            }
        }
    }
    ), {
        name: "PwzrFilledInput"
    })(ou)
      , su = lt.forwardRef((function(e, t) {
        e.children;
        var n = e.classes
          , r = e.className
          , i = e.label
          , o = e.labelWidth
          , a = e.notched
          , s = e.style
          , l = jt(e, ["children", "classes", "className", "label", "labelWidth", "notched", "style"])
          , c = "rtl" === Za().direction ? "right" : "left";
        if (void 0 !== i)
            return lt.createElement("fieldset", Vt({
                "aria-hidden": !0,
                className: Ra(n.root, r),
                ref: t,
                style: s
            }, l), lt.createElement("legend", {
                className: Ra(n.legendLabelled, a && n.legendNotched)
            }, i ? lt.createElement("span", null, i) : lt.createElement("span", {
                dangerouslySetInnerHTML: {
                    __html: "&#8203;"
                }
            })));
        var u = o > 0 ? .75 * o + 8 : .01;
        return lt.createElement("fieldset", Vt({
            "aria-hidden": !0,
            style: Vt($t({}, "padding".concat(gl(c)), 8), s),
            className: Ra(n.root, r),
            ref: t
        }, l), lt.createElement("legend", {
            className: n.legend,
            style: {
                width: a ? u : .01
            }
        }, lt.createElement("span", {
            dangerouslySetInnerHTML: {
                __html: "&#8203;"
            }
        })))
    }
    ))
      , lu = Ka((function(e) {
        return {
            root: {
                position: "absolute",
                bottom: 0,
                right: 0,
                top: -5,
                left: 0,
                margin: 0,
                padding: 0,
                paddingLeft: 8,
                pointerEvents: "none",
                borderRadius: "inherit",
                borderStyle: "solid",
                borderWidth: 1
            },
            legend: {
                textAlign: "left",
                padding: 0,
                lineHeight: "11px",
                transition: e.transitions.create("width", {
                    duration: 150,
                    easing: e.transitions.easing.easeOut
                })
            },
            legendLabelled: {
                display: "block",
                width: "auto",
                textAlign: "left",
                padding: 0,
                height: 11,
                fontSize: "0.75em",
                visibility: "hidden",
                maxWidth: .01,
                transition: e.transitions.create("max-width", {
                    duration: 50,
                    easing: e.transitions.easing.easeOut
                }),
                "& span": {
                    paddingLeft: 5,
                    paddingRight: 5
                }
            },
            legendNotched: {
                maxWidth: 1e3,
                transition: e.transitions.create("max-width", {
                    duration: 100,
                    easing: e.transitions.easing.easeOut,
                    delay: 50
                })
            }
        }
    }
    ), {
        name: "PrivateNotchedOutline"
    })(su)
      , cu = lt.forwardRef((function(e, t) {
        var n = e.classes
          , r = e.fullWidth
          , i = void 0 !== r && r
          , o = e.inputComponent
          , a = void 0 === o ? "input" : o
          , s = e.label
          , l = e.labelWidth
          , c = void 0 === l ? 0 : l
          , u = e.multiline
          , d = void 0 !== u && u
          , p = e.notched
          , f = e.type
          , h = void 0 === f ? "text" : f
          , m = jt(e, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
        return lt.createElement(Jc, Vt({
            renderSuffix: function(e) {
                return lt.createElement(lu, {
                    className: n.notchedOutline,
                    label: s,
                    labelWidth: c,
                    notched: void 0 !== p ? p : Boolean(e.startAdornment || e.filled || e.focused)
                })
            },
            classes: Vt({}, n, {
                root: Ra(n.root, n.underline),
                notchedOutline: null
            }),
            fullWidth: i,
            inputComponent: a,
            multiline: d,
            ref: t,
            type: h
        }, m))
    }
    ));
    cu.muiName = "Input";
    var uu = Ka((function(e) {
        var t = "light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
        return {
            root: {
                position: "relative",
                borderRadius: e.shape.borderRadius,
                "&:hover $notchedOutline": {
                    borderColor: e.palette.text.primary
                },
                "@media (hover: none)": {
                    "&:hover $notchedOutline": {
                        borderColor: t
                    }
                },
                "&$focused $notchedOutline": {
                    borderColor: e.palette.primary.main,
                    borderWidth: 2
                },
                "&$error $notchedOutline": {
                    borderColor: e.palette.error.main
                },
                "&$disabled $notchedOutline": {
                    borderColor: e.palette.action.disabled
                }
            },
            colorSecondary: {
                "&$focused $notchedOutline": {
                    borderColor: e.palette.secondary.main
                }
            },
            focused: {},
            disabled: {},
            adornedStart: {
                paddingLeft: 14
            },
            adornedEnd: {
                paddingRight: 14
            },
            error: {},
            marginDense: {},
            multiline: {
                padding: "18.5px 14px",
                "&$marginDense": {
                    paddingTop: 10.5,
                    paddingBottom: 10.5
                }
            },
            notchedOutline: {
                borderColor: t
            },
            input: {
                padding: "18.5px 14px",
                "&:-webkit-autofill": {
                    WebkitBoxShadow: "dark" === e.palette.type ? "0 0 0 100px #266798 inset" : null,
                    WebkitTextFillColor: "dark" === e.palette.type ? "#fff" : null,
                    borderRadius: "inherit"
                }
            },
            inputMarginDense: {
                paddingTop: 10.5,
                paddingBottom: 10.5
            },
            inputMultiline: {
                padding: 0
            },
            inputAdornedStart: {
                paddingLeft: 0
            },
            inputAdornedEnd: {
                paddingRight: 0
            }
        }
    }
    ), {
        name: "PwzrOutlinedInput"
    })(cu)
      , du = nu
      , pu = lt.createElement(eu, null)
      , fu = lt.createElement(au, null)
      , hu = lt.forwardRef((function e(t, n) {
        var r = t.autoWidth
          , i = void 0 !== r && r
          , o = t.children
          , a = t.classes
          , s = t.displayEmpty
          , l = void 0 !== s && s
          , c = t.IconComponent
          , u = void 0 === c ? qc : c
          , d = t.id
          , p = t.input
          , f = t.inputProps
          , h = t.label
          , m = t.labelId
          , v = t.labelWidth
          , g = void 0 === v ? 0 : v
          , b = t.MenuProps
          , y = t.multiple
          , w = void 0 !== y && y
          , x = t.native
          , _ = void 0 !== x && x
          , C = t.onClose
          , S = t.onOpen
          , E = t.open
          , k = t.renderValue
          , O = t.SelectDisplayProps
          , T = t.variant
          , M = void 0 === T ? "standard" : T
          , R = jt(t, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"])
          , P = _ ? tu : Vc
          , I = Pl({
            props: t,
            muiFormControl: zl(),
            states: ["variant"]
        }).variant || M
          , z = p || {
            standard: pu,
            outlined: lt.createElement(uu, {
                label: h,
                labelWidth: g
            }),
            filled: fu
        }[I];
        return lt.cloneElement(z, Vt({
            inputComponent: P,
            inputProps: Vt({
                children: o,
                IconComponent: u,
                variant: I,
                type: void 0,
                multiple: w
            }, _ ? {
                id: d
            } : {
                autoWidth: i,
                displayEmpty: l,
                labelId: m,
                MenuProps: b,
                onClose: C,
                onOpen: S,
                open: E,
                renderValue: k,
                SelectDisplayProps: Vt({
                    id: d
                }, O)
            }, {}, f, {
                classes: f ? Ni({
                    baseClasses: a,
                    newClasses: f.classes,
                    Component: e
                }) : a
            }, p ? p.props.inputProps : {}),
            ref: n
        }, R))
    }
    ));
    hu.muiName = "Select";
    var mu = Ka(du, {
        name: "PwzrSelect"
    })(hu)
      , vu = Cl(lt.createElement("path", {
        d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
    }))
      , gu = Cl(lt.createElement("path", {
        d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    }))
      , bu = lt.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12"
    })
      , yu = lt.forwardRef((function(e, t) {
        var n = e.completed
          , r = void 0 !== n && n
          , i = e.icon
          , o = e.active
          , a = void 0 !== o && o
          , s = e.error
          , l = void 0 !== s && s
          , c = e.classes;
        if ("number" == typeof i || "string" == typeof i) {
            var u = Ra(c.root, a && c.active, l && c.error, r && c.completed);
            return l ? lt.createElement(gu, {
                className: u,
                ref: t
            }) : r ? lt.createElement(vu, {
                className: u,
                ref: t
            }) : lt.createElement(_l, {
                className: u,
                ref: t
            }, bu, lt.createElement("text", {
                className: c.text,
                x: "12",
                y: "16",
                textAnchor: "middle"
            }, i))
        }
        return i
    }
    ))
      , wu = Ka((function(e) {
        return {
            root: {
                display: "block",
                color: e.palette.text.disabled,
                "&$completed": {
                    color: e.palette.primary.main
                },
                "&$active": {
                    color: e.palette.primary.main
                },
                "&$error": {
                    color: e.palette.error.main
                }
            },
            text: {
                fill: e.palette.primary.contrastText,
                fontSize: e.typography.caption.fontSize,
                fontFamily: e.typography.fontFamily
            },
            active: {},
            completed: {},
            error: {}
        }
    }
    ), {
        name: "PwzrStepIcon"
    })(yu)
      , xu = lt.forwardRef((function(e, t) {
        var n = e.active
          , r = void 0 !== n && n
          , i = e.alternativeLabel
          , o = void 0 !== i && i
          , a = e.children
          , s = e.classes
          , l = e.className
          , c = e.completed
          , u = void 0 !== c && c
          , d = e.disabled
          , p = void 0 !== d && d
          , f = e.error
          , h = void 0 !== f && f
          , m = (e.expanded,
        e.icon)
          , v = (e.last,
        e.optional)
          , g = e.orientation
          , b = void 0 === g ? "horizontal" : g
          , y = e.StepIconComponent
          , w = e.StepIconProps
          , x = jt(e, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"])
          , _ = y;
        return m && !_ && (_ = wu),
        lt.createElement("span", Vt({
            className: Ra(s.root, s[b], l, p && s.disabled, o && s.alternativeLabel, h && s.error),
            ref: t
        }, x), m || _ ? lt.createElement("span", {
            className: Ra(s.iconContainer, o && s.alternativeLabel)
        }, lt.createElement(_, Vt({
            completed: u,
            active: r,
            error: h,
            icon: m
        }, w))) : null, lt.createElement("span", {
            className: s.labelContainer
        }, lt.createElement(Tl, {
            variant: "body2",
            component: "span",
            className: Ra(s.label, o && s.alternativeLabel, u && s.completed, r && s.active, h && s.error),
            display: "block"
        }, a), v))
    }
    ));
    xu.muiName = "StepLabel";
    Ka((function(e) {
        return {
            root: {
                display: "flex",
                alignItems: "center",
                "&$alternativeLabel": {
                    flexDirection: "column"
                },
                "&$disabled": {
                    cursor: "default"
                }
            },
            horizontal: {},
            vertical: {},
            label: {
                color: e.palette.text.secondary,
                "&$active": {
                    color: e.palette.text.primary,
                    fontWeight: 500
                },
                "&$completed": {
                    color: e.palette.text.primary,
                    fontWeight: 500
                },
                "&$alternativeLabel": {
                    textAlign: "center",
                    marginTop: 16
                },
                "&$error": {
                    color: e.palette.error.main
                }
            },
            active: {},
            completed: {},
            error: {},
            disabled: {},
            iconContainer: {
                flexShrink: 0,
                display: "flex",
                paddingRight: 8,
                "&$alternativeLabel": {
                    paddingRight: 0
                }
            },
            alternativeLabel: {},
            labelContainer: {
                width: "100%"
            }
        }
    }
    ), {
        name: "PwzrStepLabel"
    })(xu);
    var _u = lt.forwardRef((function(e, t) {
        var n = e.classes
          , r = e.className
          , i = e.disableAnimation
          , o = void 0 !== i && i
          , a = (e.margin,
        e.shrink)
          , s = (e.variant,
        jt(e, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]))
          , l = zl()
          , c = a;
        void 0 === c && l && (c = l.filled || l.focused || l.adornedStart);
        var u = Pl({
            props: e,
            muiFormControl: l,
            states: ["margin", "variant"]
        });
        return lt.createElement(Ll, Vt({
            "data-shrink": c,
            className: Ra(n.root, r, l && n.formControl, !o && n.animated, c && n.shrink, "dense" === u.margin && n.marginDense, {
                filled: n.filled,
                outlined: n.outlined
            }[u.variant]),
            classes: {
                focused: n.focused,
                disabled: n.disabled,
                error: n.error,
                required: n.required,
                asterisk: n.asterisk
            },
            ref: t
        }, s))
    }
    ))
      , Cu = Ka((function(e) {
        return {
            root: {
                display: "block",
                transformOrigin: "top left"
            },
            focused: {},
            disabled: {},
            error: {},
            required: {},
            asterisk: {},
            formControl: {
                position: "absolute",
                left: 0,
                top: 0,
                transform: "translate(0, 24px) scale(1)"
            },
            marginDense: {
                transform: "translate(0, 21px) scale(1)"
            },
            shrink: {
                transform: "translate(0, 1.5px) scale(0.75)",
                transformOrigin: "top left"
            },
            animated: {
                transition: e.transitions.create(["color", "transform"], {
                    duration: e.transitions.duration.shorter,
                    easing: e.transitions.easing.easeOut
                })
            },
            filled: {
                zIndex: 1,
                pointerEvents: "none",
                transform: "translate(12px, 20px) scale(1)",
                "&$marginDense": {
                    transform: "translate(12px, 17px) scale(1)"
                },
                "&$shrink": {
                    transform: "translate(12px, 10px) scale(0.75)",
                    "&$marginDense": {
                        transform: "translate(12px, 7px) scale(0.75)"
                    }
                }
            },
            outlined: {
                zIndex: 1,
                pointerEvents: "none",
                transform: "translate(14px, 20px) scale(1)",
                "&$marginDense": {
                    transform: "translate(14px, 12px) scale(1)"
                },
                "&$shrink": {
                    transform: "translate(14px, -6px) scale(0.75)"
                }
            }
        }
    }
    ), {
        name: "PwzrInputLabel"
    })(_u)
      , Su = lt.forwardRef((function(e, t) {
        var n, r = e.children, i = e.classes, o = e.className, a = e.color, s = void 0 === a ? "primary" : a, l = e.component, c = void 0 === l ? "div" : l, u = e.disabled, d = void 0 !== u && u, p = e.error, f = void 0 !== p && p, h = e.fullWidth, m = void 0 !== h && h, v = e.hiddenLabel, g = void 0 !== v && v, b = e.margin, y = void 0 === b ? "none" : b, w = e.required, x = void 0 !== w && w, _ = e.size, C = e.variant, S = void 0 === C ? "standard" : C, E = jt(e, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"]), k = lt.useState((function() {
            var e = !1;
            return r && lt.Children.forEach(r, (function(t) {
                if (ql(t, ["Input", "Select"])) {
                    var n = ql(t, ["Select"]) ? t.props.input : t;
                    n && n.props.startAdornment && (e = !0)
                }
            }
            )),
            e
        }
        )), O = k[0], T = k[1], M = lt.useState((function() {
            var e = !1;
            return r && lt.Children.forEach(r, (function(t) {
                ql(t, ["Input", "Select"]) && Bc(t.props, !0) && (e = !0)
            }
            )),
            e
        }
        )), R = M[0], P = M[1], I = lt.useState(!1), z = I[0], A = I[1];
        d && z && A(!1);
        var L = lt.useCallback((function() {
            P(!0)
        }
        ), [])
          , D = {
            adornedStart: O,
            setAdornedStart: T,
            color: s,
            disabled: d,
            error: f,
            filled: R,
            focused: z,
            fullWidth: m,
            hiddenLabel: g,
            margin: ("small" === _ ? "dense" : void 0) || y,
            onBlur: function() {
                A(!1)
            },
            onEmpty: lt.useCallback((function() {
                P(!1)
            }
            ), []),
            onFilled: L,
            onFocus: function() {
                A(!0)
            },
            registerEffect: n,
            required: x,
            variant: S
        };
        return lt.createElement(Il.Provider, {
            value: D
        }, lt.createElement(c, Vt({
            className: Ra(i.root, o, "none" !== y && i["margin".concat(gl(y))], m && i.fullWidth),
            ref: t
        }, E), r))
    }
    ))
      , Eu = Ka({
        root: {
            display: "inline-flex",
            flexDirection: "column",
            position: "relative",
            minWidth: 0,
            padding: 0,
            margin: 0,
            border: 0,
            zIndex: 0,
            verticalAlign: "top"
        },
        marginNormal: {
            marginTop: 16,
            marginBottom: 8
        },
        marginDense: {
            marginTop: 8,
            marginBottom: 4
        },
        fullWidth: {
            width: "100%"
        }
    }, {
        name: "PwzrFormControl"
    })(Su)
      , ku = lt.forwardRef((function(e, t) {
        var n = e.children
          , r = e.classes
          , i = e.className
          , o = e.component
          , a = void 0 === o ? "p" : o
          , s = (e.disabled,
        e.error,
        e.filled,
        e.focused,
        e.margin,
        e.required,
        e.variant,
        jt(e, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]))
          , l = Pl({
            props: e,
            muiFormControl: zl(),
            states: ["variant", "margin", "disabled", "error", "filled", "focused", "required"]
        });
        return lt.createElement(a, Vt({
            className: Ra(r.root, ("filled" === l.variant || "outlined" === l.variant) && r.contained, i, l.disabled && r.disabled, l.error && r.error, l.filled && r.filled, l.focused && r.focused, l.required && r.required, "dense" === l.margin && r.marginDense),
            ref: t
        }, s), " " === n ? lt.createElement("span", {
            dangerouslySetInnerHTML: {
                __html: "&#8203;"
            }
        }) : n)
    }
    ))
      , Ou = Ka((function(e) {
        return {
            root: Vt({
                color: e.palette.text.secondary
            }, e.typography.caption, {
                textAlign: "left",
                marginTop: 3,
                margin: 0,
                "&$disabled": {
                    color: e.palette.text.disabled
                },
                "&$error": {
                    color: e.palette.error.main
                }
            }),
            error: {},
            disabled: {},
            marginDense: {
                marginTop: 4
            },
            contained: {
                marginLeft: 14,
                marginRight: 14
            },
            focused: {},
            filled: {},
            required: {}
        }
    }
    ), {
        name: "PwzrFormHelperText"
    })(ku)
      , Tu = {
        standard: eu,
        filled: au,
        outlined: uu
    }
      , Mu = lt.forwardRef((function(e, t) {
        var n = e.autoComplete
          , r = e.autoFocus
          , i = void 0 !== r && r
          , o = e.children
          , a = e.classes
          , s = e.className
          , l = e.color
          , c = void 0 === l ? "primary" : l
          , u = e.defaultValue
          , d = e.disabled
          , p = void 0 !== d && d
          , f = e.error
          , h = void 0 !== f && f
          , m = e.FormHelperTextProps
          , v = e.fullWidth
          , g = void 0 !== v && v
          , b = e.helperText
          , y = e.hiddenLabel
          , w = e.id
          , x = e.InputLabelProps
          , _ = e.inputProps
          , C = e.InputProps
          , S = e.inputRef
          , E = e.label
          , k = e.multiline
          , O = void 0 !== k && k
          , T = e.name
          , M = e.onBlur
          , R = e.onChange
          , P = e.onFocus
          , I = e.placeholder
          , z = e.required
          , A = void 0 !== z && z
          , L = e.rows
          , D = e.rowsMax
          , N = e.select
          , W = void 0 !== N && N
          , F = e.SelectProps
          , $ = e.type
          , B = e.value
          , j = e.variant
          , H = void 0 === j ? "standard" : j
          , V = jt(e, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);
        var q = {};
        "outlined" === H && (x && void 0 !== x.shrink && (q.notched = x.shrink),
        q.label = E ? lt.createElement(lt.Fragment, null, E, A && " *") : E),
        W && (F && F.native || (q.id = void 0),
        q["aria-describedby"] = void 0);
        var U = b && w ? "".concat(w, "-helper-text") : void 0
          , G = E && w ? "".concat(w, "-label") : void 0
          , Z = Tu[H]
          , K = lt.createElement(Z, Vt({
            "aria-describedby": U,
            autoComplete: n,
            autoFocus: i,
            defaultValue: u,
            fullWidth: g,
            multiline: O,
            name: T,
            rows: L,
            rowsMax: D,
            type: $,
            value: B,
            id: w,
            inputRef: S,
            onBlur: M,
            onChange: R,
            onFocus: P,
            placeholder: I,
            inputProps: _
        }, q, C));
        return lt.createElement(Eu, Vt({
            className: Ra(a.root, s),
            disabled: p,
            error: h,
            fullWidth: g,
            hiddenLabel: y,
            ref: t,
            required: A,
            color: c,
            variant: H
        }, V), E && lt.createElement(Cu, Vt({
            htmlFor: w,
            id: G
        }, x), E), W ? lt.createElement(mu, Vt({
            "aria-describedby": U,
            id: w,
            labelId: G,
            value: B,
            input: K
        }, F), o) : K, b && lt.createElement(Ou, Vt({
            id: U
        }, m), b))
    }
    ))
      , Ru = (Ka({
        root: {}
    }, {
        name: "PwzrTextField"
    })(Mu),
    "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator)
      , Pu = function() {
        for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)
            if (Ru && navigator.userAgent.indexOf(e[t]) >= 0)
                return 1;
        return 0
    }();
    var Iu = Ru && window.Promise ? function(e) {
        var t = !1;
        return function() {
            t || (t = !0,
            window.Promise.resolve().then((function() {
                t = !1,
                e()
            }
            )))
        }
    }
    : function(e) {
        var t = !1;
        return function() {
            t || (t = !0,
            setTimeout((function() {
                t = !1,
                e()
            }
            ), Pu))
        }
    }
    ;
    function zu(e) {
        return e && "[object Function]" === {}.toString.call(e)
    }
    function Au(e, t) {
        if (1 !== e.nodeType)
            return [];
        var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
        return t ? n[t] : n
    }
    function Lu(e) {
        return "HTML" === e.nodeName ? e : e.parentNode || e.host
    }
    function Du(e) {
        if (!e)
            return document.body;
        switch (e.nodeName) {
        case "HTML":
        case "BODY":
            return e.ownerDocument.body;
        case "#document":
            return e.body
        }
        var t = Au(e)
          , n = t.overflow
          , r = t.overflowX
          , i = t.overflowY;
        return /(auto|scroll|overlay)/.test(n + i + r) ? e : Du(Lu(e))
    }
    function Nu(e) {
        return e && e.referenceNode ? e.referenceNode : e
    }
    var Wu = Ru && !(!window.MSInputMethodContext || !document.documentMode)
      , Fu = Ru && /MSIE 10/.test(navigator.userAgent);
    function $u(e) {
        return 11 === e ? Wu : 10 === e ? Fu : Wu || Fu
    }
    function Bu(e) {
        if (!e)
            return document.documentElement;
        for (var t = $u(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling; )
            n = (e = e.nextElementSibling).offsetParent;
        var r = n && n.nodeName;
        return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === Au(n, "position") ? Bu(n) : n : e ? e.ownerDocument.documentElement : document.documentElement
    }
    function ju(e) {
        return null !== e.parentNode ? ju(e.parentNode) : e
    }
    function Hu(e, t) {
        if (!(e && e.nodeType && t && t.nodeType))
            return document.documentElement;
        var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING
          , r = n ? e : t
          , i = n ? t : e
          , o = document.createRange();
        o.setStart(r, 0),
        o.setEnd(i, 0);
        var a, s, l = o.commonAncestorContainer;
        if (e !== l && t !== l || r.contains(i))
            return "BODY" === (s = (a = l).nodeName) || "HTML" !== s && Bu(a.firstElementChild) !== a ? Bu(l) : l;
        var c = ju(e);
        return c.host ? Hu(c.host, t) : Hu(e, ju(t).host)
    }
    function Vu(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top"
          , n = "top" === t ? "scrollTop" : "scrollLeft"
          , r = e.nodeName;
        if ("BODY" === r || "HTML" === r) {
            var i = e.ownerDocument.documentElement
              , o = e.ownerDocument.scrollingElement || i;
            return o[n]
        }
        return e[n]
    }
    function qu(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
          , r = Vu(t, "top")
          , i = Vu(t, "left")
          , o = n ? -1 : 1;
        return e.top += r * o,
        e.bottom += r * o,
        e.left += i * o,
        e.right += i * o,
        e
    }
    function Uu(e, t) {
        var n = "x" === t ? "Left" : "Top"
          , r = "Left" === n ? "Right" : "Bottom";
        return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + r + "Width"])
    }
    function Gu(e, t, n, r) {
        return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], $u(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0)
    }
    function Zu(e) {
        var t = e.body
          , n = e.documentElement
          , r = $u(10) && getComputedStyle(n);
        return {
            height: Gu("Height", t, n, r),
            width: Gu("Width", t, n, r)
        }
    }
    var Ku = function(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
      , Yu = function() {
        function e(e, t) {
            for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r)
            }
        }
        return function(t, n, r) {
            return n && e(t.prototype, n),
            r && e(t, r),
            t
        }
    }()
      , Xu = function(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
      , Ju = Object.assign || function(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
        }
        return e
    }
    ;
    function Qu(e) {
        return Ju({}, e, {
            right: e.left + e.width,
            bottom: e.top + e.height
        })
    }
    function ed(e) {
        var t = {};
        try {
            if ($u(10)) {
                t = e.getBoundingClientRect();
                var n = Vu(e, "top")
                  , r = Vu(e, "left");
                t.top += n,
                t.left += r,
                t.bottom += n,
                t.right += r
            } else
                t = e.getBoundingClientRect()
        } catch (e) {}
        var i = {
            left: t.left,
            top: t.top,
            width: t.right - t.left,
            height: t.bottom - t.top
        }
          , o = "HTML" === e.nodeName ? Zu(e.ownerDocument) : {}
          , a = o.width || e.clientWidth || i.width
          , s = o.height || e.clientHeight || i.height
          , l = e.offsetWidth - a
          , c = e.offsetHeight - s;
        if (l || c) {
            var u = Au(e);
            l -= Uu(u, "x"),
            c -= Uu(u, "y"),
            i.width -= l,
            i.height -= c
        }
        return Qu(i)
    }
    function td(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
          , r = $u(10)
          , i = "HTML" === t.nodeName
          , o = ed(e)
          , a = ed(t)
          , s = Du(e)
          , l = Au(t)
          , c = parseFloat(l.borderTopWidth)
          , u = parseFloat(l.borderLeftWidth);
        n && i && (a.top = Math.max(a.top, 0),
        a.left = Math.max(a.left, 0));
        var d = Qu({
            top: o.top - a.top - c,
            left: o.left - a.left - u,
            width: o.width,
            height: o.height
        });
        if (d.marginTop = 0,
        d.marginLeft = 0,
        !r && i) {
            var p = parseFloat(l.marginTop)
              , f = parseFloat(l.marginLeft);
            d.top -= c - p,
            d.bottom -= c - p,
            d.left -= u - f,
            d.right -= u - f,
            d.marginTop = p,
            d.marginLeft = f
        }
        return (r && !n ? t.contains(s) : t === s && "BODY" !== s.nodeName) && (d = qu(d, t)),
        d
    }
    function nd(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
          , n = e.ownerDocument.documentElement
          , r = td(e, n)
          , i = Math.max(n.clientWidth, window.innerWidth || 0)
          , o = Math.max(n.clientHeight, window.innerHeight || 0)
          , a = t ? 0 : Vu(n)
          , s = t ? 0 : Vu(n, "left")
          , l = {
            top: a - r.top + r.marginTop,
            left: s - r.left + r.marginLeft,
            width: i,
            height: o
        };
        return Qu(l)
    }
    function rd(e) {
        var t = e.nodeName;
        if ("BODY" === t || "HTML" === t)
            return !1;
        if ("fixed" === Au(e, "position"))
            return !0;
        var n = Lu(e);
        return !!n && rd(n)
    }
    function id(e) {
        if (!e || !e.parentElement || $u())
            return document.documentElement;
        for (var t = e.parentElement; t && "none" === Au(t, "transform"); )
            t = t.parentElement;
        return t || document.documentElement
    }
    function od(e, t, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4]
          , o = {
            top: 0,
            left: 0
        }
          , a = i ? id(e) : Hu(e, Nu(t));
        if ("viewport" === r)
            o = nd(a, i);
        else {
            var s = void 0;
            "scrollParent" === r ? "BODY" === (s = Du(Lu(t))).nodeName && (s = e.ownerDocument.documentElement) : s = "window" === r ? e.ownerDocument.documentElement : r;
            var l = td(s, a, i);
            if ("HTML" !== s.nodeName || rd(a))
                o = l;
            else {
                var c = Zu(e.ownerDocument)
                  , u = c.height
                  , d = c.width;
                o.top += l.top - l.marginTop,
                o.bottom = u + l.top,
                o.left += l.left - l.marginLeft,
                o.right = d + l.left
            }
        }
        var p = "number" == typeof (n = n || 0);
        return o.left += p ? n : n.left || 0,
        o.top += p ? n : n.top || 0,
        o.right -= p ? n : n.right || 0,
        o.bottom -= p ? n : n.bottom || 0,
        o
    }
    function ad(e) {
        return e.width * e.height
    }
    function sd(e, t, n, r, i) {
        var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === e.indexOf("auto"))
            return e;
        var a = od(n, r, o, i)
          , s = {
            top: {
                width: a.width,
                height: t.top - a.top
            },
            right: {
                width: a.right - t.right,
                height: a.height
            },
            bottom: {
                width: a.width,
                height: a.bottom - t.bottom
            },
            left: {
                width: t.left - a.left,
                height: a.height
            }
        }
          , l = Object.keys(s).map((function(e) {
            return Ju({
                key: e
            }, s[e], {
                area: ad(s[e])
            })
        }
        )).sort((function(e, t) {
            return t.area - e.area
        }
        ))
          , c = l.filter((function(e) {
            var t = e.width
              , r = e.height;
            return t >= n.clientWidth && r >= n.clientHeight
        }
        ))
          , u = c.length > 0 ? c[0].key : l[0].key
          , d = e.split("-")[1];
        return u + (d ? "-" + d : "")
    }
    function ld(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null
          , i = r ? id(t) : Hu(t, Nu(n));
        return td(n, i, r)
    }
    function cd(e) {
        var t = e.ownerDocument.defaultView.getComputedStyle(e)
          , n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0)
          , r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
        return {
            width: e.offsetWidth + r,
            height: e.offsetHeight + n
        }
    }
    function ud(e) {
        var t = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return e.replace(/left|right|bottom|top/g, (function(e) {
            return t[e]
        }
        ))
    }
    function dd(e, t, n) {
        n = n.split("-")[0];
        var r = cd(e)
          , i = {
            width: r.width,
            height: r.height
        }
          , o = -1 !== ["right", "left"].indexOf(n)
          , a = o ? "top" : "left"
          , s = o ? "left" : "top"
          , l = o ? "height" : "width"
          , c = o ? "width" : "height";
        return i[a] = t[a] + t[l] / 2 - r[l] / 2,
        i[s] = n === s ? t[s] - r[c] : t[ud(s)],
        i
    }
    function pd(e, t) {
        return Array.prototype.find ? e.find(t) : e.filter(t)[0]
    }
    function fd(e, t, n) {
        return (void 0 === n ? e : e.slice(0, function(e, t, n) {
            if (Array.prototype.findIndex)
                return e.findIndex((function(e) {
                    return e[t] === n
                }
                ));
            var r = pd(e, (function(e) {
                return e[t] === n
            }
            ));
            return e.indexOf(r)
        }(e, "name", n))).forEach((function(e) {
            e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var n = e.function || e.fn;
            e.enabled && zu(n) && (t.offsets.popper = Qu(t.offsets.popper),
            t.offsets.reference = Qu(t.offsets.reference),
            t = n(t, e))
        }
        )),
        t
    }
    function hd() {
        if (!this.state.isDestroyed) {
            var e = {
                instance: this,
                styles: {},
                arrowStyles: {},
                attributes: {},
                flipped: !1,
                offsets: {}
            };
            e.offsets.reference = ld(this.state, this.popper, this.reference, this.options.positionFixed),
            e.placement = sd(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding),
            e.originalPlacement = e.placement,
            e.positionFixed = this.options.positionFixed,
            e.offsets.popper = dd(this.popper, e.offsets.reference, e.placement),
            e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute",
            e = fd(this.modifiers, e),
            this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0,
            this.options.onCreate(e))
        }
    }
    function md(e, t) {
        return e.some((function(e) {
            var n = e.name;
            return e.enabled && n === t
        }
        ))
    }
    function vd(e) {
        for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++) {
            var i = t[r]
              , o = i ? "" + i + n : e;
            if (void 0 !== document.body.style[o])
                return o
        }
        return null
    }
    function gd() {
        return this.state.isDestroyed = !0,
        md(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"),
        this.popper.style.position = "",
        this.popper.style.top = "",
        this.popper.style.left = "",
        this.popper.style.right = "",
        this.popper.style.bottom = "",
        this.popper.style.willChange = "",
        this.popper.style[vd("transform")] = ""),
        this.disableEventListeners(),
        this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper),
        this
    }
    function bd(e) {
        var t = e.ownerDocument;
        return t ? t.defaultView : window
    }
    function yd(e, t, n, r) {
        var i = "BODY" === e.nodeName
          , o = i ? e.ownerDocument.defaultView : e;
        o.addEventListener(t, n, {
            passive: !0
        }),
        i || yd(Du(o.parentNode), t, n, r),
        r.push(o)
    }
    function wd(e, t, n, r) {
        n.updateBound = r,
        bd(e).addEventListener("resize", n.updateBound, {
            passive: !0
        });
        var i = Du(e);
        return yd(i, "scroll", n.updateBound, n.scrollParents),
        n.scrollElement = i,
        n.eventsEnabled = !0,
        n
    }
    function xd() {
        this.state.eventsEnabled || (this.state = wd(this.reference, this.options, this.state, this.scheduleUpdate))
    }
    function _d() {
        var e, t;
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate),
        this.state = (e = this.reference,
        t = this.state,
        bd(e).removeEventListener("resize", t.updateBound),
        t.scrollParents.forEach((function(e) {
            e.removeEventListener("scroll", t.updateBound)
        }
        )),
        t.updateBound = null,
        t.scrollParents = [],
        t.scrollElement = null,
        t.eventsEnabled = !1,
        t))
    }
    function Cd(e) {
        return "" !== e && !isNaN(parseFloat(e)) && isFinite(e)
    }
    function Sd(e, t) {
        Object.keys(t).forEach((function(n) {
            var r = "";
            -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && Cd(t[n]) && (r = "px"),
            e.style[n] = t[n] + r
        }
        ))
    }
    var Ed = Ru && /Firefox/i.test(navigator.userAgent);
    function kd(e, t, n) {
        var r = pd(e, (function(e) {
            return e.name === t
        }
        ))
          , i = !!r && e.some((function(e) {
            return e.name === n && e.enabled && e.order < r.order
        }
        ));
        if (!i) {
            var o = "`" + t + "`"
              , a = "`" + n + "`";
            console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
        }
        return i
    }
    var Od = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"]
      , Td = Od.slice(3);
    function Md(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
          , n = Td.indexOf(e)
          , r = Td.slice(n + 1).concat(Td.slice(0, n));
        return t ? r.reverse() : r
    }
    var Rd = "flip"
      , Pd = "clockwise"
      , Id = "counterclockwise";
    function zd(e, t, n, r) {
        var i = [0, 0]
          , o = -1 !== ["right", "left"].indexOf(r)
          , a = e.split(/(\+|\-)/).map((function(e) {
            return e.trim()
        }
        ))
          , s = a.indexOf(pd(a, (function(e) {
            return -1 !== e.search(/,|\s/)
        }
        )));
        a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        var l = /\s*,\s*|\s+/
          , c = -1 !== s ? [a.slice(0, s).concat([a[s].split(l)[0]]), [a[s].split(l)[1]].concat(a.slice(s + 1))] : [a];
        return (c = c.map((function(e, r) {
            var i = (1 === r ? !o : o) ? "height" : "width"
              , a = !1;
            return e.reduce((function(e, t) {
                return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t,
                a = !0,
                e) : a ? (e[e.length - 1] += t,
                a = !1,
                e) : e.concat(t)
            }
            ), []).map((function(e) {
                return function(e, t, n, r) {
                    var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/)
                      , o = +i[1]
                      , a = i[2];
                    if (!o)
                        return e;
                    if (0 === a.indexOf("%")) {
                        var s = void 0;
                        switch (a) {
                        case "%p":
                            s = n;
                            break;
                        case "%":
                        case "%r":
                        default:
                            s = r
                        }
                        return Qu(s)[t] / 100 * o
                    }
                    if ("vh" === a || "vw" === a)
                        return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;
                    return o
                }(e, i, t, n)
            }
            ))
        }
        ))).forEach((function(e, t) {
            e.forEach((function(n, r) {
                Cd(n) && (i[t] += n * ("-" === e[r - 1] ? -1 : 1))
            }
            ))
        }
        )),
        i
    }
    var Ad = {
        placement: "bottom",
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function() {},
        onUpdate: function() {},
        modifiers: {
            shift: {
                order: 100,
                enabled: !0,
                fn: function(e) {
                    var t = e.placement
                      , n = t.split("-")[0]
                      , r = t.split("-")[1];
                    if (r) {
                        var i = e.offsets
                          , o = i.reference
                          , a = i.popper
                          , s = -1 !== ["bottom", "top"].indexOf(n)
                          , l = s ? "left" : "top"
                          , c = s ? "width" : "height"
                          , u = {
                            start: Xu({}, l, o[l]),
                            end: Xu({}, l, o[l] + o[c] - a[c])
                        };
                        e.offsets.popper = Ju({}, a, u[r])
                    }
                    return e
                }
            },
            offset: {
                order: 200,
                enabled: !0,
                fn: function(e, t) {
                    var n = t.offset
                      , r = e.placement
                      , i = e.offsets
                      , o = i.popper
                      , a = i.reference
                      , s = r.split("-")[0]
                      , l = void 0;
                    return l = Cd(+n) ? [+n, 0] : zd(n, o, a, s),
                    "left" === s ? (o.top += l[0],
                    o.left -= l[1]) : "right" === s ? (o.top += l[0],
                    o.left += l[1]) : "top" === s ? (o.left += l[0],
                    o.top -= l[1]) : "bottom" === s && (o.left += l[0],
                    o.top += l[1]),
                    e.popper = o,
                    e
                },
                offset: 0
            },
            preventOverflow: {
                order: 300,
                enabled: !0,
                fn: function(e, t) {
                    var n = t.boundariesElement || Bu(e.instance.popper);
                    e.instance.reference === n && (n = Bu(n));
                    var r = vd("transform")
                      , i = e.instance.popper.style
                      , o = i.top
                      , a = i.left
                      , s = i[r];
                    i.top = "",
                    i.left = "",
                    i[r] = "";
                    var l = od(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
                    i.top = o,
                    i.left = a,
                    i[r] = s,
                    t.boundaries = l;
                    var c = t.priority
                      , u = e.offsets.popper
                      , d = {
                        primary: function(e) {
                            var n = u[e];
                            return u[e] < l[e] && !t.escapeWithReference && (n = Math.max(u[e], l[e])),
                            Xu({}, e, n)
                        },
                        secondary: function(e) {
                            var n = "right" === e ? "left" : "top"
                              , r = u[n];
                            return u[e] > l[e] && !t.escapeWithReference && (r = Math.min(u[n], l[e] - ("right" === e ? u.width : u.height))),
                            Xu({}, n, r)
                        }
                    };
                    return c.forEach((function(e) {
                        var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                        u = Ju({}, u, d[t](e))
                    }
                    )),
                    e.offsets.popper = u,
                    e
                },
                priority: ["left", "right", "top", "bottom"],
                padding: 5,
                boundariesElement: "scrollParent"
            },
            keepTogether: {
                order: 400,
                enabled: !0,
                fn: function(e) {
                    var t = e.offsets
                      , n = t.popper
                      , r = t.reference
                      , i = e.placement.split("-")[0]
                      , o = Math.floor
                      , a = -1 !== ["top", "bottom"].indexOf(i)
                      , s = a ? "right" : "bottom"
                      , l = a ? "left" : "top"
                      , c = a ? "width" : "height";
                    return n[s] < o(r[l]) && (e.offsets.popper[l] = o(r[l]) - n[c]),
                    n[l] > o(r[s]) && (e.offsets.popper[l] = o(r[s])),
                    e
                }
            },
            arrow: {
                order: 500,
                enabled: !0,
                fn: function(e, t) {
                    var n;
                    if (!kd(e.instance.modifiers, "arrow", "keepTogether"))
                        return e;
                    var r = t.element;
                    if ("string" == typeof r) {
                        if (!(r = e.instance.popper.querySelector(r)))
                            return e
                    } else if (!e.instance.popper.contains(r))
                        return console.warn("WARNING: `arrow.element` must be child of its popper element!"),
                        e;
                    var i = e.placement.split("-")[0]
                      , o = e.offsets
                      , a = o.popper
                      , s = o.reference
                      , l = -1 !== ["left", "right"].indexOf(i)
                      , c = l ? "height" : "width"
                      , u = l ? "Top" : "Left"
                      , d = u.toLowerCase()
                      , p = l ? "left" : "top"
                      , f = l ? "bottom" : "right"
                      , h = cd(r)[c];
                    s[f] - h < a[d] && (e.offsets.popper[d] -= a[d] - (s[f] - h)),
                    s[d] + h > a[f] && (e.offsets.popper[d] += s[d] + h - a[f]),
                    e.offsets.popper = Qu(e.offsets.popper);
                    var m = s[d] + s[c] / 2 - h / 2
                      , v = Au(e.instance.popper)
                      , g = parseFloat(v["margin" + u])
                      , b = parseFloat(v["border" + u + "Width"])
                      , y = m - e.offsets.popper[d] - g - b;
                    return y = Math.max(Math.min(a[c] - h, y), 0),
                    e.arrowElement = r,
                    e.offsets.arrow = (Xu(n = {}, d, Math.round(y)),
                    Xu(n, p, ""),
                    n),
                    e
                },
                element: "[x-arrow]"
            },
            flip: {
                order: 600,
                enabled: !0,
                fn: function(e, t) {
                    if (md(e.instance.modifiers, "inner"))
                        return e;
                    if (e.flipped && e.placement === e.originalPlacement)
                        return e;
                    var n = od(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed)
                      , r = e.placement.split("-")[0]
                      , i = ud(r)
                      , o = e.placement.split("-")[1] || ""
                      , a = [];
                    switch (t.behavior) {
                    case Rd:
                        a = [r, i];
                        break;
                    case Pd:
                        a = Md(r);
                        break;
                    case Id:
                        a = Md(r, !0);
                        break;
                    default:
                        a = t.behavior
                    }
                    return a.forEach((function(s, l) {
                        if (r !== s || a.length === l + 1)
                            return e;
                        r = e.placement.split("-")[0],
                        i = ud(r);
                        var c = e.offsets.popper
                          , u = e.offsets.reference
                          , d = Math.floor
                          , p = "left" === r && d(c.right) > d(u.left) || "right" === r && d(c.left) < d(u.right) || "top" === r && d(c.bottom) > d(u.top) || "bottom" === r && d(c.top) < d(u.bottom)
                          , f = d(c.left) < d(n.left)
                          , h = d(c.right) > d(n.right)
                          , m = d(c.top) < d(n.top)
                          , v = d(c.bottom) > d(n.bottom)
                          , g = "left" === r && f || "right" === r && h || "top" === r && m || "bottom" === r && v
                          , b = -1 !== ["top", "bottom"].indexOf(r)
                          , y = !!t.flipVariations && (b && "start" === o && f || b && "end" === o && h || !b && "start" === o && m || !b && "end" === o && v)
                          , w = !!t.flipVariationsByContent && (b && "start" === o && h || b && "end" === o && f || !b && "start" === o && v || !b && "end" === o && m)
                          , x = y || w;
                        (p || g || x) && (e.flipped = !0,
                        (p || g) && (r = a[l + 1]),
                        x && (o = function(e) {
                            return "end" === e ? "start" : "start" === e ? "end" : e
                        }(o)),
                        e.placement = r + (o ? "-" + o : ""),
                        e.offsets.popper = Ju({}, e.offsets.popper, dd(e.instance.popper, e.offsets.reference, e.placement)),
                        e = fd(e.instance.modifiers, e, "flip"))
                    }
                    )),
                    e
                },
                behavior: "flip",
                padding: 5,
                boundariesElement: "viewport",
                flipVariations: !1,
                flipVariationsByContent: !1
            },
            inner: {
                order: 700,
                enabled: !1,
                fn: function(e) {
                    var t = e.placement
                      , n = t.split("-")[0]
                      , r = e.offsets
                      , i = r.popper
                      , o = r.reference
                      , a = -1 !== ["left", "right"].indexOf(n)
                      , s = -1 === ["top", "left"].indexOf(n);
                    return i[a ? "left" : "top"] = o[n] - (s ? i[a ? "width" : "height"] : 0),
                    e.placement = ud(t),
                    e.offsets.popper = Qu(i),
                    e
                }
            },
            hide: {
                order: 800,
                enabled: !0,
                fn: function(e) {
                    if (!kd(e.instance.modifiers, "hide", "preventOverflow"))
                        return e;
                    var t = e.offsets.reference
                      , n = pd(e.instance.modifiers, (function(e) {
                        return "preventOverflow" === e.name
                    }
                    )).boundaries;
                    if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                        if (!0 === e.hide)
                            return e;
                        e.hide = !0,
                        e.attributes["x-out-of-boundaries"] = ""
                    } else {
                        if (!1 === e.hide)
                            return e;
                        e.hide = !1,
                        e.attributes["x-out-of-boundaries"] = !1
                    }
                    return e
                }
            },
            computeStyle: {
                order: 850,
                enabled: !0,
                fn: function(e, t) {
                    var n = t.x
                      , r = t.y
                      , i = e.offsets.popper
                      , o = pd(e.instance.modifiers, (function(e) {
                        return "applyStyle" === e.name
                    }
                    )).gpuAcceleration;
                    void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                    var a = void 0 !== o ? o : t.gpuAcceleration
                      , s = Bu(e.instance.popper)
                      , l = ed(s)
                      , c = {
                        position: i.position
                    }
                      , u = function(e, t) {
                        var n = e.offsets
                          , r = n.popper
                          , i = n.reference
                          , o = Math.round
                          , a = Math.floor
                          , s = function(e) {
                            return e
                        }
                          , l = o(i.width)
                          , c = o(r.width)
                          , u = -1 !== ["left", "right"].indexOf(e.placement)
                          , d = -1 !== e.placement.indexOf("-")
                          , p = t ? u || d || l % 2 == c % 2 ? o : a : s
                          , f = t ? o : s;
                        return {
                            left: p(l % 2 == 1 && c % 2 == 1 && !d && t ? r.left - 1 : r.left),
                            top: f(r.top),
                            bottom: f(r.bottom),
                            right: p(r.right)
                        }
                    }(e, window.devicePixelRatio < 2 || !Ed)
                      , d = "bottom" === n ? "top" : "bottom"
                      , p = "right" === r ? "left" : "right"
                      , f = vd("transform")
                      , h = void 0
                      , m = void 0;
                    if (m = "bottom" === d ? "HTML" === s.nodeName ? -s.clientHeight + u.bottom : -l.height + u.bottom : u.top,
                    h = "right" === p ? "HTML" === s.nodeName ? -s.clientWidth + u.right : -l.width + u.right : u.left,
                    a && f)
                        c[f] = "translate3d(" + h + "px, " + m + "px, 0)",
                        c[d] = 0,
                        c[p] = 0,
                        c.willChange = "transform";
                    else {
                        var v = "bottom" === d ? -1 : 1
                          , g = "right" === p ? -1 : 1;
                        c[d] = m * v,
                        c[p] = h * g,
                        c.willChange = d + ", " + p
                    }
                    var b = {
                        "x-placement": e.placement
                    };
                    return e.attributes = Ju({}, b, e.attributes),
                    e.styles = Ju({}, c, e.styles),
                    e.arrowStyles = Ju({}, e.offsets.arrow, e.arrowStyles),
                    e
                },
                gpuAcceleration: !0,
                x: "bottom",
                y: "right"
            },
            applyStyle: {
                order: 900,
                enabled: !0,
                fn: function(e) {
                    var t, n;
                    return Sd(e.instance.popper, e.styles),
                    t = e.instance.popper,
                    n = e.attributes,
                    Object.keys(n).forEach((function(e) {
                        !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e)
                    }
                    )),
                    e.arrowElement && Object.keys(e.arrowStyles).length && Sd(e.arrowElement, e.arrowStyles),
                    e
                },
                onLoad: function(e, t, n, r, i) {
                    var o = ld(i, t, e, n.positionFixed)
                      , a = sd(n.placement, o, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                    return t.setAttribute("x-placement", a),
                    Sd(t, {
                        position: n.positionFixed ? "fixed" : "absolute"
                    }),
                    n
                },
                gpuAcceleration: void 0
            }
        }
    }
      , Ld = function() {
        function e(t, n) {
            var r = this
              , i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            Ku(this, e),
            this.scheduleUpdate = function() {
                return requestAnimationFrame(r.update)
            }
            ,
            this.update = Iu(this.update.bind(this)),
            this.options = Ju({}, e.Defaults, i),
            this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
            },
            this.reference = t && t.jquery ? t[0] : t,
            this.popper = n && n.jquery ? n[0] : n,
            this.options.modifiers = {},
            Object.keys(Ju({}, e.Defaults.modifiers, i.modifiers)).forEach((function(t) {
                r.options.modifiers[t] = Ju({}, e.Defaults.modifiers[t] || {}, i.modifiers ? i.modifiers[t] : {})
            }
            )),
            this.modifiers = Object.keys(this.options.modifiers).map((function(e) {
                return Ju({
                    name: e
                }, r.options.modifiers[e])
            }
            )).sort((function(e, t) {
                return e.order - t.order
            }
            )),
            this.modifiers.forEach((function(e) {
                e.enabled && zu(e.onLoad) && e.onLoad(r.reference, r.popper, r.options, e, r.state)
            }
            )),
            this.update();
            var o = this.options.eventsEnabled;
            o && this.enableEventListeners(),
            this.state.eventsEnabled = o
        }
        return Yu(e, [{
            key: "update",
            value: function() {
                return hd.call(this)
            }
        }, {
            key: "destroy",
            value: function() {
                return gd.call(this)
            }
        }, {
            key: "enableEventListeners",
            value: function() {
                return xd.call(this)
            }
        }, {
            key: "disableEventListeners",
            value: function() {
                return _d.call(this)
            }
        }]),
        e
    }();
    function Dd(e) {
        return "function" == typeof e ? e() : e
    }
    Ld.Utils = ("undefined" != typeof window ? window : e).PopperUtils,
    Ld.placements = Od,
    Ld.Defaults = Ad;
    var Nd = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect
      , Wd = {}
      , Fd = lt.forwardRef((function(e, t) {
        var n = e.anchorEl
          , r = e.children
          , i = e.container
          , o = e.disablePortal
          , a = void 0 !== o && o
          , s = e.keepMounted
          , l = void 0 !== s && s
          , c = e.modifiers
          , u = e.open
          , d = e.placement
          , p = void 0 === d ? "bottom" : d
          , f = e.popperOptions
          , h = void 0 === f ? Wd : f
          , m = e.popperRef
          , v = e.transition
          , g = void 0 !== v && v
          , b = jt(e, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition"])
          , y = lt.useRef(null)
          , w = Ds(y, t)
          , x = lt.useRef(null)
          , _ = Ds(x, m)
          , C = lt.useRef(_);
        Nd((function() {
            C.current = _
        }
        ), [_]),
        lt.useImperativeHandle(m, (function() {
            return x.current
        }
        ), []);
        var S = lt.useState(!0)
          , E = S[0]
          , k = S[1]
          , O = function(e, t) {
            if ("ltr" === (t && t.direction || "ltr"))
                return e;
            switch (e) {
            case "bottom-end":
                return "bottom-start";
            case "bottom-start":
                return "bottom-end";
            case "top-end":
                return "top-start";
            case "top-start":
                return "top-end";
            default:
                return e
            }
        }(p, ji())
          , T = lt.useState(O)
          , M = T[0]
          , R = T[1];
        lt.useEffect((function() {
            x.current && x.current.update()
        }
        ));
        var P = lt.useCallback((function() {
            if (y.current && n && u) {
                x.current && (x.current.destroy(),
                C.current(null));
                var e = function(e) {
                    R(e.placement)
                }
                  , t = (Dd(n),
                new Ld(Dd(n),y.current,Vt({
                    placement: O
                }, h, {
                    modifiers: Vt({}, a ? {} : {
                        preventOverflow: {
                            boundariesElement: "window"
                        }
                    }, {}, c, {}, h.modifiers),
                    onCreate: tc(e, h.onCreate),
                    onUpdate: tc(e, h.onUpdate)
                })));
                C.current(t)
            }
        }
        ), [n, a, c, u, O, h])
          , I = lt.useCallback((function(e) {
            Ls(w, e),
            P()
        }
        ), [w, P])
          , z = function() {
            x.current && (x.current.destroy(),
            C.current(null))
        };
        if (lt.useEffect((function() {
            P()
        }
        ), [P]),
        lt.useEffect((function() {
            return function() {
                z()
            }
        }
        ), []),
        lt.useEffect((function() {
            u || g || z()
        }
        ), [u, g]),
        !l && !u && (!g || E))
            return null;
        var A = {
            placement: M
        };
        return g && (A.TransitionProps = {
            in: u,
            onEnter: function() {
                k(!1)
            },
            onExited: function() {
                k(!0),
                z()
            }
        }),
        lt.createElement(rc, {
            disablePortal: a,
            container: i
        }, lt.createElement("div", Vt({
            ref: I,
            role: "tooltip"
        }, b, {
            style: Vt({
                position: "fixed",
                top: 0,
                left: 0
            }, b.style)
        }), "function" == typeof r ? r(A) : r))
    }
    ));
    function $d(e) {
        return Math.round(1e5 * e) / 1e5
    }
    var Bd = !1
      , jd = null
      , Hd = lt.forwardRef((function(e, t) {
        var n = e.arrow
          , r = void 0 !== n && n
          , i = e.children
          , o = e.classes
          , a = e.disableFocusListener
          , s = void 0 !== a && a
          , l = e.disableHoverListener
          , c = void 0 !== l && l
          , u = e.disableTouchListener
          , d = void 0 !== u && u
          , p = e.enterDelay
          , f = void 0 === p ? 0 : p
          , h = e.enterTouchDelay
          , m = void 0 === h ? 700 : h
          , v = e.id
          , g = e.interactive
          , b = void 0 !== g && g
          , y = e.leaveDelay
          , w = void 0 === y ? 0 : y
          , x = e.leaveTouchDelay
          , _ = void 0 === x ? 1500 : x
          , C = e.onClose
          , S = e.onOpen
          , E = e.open
          , k = e.placement
          , O = void 0 === k ? "bottom" : k
          , T = e.PopperProps
          , M = e.title
          , R = e.TransitionComponent
          , P = void 0 === R ? yc : R
          , I = e.TransitionProps
          , z = jt(e, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "title", "TransitionComponent", "TransitionProps"])
          , A = Za()
          , L = lt.useState()
          , D = L[0]
          , N = L[1]
          , W = lt.useState(null)
          , F = W[0]
          , $ = W[1]
          , B = lt.useRef(!1)
          , j = lt.useRef()
          , H = lt.useRef()
          , V = lt.useRef()
          , q = lt.useRef()
          , U = ys(jc({
            controlled: E,
            default: !1,
            name: "Tooltip"
        }), 2)
          , G = U[0]
          , Z = U[1]
          , K = G
          , Y = lt.useState()
          , X = Y[0]
          , J = Y[1]
          , Q = v || X;
        lt.useEffect((function() {
            K && !X && J("mui-tooltip-".concat(Math.round(1e5 * Math.random())))
        }
        ), [K, X]),
        lt.useEffect((function() {
            return function() {
                clearTimeout(j.current),
                clearTimeout(H.current),
                clearTimeout(V.current),
                clearTimeout(q.current)
            }
        }
        ), []);
        var ee = function(e) {
            clearTimeout(jd),
            Bd = !0,
            Z(!0),
            S && S(e)
        }
          , te = function(e) {
            var t = i.props;
            "mouseover" === e.type && t.onMouseOver && e.currentTarget === D && t.onMouseOver(e),
            B.current && "touchstart" !== e.type || (D && D.removeAttribute("title"),
            clearTimeout(H.current),
            clearTimeout(V.current),
            f && !Bd ? (e.persist(),
            H.current = setTimeout((function() {
                ee(e)
            }
            ), f)) : ee(e))
        }
          , ne = Ys()
          , re = ne.isFocusVisible
          , ie = ne.onBlurVisible
          , oe = ne.ref
          , ae = lt.useState(!1)
          , se = ae[0]
          , le = ae[1]
          , ce = function(e) {
            clearTimeout(jd),
            jd = setTimeout((function() {
                Bd = !1
            }
            ), 500),
            Z(!1),
            C && C(e),
            clearTimeout(j.current),
            j.current = setTimeout((function() {
                B.current = !1
            }
            ), A.transitions.duration.shortest)
        }
          , ue = function(e) {
            var t = i.props;
            "blur" === e.type && (t.onBlur && e.currentTarget === D && t.onBlur(e),
            se && (le(!1),
            ie())),
            "mouseleave" === e.type && t.onMouseLeave && e.currentTarget === D && t.onMouseLeave(e),
            clearTimeout(H.current),
            clearTimeout(V.current),
            e.persist(),
            V.current = setTimeout((function() {
                ce(e)
            }
            ), w)
        }
          , de = Ds(N, t)
          , pe = Ds(oe, de)
          , fe = lt.useCallback((function(e) {
            Ls(pe, lt.findDOMNode(e))
        }
        ), [pe])
          , he = Ds(i.ref, fe);
        "" === M && (K = !1);
        var me = Vt({
            "aria-describedby": K ? Q : null,
            title: !K && !c && "string" == typeof M ? M : null
        }, z, {}, i.props, {
            className: Ra(z.className, i.props.className)
        });
        d || (me.onTouchStart = function(e) {
            B.current = !0;
            var t = i.props;
            t.onTouchStart && t.onTouchStart(e),
            clearTimeout(V.current),
            clearTimeout(j.current),
            clearTimeout(q.current),
            e.persist(),
            q.current = setTimeout((function() {
                te(e)
            }
            ), m)
        }
        ,
        me.onTouchEnd = function(e) {
            i.props.onTouchEnd && i.props.onTouchEnd(e),
            clearTimeout(q.current),
            clearTimeout(V.current),
            e.persist(),
            V.current = setTimeout((function() {
                ce(e)
            }
            ), _)
        }
        ),
        c || (me.onMouseOver = te,
        me.onMouseLeave = ue),
        s || (me.onFocus = function(e) {
            D || N(e.currentTarget),
            re(e) && (le(!0),
            te(e));
            var t = i.props;
            t.onFocus && e.currentTarget === D && t.onFocus(e)
        }
        ,
        me.onBlur = ue);
        var ve = b ? {
            onMouseOver: me.onMouseOver,
            onMouseLeave: me.onMouseLeave,
            onFocus: me.onFocus,
            onBlur: me.onBlur
        } : {};
        var ge = lt.useMemo((function() {
            return {
                modifiers: {
                    arrow: {
                        enabled: Boolean(F),
                        element: F
                    }
                }
            }
        }
        ), [F]);
        return lt.createElement(lt.Fragment, null, lt.cloneElement(i, Vt({
            ref: he
        }, me)), lt.createElement(Fd, Vt({
            className: Ra(o.popper, b && o.popperInteractive, r && o.popperArrow),
            placement: O,
            anchorEl: D,
            open: !!D && K,
            id: me["aria-describedby"],
            transition: !0,
            popperOptions: ge
        }, ve, T), (function(e) {
            var t = e.placement
              , n = e.TransitionProps;
            return lt.createElement(P, Vt({
                timeout: A.transitions.duration.shorter
            }, n, I), lt.createElement("div", {
                className: Ra(o.tooltip, o["tooltipPlacement".concat(gl(t.split("-")[0]))], B.current && o.touch, r && o.tooltipArrow)
            }, M, r ? lt.createElement("span", {
                className: o.arrow,
                ref: $
            }) : null))
        }
        )))
    }
    ))
      , Vd = Ka((function(e) {
        return {
            popper: {
                zIndex: e.zIndex.tooltip,
                pointerEvents: "none",
                flip: !1
            },
            popperInteractive: {
                pointerEvents: "auto"
            },
            popperArrow: {
                '&[x-placement*="bottom"] $arrow': {
                    flip: !1,
                    top: 0,
                    left: 0,
                    marginTop: "-0.95em",
                    marginLeft: 4,
                    marginRight: 4,
                    width: "2em",
                    height: "1em",
                    "&::before": {
                        flip: !1,
                        borderWidth: "0 1em 1em 1em",
                        borderColor: "transparent transparent currentcolor transparent"
                    }
                },
                '&[x-placement*="top"] $arrow': {
                    flip: !1,
                    bottom: 0,
                    left: 0,
                    marginBottom: "-0.95em",
                    marginLeft: 4,
                    marginRight: 4,
                    width: "2em",
                    height: "1em",
                    "&::before": {
                        flip: !1,
                        borderWidth: "1em 1em 0 1em",
                        borderColor: "currentcolor transparent transparent transparent"
                    }
                },
                '&[x-placement*="right"] $arrow': {
                    flip: !1,
                    left: 0,
                    marginLeft: "-0.95em",
                    marginTop: 4,
                    marginBottom: 4,
                    height: "2em",
                    width: "1em",
                    "&::before": {
                        flip: !1,
                        borderWidth: "1em 1em 1em 0",
                        borderColor: "transparent currentcolor transparent transparent"
                    }
                },
                '&[x-placement*="left"] $arrow': {
                    flip: !1,
                    right: 0,
                    marginRight: "-0.95em",
                    marginTop: 4,
                    marginBottom: 4,
                    height: "2em",
                    width: "1em",
                    "&::before": {
                        flip: !1,
                        borderWidth: "1em 0 1em 1em",
                        borderColor: "transparent transparent transparent currentcolor"
                    }
                }
            },
            tooltip: {
                backgroundColor: Nt(e.palette.grey[700], .9),
                borderRadius: e.shape.borderRadius,
                color: e.palette.common.white,
                fontFamily: e.typography.fontFamily,
                padding: "4px 8px",
                fontSize: e.typography.pxToRem(10),
                lineHeight: "".concat($d(1.4), "em"),
                maxWidth: 300,
                wordWrap: "break-word",
                fontWeight: e.typography.fontWeightMedium
            },
            tooltipArrow: {
                position: "relative",
                margin: "0"
            },
            arrow: {
                position: "absolute",
                fontSize: 6,
                color: Nt(e.palette.grey[700], .9),
                "&::before": {
                    content: '""',
                    margin: "auto",
                    display: "block",
                    width: 0,
                    height: 0,
                    borderStyle: "solid"
                }
            },
            touch: {
                padding: "8px 16px",
                fontSize: e.typography.pxToRem(14),
                lineHeight: "".concat($d(16 / 14), "em"),
                fontWeight: e.typography.fontWeightRegular
            },
            tooltipPlacementLeft: $t({
                transformOrigin: "right center",
                margin: "0 24px "
            }, e.breakpoints.up("sm"), {
                margin: "0 14px"
            }),
            tooltipPlacementRight: $t({
                transformOrigin: "left center",
                margin: "0 24px"
            }, e.breakpoints.up("sm"), {
                margin: "0 14px"
            }),
            tooltipPlacementTop: $t({
                transformOrigin: "center bottom",
                margin: "24px 0"
            }, e.breakpoints.up("sm"), {
                margin: "14px 0"
            }),
            tooltipPlacementBottom: $t({
                transformOrigin: "center top",
                margin: "24px 0"
            }, e.breakpoints.up("sm"), {
                margin: "14px 0"
            })
        }
    }
    ), {
        name: "PwzrTooltip"
    })(Hd);
    function qd(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
          , n = ji()
          , r = Er({
            theme: n,
            name: "PwzrUseMediaQuery",
            props: {}
        });
        var i = "function" == typeof e ? e(n) : e;
        i = i.replace(/^@media( ?)/m, "");
        var o = "undefined" != typeof window && void 0 !== window.matchMedia
          , a = Vt({}, r, {}, t)
          , s = a.defaultMatches
          , l = void 0 !== s && s
          , c = a.matchMedia
          , u = void 0 === c ? o ? window.matchMedia : null : c
          , d = a.noSsr
          , p = void 0 !== d && d
          , f = a.ssrMatchMedia
          , h = void 0 === f ? null : f
          , m = lt.useState((function() {
            return p && o ? u(i).matches : h ? h(i).matches : l
        }
        ))
          , v = m[0]
          , g = m[1];
        return lt.useEffect((function() {
            var e = !0;
            if (o) {
                var t = u(i)
                  , n = function() {
                    e && g(t.matches)
                };
                return n(),
                t.addListener(n),
                function() {
                    e = !1,
                    t.removeListener(n)
                }
            }
        }
        ), [i, u, o]),
        v
    }
    var Ud, Gd = !1;
    function Zd() {
        Ud = {},
        Ud = () => {
            var e;
            !function() {
                if ("function" == typeof window.CustomEvent)
                    return !1;
                window.CustomEvent = function(e, t) {
                    t = t || {
                        bubbles: !1,
                        cancelable: !1,
                        detail: null
                    };
                    var n = document.createEvent("CustomEvent");
                    return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail),
                    n
                }
            }(),
            history.pushState = (e = history.pushState,
            function() {
                var t = e.apply(this, arguments);
                return window.dispatchEvent(new CustomEvent("pushState")),
                window.dispatchEvent(new CustomEvent("locationchange")),
                t
            }
            ),
            history.replaceState = function(e) {
                return function() {
                    var t = e.apply(this, arguments);
                    return window.dispatchEvent(new CustomEvent("replaceState")),
                    window.dispatchEvent(new CustomEvent("locationchange")),
                    t
                }
            }(history.replaceState),
            window.addEventListener("popstate", (function() {
                window.dispatchEvent(new CustomEvent("locationchange"))
            }
            ))
        }
    }
    var Kd, Yd = {}, Xd = !1;
    function Jd() {
        return Xd || (Xd = !0,
        function(e, t) {
            if (void 0 !== Kd)
                t(Kd);
            else {
                var n = {
                    exports: {}
                };
                t(n.exports),
                e.index = n.exports
            }
        }(Kd = {}, (function(e) {
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var t = Object.assign || function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
                }
                return e
            }
              , n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
              , r = (e.isDate = function(e) {
                return e instanceof Date
            }
            ,
            e.isEmpty = function(e) {
                return 0 === Object.keys(e).length
            }
            ,
            e.isObject = function(e) {
                return null != e && "object" === (void 0 === e ? "undefined" : n(e))
            }
            );
            e.properObject = function(e) {
                return r(e) && !e.hasOwnProperty ? t({}, e) : e
            }
        }
        ))),
        Kd
    }
    var Qd, ep = !1;
    function tp() {
        return ep || (ep = !0,
        Qd = function() {
            var e = this
              , t = {
                exports: this
            };
            return function(n, r) {
                if (void 0 !== e)
                    r(t, e, Jd());
                else {
                    var i = {
                        exports: {}
                    };
                    r(i, i.exports, n.utils),
                    n.index = i.exports
                }
            }(this, (function(e, t, n) {
                function r(e, t, n) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n,
                    e
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = Object.assign || function(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var r in n)
                            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
                    }
                    return e
                }
                ;
                t.default = function e(t, o) {
                    if (t === o)
                        return {};
                    if (!(0,
                    n.isObject)(t) || !(0,
                    n.isObject)(o))
                        return o;
                    var a = (0,
                    n.properObject)(t)
                      , s = (0,
                    n.properObject)(o)
                      , l = Object.keys(a).reduce((function(e, t) {
                        return s.hasOwnProperty(t) ? e : i({}, e, r({}, t, void 0))
                    }
                    ), {});
                    return (0,
                    n.isDate)(a) || (0,
                    n.isDate)(s) ? a.valueOf() == s.valueOf() ? {} : s : Object.keys(s).reduce((function(t, o) {
                        if (!a.hasOwnProperty(o))
                            return i({}, t, r({}, o, s[o]));
                        var l = e(a[o], s[o]);
                        return (0,
                        n.isObject)(l) && (0,
                        n.isEmpty)(l) && !(0,
                        n.isDate)(l) ? t : i({}, t, r({}, o, l))
                    }
                    ), l)
                }
                ,
                e.exports = t.default
            }
            )),
            t.exports
        }
        .call({})),
        Qd
    }
    var np, rp = !1;
    function ip() {
        return rp || (rp = !0,
        np = function() {
            var e = this
              , t = {
                exports: this
            };
            return function(n, r) {
                if (void 0 !== e)
                    r(t, e, Jd());
                else {
                    var i = {
                        exports: {}
                    };
                    r(i, i.exports, n.utils),
                    n.index = i.exports
                }
            }(this, (function(e, t, n) {
                function r(e, t, n) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n,
                    e
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = Object.assign || function(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var r in n)
                            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
                    }
                    return e
                }
                ;
                t.default = function e(t, o) {
                    if (t === o || !(0,
                    n.isObject)(t) || !(0,
                    n.isObject)(o))
                        return {};
                    var a = (0,
                    n.properObject)(t)
                      , s = (0,
                    n.properObject)(o);
                    return Object.keys(s).reduce((function(t, o) {
                        if (a.hasOwnProperty(o)) {
                            var l = e(a[o], s[o]);
                            return (0,
                            n.isObject)(l) && (0,
                            n.isEmpty)(l) ? t : i({}, t, r({}, o, l))
                        }
                        return i({}, t, r({}, o, s[o]))
                    }
                    ), {})
                }
                ,
                e.exports = t.default
            }
            )),
            t.exports
        }
        .call({})),
        np
    }
    var op, ap = !1;
    function sp() {
        return ap || (ap = !0,
        op = function() {
            var e = this
              , t = {
                exports: this
            };
            return function(n, r) {
                if (void 0 !== e)
                    r(t, e, Jd());
                else {
                    var i = {
                        exports: {}
                    };
                    r(i, i.exports, n.utils),
                    n.index = i.exports
                }
            }(this, (function(e, t, n) {
                function r(e, t, n) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n,
                    e
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = Object.assign || function(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var r in n)
                            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
                    }
                    return e
                }
                ;
                t.default = function e(t, o) {
                    if (t === o || !(0,
                    n.isObject)(t) || !(0,
                    n.isObject)(o))
                        return {};
                    var a = (0,
                    n.properObject)(t)
                      , s = (0,
                    n.properObject)(o);
                    return Object.keys(a).reduce((function(t, o) {
                        if (s.hasOwnProperty(o)) {
                            var l = e(a[o], s[o]);
                            return (0,
                            n.isObject)(l) && (0,
                            n.isEmpty)(l) ? t : i({}, t, r({}, o, l))
                        }
                        return i({}, t, r({}, o, void 0))
                    }
                    ), {})
                }
                ,
                e.exports = t.default
            }
            )),
            t.exports
        }
        .call({})),
        op
    }
    var lp, cp = !1;
    function up() {
        lp = function() {
            var e = this
              , t = {
                exports: this
            };
            return function(n, r) {
                if (void 0 !== e)
                    r(t, e, Jd());
                else {
                    var i = {
                        exports: {}
                    };
                    r(i, i.exports, n.utils),
                    n.index = i.exports
                }
            }(this, (function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var r = Object.assign || function(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var r in n)
                            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
                    }
                    return e
                }
                ;
                t.default = function e(t, i) {
                    if (t === i)
                        return {};
                    if (!(0,
                    n.isObject)(t) || !(0,
                    n.isObject)(i))
                        return i;
                    var o = (0,
                    n.properObject)(t)
                      , a = (0,
                    n.properObject)(i);
                    return (0,
                    n.isDate)(o) || (0,
                    n.isDate)(a) ? o.valueOf() == a.valueOf() ? {} : a : Object.keys(a).reduce((function(t, i) {
                        if (o.hasOwnProperty(i)) {
                            var s = e(o[i], a[i]);
                            return (0,
                            n.isObject)(s) && (0,
                            n.isEmpty)(s) && !(0,
                            n.isDate)(s) ? t : r({}, t, function(e, t, n) {
                                return t in e ? Object.defineProperty(e, t, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e[t] = n,
                                e
                            }({}, i, s))
                        }
                        return t
                    }
                    ), {})
                }
                ,
                e.exports = t.default
            }
            )),
            t.exports
        }
        .call({})
    }
    function dp() {
        return cp || (cp = !0,
        up()),
        lp
    }
    var pp, fp = !1;
    function hp() {
        return fp || (fp = !0,
        pp = function() {
            var e = this
              , t = {
                exports: this
            };
            return function(n, r) {
                if (void 0 !== e)
                    r(t, e, ip(), sp(), dp());
                else {
                    var i = {
                        exports: {}
                    };
                    r(i, i.exports, n.added, n.deleted, n.updated),
                    n.index = i.exports
                }
            }(this, (function(e, t, n, r, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var o = l(n)
                  , a = l(r)
                  , s = l(i);
                function l(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    }
                }
                t.default = function(e, t) {
                    return {
                        added: (0,
                        o.default)(e, t),
                        deleted: (0,
                        a.default)(e, t),
                        updated: (0,
                        s.default)(e, t)
                    }
                }
                ,
                e.exports = t.default
            }
            )),
            t.exports
        }
        .call({})),
        pp
    }
    !function(e, t) {
        if (void 0 !== Yd)
            t(Yd, tp(), ip(), sp(), dp(), hp());
        else {
            var n = {
                exports: {}
            };
            t(n.exports, e.diff, e.added, e.deleted, e.updated, e.detailed),
            e.index = n.exports
        }
    }(Yd, (function(e, t, n, r, i, o) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        }),
        e.detailedDiff = e.updatedDiff = e.deletedDiff = e.diff = e.addedDiff = void 0;
        var a = d(t)
          , s = d(n)
          , l = d(r)
          , c = d(i)
          , u = d(o);
        function d(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }
        e.addedDiff = s.default,
        e.diff = a.default,
        e.deletedDiff = l.default,
        e.updatedDiff = c.default,
        e.detailedDiff = u.default
    }
    ));
    var mp, vp = {};
    var gp = mp = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    ;
    Object.defineProperty(vp, "__esModule", {
        value: !0
    });
    var bp = void 0;
    vp.default = bp;
    var yp = {};
    function wp() {
        return yp = wp = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ,
        wp.apply(this, arguments)
    }
    var xp = t(yp = wp)
      , _p = gp(yp)
      , Cp = {}
      , Sp = mp;
    Object.defineProperty(Cp, "__esModule", {
        value: !0
    });
    var Ep = void 0;
    Cp.default = Ep;
    var kp = {}
      , Op = mp;
    Object.defineProperty(kp, "__esModule", {
        value: !0
    });
    var Tp = void 0;
    kp.default = Tp;
    var Mp;
    var Rp, Pp = t(Mp = function(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    );
    Op(Mp);
    var Ip = function(e, t) {
        if (null == e)
            return {};
        var n, r, i = {}, o = Object.keys(e);
        for (r = 0; r < o.length; r++)
            n = o[r],
            t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i
    };
    var zp = Op(Rp = function(e, t) {
        if (null == e)
            return {};
        var n, r, i = Ip(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (r = 0; r < o.length; r++)
                n = o[r],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n])
        }
        return i
    }
    )
      , Ap = {}
      , Lp = mp;
    Object.defineProperty(Ap, "__esModule", {
        value: !0
    });
    var Dp = function(e) {
        var t = e.values
          , n = void 0 === t ? {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920
        } : t
          , r = e.unit
          , i = void 0 === r ? "px" : r
          , o = e.step
          , a = void 0 === o ? 5 : o
          , s = (0,
        Fp.default)(e, ["values", "unit", "step"]);
        function l(e) {
            var t = "number" == typeof n[e] ? n[e] : e;
            return "@media (min-width:".concat(t).concat(i, ")")
        }
        function c(e, t) {
            var r = $p.indexOf(t);
            return r === $p.length - 1 ? l(e) : "@media (min-width:".concat("number" == typeof n[e] ? n[e] : e).concat(i, ") and ") + "(max-width:".concat((-1 !== r && "number" == typeof n[$p[r + 1]] ? n[$p[r + 1]] : t) - a / 100).concat(i, ")")
        }
        return (0,
        Wp.default)({
            keys: $p,
            values: n,
            up: l,
            down: function(e) {
                var t = $p.indexOf(e) + 1
                  , r = n[$p[t]];
                return t === $p.length ? l("xs") : "@media (max-width:".concat(("number" == typeof r && t > 0 ? r : e) - a / 100).concat(i, ")")
            },
            between: c,
            only: function(e) {
                return c(e, e)
            },
            width: function(e) {
                return n[e]
            }
        }, s)
    };
    Ap.default = Dp;
    var Np = void 0;
    Ap.keys = Np;
    var Wp = Lp(yp)
      , Fp = Lp(Rp)
      , $p = ["xs", "sm", "md", "lg", "xl"];
    Np = $p,
    Ap.keys = Np;
    var Bp = Op(Ap)
      , jp = {}
      , Hp = mp;
    Object.defineProperty(jp, "__esModule", {
        value: !0
    });
    var Vp = function(e, t, n) {
        var r;
        return (0,
        Up.default)({
            gutters: function() {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return (0,
                Up.default)({
                    paddingLeft: t(2),
                    paddingRight: t(2)
                }, n, (0,
                qp.default)({}, e.up("sm"), (0,
                Up.default)({
                    paddingLeft: t(3),
                    paddingRight: t(3)
                }, n[e.up("sm")])))
            },
            toolbar: (r = {
                minHeight: 56
            },
            (0,
            qp.default)(r, "".concat(e.up("xs"), " and (orientation: landscape)"), {
                minHeight: 48
            }),
            (0,
            qp.default)(r, e.up("sm"), {
                minHeight: 64
            }),
            r)
        }, n)
    };
    jp.default = Vp;
    var qp = Hp(Mp)
      , Up = Hp(yp);
    var Gp = Op(jp)
      , Zp = {}
      , Kp = mp;
    Object.defineProperty(Zp, "__esModule", {
        value: !0
    });
    var Yp = function(e) {
        var t = e.primary
          , n = void 0 === t ? {
            light: cf.default[300],
            main: cf.default[500],
            dark: cf.default[700]
        } : t
          , r = e.secondary
          , i = void 0 === r ? {
            light: pf.default.A200,
            main: pf.default.A400,
            dark: pf.default.A700
        } : r
          , o = e.error
          , a = void 0 === o ? {
            light: mf.default[300],
            main: mf.default[500],
            dark: mf.default[700]
        } : o
          , s = e.warning
          , l = void 0 === s ? {
            light: bf.default[300],
            main: bf.default[500],
            dark: bf.default[700]
        } : s
          , c = e.info
          , u = void 0 === c ? {
            light: xf.default[300],
            main: xf.default[500],
            dark: xf.default[700]
        } : c
          , d = e.success
          , p = void 0 === d ? {
            light: Sf.default[300],
            main: Sf.default[500],
            dark: Sf.default[700]
        } : d
          , f = e.type
          , h = void 0 === f ? "light" : f
          , m = e.contrastThreshold
          , v = void 0 === m ? 3 : m
          , g = e.tonalOffset
          , b = void 0 === g ? .2 : g
          , y = (0,
        Qp.default)(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
        function w(e) {
            if (!e)
                throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(e, ")."));
            var t = (0,
            Ef.getContrastRatio)(e, Gf.text.primary) >= v ? Gf.text.primary : qf.text.primary;
            return t
        }
        function x(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500
              , n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 300
              , r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 700;
            return !(e = (0,
            Jp.default)({}, e)).main && e[t] && (e.main = e[t]),
            Zf(e, "light", n, b),
            Zf(e, "dark", r, b),
            e.contrastText || (e.contrastText = w(e.main)),
            e
        }
        var _ = {
            dark: Gf,
            light: qf
        };
        0;
        return Zt((0,
        Jp.default)({
            common: nf.default,
            type: h,
            primary: x(n),
            secondary: x(i, "A400", "A200", "A700"),
            error: x(a),
            warning: x(l),
            info: x(u),
            success: x(p),
            grey: af.default,
            contrastThreshold: v,
            getContrastText: w,
            augmentColor: x,
            tonalOffset: b
        }, _[h]), y)
    };
    Zp.default = Yp;
    var Xp = (Uf = void 0,
    Zp.light = Uf);
    Zp.dark = Xp;
    var Jp = Kp(yp)
      , Qp = Kp(Rp)
      , ef = {};
    Object.defineProperty(ef, "__esModule", {
        value: !0
    });
    var tf = void 0;
    ef.default = tf;
    tf = {
        black: "#000",
        white: "#fff"
    },
    ef.default = tf;
    var nf = Kp(ef)
      , rf = {};
    Object.defineProperty(rf, "__esModule", {
        value: !0
    });
    var of = void 0;
    rf.default = of;
    of = {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#eeeeee",
        300: "#e0e0e0",
        400: "#bdbdbd",
        500: "#9e9e9e",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
        A100: "#d5d5d5",
        A200: "#aaaaaa",
        A400: "#303030",
        A700: "#616161"
    },
    rf.default = of;
    var af = Kp(rf)
      , sf = {};
    Object.defineProperty(sf, "__esModule", {
        value: !0
    });
    var lf = void 0;
    sf.default = lf;
    lf = {
        50: "#e8eaf6",
        100: "#c5cae9",
        200: "#9fa8da",
        300: "#7986cb",
        400: "#5c6bc0",
        500: "#3f51b5",
        600: "#3949ab",
        700: "#303f9f",
        800: "#283593",
        900: "#1a237e",
        A100: "#8c9eff",
        A200: "#536dfe",
        A400: "#3d5afe",
        A700: "#304ffe"
    },
    sf.default = lf;
    var cf = Kp(sf)
      , uf = {};
    Object.defineProperty(uf, "__esModule", {
        value: !0
    });
    var df = void 0;
    uf.default = df;
    df = {
        50: "#fce4ec",
        100: "#f8bbd0",
        200: "#f48fb1",
        300: "#f06292",
        400: "#ec407a",
        500: "#e91e63",
        600: "#d81b60",
        700: "#c2185b",
        800: "#ad1457",
        900: "#880e4f",
        A100: "#ff80ab",
        A200: "#ff4081",
        A400: "#f50057",
        A700: "#c51162"
    },
    uf.default = df;
    var pf = Kp(uf)
      , ff = {};
    Object.defineProperty(ff, "__esModule", {
        value: !0
    });
    var hf = void 0;
    ff.default = hf;
    hf = {
        50: "#ffebee",
        100: "#ffcdd2",
        200: "#ef9a9a",
        300: "#e57373",
        400: "#ef5350",
        500: "#f44336",
        600: "#e53935",
        700: "#d32f2f",
        800: "#c62828",
        900: "#b71c1c",
        A100: "#ff8a80",
        A200: "#ff5252",
        A400: "#ff1744",
        A700: "#d50000"
    },
    ff.default = hf;
    var mf = Kp(ff)
      , vf = {};
    Object.defineProperty(vf, "__esModule", {
        value: !0
    });
    var gf = void 0;
    vf.default = gf;
    gf = {
        50: "#fff3e0",
        100: "#ffe0b2",
        200: "#ffcc80",
        300: "#ffb74d",
        400: "#ffa726",
        500: "#ff9800",
        600: "#fb8c00",
        700: "#f57c00",
        800: "#ef6c00",
        900: "#e65100",
        A100: "#ffd180",
        A200: "#ffab40",
        A400: "#ff9100",
        A700: "#ff6d00"
    },
    vf.default = gf;
    var bf = Kp(vf)
      , yf = {};
    Object.defineProperty(yf, "__esModule", {
        value: !0
    });
    var wf = void 0;
    yf.default = wf;
    wf = {
        50: "#e3f2fd",
        100: "#bbdefb",
        200: "#90caf9",
        300: "#64b5f6",
        400: "#42a5f5",
        500: "#2196f3",
        600: "#1e88e5",
        700: "#1976d2",
        800: "#1565c0",
        900: "#0d47a1",
        A100: "#82b1ff",
        A200: "#448aff",
        A400: "#2979ff",
        A700: "#2962ff"
    },
    yf.default = wf;
    var xf = Kp(yf)
      , _f = {};
    Object.defineProperty(_f, "__esModule", {
        value: !0
    });
    var Cf = void 0;
    _f.default = Cf;
    Cf = {
        50: "#e8f5e9",
        100: "#c8e6c9",
        200: "#a5d6a7",
        300: "#81c784",
        400: "#66bb6a",
        500: "#4caf50",
        600: "#43a047",
        700: "#388e3c",
        800: "#2e7d32",
        900: "#1b5e20",
        A100: "#b9f6ca",
        A200: "#69f0ae",
        A400: "#00e676",
        A700: "#00c853"
    },
    _f.default = Cf;
    var Sf = Kp(_f)
      , Ef = {};
    Object.defineProperty(Ef, "__esModule", {
        value: !0
    });
    var kf = Wf;
    Ef.hexToRgb = kf;
    var Of = function(e) {
        if (0 === e.indexOf("#"))
            return e;
        var t = $f(e).values;
        return "#".concat(t.map((function(e) {
            return 1 === (t = e.toString(16)).length ? "0".concat(t) : t;
            var t
        }
        )).join(""))
    };
    Ef.rgbToHex = Of;
    var Tf = Ff;
    Ef.hslToRgb = Tf;
    var Mf = $f;
    Ef.decomposeColor = Mf;
    var Rf = Bf;
    Ef.recomposeColor = Rf;
    var Pf = function(e, t) {
        var n = jf(e)
          , r = jf(t);
        return (Math.max(n, r) + .05) / (Math.min(n, r) + .05)
    };
    Ef.getContrastRatio = Pf;
    var If = jf;
    Ef.getLuminance = If;
    var zf = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .15;
        return jf(e) > .5 ? Hf(e, t) : Vf(e, t)
    };
    Ef.emphasize = zf;
    var Af = function(e, t) {
        e = $f(e),
        t = Nf(t),
        ("rgb" === e.type || "hsl" === e.type) && (e.type += "a");
        return e.values[3] = t,
        Bf(e)
    };
    Ef.fade = Af;
    var Lf = Hf;
    Ef.darken = Lf;
    var Df = Vf;
    function Nf(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0
          , n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        return Math.min(Math.max(t, e), n)
    }
    function Wf(e) {
        e = e.substr(1);
        var t = new RegExp(".{1,".concat(e.length / 3, "}"),"g")
          , n = e.match(t);
        return n && 1 === n[0].length && (n = n.map((function(e) {
            return e + e
        }
        ))),
        n ? "rgb(".concat(n.map((function(e) {
            return parseInt(e, 16)
        }
        )).join(", "), ")") : ""
    }
    function Ff(e) {
        var t = (e = $f(e)).values
          , n = t[0]
          , r = t[1] / 100
          , i = t[2] / 100
          , o = r * Math.min(i, 1 - i)
          , a = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e + n / 30) % 12;
            return i - o * Math.max(Math.min(t - 3, 9 - t, 1), -1)
        }
          , s = "rgb"
          , l = [Math.round(255 * a(0)), Math.round(255 * a(8)), Math.round(255 * a(4))];
        return "hsla" === e.type && (s += "a",
        l.push(t[3])),
        Bf({
            type: s,
            values: l
        })
    }
    function $f(e) {
        if (e.type)
            return e;
        if ("#" === e.charAt(0))
            return $f(Wf(e));
        var t = e.indexOf("(")
          , n = e.substring(0, t);
        if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(n))
            throw new Error(["Material-UI: unsupported `".concat(e, "` color."), "We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."].join("\n"));
        var r = e.substring(t + 1, e.length - 1).split(",");
        return {
            type: n,
            values: r = r.map((function(e) {
                return parseFloat(e)
            }
            ))
        }
    }
    function Bf(e) {
        var t = e.type
          , n = e.values;
        return -1 !== t.indexOf("rgb") ? n = n.map((function(e, t) {
            return t < 3 ? parseInt(e, 10) : e
        }
        )) : -1 !== t.indexOf("hsl") && (n[1] = "".concat(n[1], "%"),
        n[2] = "".concat(n[2], "%")),
        "".concat(t, "(").concat(n.join(", "), ")")
    }
    function jf(e) {
        var t = "hsl" === (e = $f(e)).type ? $f(Ff(e)).values : e.values;
        return t = t.map((function(e) {
            return (e /= 255) <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)
        }
        )),
        Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3))
    }
    function Hf(e, t) {
        if (e = $f(e),
        t = Nf(t),
        -1 !== e.type.indexOf("hsl"))
            e.values[2] *= 1 - t;
        else if (-1 !== e.type.indexOf("rgb"))
            for (var n = 0; n < 3; n += 1)
                e.values[n] *= 1 - t;
        return Bf(e)
    }
    function Vf(e, t) {
        if (e = $f(e),
        t = Nf(t),
        -1 !== e.type.indexOf("hsl"))
            e.values[2] += (100 - e.values[2]) * t;
        else if (-1 !== e.type.indexOf("rgb"))
            for (var n = 0; n < 3; n += 1)
                e.values[n] += (255 - e.values[n]) * t;
        return Bf(e)
    }
    Ef.lighten = Df;
    var qf = {
        text: {
            primary: "rgba(0, 0, 0, 0.87)",
            secondary: "rgba(0, 0, 0, 0.54)",
            disabled: "rgba(0, 0, 0, 0.38)",
            hint: "rgba(0, 0, 0, 0.38)"
        },
        divider: "rgba(0, 0, 0, 0.12)",
        background: {
            paper: nf.default.white,
            default: af.default[50]
        },
        action: {
            active: "rgba(0, 0, 0, 0.54)",
            hover: "rgba(0, 0, 0, 0.04)",
            hoverOpacity: .04,
            selected: "rgba(0, 0, 0, 0.08)",
            selectedOpacity: .08,
            disabled: "rgba(0, 0, 0, 0.26)",
            disabledBackground: "rgba(0, 0, 0, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(0, 0, 0, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .12
        }
    }
      , Uf = qf;
    Zp.light = Uf;
    var Gf = {
        text: {
            primary: nf.default.white,
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
            hint: "rgba(255, 255, 255, 0.5)",
            icon: "rgba(255, 255, 255, 0.5)"
        },
        divider: "rgba(255, 255, 255, 0.12)",
        background: {
            paper: af.default[800],
            default: "#303030"
        },
        action: {
            active: nf.default.white,
            hover: "rgba(255, 255, 255, 0.08)",
            hoverOpacity: .08,
            selected: "rgba(255, 255, 255, 0.16)",
            selectedOpacity: .16,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .24
        }
    };
    function Zf(e, t, n, r) {
        e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : "light" === t ? e.light = (0,
        Ef.lighten)(e.main, r) : "dark" === t && (e.dark = (0,
        Ef.darken)(e.main, 1.5 * r)))
    }
    Xp = Gf,
    Zp.dark = Xp;
    var Kf = Op(Zp)
      , Yf = {}
      , Xf = mp;
    Object.defineProperty(Yf, "__esModule", {
        value: !0
    });
    var Jf = function(e, t) {
        var n = "function" == typeof t ? t(e) : t
          , r = n.fontFamily
          , i = void 0 === r ? rh : r
          , o = n.fontSize
          , a = void 0 === o ? 14 : o
          , s = n.fontWeightLight
          , l = void 0 === s ? 300 : s
          , c = n.fontWeightRegular
          , u = void 0 === c ? 400 : c
          , d = n.fontWeightMedium
          , p = void 0 === d ? 500 : d
          , f = n.fontWeightBold
          , h = void 0 === f ? 700 : f
          , m = n.htmlFontSize
          , v = void 0 === m ? 16 : m
          , g = n.allVariants
          , b = n.pxToRem
          , y = (0,
        eh.default)(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
        0;
        var w = a / 14
          , x = b || function(e) {
            return "".concat(e / v * w, "rem")
        }
          , _ = function(e, t, n, r, o) {
            return (0,
            Qf.default)({
                fontFamily: i,
                fontWeight: e,
                fontSize: x(t),
                lineHeight: n
            }, i === rh ? {
                letterSpacing: "".concat(th(r / t), "em")
            } : {}, {}, o, {}, g)
        }
          , C = {
            h1: _(l, 96, 1.167, -1.5),
            h2: _(l, 60, 1.2, -.5),
            h3: _(u, 48, 1.167, 0),
            h4: _(u, 34, 1.235, .25),
            h5: _(u, 24, 1.334, 0),
            h6: _(p, 20, 1.6, .15),
            subtitle1: _(u, 16, 1.75, .15),
            subtitle2: _(p, 14, 1.57, .1),
            body1: _(u, 16, 1.5, .15),
            body2: _(u, 14, 1.43, .15),
            button: _(p, 14, 1.75, .4, nh),
            caption: _(u, 12, 1.66, .4),
            overline: _(u, 12, 2.66, 1, nh)
        };
        return Zt((0,
        Qf.default)({
            htmlFontSize: v,
            pxToRem: x,
            round: th,
            fontFamily: i,
            fontSize: a,
            fontWeightLight: l,
            fontWeightRegular: u,
            fontWeightMedium: p,
            fontWeightBold: h
        }, C), y, {
            clone: !1
        })
    };
    Yf.default = Jf;
    var Qf = Xf(yp)
      , eh = Xf(Rp);
    function th(e) {
        return Math.round(1e5 * e) / 1e5
    }
    var nh = {
        textTransform: "uppercase"
    }
      , rh = '"Roboto", "Helvetica", "Arial", sans-serif';
    var ih = Op(Yf)
      , oh = {};
    Object.defineProperty(oh, "__esModule", {
        value: !0
    });
    var ah = void 0;
    oh.default = ah;
    function sh() {
        return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(.2, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(.14, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(.12, ")")].join(",")
    }
    ah = ["none", sh(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), sh(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), sh(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), sh(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), sh(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), sh(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), sh(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), sh(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), sh(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), sh(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), sh(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), sh(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), sh(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), sh(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), sh(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), sh(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), sh(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), sh(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), sh(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), sh(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), sh(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), sh(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), sh(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), sh(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)],
    oh.default = ah;
    var lh = Op(oh)
      , ch = {};
    Object.defineProperty(ch, "__esModule", {
        value: !0
    });
    var uh = void 0;
    ch.default = uh;
    uh = {
        borderRadius: 4
    },
    ch.default = uh;
    var dh = Op(ch)
      , ph = {};
    Object.defineProperty(ph, "__esModule", {
        value: !0
    });
    var fh = function() {
        var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8;
        if (t.mui)
            return t;
        e = "function" == typeof t ? t : function(e) {
            return t * e
        }
        ;
        var n = function() {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            return 0 === n.length ? e(1) : 1 === n.length ? e(n[0]) : n.map((function(t) {
                var n = e(t);
                return "number" == typeof n ? "".concat(n, "px") : n
            }
            )).join(" ")
        };
        return Object.defineProperty(n, "unit", {
            get: function() {
                return t
            }
        }),
        n.mui = !0,
        n
    };
    ph.default = fh;
    var hh = Op(ph)
      , mh = {}
      , vh = mp;
    Object.defineProperty(mh, "__esModule", {
        value: !0
    });
    var gh = (wh = void 0,
    _h = mh.easing = wh,
    mh.duration = _h);
    mh.default = gh;
    var bh = vh(Rp)
      , yh = {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    }
      , wh = yh;
    mh.easing = wh;
    var xh = {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195
    }
      , _h = xh;
    function Ch(e) {
        return "".concat(Math.round(e), "ms")
    }
    mh.duration = _h,
    gh = {
        easing: yh,
        duration: xh,
        create: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["all"]
              , t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
              , n = t.duration
              , r = void 0 === n ? xh.standard : n
              , i = t.easing
              , o = void 0 === i ? yh.easeInOut : i
              , a = t.delay
              , s = void 0 === a ? 0 : a;
            (0,
            bh.default)(t, ["duration", "easing", "delay"]);
            return (Array.isArray(e) ? e : [e]).map((function(e) {
                return "".concat(e, " ").concat("string" == typeof r ? r : Ch(r), " ").concat(o, " ").concat("string" == typeof s ? s : Ch(s))
            }
            )).join(",")
        },
        getAutoHeightDuration: function(e) {
            if (!e)
                return 0;
            var t = e / 36;
            return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5))
        }
    },
    mh.default = gh;
    var Sh = Op(mh)
      , Eh = {};
    Object.defineProperty(Eh, "__esModule", {
        value: !0
    });
    var kh = void 0;
    Eh.default = kh;
    kh = {
        mobileStepper: 1e3,
        speedDial: 1050,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500
    },
    Eh.default = kh;
    var Oh = Op(Eh);
    Tp = function() {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.breakpoints, n = void 0 === t ? {} : t, r = e.mixins, i = void 0 === r ? {} : r, o = e.palette, a = void 0 === o ? {} : o, s = e.spacing, l = e.typography, c = void 0 === l ? {} : l, u = (0,
        zp.default)(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = (0,
        Kf.default)(a), p = (0,
        Bp.default)(n), f = (0,
        hh.default)(s), h = Zt({
            breakpoints: p,
            direction: "ltr",
            mixins: (0,
            Gp.default)(p, f, i),
            overrides: {},
            palette: d,
            props: {},
            shadows: lh.default,
            typography: (0,
            ih.default)(d, c),
            spacing: f,
            shape: dh.default,
            transitions: Sh.default,
            zIndex: Oh.default
        }, u), m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++)
            v[g - 1] = arguments[g];
        return h = v.reduce((function(e, t) {
            return Zt(e, t)
        }
        ), h)
    }
    ,
    kp.default = Tp,
    Ep = (0,
    Sp(kp).default)(),
    Cp.default = Ep;
    var Th = gp(Cp);
    bp = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Ta(e, (0,
        _p.default)({
            defaultTheme: Th.default
        }, t))
    }
    ,
    vp.default = bp;
    var Mh = t(vp)
      , Rh = {}
      , Ph = mp;
    Object.defineProperty(Rh, "__esModule", {
        value: !0
    });
    var Ih = function() {
        return ji() || zh.default
    };
    Rh.default = Ih;
    var zh = Ph(Cp);
    var Ah = t(Rh)
      , Lh = function() {
        if ("undefined" != typeof Map)
            return Map;
        function e(e, t) {
            var n = -1;
            return e.some((function(e, r) {
                return e[0] === t && (n = r,
                !0)
            }
            )),
            n
        }
        return function() {
            function t() {
                this.__entries__ = []
            }
            return Object.defineProperty(t.prototype, "size", {
                get: function() {
                    return this.__entries__.length
                },
                enumerable: !0,
                configurable: !0
            }),
            t.prototype.get = function(t) {
                var n = e(this.__entries__, t)
                  , r = this.__entries__[n];
                return r && r[1]
            }
            ,
            t.prototype.set = function(t, n) {
                var r = e(this.__entries__, t);
                ~r ? this.__entries__[r][1] = n : this.__entries__.push([t, n])
            }
            ,
            t.prototype.delete = function(t) {
                var n = this.__entries__
                  , r = e(n, t);
                ~r && n.splice(r, 1)
            }
            ,
            t.prototype.has = function(t) {
                return !!~e(this.__entries__, t)
            }
            ,
            t.prototype.clear = function() {
                this.__entries__.splice(0)
            }
            ,
            t.prototype.forEach = function(e, t) {
                void 0 === t && (t = null);
                for (var n = 0, r = this.__entries__; n < r.length; n++) {
                    var i = r[n];
                    e.call(t, i[1], i[0])
                }
            }
            ,
            t
        }()
    }()
      , Dh = "undefined" != typeof window && "undefined" != typeof document && window.document === document
      , Nh = void 0 !== e && e.Math === Math ? e : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")()
      , Wh = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(Nh) : function(e) {
        return setTimeout((function() {
            return e(Date.now())
        }
        ), 1e3 / 60)
    }
    ;
    var Fh = ["top", "right", "bottom", "left", "width", "height", "size", "weight"]
      , $h = "undefined" != typeof MutationObserver
      , Bh = function() {
        function e() {
            this.connected_ = !1,
            this.mutationEventsAdded_ = !1,
            this.mutationsObserver_ = null,
            this.observers_ = [],
            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this),
            this.refresh = function(e, t) {
                var n = !1
                  , r = !1
                  , i = 0;
                function o() {
                    n && (n = !1,
                    e()),
                    r && s()
                }
                function a() {
                    Wh(o)
                }
                function s() {
                    var e = Date.now();
                    if (n) {
                        if (e - i < 2)
                            return;
                        r = !0
                    } else
                        n = !0,
                        r = !1,
                        setTimeout(a, t);
                    i = e
                }
                return s
            }(this.refresh.bind(this), 20)
        }
        return e.prototype.addObserver = function(e) {
            ~this.observers_.indexOf(e) || this.observers_.push(e),
            this.connected_ || this.connect_()
        }
        ,
        e.prototype.removeObserver = function(e) {
            var t = this.observers_
              , n = t.indexOf(e);
            ~n && t.splice(n, 1),
            !t.length && this.connected_ && this.disconnect_()
        }
        ,
        e.prototype.refresh = function() {
            this.updateObservers_() && this.refresh()
        }
        ,
        e.prototype.updateObservers_ = function() {
            var e = this.observers_.filter((function(e) {
                return e.gatherActive(),
                e.hasActive()
            }
            ));
            return e.forEach((function(e) {
                return e.broadcastActive()
            }
            )),
            e.length > 0
        }
        ,
        e.prototype.connect_ = function() {
            Dh && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_),
            window.addEventListener("resize", this.refresh),
            $h ? (this.mutationsObserver_ = new MutationObserver(this.refresh),
            this.mutationsObserver_.observe(document, {
                attributes: !0,
                childList: !0,
                characterData: !0,
                subtree: !0
            })) : (document.addEventListener("DOMSubtreeModified", this.refresh),
            this.mutationEventsAdded_ = !0),
            this.connected_ = !0)
        }
        ,
        e.prototype.disconnect_ = function() {
            Dh && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_),
            window.removeEventListener("resize", this.refresh),
            this.mutationsObserver_ && this.mutationsObserver_.disconnect(),
            this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh),
            this.mutationsObserver_ = null,
            this.mutationEventsAdded_ = !1,
            this.connected_ = !1)
        }
        ,
        e.prototype.onTransitionEnd_ = function(e) {
            var t = e.propertyName
              , n = void 0 === t ? "" : t;
            Fh.some((function(e) {
                return !!~n.indexOf(e)
            }
            )) && this.refresh()
        }
        ,
        e.getInstance = function() {
            return this.instance_ || (this.instance_ = new e),
            this.instance_
        }
        ,
        e.instance_ = null,
        e
    }()
      , jh = function(e, t) {
        for (var n = 0, r = Object.keys(t); n < r.length; n++) {
            var i = r[n];
            Object.defineProperty(e, i, {
                value: t[i],
                enumerable: !1,
                writable: !1,
                configurable: !0
            })
        }
        return e
    }
      , Hh = function(e) {
        return e && e.ownerDocument && e.ownerDocument.defaultView || Nh
    }
      , Vh = Yh(0, 0, 0, 0);
    function qh(e) {
        return parseFloat(e) || 0
    }
    function Uh(e) {
        for (var t = [], n = 1; n < arguments.length; n++)
            t[n - 1] = arguments[n];
        return t.reduce((function(t, n) {
            return t + qh(e["border-" + n + "-width"])
        }
        ), 0)
    }
    function Gh(e) {
        var t = e.clientWidth
          , n = e.clientHeight;
        if (!t && !n)
            return Vh;
        var r = Hh(e).getComputedStyle(e)
          , i = function(e) {
            for (var t = {}, n = 0, r = ["top", "right", "bottom", "left"]; n < r.length; n++) {
                var i = r[n]
                  , o = e["padding-" + i];
                t[i] = qh(o)
            }
            return t
        }(r)
          , o = i.left + i.right
          , a = i.top + i.bottom
          , s = qh(r.width)
          , l = qh(r.height);
        if ("border-box" === r.boxSizing && (Math.round(s + o) !== t && (s -= Uh(r, "left", "right") + o),
        Math.round(l + a) !== n && (l -= Uh(r, "top", "bottom") + a)),
        !function(e) {
            return e === Hh(e).document.documentElement
        }(e)) {
            var c = Math.round(s + o) - t
              , u = Math.round(l + a) - n;
            1 !== Math.abs(c) && (s -= c),
            1 !== Math.abs(u) && (l -= u)
        }
        return Yh(i.left, i.top, s, l)
    }
    var Zh = "undefined" != typeof SVGGraphicsElement ? function(e) {
        return e instanceof Hh(e).SVGGraphicsElement
    }
    : function(e) {
        return e instanceof Hh(e).SVGElement && "function" == typeof e.getBBox
    }
    ;
    function Kh(e) {
        return Dh ? Zh(e) ? function(e) {
            var t = e.getBBox();
            return Yh(0, 0, t.width, t.height)
        }(e) : Gh(e) : Vh
    }
    function Yh(e, t, n, r) {
        return {
            x: e,
            y: t,
            width: n,
            height: r
        }
    }
    var Xh = function() {
        function e(e) {
            this.broadcastWidth = 0,
            this.broadcastHeight = 0,
            this.contentRect_ = Yh(0, 0, 0, 0),
            this.target = e
        }
        return e.prototype.isActive = function() {
            var e = Kh(this.target);
            return this.contentRect_ = e,
            e.width !== this.broadcastWidth || e.height !== this.broadcastHeight
        }
        ,
        e.prototype.broadcastRect = function() {
            var e = this.contentRect_;
            return this.broadcastWidth = e.width,
            this.broadcastHeight = e.height,
            e
        }
        ,
        e
    }()
      , Jh = function(e, t) {
        var n, r, i, o, a, s, l, c = (r = (n = t).x,
        i = n.y,
        o = n.width,
        a = n.height,
        s = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object,
        l = Object.create(s.prototype),
        jh(l, {
            x: r,
            y: i,
            width: o,
            height: a,
            top: i,
            right: r + o,
            bottom: a + i,
            left: r
        }),
        l);
        jh(this, {
            target: e,
            contentRect: c
        })
    }
      , Qh = function() {
        function e(e, t, n) {
            if (this.activeObservations_ = [],
            this.observations_ = new Lh,
            "function" != typeof e)
                throw new TypeError("The callback provided as parameter 1 is not a function.");
            this.callback_ = e,
            this.controller_ = t,
            this.callbackCtx_ = n
        }
        return e.prototype.observe = function(e) {
            if (!arguments.length)
                throw new TypeError("1 argument required, but only 0 present.");
            if ("undefined" != typeof Element && Element instanceof Object) {
                if (!(e instanceof Hh(e).Element))
                    throw new TypeError('parameter 1 is not of type "Element".');
                var t = this.observations_;
                t.has(e) || (t.set(e, new Xh(e)),
                this.controller_.addObserver(this),
                this.controller_.refresh())
            }
        }
        ,
        e.prototype.unobserve = function(e) {
            if (!arguments.length)
                throw new TypeError("1 argument required, but only 0 present.");
            if ("undefined" != typeof Element && Element instanceof Object) {
                if (!(e instanceof Hh(e).Element))
                    throw new TypeError('parameter 1 is not of type "Element".');
                var t = this.observations_;
                t.has(e) && (t.delete(e),
                t.size || this.controller_.removeObserver(this))
            }
        }
        ,
        e.prototype.disconnect = function() {
            this.clearActive(),
            this.observations_.clear(),
            this.controller_.removeObserver(this)
        }
        ,
        e.prototype.gatherActive = function() {
            var e = this;
            this.clearActive(),
            this.observations_.forEach((function(t) {
                t.isActive() && e.activeObservations_.push(t)
            }
            ))
        }
        ,
        e.prototype.broadcastActive = function() {
            if (this.hasActive()) {
                var e = this.callbackCtx_
                  , t = this.activeObservations_.map((function(e) {
                    return new Jh(e.target,e.broadcastRect())
                }
                ));
                this.callback_.call(e, t, e),
                this.clearActive()
            }
        }
        ,
        e.prototype.clearActive = function() {
            this.activeObservations_.splice(0)
        }
        ,
        e.prototype.hasActive = function() {
            return this.activeObservations_.length > 0
        }
        ,
        e
    }()
      , em = "undefined" != typeof WeakMap ? new WeakMap : new Lh
      , tm = function e(t) {
        if (!(this instanceof e))
            throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length)
            throw new TypeError("1 argument required, but only 0 present.");
        var n = Bh.getInstance()
          , r = new Qh(t,n,this);
        em.set(this, r)
    };
    ["observe", "unobserve", "disconnect"].forEach((function(e) {
        tm.prototype[e] = function() {
            var t;
            return (t = em.get(this))[e].apply(t, arguments)
        }
    }
    ));
    var nm = void 0 !== Nh.ResizeObserver ? Nh.ResizeObserver : tm;
    function rm(e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t)
    }
    var im = "object" == typeof e && e && e.Object === Object && e
      , om = "object" == typeof self && self && self.Object === Object && self
      , am = im || om || Function("return this")()
      , sm = function() {
        return am.Date.now()
    }
      , lm = am.Symbol
      , cm = Object.prototype
      , um = cm.hasOwnProperty
      , dm = cm.toString
      , pm = lm ? lm.toStringTag : void 0;
    var fm = Object.prototype.toString;
    var hm = lm ? lm.toStringTag : void 0;
    function mm(e) {
        return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : hm && hm in Object(e) ? function(e) {
            var t = um.call(e, pm)
              , n = e[pm];
            try {
                e[pm] = void 0;
                var r = !0
            } catch (e) {}
            var i = dm.call(e);
            return r && (t ? e[pm] = n : delete e[pm]),
            i
        }(e) : function(e) {
            return fm.call(e)
        }(e)
    }
    var vm = /^\s+|\s+$/g
      , gm = /^[-+]0x[0-9a-f]+$/i
      , bm = /^0b[01]+$/i
      , ym = /^0o[0-7]+$/i
      , wm = parseInt;
    function xm(e) {
        if ("number" == typeof e)
            return e;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return null != e && "object" == typeof e
            }(e) && "[object Symbol]" == mm(e)
        }(e))
            return NaN;
        if (rm(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = rm(t) ? t + "" : t
        }
        if ("string" != typeof e)
            return 0 === e ? e : +e;
        e = e.replace(vm, "");
        var n = bm.test(e);
        return n || ym.test(e) ? wm(e.slice(2), n ? 2 : 8) : gm.test(e) ? NaN : +e
    }
    var _m = Math.max
      , Cm = Math.min;
    function Sm(e, t, n) {
        var r, i, o, a, s, l, c = 0, u = !1, d = !1, p = !0;
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        function f(t) {
            var n = r
              , o = i;
            return r = i = void 0,
            c = t,
            a = e.apply(o, n)
        }
        function h(e) {
            return c = e,
            s = setTimeout(v, t),
            u ? f(e) : a
        }
        function m(e) {
            var n = e - l;
            return void 0 === l || n >= t || n < 0 || d && e - c >= o
        }
        function v() {
            var e = sm();
            if (m(e))
                return g(e);
            s = setTimeout(v, function(e) {
                var n = t - (e - l);
                return d ? Cm(n, o - (e - c)) : n
            }(e))
        }
        function g(e) {
            return s = void 0,
            p && r ? f(e) : (r = i = void 0,
            a)
        }
        function b() {
            var e = sm()
              , n = m(e);
            if (r = arguments,
            i = this,
            l = e,
            n) {
                if (void 0 === s)
                    return h(l);
                if (d)
                    return clearTimeout(s),
                    s = setTimeout(v, t),
                    f(l)
            }
            return void 0 === s && (s = setTimeout(v, t)),
            a
        }
        return t = xm(t) || 0,
        rm(n) && (u = !!n.leading,
        o = (d = "maxWait"in n) ? _m(xm(n.maxWait) || 0, t) : o,
        p = "trailing"in n ? !!n.trailing : p),
        b.cancel = function() {
            void 0 !== s && clearTimeout(s),
            c = 0,
            r = l = i = s = void 0
        }
        ,
        b.flush = function() {
            return void 0 === s ? a : g(sm())
        }
        ,
        b
    }
    var Em = {
        debounce: Sm,
        throttle: function(e, t, n) {
            var r = !0
              , i = !0;
            if ("function" != typeof e)
                throw new TypeError("Expected a function");
            return rm(n) && (r = "leading"in n ? !!n.leading : r,
            i = "trailing"in n ? !!n.trailing : i),
            Sm(e, t, {
                leading: r,
                maxWait: t,
                trailing: i
            })
        }
    }
      , km = function(e) {
        return "function" == typeof e
    }
      , Om = function() {
        return "undefined" == typeof window
    };
    function Tm(e) {
        return (Tm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        )(e)
    }
    function Mm(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function Rm(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function Pm(e, t) {
        return !t || "object" !== Tm(t) && "function" != typeof t ? function(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }(e) : t
    }
    function Im(e) {
        return (Im = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        }
        )(e)
    }
    function zm(e, t) {
        return (zm = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t,
            e
        }
        )(e, t)
    }
    var Am = function(e) {
        function t() {
            return Mm(this, t),
            Pm(this, Im(t).apply(this, arguments))
        }
        var n, r, i;
        return function(e, t) {
            if ("function" != typeof t && null !== t)
                throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            t && zm(e, t)
        }(t, e),
        n = t,
        (r = [{
            key: "render",
            value: function() {
                return this.props.children
            }
        }]) && Rm(n.prototype, r),
        i && Rm(n, i),
        t
    }(Ce);
    function Lm(e) {
        return (Lm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        )(e)
    }
    function Dm(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function Nm(e) {
        return (Nm = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        }
        )(e)
    }
    function Wm(e) {
        if (void 0 === e)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }
    function Fm(e, t) {
        return (Fm = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t,
            e
        }
        )(e, t)
    }
    function $m(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    var Bm = function(e) {
        function t(e) {
            var n;
            !function(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }(this, t),
            n = function(e, t) {
                return !t || "object" !== Lm(t) && "function" != typeof t ? Wm(e) : t
            }(this, Nm(t).call(this, e)),
            $m(Wm(n), "cancelHandler", (function() {
                n.resizeHandler && n.resizeHandler.cancel && (n.resizeHandler.cancel(),
                n.resizeHandler = null)
            }
            )),
            $m(Wm(n), "rafClean", (function() {
                n.raf && n.raf.cancel && (n.raf.cancel(),
                n.raf = null)
            }
            )),
            $m(Wm(n), "toggleObserver", (function(e) {
                var t = n.getElement();
                t && n.resizeObserver[e] && n.resizeObserver[e](t)
            }
            )),
            $m(Wm(n), "getElement", (function() {
                var e = n.props
                  , t = e.querySelector
                  , r = e.targetDomEl;
                if (!Om()) {
                    if (t)
                        return document.querySelector(t);
                    if (r && ((i = r)instanceof Element || i instanceof HTMLDocument))
                        return r;
                    var i, o = n.element && ot(n.element);
                    if (o)
                        return o.parentElement
                }
            }
            )),
            $m(Wm(n), "createUpdater", (function() {
                return n.rafClean(),
                n.raf = function(e) {
                    var t = []
                      , n = null
                      , r = function() {
                        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
                            i[o] = arguments[o];
                        t = i,
                        n || (n = requestAnimationFrame((function() {
                            n = null,
                            e.apply(void 0, t)
                        }
                        )))
                    };
                    return r.cancel = function() {
                        n && (cancelAnimationFrame(n),
                        n = null)
                    }
                    ,
                    r
                }((function(e) {
                    var t = e.width
                      , r = e.height
                      , i = n.props.onResize;
                    km(i) && i(t, r),
                    n.setState({
                        width: t,
                        height: r
                    })
                }
                )),
                n.raf
            }
            )),
            $m(Wm(n), "createResizeHandler", (function(e) {
                var t = n.state
                  , r = t.width
                  , i = t.height
                  , o = n.props
                  , a = o.handleWidth
                  , s = o.handleHeight;
                if (a || s) {
                    var l = n.createUpdater();
                    e.forEach((function(e) {
                        var t = e && e.contentRect || {}
                          , o = t.width
                          , c = t.height
                          , u = a && r !== o || s && i !== c;
                        !n.skipOnMount && u && !Om() && l({
                            width: o,
                            height: c
                        }),
                        n.skipOnMount = !1
                    }
                    ))
                }
            }
            )),
            $m(Wm(n), "onRef", (function(e) {
                n.element = e
            }
            )),
            $m(Wm(n), "getRenderType", (function() {
                var e = n.props
                  , t = e.render
                  , r = e.children;
                return km(t) ? "renderProp" : km(r) ? "childFunction" : nt(r) ? "child" : Array.isArray(r) ? "childArray" : "parent"
            }
            )),
            $m(Wm(n), "getTargetComponent", (function() {
                var e = n.props
                  , t = e.render
                  , r = e.children
                  , i = e.nodeType
                  , o = n.state
                  , a = {
                    width: o.width,
                    height: o.height
                };
                switch (n.getRenderType()) {
                case "renderProp":
                    return rt(t(a), {
                        key: "resize-detector"
                    });
                case "childFunction":
                    return rt(r(a));
                case "child":
                    return rt(r, a);
                case "childArray":
                    return r.map((function(e) {
                        return !!e && rt(e, a)
                    }
                    ));
                default:
                    return V().createElement(i)
                }
            }
            ));
            var r = e.skipOnMount
              , i = e.refreshMode
              , o = e.refreshRate
              , a = e.refreshOptions;
            n.state = {
                width: void 0,
                height: void 0
            },
            n.skipOnMount = r,
            n.raf = null,
            n.element = null,
            n.unmounted = !1;
            var s = Em[i];
            return n.resizeHandler = s ? s(n.createResizeHandler, o, a) : n.createResizeHandler,
            n.resizeObserver = new nm(n.resizeHandler),
            n
        }
        var n, r, i;
        return function(e, t) {
            if ("function" != typeof t && null !== t)
                throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            t && Fm(e, t)
        }(t, e),
        n = t,
        (r = [{
            key: "componentDidMount",
            value: function() {
                this.toggleObserver("observe")
            }
        }, {
            key: "componentWillUnmount",
            value: function() {
                this.toggleObserver("unobserve"),
                this.rafClean(),
                this.cancelHandler(),
                this.unmounted = !0
            }
        }, {
            key: "render",
            value: function() {
                return lt.createElement(Am, {
                    ref: this.onRef
                }, this.getTargetComponent())
            }
        }]) && Dm(n.prototype, r),
        i && Dm(n, i),
        t
    }(Ce);
    Bm.propTypes = {
        handleWidth: rn.bool,
        handleHeight: rn.bool,
        skipOnMount: rn.bool,
        refreshRate: rn.number,
        refreshMode: rn.string,
        refreshOptions: rn.shape({
            leading: rn.bool,
            trailing: rn.bool
        }),
        querySelector: rn.string,
        targetDomEl: rn.any,
        onResize: rn.func,
        render: rn.func,
        children: rn.any,
        nodeType: rn.node
    },
    Bm.defaultProps = {
        handleWidth: !1,
        handleHeight: !1,
        skipOnMount: !1,
        refreshRate: 1e3,
        refreshMode: void 0,
        refreshOptions: void 0,
        querySelector: null,
        targetDomEl: null,
        onResize: null,
        render: void 0,
        children: null,
        nodeType: "div"
    };
    var jm = Bm
      , Hm = {}
      , Vm = mp;
    Object.defineProperty(Hm, "__esModule", {
        value: !0
    });
    var qm = void 0;
    Hm.default = qm;
    var Um = Vm(f)
      , Gm = {}
      , Zm = mp;
    Object.defineProperty(Gm, "__esModule", {
        value: !0
    });
    var Km = function(e, t) {
        var n = Xm.default.memo(Xm.default.forwardRef((function(t, n) {
            return Xm.default.createElement(Jm.default, (0,
            Ym.default)({
                ref: n
            }, t), e)
        }
        )));
        0;
        return n.muiName = Jm.default.muiName,
        n
    };
    Gm.default = Km;
    var Ym = Zm(yp)
      , Xm = Zm(f)
      , Jm = Zm(wl);
    qm = (0,
    Vm(Gm).default)(Um.default.createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }), "KeyboardArrowLeft"),
    Hm.default = qm;
    var Qm = t(Hm)
      , ev = {}
      , tv = mp;
    Object.defineProperty(ev, "__esModule", {
        value: !0
    });
    var nv = void 0;
    ev.default = nv;
    var rv = tv(f);
    nv = (0,
    tv(Gm).default)(rv.default.createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }), "KeyboardArrowRight"),
    ev.default = nv;
    var iv = t(ev)
      , ov = {}
      , av = mp;
    Object.defineProperty(ov, "__esModule", {
        value: !0
    });
    var sv = void 0;
    ov.default = sv;
    var lv = av(f);
    sv = (0,
    av(Gm).default)(lv.default.createElement("path", {
        d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
    }), "KeyboardArrowDown"),
    ov.default = sv;
    var cv = t(ov)
      , uv = {}
      , dv = mp;
    Object.defineProperty(uv, "__esModule", {
        value: !0
    });
    var pv = void 0;
    uv.default = pv;
    var fv = dv(f);
    pv = (0,
    dv(Gm).default)(fv.default.createElement("path", {
        d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
    }), "KeyboardArrowUp"),
    uv.default = pv;
    var hv = t(uv)
      , mv = {}
      , vv = {}
      , gv = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
    if (gv) {
        var bv = new Uint8Array(16);
        vv = function() {
            return gv(bv),
            bv
        }
    } else {
        var yv = new Array(16);
        vv = function() {
            for (var e, t = 0; t < 16; t++)
                0 == (3 & t) && (e = 4294967296 * Math.random()),
                yv[t] = e >>> ((3 & t) << 3) & 255;
            return yv
        }
    }
    for (var wv, xv = vv, _v = [], Cv = 0; Cv < 256; ++Cv)
        _v[Cv] = (Cv + 256).toString(16).substr(1);
    var Sv, Ev, kv = wv = function(e, t) {
        var n = t || 0
          , r = _v;
        return [r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]]].join("")
    }
    , Ov = 0, Tv = 0;
    var Mv = function(e, t, n) {
        var r = t && n || 0
          , i = t || []
          , o = (e = e || {}).node || Sv
          , a = void 0 !== e.clockseq ? e.clockseq : Ev;
        if (null == o || null == a) {
            var s = xv();
            null == o && (o = Sv = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]),
            null == a && (a = Ev = 16383 & (s[6] << 8 | s[7]))
        }
        var l = void 0 !== e.msecs ? e.msecs : (new Date).getTime()
          , c = void 0 !== e.nsecs ? e.nsecs : Tv + 1
          , u = l - Ov + (c - Tv) / 1e4;
        if (u < 0 && void 0 === e.clockseq && (a = a + 1 & 16383),
        (u < 0 || l > Ov) && void 0 === e.nsecs && (c = 0),
        c >= 1e4)
            throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
        Ov = l,
        Tv = c,
        Ev = a;
        var d = (1e4 * (268435455 & (l += 122192928e5)) + c) % 4294967296;
        i[r++] = d >>> 24 & 255,
        i[r++] = d >>> 16 & 255,
        i[r++] = d >>> 8 & 255,
        i[r++] = 255 & d;
        var p = l / 4294967296 * 1e4 & 268435455;
        i[r++] = p >>> 8 & 255,
        i[r++] = 255 & p,
        i[r++] = p >>> 24 & 15 | 16,
        i[r++] = p >>> 16 & 255,
        i[r++] = a >>> 8 | 128,
        i[r++] = 255 & a;
        for (var f = 0; f < 6; ++f)
            i[r + f] = o[f];
        return t || kv(i)
    }
      , Rv = vv
      , Pv = wv;
    var Iv = function(e, t, n) {
        var r = t && n || 0;
        "string" == typeof e && (t = "binary" === e ? new Array(16) : null,
        e = null);
        var i = (e = e || {}).random || (e.rng || Rv)();
        if (i[6] = 15 & i[6] | 64,
        i[8] = 63 & i[8] | 128,
        t)
            for (var o = 0; o < 16; ++o)
                t[r + o] = i[o];
        return t || Pv(i)
    }
      , zv = Iv;
    zv.v1 = Mv,
    zv.v4 = Iv,
    mv = zv;
    var Av, Lv, Dv = !1;
    function Nv(e) {
        return (Nv = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        )(e)
    }
    function Wv(e) {
        return Lv ? e instanceof HTMLElement : e && "object" === Nv(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
    }
    function Fv(e, t) {
        t.forEach((function(t) {
            e.classList.add(t)
        }
        ))
    }
    function $v(e, t) {
        t.forEach((function(t) {
            e.classList.remove(t)
        }
        ))
    }
    function Bv() {
        return Dv || (Dv = !0,
        Av = {},
        Lv = "object" === ("undefined" == typeof HTMLElement ? "undefined" : Nv(HTMLElement)),
        r(Av, "isDOMElement", (function() {
            return Wv
        }
        )),
        r(Av, "addClasses", (function() {
            return Fv
        }
        )),
        r(Av, "removeClasses", (function() {
            return $v
        }
        ))),
        Av
    }
    var jv, Hv, Vv = !1;
    function qv() {
        if (!document.querySelector(".pwzrdrift-base-styles")) {
            var e = document.createElement("style");
            e.type = "text/css",
            e.classList.add("pwzrdrift-base-styles"),
            e.appendChild(document.createTextNode(Hv));
            var t = document.head;
            t.insertBefore(e, t.firstChild)
        }
    }
    function Uv() {
        return Vv || (Vv = !0,
        Hv = ".pwzrdrift-bounding-box,.pwzrdrift-zoom-pane{position:absolute;pointer-events:none}@keyframes pwzrnoop{0%{zoom:1}}@-webkit-keyframes pwzrnoop{0%{zoom:1}}.pwzrdrift-zoom-pane.pwzrdrift-open{display:block}.pwzrdrift-zoom-pane.pwzrdrift-closing,.pwzrdrift-zoom-pane.pwzrdrift-opening{animation:pwzrnoop 1ms;-webkit-animation:pwzrnoop 1ms}.pwzrdrift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.pwzrdrift-zoom-pane-loader{display:none}.pwzrdrift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}",
        r(jv = {}, "default", (function() {
            return qv
        }
        ))),
        jv
    }
    var Gv, Zv = !1;
    function Kv() {
        throw new Error("Missing parameter")
    }
    function Yv() {
        return Zv || (Zv = !0,
        r(Gv = {}, "default", (function() {
            return Kv
        }
        ))),
        Gv
    }
    var Xv, Jv, Qv = !1;
    function eg(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function tg() {
        Xv = {},
        Yv(),
        Bv(),
        Jv = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e),
                this.isShowing = !1;
                var n = t.namespace
                  , r = void 0 === n ? null : n
                  , i = t.zoomFactor
                  , o = void 0 === i ? Yv().default() : i
                  , a = t.containerEl
                  , s = void 0 === a ? Yv().default() : a;
                this.settings = {
                    namespace: r,
                    zoomFactor: o,
                    containerEl: s
                },
                this.openClasses = this._buildClasses("open"),
                this._buildElement()
            }
            var t, n, r;
            return t = e,
            (n = [{
                key: "_buildClasses",
                value: function(e) {
                    var t = ["pwzrdrift-".concat(e)]
                      , n = this.settings.namespace;
                    return n && t.push("".concat(n, "-").concat(e)),
                    t
                }
            }, {
                key: "_buildElement",
                value: function() {
                    this.el = document.createElement("div"),
                    Bv().addClasses(this.el, this._buildClasses("bounding-box"))
                }
            }, {
                key: "show",
                value: function(e, t) {
                    this.isShowing = !0,
                    this.settings.containerEl.appendChild(this.el);
                    var n = this.el.style;
                    n.width = "".concat(Math.round(e / this.settings.zoomFactor), "px"),
                    n.height = "".concat(Math.round(t / this.settings.zoomFactor), "px"),
                    Bv().addClasses(this.el, this.openClasses)
                }
            }, {
                key: "hide",
                value: function() {
                    this.isShowing && this.settings.containerEl.removeChild(this.el),
                    this.isShowing = !1,
                    Bv().removeClasses(this.el, this.openClasses)
                }
            }, {
                key: "setPosition",
                value: function(e, t, n) {
                    var r = window.pageXOffset
                      , i = window.pageYOffset
                      , o = n.left + e * n.width - this.el.clientWidth / 2 + r
                      , a = n.top + t * n.height - this.el.clientHeight / 2 + i;
                    o < n.left + r ? o = n.left + r : o + this.el.clientWidth > n.left + n.width + r && (o = n.left + n.width - this.el.clientWidth + r),
                    a < n.top + i ? a = n.top + i : a + this.el.clientHeight > n.top + n.height + i && (a = n.top + n.height - this.el.clientHeight + i),
                    this.el.style.left = "".concat(o, "px"),
                    this.el.style.top = "".concat(a, "px")
                }
            }]) && eg(t.prototype, n),
            r && eg(t, r),
            e
        }(),
        r(Xv, "default", (function() {
            return Jv
        }
        ))
    }
    function ng() {
        return Qv || (Qv = !0,
        tg()),
        Xv
    }
    var rg, ig, og = !1;
    function ag(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function sg(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function lg() {
        rg = {},
        Yv(),
        ng(),
        ig = function() {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                ag(this, e),
                this._show = this._show.bind(this),
                this._hide = this._hide.bind(this),
                this._handleEntry = this._handleEntry.bind(this),
                this._handleMovement = this._handleMovement.bind(this);
                var n = t.el
                  , r = void 0 === n ? Yv().default() : n
                  , i = t.zoomPane
                  , o = void 0 === i ? Yv().default() : i
                  , a = t.sourceAttribute
                  , s = void 0 === a ? Yv().default() : a
                  , l = t.handleTouch
                  , c = void 0 === l ? Yv().default() : l
                  , u = t.onShow
                  , d = void 0 === u ? null : u
                  , p = t.onHide
                  , f = void 0 === p ? null : p
                  , h = t.hoverDelay
                  , m = void 0 === h ? 0 : h
                  , v = t.touchDelay
                  , g = void 0 === v ? 0 : v
                  , b = t.hoverBoundingBox
                  , y = void 0 === b ? Yv().default() : b
                  , w = t.touchBoundingBox
                  , x = void 0 === w ? Yv().default() : w
                  , _ = t.namespace
                  , C = void 0 === _ ? null : _
                  , S = t.zoomFactor
                  , E = void 0 === S ? Yv().default() : S
                  , k = t.boundingBoxContainer
                  , O = void 0 === k ? Yv().default() : k
                  , T = t.inlineContainer
                  , M = void 0 === T ? Yv().default() : T;
                this.settings = {
                    el: r,
                    zoomPane: o,
                    sourceAttribute: s,
                    handleTouch: c,
                    onShow: d,
                    onHide: f,
                    hoverDelay: m,
                    touchDelay: g,
                    hoverBoundingBox: y,
                    touchBoundingBox: x,
                    namespace: C,
                    zoomFactor: E,
                    boundingBoxContainer: O,
                    inlineContainer: M
                },
                (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new (ng().default)({
                    namespace: this.settings.namespace,
                    zoomFactor: this.settings.zoomFactor,
                    containerEl: this.settings.boundingBoxContainer
                })),
                this.enabled = !0,
                this._bindEvents()
            }
            var t, n, r;
            return t = e,
            (n = [{
                key: "_preventDefault",
                value: function(e) {
                    e.preventDefault()
                }
            }, {
                key: "_preventDefaultAllowTouchScroll",
                value: function(e) {
                    this.settings.touchDelay && this._isTouchEvent(e) && !this.isShowing || e.preventDefault()
                }
            }, {
                key: "_isTouchEvent",
                value: function(e) {
                    return !!e.touches
                }
            }, {
                key: "_bindEvents",
                value: function() {
                    this.settings.el.addEventListener("mouseenter", this._handleEntry, !1),
                    this.settings.el.addEventListener("mouseleave", this._hide, !1),
                    this.settings.el.addEventListener("mousemove", this._handleMovement, !1),
                    this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, !1),
                    this.settings.el.addEventListener("touchend", this._hide, !1),
                    this.settings.el.addEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, !1),
                    this.settings.el.addEventListener("touchend", this._preventDefault, !1),
                    this.settings.el.addEventListener("touchmove", this._preventDefault, !1))
                }
            }, {
                key: "_unbindEvents",
                value: function() {
                    this.settings.el.removeEventListener("mouseenter", this._handleEntry, !1),
                    this.settings.el.removeEventListener("mouseleave", this._hide, !1),
                    this.settings.el.removeEventListener("mousemove", this._handleMovement, !1),
                    this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry, !1),
                    this.settings.el.removeEventListener("touchend", this._hide, !1),
                    this.settings.el.removeEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault, !1),
                    this.settings.el.removeEventListener("touchend", this._preventDefault, !1),
                    this.settings.el.removeEventListener("touchmove", this._preventDefault, !1))
                }
            }, {
                key: "_handleEntry",
                value: function(e) {
                    this._preventDefaultAllowTouchScroll(e),
                    this._lastMovement = e,
                    "mouseenter" == e.type && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show()
                }
            }, {
                key: "_show",
                value: function() {
                    if (this.enabled) {
                        var e = this.settings.onShow;
                        if (e && "function" == typeof e && e(),
                        this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight),
                        this._lastMovement) {
                            var t = this._lastMovement.touches;
                            (t && this.settings.touchBoundingBox || !t && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight)
                        }
                        this._handleMovement()
                    }
                }
            }, {
                key: "_hide",
                value: function(e) {
                    e && this._preventDefaultAllowTouchScroll(e),
                    this._lastMovement = null,
                    this.entryTimeout && clearTimeout(this.entryTimeout),
                    this.boundingBox && this.boundingBox.hide();
                    var t = this.settings.onHide;
                    t && "function" == typeof t && t(),
                    this.settings.zoomPane.hide()
                }
            }, {
                key: "_handleMovement",
                value: function(e) {
                    if (e)
                        this._preventDefaultAllowTouchScroll(e),
                        this._lastMovement = e;
                    else {
                        if (!this._lastMovement)
                            return;
                        e = this._lastMovement
                    }
                    var t, n;
                    if (e.touches) {
                        var r = e.touches[0];
                        t = r.clientX,
                        n = r.clientY
                    } else
                        t = e.clientX,
                        n = e.clientY;
                    var i = this.settings.el.getBoundingClientRect()
                      , o = t - i.left
                      , a = n - i.top
                      , s = o / this.settings.el.clientWidth
                      , l = a / this.settings.el.clientHeight
                      , c = this.settings.inlineContainer.getBoundingClientRect()
                      , u = {
                        left: i.left - c.left,
                        top: i.top - c.top,
                        width: i.width,
                        height: i.height
                    };
                    this.boundingBox && this.boundingBox.setPosition(s, l, u),
                    this.settings.zoomPane.setPosition(s, l, u)
                }
            }, {
                key: "isShowing",
                get: function() {
                    return this.settings.zoomPane.isShowing
                }
            }]) && sg(t.prototype, n),
            r && sg(t, r),
            e
        }(),
        r(rg, "default", (function() {
            return ig
        }
        ))
    }
    function cg() {
        return og || (og = !0,
        lg()),
        rg
    }
    var ug, dg, pg, fg, hg = !1;
    function mg(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function vg(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function gg() {
        ug = {},
        Yv(),
        Bv(),
        dg = document.createElement("div").style,
        pg = "undefined" != typeof document && ("animation"in dg || "webkitAnimation"in dg),
        fg = function() {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                mg(this, e),
                this._completeShow = this._completeShow.bind(this),
                this._completeHide = this._completeHide.bind(this),
                this._handleLoad = this._handleLoad.bind(this),
                this.isShowing = !1;
                var n = t.container
                  , r = void 0 === n ? null : n
                  , i = t.zoomFactor
                  , o = void 0 === i ? Yv().default() : i
                  , a = t.inline
                  , s = void 0 === a ? Yv().default() : a
                  , l = t.namespace
                  , c = void 0 === l ? null : l
                  , u = t.showWhitespaceAtEdges
                  , d = void 0 === u ? Yv().default() : u
                  , p = t.containInline
                  , f = void 0 === p ? Yv().default() : p
                  , h = t.inlineOffsetX
                  , m = void 0 === h ? 0 : h
                  , v = t.inlineOffsetY
                  , g = void 0 === v ? 0 : v
                  , b = t.inlineContainer
                  , y = void 0 === b ? document.body : b;
                this.settings = {
                    container: r,
                    zoomFactor: o,
                    inline: s,
                    namespace: c,
                    showWhitespaceAtEdges: d,
                    containInline: f,
                    inlineOffsetX: m,
                    inlineOffsetY: g,
                    inlineContainer: y
                },
                this.openClasses = this._buildClasses("open"),
                this.openingClasses = this._buildClasses("opening"),
                this.closingClasses = this._buildClasses("closing"),
                this.inlineClasses = this._buildClasses("inline"),
                this.loadingClasses = this._buildClasses("loading"),
                this._buildElement()
            }
            var t, n, r;
            return t = e,
            (n = [{
                key: "_buildClasses",
                value: function(e) {
                    var t = ["pwzrdrift-".concat(e)]
                      , n = this.settings.namespace;
                    return n && t.push("".concat(n, "-").concat(e)),
                    t
                }
            }, {
                key: "_buildElement",
                value: function() {
                    this.el = document.createElement("div"),
                    Bv().addClasses(this.el, this._buildClasses("zoom-pane"));
                    var e = document.createElement("div");
                    Bv().addClasses(e, this._buildClasses("zoom-pane-loader")),
                    this.el.appendChild(e),
                    this.imgEl = document.createElement("img"),
                    this.el.appendChild(this.imgEl)
                }
            }, {
                key: "_setImageURL",
                value: function(e) {
                    this.imgEl.setAttribute("src", e)
                }
            }, {
                key: "_setImageSize",
                value: function(e, t) {
                    this.imgEl.style.width = "".concat(e * this.settings.zoomFactor, "px"),
                    this.imgEl.style.height = "".concat(t * this.settings.zoomFactor, "px"),
                    this.imgEl.style.maxWidth = "none"
                }
            }, {
                key: "setPosition",
                value: function(e, t, n) {
                    var r = this.imgEl.offsetWidth
                      , i = this.imgEl.offsetHeight
                      , o = this.el.offsetWidth
                      , a = this.el.offsetHeight
                      , s = o / 2 - r * e
                      , l = a / 2 - i * t
                      , c = o - r
                      , u = a - i
                      , d = c > 0
                      , p = u > 0
                      , f = d ? c / 2 : 0
                      , h = p ? u / 2 : 0
                      , m = d ? c / 2 : c
                      , v = p ? u / 2 : u;
                    if (this.el.parentElement === this.settings.inlineContainer) {
                        var g = n.left + e * n.width - o / 2 + this.settings.inlineOffsetX + 0
                          , b = n.top + t * n.height - a / 2 + this.settings.inlineOffsetY + 0;
                        this.settings.containInline && (g < n.left + 0 ? g = n.left + 0 : g + o > n.left + n.width + 0 && (g = n.left + n.width - o + 0),
                        b < n.top + 0 ? b = n.top + 0 : b + a > n.top + n.height + 0 && (b = n.top + n.height - a + 0)),
                        "yes" === getComputedStyle(this.el).getPropertyValue("--magnify-width-full") && (g = 0),
                        "yes" === getComputedStyle(this.el).getPropertyValue("--magnify-height-full") && (b = 0),
                        this.el.style.left = "".concat(g, "px"),
                        this.el.style.top = "".concat(b, "px")
                    }
                    this.settings.showWhitespaceAtEdges || (s > f ? s = f : s < m && (s = m),
                    l > h ? l = h : l < v && (l = v)),
                    this.imgEl.style.transform = "translate(".concat(s, "px, ").concat(l, "px)"),
                    this.imgEl.style.webkitTransform = "translate(".concat(s, "px, ").concat(l, "px)")
                }
            }, {
                key: "_removeListenersAndResetClasses",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeShow, !1),
                    this.el.removeEventListener("animationend", this._completeHide, !1),
                    this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1),
                    this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1),
                    Bv().removeClasses(this.el, this.openClasses),
                    Bv().removeClasses(this.el, this.closingClasses)
                }
            }, {
                key: "show",
                value: function(e, t, n) {
                    if (this._removeListenersAndResetClasses(),
                    this.isShowing = !0,
                    Bv().addClasses(this.el, this.openClasses),
                    this.imgEl.getAttribute("src") != e) {
                        var r = this.el.querySelector(".pwzrdrift-zoom-pane-loader");
                        r && (r.style.display = "block"),
                        Bv().addClasses(this.el, this.loadingClasses),
                        this.imgEl.addEventListener("load", this._handleLoad, !1),
                        this._setImageURL(e)
                    }
                    this._setImageSize(t, n),
                    this._isInline ? this._showInline() : this._showInContainer(),
                    pg && (this.el.addEventListener("animationend", this._completeShow, !1),
                    this.el.addEventListener("webkitAnimationEnd", this._completeShow, !1),
                    Bv().addClasses(this.el, this.openingClasses))
                }
            }, {
                key: "_showInline",
                value: function() {
                    this.settings.inlineContainer.appendChild(this.el),
                    Bv().addClasses(this.el, this.inlineClasses)
                }
            }, {
                key: "_showInContainer",
                value: function() {
                    this.settings.container.appendChild(this.el)
                }
            }, {
                key: "hide",
                value: function() {
                    this._removeListenersAndResetClasses(),
                    this.isShowing = !1,
                    pg ? (this.el.addEventListener("animationend", this._completeHide, !1),
                    this.el.addEventListener("webkitAnimationEnd", this._completeHide, !1),
                    Bv().addClasses(this.el, this.closingClasses)) : (Bv().removeClasses(this.el, this.openClasses),
                    Bv().removeClasses(this.el, this.inlineClasses))
                }
            }, {
                key: "_completeShow",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeShow, !1),
                    this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1),
                    Bv().removeClasses(this.el, this.openingClasses)
                }
            }, {
                key: "_completeHide",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeHide, !1),
                    this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1),
                    Bv().removeClasses(this.el, this.openClasses),
                    Bv().removeClasses(this.el, this.closingClasses),
                    Bv().removeClasses(this.el, this.inlineClasses),
                    this.el.setAttribute("style", ""),
                    this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el)
                }
            }, {
                key: "_handleLoad",
                value: function() {
                    var e = this.el.querySelector(".pwzrdrift-zoom-pane-loader");
                    e && (e.style.display = "none"),
                    this.imgEl.removeEventListener("load", this._handleLoad, !1),
                    Bv().removeClasses(this.el, this.loadingClasses)
                }
            }, {
                key: "_isInline",
                get: function() {
                    var e = this.settings.inline;
                    return !0 === e || "number" == typeof e && window.innerWidth <= e
                }
            }]) && vg(t.prototype, n),
            r && vg(t, r),
            e
        }(),
        r(ug, "default", (function() {
            return fg
        }
        ))
    }
    function bg() {
        return hg || (hg = !0,
        gg()),
        ug
    }
    var yg, wg, xg = !1;
    function _g(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function Cg(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function Sg() {
        yg = {},
        Bv(),
        Uv(),
        cg(),
        bg(),
        wg = function() {
            function e(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (_g(this, e),
                this.VERSION = "1.4.0",
                this.triggerEl = t,
                this.destroy = this.destroy.bind(this),
                !Bv().isDOMElement(this.triggerEl))
                    throw new TypeError("`new Drift` requires a DOM element as its first argument.");
                var r = n.namespace || null
                  , i = n.showWhitespaceAtEdges || !1
                  , o = n.containInline || !1
                  , a = n.inlineOffsetX || 0
                  , s = n.inlineOffsetY || 0
                  , l = n.inlineContainer || document.body
                  , c = n.sourceAttribute || "data-zoom"
                  , u = n.zoomFactor || 3
                  , d = void 0 === n.paneContainer ? document.body : n.paneContainer
                  , p = n.inlinePane || 375
                  , f = !("handleTouch"in n) || !!n.handleTouch
                  , h = n.onShow || null
                  , m = n.onHide || null
                  , v = !("injectBaseStyles"in n) || !!n.injectBaseStyles
                  , g = n.hoverDelay || 0
                  , b = n.touchDelay || 0
                  , y = n.hoverBoundingBox || !1
                  , w = n.touchBoundingBox || !1
                  , x = n.boundingBoxContainer || document.body;
                if (!0 !== p && !Bv().isDOMElement(d))
                    throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
                if (!Bv().isDOMElement(l))
                    throw new TypeError("`inlineContainer` must be a DOM element");
                this.settings = {
                    namespace: r,
                    showWhitespaceAtEdges: i,
                    containInline: o,
                    inlineOffsetX: a,
                    inlineOffsetY: s,
                    inlineContainer: l,
                    sourceAttribute: c,
                    zoomFactor: u,
                    paneContainer: d,
                    inlinePane: p,
                    handleTouch: f,
                    onShow: h,
                    onHide: m,
                    injectBaseStyles: v,
                    hoverDelay: g,
                    touchDelay: b,
                    hoverBoundingBox: y,
                    touchBoundingBox: w,
                    boundingBoxContainer: x
                },
                this.settings.injectBaseStyles && Uv().default(),
                this._buildZoomPane(),
                this._buildTrigger()
            }
            var t, n, r;
            return t = e,
            (n = [{
                key: "_buildZoomPane",
                value: function() {
                    this.zoomPane = new (bg().default)({
                        container: this.settings.paneContainer,
                        zoomFactor: this.settings.zoomFactor,
                        showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                        containInline: this.settings.containInline,
                        inline: this.settings.inlinePane,
                        namespace: this.settings.namespace,
                        inlineOffsetX: this.settings.inlineOffsetX,
                        inlineOffsetY: this.settings.inlineOffsetY,
                        inlineContainer: this.settings.inlineContainer
                    })
                }
            }, {
                key: "_buildTrigger",
                value: function() {
                    this.trigger = new (cg().default)({
                        el: this.triggerEl,
                        zoomPane: this.zoomPane,
                        handleTouch: this.settings.handleTouch,
                        onShow: this.settings.onShow,
                        onHide: this.settings.onHide,
                        sourceAttribute: this.settings.sourceAttribute,
                        hoverDelay: this.settings.hoverDelay,
                        touchDelay: this.settings.touchDelay,
                        hoverBoundingBox: this.settings.hoverBoundingBox,
                        touchBoundingBox: this.settings.touchBoundingBox,
                        namespace: this.settings.namespace,
                        zoomFactor: this.settings.zoomFactor,
                        boundingBoxContainer: this.settings.boundingBoxContainer,
                        inlineContainer: this.settings.inlineContainer
                    })
                }
            }, {
                key: "setZoomImageURL",
                value: function(e) {
                    this.zoomPane._setImageURL(e)
                }
            }, {
                key: "disable",
                value: function() {
                    this.trigger.enabled = !1
                }
            }, {
                key: "enable",
                value: function() {
                    this.trigger.enabled = !0
                }
            }, {
                key: "destroy",
                value: function() {
                    this.trigger._hide(),
                    this.trigger._unbindEvents()
                }
            }, {
                key: "isShowing",
                get: function() {
                    return this.zoomPane.isShowing
                }
            }, {
                key: "zoomFactor",
                get: function() {
                    return this.settings.zoomFactor
                },
                set: function(e) {
                    this.settings.zoomFactor = e,
                    this.zoomPane.settings.zoomFactor = e,
                    this.trigger.settings.zoomFactor = e,
                    this.boundingBox.settings.zoomFactor = e
                }
            }]) && Cg(t.prototype, n),
            r && Cg(t, r),
            e
        }(),
        r(yg, "default", (function() {
            return wg
        }
        )),
        Object.defineProperty(wg.prototype, "isShowing", {
            get: function() {
                return this.isShowing
            }
        }),
        Object.defineProperty(wg.prototype, "zoomFactor", {
            get: function() {
                return this.zoomFactor
            },
            set: function(e) {
                this.zoomFactor = e
            }
        }),
        wg.prototype.setZoomImageURL = wg.prototype.setZoomImageURL,
        wg.prototype.disable = wg.prototype.disable,
        wg.prototype.enable = wg.prototype.enable,
        wg.prototype.destroy = wg.prototype.destroy
    }
    var Eg = {}
      , kg = mp;
    Object.defineProperty(Eg, "__esModule", {
        value: !0
    });
    var Og = void 0;
    Eg.default = Og;
    var Tg = kg(yp)
      , Mg = kg(Cp);
    Og = function(e, t) {
        return qa(e, (0,
        Tg.default)({
            defaultTheme: Mg.default
        }, t))
    }
    ,
    Eg.default = Og;
    var Rg = t(Eg);
    function Pg(e) {
        return null !== e && "object" == typeof e && "constructor"in e && e.constructor === Object
    }
    function Ig(e, t) {
        void 0 === e && (e = {}),
        void 0 === t && (t = {}),
        Object.keys(t).forEach((function(n) {
            void 0 === e[n] ? e[n] = t[n] : Pg(t[n]) && Pg(e[n]) && Object.keys(t[n]).length > 0 && Ig(e[n], t[n])
        }
        ))
    }
    var zg = {
        body: {},
        addEventListener: function() {},
        removeEventListener: function() {},
        activeElement: {
            blur: function() {},
            nodeName: ""
        },
        querySelector: function() {
            return null
        },
        querySelectorAll: function() {
            return []
        },
        getElementById: function() {
            return null
        },
        createEvent: function() {
            return {
                initEvent: function() {}
            }
        },
        createElement: function() {
            return {
                children: [],
                childNodes: [],
                style: {},
                setAttribute: function() {},
                getElementsByTagName: function() {
                    return []
                }
            }
        },
        createElementNS: function() {
            return {}
        },
        importNode: function() {
            return null
        },
        location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: ""
        }
    };
    function Ag() {
        var e = "undefined" != typeof document ? document : {};
        return Ig(e, zg),
        e
    }
    var Lg = {
        document: zg,
        navigator: {
            userAgent: ""
        },
        location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: ""
        },
        history: {
            replaceState: function() {},
            pushState: function() {},
            go: function() {},
            back: function() {}
        },
        CustomEvent: function() {
            return this
        },
        addEventListener: function() {},
        removeEventListener: function() {},
        getComputedStyle: function() {
            return {
                getPropertyValue: function() {
                    return ""
                }
            }
        },
        Image: function() {},
        Date: function() {},
        screen: {},
        setTimeout: function() {},
        clearTimeout: function() {},
        matchMedia: function() {
            return {}
        },
        requestAnimationFrame: function(e) {
            return "undefined" == typeof setTimeout ? (e(),
            null) : setTimeout(e, 0)
        },
        cancelAnimationFrame: function(e) {
            "undefined" != typeof setTimeout && clearTimeout(e)
        }
    };
    function Dg() {
        var e = "undefined" != typeof window ? window : {};
        return Ig(e, Lg),
        e
    }
    function Ng(e) {
        return (Ng = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        }
        )(e)
    }
    function Wg(e, t) {
        return (Wg = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t,
            e
        }
        )(e, t)
    }
    function Fg() {
        if ("undefined" == typeof Reflect || !Reflect.construct)
            return !1;
        if (Reflect.construct.sham)
            return !1;
        if ("function" == typeof Proxy)
            return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}
            ))),
            !0
        } catch (e) {
            return !1
        }
    }
    function $g(e, t, n) {
        return ($g = Fg() ? Reflect.construct : function(e, t, n) {
            var r = [null];
            r.push.apply(r, t);
            var i = new (Function.bind.apply(e, r));
            return n && Wg(i, n.prototype),
            i
        }
        ).apply(null, arguments)
    }
    function Bg(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return (Bg = function(e) {
            if (null === e || !function(e) {
                return -1 !== Function.toString.call(e).indexOf("[native code]")
            }(e))
                return e;
            if ("function" != typeof e)
                throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e))
                    return t.get(e);
                t.set(e, n)
            }
            function n() {
                return $g(e, arguments, Ng(this).constructor)
            }
            return n.prototype = Object.create(e.prototype, {
                constructor: {
                    value: n,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }),
            Wg(n, e)
        }
        )(e)
    }
    var jg = function(e) {
        var t, n;
        function r(t) {
            var n, r, i;
            return n = e.call.apply(e, [this].concat(t)) || this,
            r = function(e) {
                if (void 0 === e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e
            }(n),
            i = r.__proto__,
            Object.defineProperty(r, "__proto__", {
                get: function() {
                    return i
                },
                set: function(e) {
                    i.__proto__ = e
                }
            }),
            n
        }
        return n = e,
        (t = r).prototype = Object.create(n.prototype),
        t.prototype.constructor = t,
        t.__proto__ = n,
        r
    }(Bg(Array));
    function Hg(e) {
        void 0 === e && (e = []);
        var t = [];
        return e.forEach((function(e) {
            Array.isArray(e) ? t.push.apply(t, Hg(e)) : t.push(e)
        }
        )),
        t
    }
    function Vg(e, t) {
        return Array.prototype.filter.call(e, t)
    }
    function qg(e, t) {
        var n = Dg()
          , r = Ag()
          , i = [];
        if (!t && e instanceof jg)
            return e;
        if (!e)
            return new jg(i);
        if ("string" == typeof e) {
            var o = e.trim();
            if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
                var a = "div";
                0 === o.indexOf("<li") && (a = "ul"),
                0 === o.indexOf("<tr") && (a = "tbody"),
                0 !== o.indexOf("<td") && 0 !== o.indexOf("<th") || (a = "tr"),
                0 === o.indexOf("<tbody") && (a = "table"),
                0 === o.indexOf("<option") && (a = "select");
                var s = r.createElement(a);
                s.innerHTML = o;
                for (var l = 0; l < s.childNodes.length; l += 1)
                    i.push(s.childNodes[l])
            } else
                i = function(e, t) {
                    if ("string" != typeof e)
                        return [e];
                    for (var n = [], r = t.querySelectorAll(e), i = 0; i < r.length; i += 1)
                        n.push(r[i]);
                    return n
                }(e.trim(), t || r)
        } else if (e.nodeType || e === n || e === r)
            i.push(e);
        else if (Array.isArray(e)) {
            if (e instanceof jg)
                return e;
            i = e
        }
        return new jg(function(e) {
            for (var t = [], n = 0; n < e.length; n += 1)
                -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t
        }(i))
    }
    qg.fn = jg.prototype;
    var Ug = "resize scroll".split(" ");
    function Gg(e) {
        return function() {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            if (void 0 === n[0]) {
                for (var i = 0; i < this.length; i += 1)
                    Ug.indexOf(e) < 0 && (e in this[i] ? this[i][e]() : qg(this[i]).trigger(e));
                return this
            }
            return this.on.apply(this, [e].concat(n))
        }
    }
    Gg("click"),
    Gg("blur"),
    Gg("focus"),
    Gg("focusin"),
    Gg("focusout"),
    Gg("keyup"),
    Gg("keydown"),
    Gg("keypress"),
    Gg("submit"),
    Gg("change"),
    Gg("mousedown"),
    Gg("mousemove"),
    Gg("mouseup"),
    Gg("mouseenter"),
    Gg("mouseleave"),
    Gg("mouseout"),
    Gg("mouseover"),
    Gg("touchstart"),
    Gg("touchend"),
    Gg("touchmove"),
    Gg("resize"),
    Gg("scroll");
    var Zg = {
        addClass: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = Hg(t.map((function(e) {
                return e.split(" ")
            }
            )));
            return this.forEach((function(e) {
                var t;
                (t = e.classList).add.apply(t, r)
            }
            )),
            this
        },
        removeClass: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = Hg(t.map((function(e) {
                return e.split(" ")
            }
            )));
            return this.forEach((function(e) {
                var t;
                (t = e.classList).remove.apply(t, r)
            }
            )),
            this
        },
        hasClass: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = Hg(t.map((function(e) {
                return e.split(" ")
            }
            )));
            return Vg(this, (function(e) {
                return r.filter((function(t) {
                    return e.classList.contains(t)
                }
                )).length > 0
            }
            )).length > 0
        },
        toggleClass: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = Hg(t.map((function(e) {
                return e.split(" ")
            }
            )));
            this.forEach((function(e) {
                r.forEach((function(t) {
                    e.classList.toggle(t)
                }
                ))
            }
            ))
        },
        attr: function(e, t) {
            if (1 === arguments.length && "string" == typeof e)
                return this[0] ? this[0].getAttribute(e) : void 0;
            for (var n = 0; n < this.length; n += 1)
                if (2 === arguments.length)
                    this[n].setAttribute(e, t);
                else
                    for (var r in e)
                        this[n][r] = e[r],
                        this[n].setAttribute(r, e[r]);
            return this
        },
        removeAttr: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].removeAttribute(e);
            return this
        },
        transform: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].style.transform = e;
            return this
        },
        transition: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].style.transitionDuration = "string" != typeof e ? e + "ms" : e;
            return this
        },
        on: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = t[0]
              , i = t[1]
              , o = t[2]
              , a = t[3];
            function s(e) {
                var t = e.target;
                if (t) {
                    var n = e.target.dom7EventData || [];
                    if (n.indexOf(e) < 0 && n.unshift(e),
                    qg(t).is(i))
                        o.apply(t, n);
                    else
                        for (var r = qg(t).parents(), a = 0; a < r.length; a += 1)
                            qg(r[a]).is(i) && o.apply(r[a], n)
                }
            }
            function l(e) {
                var t = e && e.target && e.target.dom7EventData || [];
                t.indexOf(e) < 0 && t.unshift(e),
                o.apply(this, t)
            }
            "function" == typeof t[1] && (r = t[0],
            o = t[1],
            a = t[2],
            i = void 0),
            a || (a = !1);
            for (var c, u = r.split(" "), d = 0; d < this.length; d += 1) {
                var p = this[d];
                if (i)
                    for (c = 0; c < u.length; c += 1) {
                        var f = u[c];
                        p.dom7LiveListeners || (p.dom7LiveListeners = {}),
                        p.dom7LiveListeners[f] || (p.dom7LiveListeners[f] = []),
                        p.dom7LiveListeners[f].push({
                            listener: o,
                            proxyListener: s
                        }),
                        p.addEventListener(f, s, a)
                    }
                else
                    for (c = 0; c < u.length; c += 1) {
                        var h = u[c];
                        p.dom7Listeners || (p.dom7Listeners = {}),
                        p.dom7Listeners[h] || (p.dom7Listeners[h] = []),
                        p.dom7Listeners[h].push({
                            listener: o,
                            proxyListener: l
                        }),
                        p.addEventListener(h, l, a)
                    }
            }
            return this
        },
        off: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = t[0]
              , i = t[1]
              , o = t[2]
              , a = t[3];
            "function" == typeof t[1] && (r = t[0],
            o = t[1],
            a = t[2],
            i = void 0),
            a || (a = !1);
            for (var s = r.split(" "), l = 0; l < s.length; l += 1)
                for (var c = s[l], u = 0; u < this.length; u += 1) {
                    var d = this[u]
                      , p = void 0;
                    if (!i && d.dom7Listeners ? p = d.dom7Listeners[c] : i && d.dom7LiveListeners && (p = d.dom7LiveListeners[c]),
                    p && p.length)
                        for (var f = p.length - 1; f >= 0; f -= 1) {
                            var h = p[f];
                            o && h.listener === o || o && h.listener && h.listener.dom7proxy && h.listener.dom7proxy === o ? (d.removeEventListener(c, h.proxyListener, a),
                            p.splice(f, 1)) : o || (d.removeEventListener(c, h.proxyListener, a),
                            p.splice(f, 1))
                        }
                }
            return this
        },
        trigger: function() {
            for (var e = Dg(), t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            for (var i = n[0].split(" "), o = n[1], a = 0; a < i.length; a += 1)
                for (var s = i[a], l = 0; l < this.length; l += 1) {
                    var c = this[l];
                    if (e.CustomEvent) {
                        var u = new e.CustomEvent(s,{
                            detail: o,
                            bubbles: !0,
                            cancelable: !0
                        });
                        c.dom7EventData = n.filter((function(e, t) {
                            return t > 0
                        }
                        )),
                        c.dispatchEvent(u),
                        c.dom7EventData = [],
                        delete c.dom7EventData
                    }
                }
            return this
        },
        transitionEnd: function(e) {
            var t = this;
            return e && t.on("transitionend", (function n(r) {
                r.target === this && (e.call(this, r),
                t.off("transitionend", n))
            }
            )),
            this
        },
        outerWidth: function(e) {
            if (this.length > 0) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"))
                }
                return this[0].offsetWidth
            }
            return null
        },
        outerHeight: function(e) {
            if (this.length > 0) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"))
                }
                return this[0].offsetHeight
            }
            return null
        },
        styles: function() {
            var e = Dg();
            return this[0] ? e.getComputedStyle(this[0], null) : {}
        },
        offset: function() {
            if (this.length > 0) {
                var e = Dg()
                  , t = Ag()
                  , n = this[0]
                  , r = n.getBoundingClientRect()
                  , i = t.body
                  , o = n.clientTop || i.clientTop || 0
                  , a = n.clientLeft || i.clientLeft || 0
                  , s = n === e ? e.scrollY : n.scrollTop
                  , l = n === e ? e.scrollX : n.scrollLeft;
                return {
                    top: r.top + s - o,
                    left: r.left + l - a
                }
            }
            return null
        },
        css: function(e, t) {
            var n, r = Dg();
            if (1 === arguments.length) {
                if ("string" != typeof e) {
                    for (n = 0; n < this.length; n += 1)
                        for (var i in e)
                            this[n].style[i] = e[i];
                    return this
                }
                if (this[0])
                    return r.getComputedStyle(this[0], null).getPropertyValue(e)
            }
            if (2 === arguments.length && "string" == typeof e) {
                for (n = 0; n < this.length; n += 1)
                    this[n].style[e] = t;
                return this
            }
            return this
        },
        each: function(e) {
            return e ? (this.forEach((function(t, n) {
                e.apply(t, [t, n])
            }
            )),
            this) : this
        },
        html: function(e) {
            if (void 0 === e)
                return this[0] ? this[0].innerHTML : null;
            for (var t = 0; t < this.length; t += 1)
                this[t].innerHTML = e;
            return this
        },
        text: function(e) {
            if (void 0 === e)
                return this[0] ? this[0].textContent.trim() : null;
            for (var t = 0; t < this.length; t += 1)
                this[t].textContent = e;
            return this
        },
        is: function(e) {
            var t, n, r = Dg(), i = Ag(), o = this[0];
            if (!o || void 0 === e)
                return !1;
            if ("string" == typeof e) {
                if (o.matches)
                    return o.matches(e);
                if (o.webkitMatchesSelector)
                    return o.webkitMatchesSelector(e);
                if (o.msMatchesSelector)
                    return o.msMatchesSelector(e);
                for (t = qg(e),
                n = 0; n < t.length; n += 1)
                    if (t[n] === o)
                        return !0;
                return !1
            }
            if (e === i)
                return o === i;
            if (e === r)
                return o === r;
            if (e.nodeType || e instanceof jg) {
                for (t = e.nodeType ? [e] : e,
                n = 0; n < t.length; n += 1)
                    if (t[n] === o)
                        return !0;
                return !1
            }
            return !1
        },
        index: function() {
            var e, t = this[0];
            if (t) {
                for (e = 0; null !== (t = t.previousSibling); )
                    1 === t.nodeType && (e += 1);
                return e
            }
        },
        eq: function(e) {
            if (void 0 === e)
                return this;
            var t = this.length;
            if (e > t - 1)
                return qg([]);
            if (e < 0) {
                var n = t + e;
                return qg(n < 0 ? [] : [this[n]])
            }
            return qg([this[e]])
        },
        append: function() {
            for (var e, t = Ag(), n = 0; n < arguments.length; n += 1) {
                e = n < 0 || arguments.length <= n ? void 0 : arguments[n];
                for (var r = 0; r < this.length; r += 1)
                    if ("string" == typeof e) {
                        var i = t.createElement("div");
                        for (i.innerHTML = e; i.firstChild; )
                            this[r].appendChild(i.firstChild)
                    } else if (e instanceof jg)
                        for (var o = 0; o < e.length; o += 1)
                            this[r].appendChild(e[o]);
                    else
                        this[r].appendChild(e)
            }
            return this
        },
        prepend: function(e) {
            var t, n, r = Ag();
            for (t = 0; t < this.length; t += 1)
                if ("string" == typeof e) {
                    var i = r.createElement("div");
                    for (i.innerHTML = e,
                    n = i.childNodes.length - 1; n >= 0; n -= 1)
                        this[t].insertBefore(i.childNodes[n], this[t].childNodes[0])
                } else if (e instanceof jg)
                    for (n = 0; n < e.length; n += 1)
                        this[t].insertBefore(e[n], this[t].childNodes[0]);
                else
                    this[t].insertBefore(e, this[t].childNodes[0]);
            return this
        },
        next: function(e) {
            return this.length > 0 ? e ? this[0].nextElementSibling && qg(this[0].nextElementSibling).is(e) ? qg([this[0].nextElementSibling]) : qg([]) : this[0].nextElementSibling ? qg([this[0].nextElementSibling]) : qg([]) : qg([])
        },
        nextAll: function(e) {
            var t = []
              , n = this[0];
            if (!n)
                return qg([]);
            for (; n.nextElementSibling; ) {
                var r = n.nextElementSibling;
                e ? qg(r).is(e) && t.push(r) : t.push(r),
                n = r
            }
            return qg(t)
        },
        prev: function(e) {
            if (this.length > 0) {
                var t = this[0];
                return e ? t.previousElementSibling && qg(t.previousElementSibling).is(e) ? qg([t.previousElementSibling]) : qg([]) : t.previousElementSibling ? qg([t.previousElementSibling]) : qg([])
            }
            return qg([])
        },
        prevAll: function(e) {
            var t = []
              , n = this[0];
            if (!n)
                return qg([]);
            for (; n.previousElementSibling; ) {
                var r = n.previousElementSibling;
                e ? qg(r).is(e) && t.push(r) : t.push(r),
                n = r
            }
            return qg(t)
        },
        parent: function(e) {
            for (var t = [], n = 0; n < this.length; n += 1)
                null !== this[n].parentNode && (e ? qg(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
            return qg(t)
        },
        parents: function(e) {
            for (var t = [], n = 0; n < this.length; n += 1)
                for (var r = this[n].parentNode; r; )
                    e ? qg(r).is(e) && t.push(r) : t.push(r),
                    r = r.parentNode;
            return qg(t)
        },
        closest: function(e) {
            var t = this;
            return void 0 === e ? qg([]) : (t.is(e) || (t = t.parents(e).eq(0)),
            t)
        },
        find: function(e) {
            for (var t = [], n = 0; n < this.length; n += 1)
                for (var r = this[n].querySelectorAll(e), i = 0; i < r.length; i += 1)
                    t.push(r[i]);
            return qg(t)
        },
        children: function(e) {
            for (var t = [], n = 0; n < this.length; n += 1)
                for (var r = this[n].children, i = 0; i < r.length; i += 1)
                    e && !qg(r[i]).is(e) || t.push(r[i]);
            return qg(t)
        },
        filter: function(e) {
            return qg(Vg(this, e))
        },
        remove: function() {
            for (var e = 0; e < this.length; e += 1)
                this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            return this
        }
    };
    Object.keys(Zg).forEach((function(e) {
        qg.fn[e] = Zg[e]
    }
    ));
    var Kg, Yg, Xg, Jg = qg;
    function Qg(e, t) {
        return void 0 === t && (t = 0),
        setTimeout(e, t)
    }
    function eb() {
        return Date.now()
    }
    function tb(e) {
        return "object" == typeof e && null !== e && e.constructor && e.constructor === Object
    }
    function nb() {
        for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = 1; t < arguments.length; t += 1) {
            var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
            if (null != n)
                for (var r = Object.keys(Object(n)), i = 0, o = r.length; i < o; i += 1) {
                    var a = r[i]
                      , s = Object.getOwnPropertyDescriptor(n, a);
                    void 0 !== s && s.enumerable && (tb(e[a]) && tb(n[a]) ? nb(e[a], n[a]) : !tb(e[a]) && tb(n[a]) ? (e[a] = {},
                    nb(e[a], n[a])) : e[a] = n[a])
                }
        }
        return e
    }
    function rb(e, t) {
        Object.keys(t).forEach((function(n) {
            tb(t[n]) && Object.keys(t[n]).forEach((function(r) {
                "function" == typeof t[n][r] && (t[n][r] = t[n][r].bind(e))
            }
            )),
            e[n] = t[n]
        }
        ))
    }
    function ib() {
        return Kg || (Kg = function() {
            var e = Dg()
              , t = Ag();
            return {
                touch: !!("ontouchstart"in e || e.DocumentTouch && t instanceof e.DocumentTouch),
                pointerEvents: !!e.PointerEvent && "maxTouchPoints"in e.navigator && e.navigator.maxTouchPoints >= 0,
                observer: "MutationObserver"in e || "WebkitMutationObserver"in e,
                passiveListener: function() {
                    var t = !1;
                    try {
                        var n = Object.defineProperty({}, "passive", {
                            get: function() {
                                t = !0
                            }
                        });
                        e.addEventListener("testPassiveListener", null, n)
                    } catch (e) {}
                    return t
                }(),
                gestures: "ongesturestart"in e
            }
        }()),
        Kg
    }
    function ob(e) {
        return void 0 === e && (e = {}),
        Yg || (Yg = function(e) {
            var t = (void 0 === e ? {} : e).userAgent
              , n = ib()
              , r = Dg()
              , i = r.navigator.platform
              , o = t || r.navigator.userAgent
              , a = {
                ios: !1,
                android: !1
            }
              , s = r.screen.width
              , l = r.screen.height
              , c = o.match(/(Android);?[\s\/]+([\d.]+)?/)
              , u = o.match(/(iPad).*OS\s([\d_]+)/)
              , d = o.match(/(iPod)(.*OS\s([\d_]+))?/)
              , p = !u && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/)
              , f = "Win32" === i
              , h = "MacIntel" === i;
            return !u && h && n.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(s + "x" + l) >= 0 && ((u = o.match(/(Version)\/([\d.]+)/)) || (u = [0, 1, "13_0_0"]),
            h = !1),
            c && !f && (a.os = "android",
            a.android = !0),
            (u || p || d) && (a.os = "ios",
            a.ios = !0),
            a
        }(e)),
        Yg
    }
    function ab() {
        return Xg || (Xg = function() {
            var e, t = Dg();
            return {
                isEdge: !!t.navigator.userAgent.match(/Edge/g),
                isSafari: (e = t.navigator.userAgent.toLowerCase(),
                e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
            }
        }()),
        Xg
    }
    var sb = {
        name: "resize",
        create: function() {
            var e = this;
            nb(e, {
                resize: {
                    observer: null,
                    createObserver: function() {
                        e && !e.destroyed && e.initialized && (e.resize.observer = new ResizeObserver((function(t) {
                            var n = e.width
                              , r = e.height
                              , i = n
                              , o = r;
                            t.forEach((function(t) {
                                var n = t.contentBoxSize
                                  , r = t.contentRect
                                  , a = t.target;
                                a && a !== e.el || (i = r ? r.width : (n[0] || n).inlineSize,
                                o = r ? r.height : (n[0] || n).blockSize)
                            }
                            )),
                            i === n && o === r || e.resize.resizeHandler()
                        }
                        )),
                        e.resize.observer.observe(e.el))
                    },
                    removeObserver: function() {
                        e.resize.observer && e.resize.observer.unobserve && e.el && (e.resize.observer.unobserve(e.el),
                        e.resize.observer = null)
                    },
                    resizeHandler: function() {
                        e && !e.destroyed && e.initialized && (e.emit("beforeResize"),
                        e.emit("resize"))
                    },
                    orientationChangeHandler: function() {
                        e && !e.destroyed && e.initialized && e.emit("orientationchange")
                    }
                }
            })
        },
        on: {
            init: function(e) {
                var t = Dg();
                e.params.resizeObserver && void 0 !== Dg().ResizeObserver ? e.resize.createObserver() : (t.addEventListener("resize", e.resize.resizeHandler),
                t.addEventListener("orientationchange", e.resize.orientationChangeHandler))
            },
            destroy: function(e) {
                var t = Dg();
                e.resize.removeObserver(),
                t.removeEventListener("resize", e.resize.resizeHandler),
                t.removeEventListener("orientationchange", e.resize.orientationChangeHandler)
            }
        }
    };
    function lb() {
        return (lb = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ).apply(this, arguments)
    }
    var cb = {
        attach: function(e, t) {
            void 0 === t && (t = {});
            var n = Dg()
              , r = this
              , i = new (n.MutationObserver || n.WebkitMutationObserver)((function(e) {
                if (1 !== e.length) {
                    var t = function() {
                        r.emit("observerUpdate", e[0])
                    };
                    n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0)
                } else
                    r.emit("observerUpdate", e[0])
            }
            ));
            i.observe(e, {
                attributes: void 0 === t.attributes || t.attributes,
                childList: void 0 === t.childList || t.childList,
                characterData: void 0 === t.characterData || t.characterData
            }),
            r.observer.observers.push(i)
        },
        init: function() {
            var e = this;
            if (e.support.observer && e.params.observer) {
                if (e.params.observeParents)
                    for (var t = e.$el.parents(), n = 0; n < t.length; n += 1)
                        e.observer.attach(t[n]);
                e.observer.attach(e.$el[0], {
                    childList: e.params.observeSlideChildren
                }),
                e.observer.attach(e.$wrapperEl[0], {
                    attributes: !1
                })
            }
        },
        destroy: function() {
            this.observer.observers.forEach((function(e) {
                e.disconnect()
            }
            )),
            this.observer.observers = []
        }
    }
      , ub = {
        name: "observer",
        params: {
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1
        },
        create: function() {
            rb(this, {
                observer: lb({}, cb, {
                    observers: []
                })
            })
        },
        on: {
            init: function(e) {
                e.observer.init()
            },
            destroy: function(e) {
                e.observer.destroy()
            }
        }
    };
    function db(e) {
        var t = this
          , n = Ag()
          , r = Dg()
          , i = t.touchEventsData
          , o = t.params
          , a = t.touches;
        if (!t.animating || !o.preventInteractionOnTransition) {
            var s = e;
            s.originalEvent && (s = s.originalEvent);
            var l = Jg(s.target);
            if ("wrapper" !== o.touchEventsTarget || l.closest(t.wrapperEl).length)
                if (i.isTouchEvent = "touchstart" === s.type,
                i.isTouchEvent || !("which"in s) || 3 !== s.which)
                    if (!(!i.isTouchEvent && "button"in s && s.button > 0))
                        if (!i.isTouched || !i.isMoved)
                            if (!!o.noSwipingClass && "" !== o.noSwipingClass && s.target && s.target.shadowRoot && e.path && e.path[0] && (l = Jg(e.path[0])),
                            o.noSwiping && l.closest(o.noSwipingSelector ? o.noSwipingSelector : "." + o.noSwipingClass)[0])
                                t.allowClick = !0;
                            else if (!o.swipeHandler || l.closest(o.swipeHandler)[0]) {
                                a.currentX = "touchstart" === s.type ? s.targetTouches[0].pageX : s.pageX,
                                a.currentY = "touchstart" === s.type ? s.targetTouches[0].pageY : s.pageY;
                                var c = a.currentX
                                  , u = a.currentY
                                  , d = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection
                                  , p = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
                                if (d && (c <= p || c >= r.innerWidth - p)) {
                                    if ("prevent" !== d)
                                        return;
                                    e.preventDefault()
                                }
                                if (nb(i, {
                                    isTouched: !0,
                                    isMoved: !1,
                                    allowTouchCallbacks: !0,
                                    isScrolling: void 0,
                                    startMoving: void 0
                                }),
                                a.startX = c,
                                a.startY = u,
                                i.touchStartTime = eb(),
                                t.allowClick = !0,
                                t.updateSize(),
                                t.swipeDirection = void 0,
                                o.threshold > 0 && (i.allowThresholdMove = !1),
                                "touchstart" !== s.type) {
                                    var f = !0;
                                    l.is(i.formElements) && (f = !1),
                                    n.activeElement && Jg(n.activeElement).is(i.formElements) && n.activeElement !== l[0] && n.activeElement.blur();
                                    var h = f && t.allowTouchMove && o.touchStartPreventDefault;
                                    !o.touchStartForcePreventDefault && !h || l[0].isContentEditable || s.preventDefault()
                                }
                                t.emit("touchStart", s)
                            }
        }
    }
    function pb(e) {
        var t = Ag()
          , n = this
          , r = n.touchEventsData
          , i = n.params
          , o = n.touches
          , a = n.rtlTranslate
          , s = e;
        if (s.originalEvent && (s = s.originalEvent),
        r.isTouched) {
            if (!r.isTouchEvent || "touchmove" === s.type) {
                var l = "touchmove" === s.type && s.targetTouches && (s.targetTouches[0] || s.changedTouches[0])
                  , c = "touchmove" === s.type ? l.pageX : s.pageX
                  , u = "touchmove" === s.type ? l.pageY : s.pageY;
                if (s.preventedByNestedSwiper)
                    return o.startX = c,
                    void (o.startY = u);
                if (!n.allowTouchMove)
                    return n.allowClick = !1,
                    void (r.isTouched && (nb(o, {
                        startX: c,
                        startY: u,
                        currentX: c,
                        currentY: u
                    }),
                    r.touchStartTime = eb()));
                if (r.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
                    if (n.isVertical()) {
                        if (u < o.startY && n.translate <= n.maxTranslate() || u > o.startY && n.translate >= n.minTranslate())
                            return r.isTouched = !1,
                            void (r.isMoved = !1)
                    } else if (c < o.startX && n.translate <= n.maxTranslate() || c > o.startX && n.translate >= n.minTranslate())
                        return;
                if (r.isTouchEvent && t.activeElement && s.target === t.activeElement && Jg(s.target).is(r.formElements))
                    return r.isMoved = !0,
                    void (n.allowClick = !1);
                if (r.allowTouchCallbacks && n.emit("touchMove", s),
                !(s.targetTouches && s.targetTouches.length > 1)) {
                    o.currentX = c,
                    o.currentY = u;
                    var d = o.currentX - o.startX
                      , p = o.currentY - o.startY;
                    if (!(n.params.threshold && Math.sqrt(Math.pow(d, 2) + Math.pow(p, 2)) < n.params.threshold)) {
                        var f;
                        if (void 0 === r.isScrolling)
                            n.isHorizontal() && o.currentY === o.startY || n.isVertical() && o.currentX === o.startX ? r.isScrolling = !1 : d * d + p * p >= 25 && (f = 180 * Math.atan2(Math.abs(p), Math.abs(d)) / Math.PI,
                            r.isScrolling = n.isHorizontal() ? f > i.touchAngle : 90 - f > i.touchAngle);
                        if (r.isScrolling && n.emit("touchMoveOpposite", s),
                        void 0 === r.startMoving && (o.currentX === o.startX && o.currentY === o.startY || (r.startMoving = !0)),
                        r.isScrolling)
                            r.isTouched = !1;
                        else if (r.startMoving) {
                            n.allowClick = !1,
                            !i.cssMode && s.cancelable && s.preventDefault(),
                            i.touchMoveStopPropagation && !i.nested && s.stopPropagation(),
                            r.isMoved || (i.loop && n.loopFix(),
                            r.startTranslate = n.getTranslate(),
                            n.setTransition(0),
                            n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                            r.allowMomentumBounce = !1,
                            !i.grabCursor || !0 !== n.allowSlideNext && !0 !== n.allowSlidePrev || n.setGrabCursor(!0),
                            n.emit("sliderFirstMove", s)),
                            n.emit("sliderMove", s),
                            r.isMoved = !0;
                            var h = n.isHorizontal() ? d : p;
                            o.diff = h,
                            h *= i.touchRatio,
                            a && (h = -h),
                            n.swipeDirection = h > 0 ? "prev" : "next",
                            r.currentTranslate = h + r.startTranslate;
                            var m = !0
                              , v = i.resistanceRatio;
                            if (i.touchReleaseOnEdges && (v = 0),
                            h > 0 && r.currentTranslate > n.minTranslate() ? (m = !1,
                            i.resistance && (r.currentTranslate = n.minTranslate() - 1 + Math.pow(-n.minTranslate() + r.startTranslate + h, v))) : h < 0 && r.currentTranslate < n.maxTranslate() && (m = !1,
                            i.resistance && (r.currentTranslate = n.maxTranslate() + 1 - Math.pow(n.maxTranslate() - r.startTranslate - h, v))),
                            m && (s.preventedByNestedSwiper = !0),
                            !n.allowSlideNext && "next" === n.swipeDirection && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate),
                            !n.allowSlidePrev && "prev" === n.swipeDirection && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate),
                            n.allowSlidePrev || n.allowSlideNext || (r.currentTranslate = r.startTranslate),
                            i.threshold > 0) {
                                if (!(Math.abs(h) > i.threshold || r.allowThresholdMove))
                                    return void (r.currentTranslate = r.startTranslate);
                                if (!r.allowThresholdMove)
                                    return r.allowThresholdMove = !0,
                                    o.startX = o.currentX,
                                    o.startY = o.currentY,
                                    r.currentTranslate = r.startTranslate,
                                    void (o.diff = n.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY)
                            }
                            i.followFinger && !i.cssMode && ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (n.updateActiveIndex(),
                            n.updateSlidesClasses()),
                            i.freeMode && (0 === r.velocities.length && r.velocities.push({
                                position: o[n.isHorizontal() ? "startX" : "startY"],
                                time: r.touchStartTime
                            }),
                            r.velocities.push({
                                position: o[n.isHorizontal() ? "currentX" : "currentY"],
                                time: eb()
                            })),
                            n.updateProgress(r.currentTranslate),
                            n.setTranslate(r.currentTranslate))
                        }
                    }
                }
            }
        } else
            r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", s)
    }
    function fb(e) {
        var t = this
          , n = t.touchEventsData
          , r = t.params
          , i = t.touches
          , o = t.rtlTranslate
          , a = t.$wrapperEl
          , s = t.slidesGrid
          , l = t.snapGrid
          , c = e;
        if (c.originalEvent && (c = c.originalEvent),
        n.allowTouchCallbacks && t.emit("touchEnd", c),
        n.allowTouchCallbacks = !1,
        !n.isTouched)
            return n.isMoved && r.grabCursor && t.setGrabCursor(!1),
            n.isMoved = !1,
            void (n.startMoving = !1);
        r.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
        var u, d = eb(), p = d - n.touchStartTime;
        if (t.allowClick && (t.updateClickedSlide(c),
        t.emit("tap click", c),
        p < 300 && d - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", c)),
        n.lastClickTime = eb(),
        Qg((function() {
            t.destroyed || (t.allowClick = !0)
        }
        )),
        !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === i.diff || n.currentTranslate === n.startTranslate)
            return n.isTouched = !1,
            n.isMoved = !1,
            void (n.startMoving = !1);
        if (n.isTouched = !1,
        n.isMoved = !1,
        n.startMoving = !1,
        u = r.followFinger ? o ? t.translate : -t.translate : -n.currentTranslate,
        !r.cssMode)
            if (r.freeMode) {
                if (u < -t.minTranslate())
                    return void t.slideTo(t.activeIndex);
                if (u > -t.maxTranslate())
                    return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
                if (r.freeModeMomentum) {
                    if (n.velocities.length > 1) {
                        var f = n.velocities.pop()
                          , h = n.velocities.pop()
                          , m = f.position - h.position
                          , v = f.time - h.time;
                        t.velocity = m / v,
                        t.velocity /= 2,
                        Math.abs(t.velocity) < r.freeModeMinimumVelocity && (t.velocity = 0),
                        (v > 150 || eb() - f.time > 300) && (t.velocity = 0)
                    } else
                        t.velocity = 0;
                    t.velocity *= r.freeModeMomentumVelocityRatio,
                    n.velocities.length = 0;
                    var g = 1e3 * r.freeModeMomentumRatio
                      , b = t.velocity * g
                      , y = t.translate + b;
                    o && (y = -y);
                    var w, x, _ = !1, C = 20 * Math.abs(t.velocity) * r.freeModeMomentumBounceRatio;
                    if (y < t.maxTranslate())
                        r.freeModeMomentumBounce ? (y + t.maxTranslate() < -C && (y = t.maxTranslate() - C),
                        w = t.maxTranslate(),
                        _ = !0,
                        n.allowMomentumBounce = !0) : y = t.maxTranslate(),
                        r.loop && r.centeredSlides && (x = !0);
                    else if (y > t.minTranslate())
                        r.freeModeMomentumBounce ? (y - t.minTranslate() > C && (y = t.minTranslate() + C),
                        w = t.minTranslate(),
                        _ = !0,
                        n.allowMomentumBounce = !0) : y = t.minTranslate(),
                        r.loop && r.centeredSlides && (x = !0);
                    else if (r.freeModeSticky) {
                        for (var S, E = 0; E < l.length; E += 1)
                            if (l[E] > -y) {
                                S = E;
                                break
                            }
                        y = -(y = Math.abs(l[S] - y) < Math.abs(l[S - 1] - y) || "next" === t.swipeDirection ? l[S] : l[S - 1])
                    }
                    if (x && t.once("transitionEnd", (function() {
                        t.loopFix()
                    }
                    )),
                    0 !== t.velocity) {
                        if (g = o ? Math.abs((-y - t.translate) / t.velocity) : Math.abs((y - t.translate) / t.velocity),
                        r.freeModeSticky) {
                            var k = Math.abs((o ? -y : y) - t.translate)
                              , O = t.slidesSizesGrid[t.activeIndex];
                            g = k < O ? r.speed : k < 2 * O ? 1.5 * r.speed : 2.5 * r.speed
                        }
                    } else if (r.freeModeSticky)
                        return void t.slideToClosest();
                    r.freeModeMomentumBounce && _ ? (t.updateProgress(w),
                    t.setTransition(g),
                    t.setTranslate(y),
                    t.transitionStart(!0, t.swipeDirection),
                    t.animating = !0,
                    a.transitionEnd((function() {
                        t && !t.destroyed && n.allowMomentumBounce && (t.emit("momentumBounce"),
                        t.setTransition(r.speed),
                        setTimeout((function() {
                            t.setTranslate(w),
                            a.transitionEnd((function() {
                                t && !t.destroyed && t.transitionEnd()
                            }
                            ))
                        }
                        ), 0))
                    }
                    ))) : t.velocity ? (t.updateProgress(y),
                    t.setTransition(g),
                    t.setTranslate(y),
                    t.transitionStart(!0, t.swipeDirection),
                    t.animating || (t.animating = !0,
                    a.transitionEnd((function() {
                        t && !t.destroyed && t.transitionEnd()
                    }
                    )))) : (t.emit("_freeModeNoMomentumRelease"),
                    t.updateProgress(y)),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses()
                } else {
                    if (r.freeModeSticky)
                        return void t.slideToClosest();
                    r.freeMode && t.emit("_freeModeNoMomentumRelease")
                }
                (!r.freeModeMomentum || p >= r.longSwipesMs) && (t.updateProgress(),
                t.updateActiveIndex(),
                t.updateSlidesClasses())
            } else {
                for (var T = 0, M = t.slidesSizesGrid[0], R = 0; R < s.length; R += R < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
                    var P = R < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                    void 0 !== s[R + P] ? u >= s[R] && u < s[R + P] && (T = R,
                    M = s[R + P] - s[R]) : u >= s[R] && (T = R,
                    M = s[s.length - 1] - s[s.length - 2])
                }
                var I = (u - s[T]) / M
                  , z = T < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                if (p > r.longSwipesMs) {
                    if (!r.longSwipes)
                        return void t.slideTo(t.activeIndex);
                    "next" === t.swipeDirection && (I >= r.longSwipesRatio ? t.slideTo(T + z) : t.slideTo(T)),
                    "prev" === t.swipeDirection && (I > 1 - r.longSwipesRatio ? t.slideTo(T + z) : t.slideTo(T))
                } else {
                    if (!r.shortSwipes)
                        return void t.slideTo(t.activeIndex);
                    t.navigation && (c.target === t.navigation.nextEl || c.target === t.navigation.prevEl) ? c.target === t.navigation.nextEl ? t.slideTo(T + z) : t.slideTo(T) : ("next" === t.swipeDirection && t.slideTo(T + z),
                    "prev" === t.swipeDirection && t.slideTo(T))
                }
            }
    }
    function hb() {
        var e = this
          , t = e.params
          , n = e.el;
        if (!n || 0 !== n.offsetWidth) {
            t.breakpoints && e.setBreakpoint();
            var r = e.allowSlideNext
              , i = e.allowSlidePrev
              , o = e.snapGrid;
            e.allowSlideNext = !0,
            e.allowSlidePrev = !0,
            e.updateSize(),
            e.updateSlides(),
            e.updateSlidesClasses(),
            ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0),
            e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
            e.allowSlidePrev = i,
            e.allowSlideNext = r,
            e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow()
        }
    }
    function mb(e) {
        var t = this;
        t.allowClick || (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation && t.animating && (e.stopPropagation(),
        e.stopImmediatePropagation()))
    }
    function vb() {
        var e = this
          , t = e.wrapperEl
          , n = e.rtlTranslate;
        e.previousTranslate = e.translate,
        e.isHorizontal() ? e.translate = n ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft : e.translate = -t.scrollTop,
        -0 === e.translate && (e.translate = 0),
        e.updateActiveIndex(),
        e.updateSlidesClasses();
        var r = e.maxTranslate() - e.minTranslate();
        (0 === r ? 0 : (e.translate - e.minTranslate()) / r) !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
        e.emit("setTranslate", e.translate, !1)
    }
    var gb = !1;
    function bb() {}
    var yb = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !1,
        nested: !1,
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: .02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsBase: "window",
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: .85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        loopPreventsSlide: !0,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "pwzrswiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "pwzrswiper-container-",
        slideClass: "pwzrswiper-slide",
        slideBlankClass: "pwzrswiper-slide-invisible-blank",
        slideActiveClass: "pwzrswiper-slide-active",
        slideDuplicateActiveClass: "pwzrswiper-slide-duplicate-active",
        slideVisibleClass: "pwzrswiper-slide-visible",
        slideDuplicateClass: "pwzrswiper-slide-duplicate",
        slideNextClass: "pwzrswiper-slide-next",
        slideDuplicateNextClass: "pwzrswiper-slide-duplicate-next",
        slidePrevClass: "pwzrswiper-slide-prev",
        slideDuplicatePrevClass: "pwzrswiper-slide-duplicate-prev",
        wrapperClass: "pwzrswiper-wrapper",
        runCallbacksOnInit: !0,
        _emitClasses: !1
    };
    function wb(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value"in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    var xb = {
        modular: {
            useParams: function(e) {
                var t = this;
                t.modules && Object.keys(t.modules).forEach((function(n) {
                    var r = t.modules[n];
                    r.params && nb(e, r.params)
                }
                ))
            },
            useModules: function(e) {
                void 0 === e && (e = {});
                var t = this;
                t.modules && Object.keys(t.modules).forEach((function(n) {
                    var r = t.modules[n]
                      , i = e[n] || {};
                    r.on && t.on && Object.keys(r.on).forEach((function(e) {
                        t.on(e, r.on[e])
                    }
                    )),
                    r.create && r.create.bind(t)(i)
                }
                ))
            }
        },
        eventsEmitter: {
            on: function(e, t, n) {
                var r = this;
                if ("function" != typeof t)
                    return r;
                var i = n ? "unshift" : "push";
                return e.split(" ").forEach((function(e) {
                    r.eventsListeners[e] || (r.eventsListeners[e] = []),
                    r.eventsListeners[e][i](t)
                }
                )),
                r
            },
            once: function(e, t, n) {
                var r = this;
                if ("function" != typeof t)
                    return r;
                function i() {
                    r.off(e, i),
                    i.__emitterProxy && delete i.__emitterProxy;
                    for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
                        o[a] = arguments[a];
                    t.apply(r, o)
                }
                return i.__emitterProxy = t,
                r.on(e, i, n)
            },
            onAny: function(e, t) {
                var n = this;
                if ("function" != typeof e)
                    return n;
                var r = t ? "unshift" : "push";
                return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e),
                n
            },
            offAny: function(e) {
                var t = this;
                if (!t.eventsAnyListeners)
                    return t;
                var n = t.eventsAnyListeners.indexOf(e);
                return n >= 0 && t.eventsAnyListeners.splice(n, 1),
                t
            },
            off: function(e, t) {
                var n = this;
                return n.eventsListeners ? (e.split(" ").forEach((function(e) {
                    void 0 === t ? n.eventsListeners[e] = [] : n.eventsListeners[e] && n.eventsListeners[e].forEach((function(r, i) {
                        (r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[e].splice(i, 1)
                    }
                    ))
                }
                )),
                n) : n
            },
            emit: function() {
                var e, t, n, r = this;
                if (!r.eventsListeners)
                    return r;
                for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
                    o[a] = arguments[a];
                "string" == typeof o[0] || Array.isArray(o[0]) ? (e = o[0],
                t = o.slice(1, o.length),
                n = r) : (e = o[0].events,
                t = o[0].data,
                n = o[0].context || r),
                t.unshift(n);
                var s = Array.isArray(e) ? e : e.split(" ");
                return s.forEach((function(e) {
                    r.eventsAnyListeners && r.eventsAnyListeners.length && r.eventsAnyListeners.forEach((function(r) {
                        r.apply(n, [e].concat(t))
                    }
                    )),
                    r.eventsListeners && r.eventsListeners[e] && r.eventsListeners[e].forEach((function(e) {
                        e.apply(n, t)
                    }
                    ))
                }
                )),
                r
            }
        },
        update: {
            updateSize: function() {
                var e, t, n = this, r = n.$el;
                e = void 0 !== n.params.width && null !== n.params.width ? n.params.width : r[0].clientWidth,
                t = void 0 !== n.params.height && null !== n.params.height ? n.params.height : r[0].clientHeight,
                0 === e && n.isHorizontal() || 0 === t && n.isVertical() || (e = e - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10),
                t = t - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10),
                Number.isNaN(e) && (e = 0),
                Number.isNaN(t) && (t = 0),
                nb(n, {
                    width: e,
                    height: t,
                    size: n.isHorizontal() ? e : t
                }))
            },
            updateSlides: function() {
                var e = this
                  , t = function(t) {
                    return e.isHorizontal() ? t : {
                        width: "height",
                        "margin-top": "margin-left",
                        "margin-bottom ": "margin-right",
                        "margin-left": "margin-top",
                        "margin-right": "margin-bottom",
                        "padding-left": "padding-top",
                        "padding-right": "padding-bottom",
                        marginRight: "marginBottom"
                    }[t]
                }
                  , n = function(e, n) {
                    return parseFloat(e.getPropertyValue(t(n)) || 0)
                }
                  , r = Dg()
                  , i = e.params
                  , o = e.$wrapperEl
                  , a = e.size
                  , s = e.rtlTranslate
                  , l = e.wrongRTL
                  , c = e.virtual && i.virtual.enabled
                  , u = c ? e.virtual.slides.length : e.slides.length
                  , d = o.children("." + e.params.slideClass)
                  , p = c ? e.virtual.slides.length : d.length
                  , f = []
                  , h = []
                  , m = []
                  , v = i.slidesOffsetBefore;
                "function" == typeof v && (v = i.slidesOffsetBefore.call(e));
                var g = i.slidesOffsetAfter;
                "function" == typeof g && (g = i.slidesOffsetAfter.call(e));
                var b = e.snapGrid.length
                  , y = e.slidesGrid.length
                  , w = i.spaceBetween
                  , x = -v
                  , _ = 0
                  , C = 0;
                if (void 0 !== a) {
                    var S, E;
                    "string" == typeof w && w.indexOf("%") >= 0 && (w = parseFloat(w.replace("%", "")) / 100 * a),
                    e.virtualSize = -w,
                    s ? d.css({
                        marginLeft: "",
                        marginTop: ""
                    }) : d.css({
                        marginRight: "",
                        marginBottom: ""
                    }),
                    i.slidesPerColumn > 1 && (S = Math.floor(p / i.slidesPerColumn) === p / e.params.slidesPerColumn ? p : Math.ceil(p / i.slidesPerColumn) * i.slidesPerColumn,
                    "auto" !== i.slidesPerView && "row" === i.slidesPerColumnFill && (S = Math.max(S, i.slidesPerView * i.slidesPerColumn)));
                    for (var k, O, T, M = i.slidesPerColumn, R = S / M, P = Math.floor(p / i.slidesPerColumn), I = 0; I < p; I += 1) {
                        E = 0;
                        var z = d.eq(I);
                        if (i.slidesPerColumn > 1) {
                            var A = void 0
                              , L = void 0
                              , D = void 0;
                            if ("row" === i.slidesPerColumnFill && i.slidesPerGroup > 1) {
                                var N = Math.floor(I / (i.slidesPerGroup * i.slidesPerColumn))
                                  , W = I - i.slidesPerColumn * i.slidesPerGroup * N
                                  , F = 0 === N ? i.slidesPerGroup : Math.min(Math.ceil((p - N * M * i.slidesPerGroup) / M), i.slidesPerGroup);
                                A = (L = W - (D = Math.floor(W / F)) * F + N * i.slidesPerGroup) + D * S / M,
                                z.css({
                                    "-webkit-box-ordinal-group": A,
                                    "-moz-box-ordinal-group": A,
                                    "-ms-flex-order": A,
                                    "-webkit-order": A,
                                    order: A
                                })
                            } else
                                "column" === i.slidesPerColumnFill ? (D = I - (L = Math.floor(I / M)) * M,
                                (L > P || L === P && D === M - 1) && (D += 1) >= M && (D = 0,
                                L += 1)) : L = I - (D = Math.floor(I / R)) * R;
                            z.css(t("margin-top"), 0 !== D && i.spaceBetween && i.spaceBetween + "px")
                        }
                        if ("none" !== z.css("display")) {
                            if ("auto" === i.slidesPerView) {
                                var $ = r.getComputedStyle(z[0], null)
                                  , B = z[0].style.transform
                                  , j = z[0].style.webkitTransform;
                                if (B && (z[0].style.transform = "none"),
                                j && (z[0].style.webkitTransform = "none"),
                                i.roundLengths)
                                    E = e.isHorizontal() ? z.outerWidth(!0) : z.outerHeight(!0);
                                else {
                                    var H = n($, "width")
                                      , V = n($, "padding-left")
                                      , q = n($, "padding-right")
                                      , U = n($, "margin-left")
                                      , G = n($, "margin-right")
                                      , Z = $.getPropertyValue($, "box-sizing");
                                    if (Z && "border-box" === Z)
                                        E = H + U + G;
                                    else {
                                        var K = z[0]
                                          , Y = K.clientWidth;
                                        E = H + V + q + U + G + (K.offsetWidth - Y)
                                    }
                                }
                                B && (z[0].style.transform = B),
                                j && (z[0].style.webkitTransform = j),
                                i.roundLengths && (E = Math.floor(E))
                            } else
                                E = (a - (i.slidesPerView - 1) * w) / i.slidesPerView,
                                i.roundLengths && (E = Math.floor(E)),
                                d[I] && (d[I].style[t("width")] = E + "px");
                            d[I] && (d[I].swiperSlideSize = E),
                            m.push(E),
                            i.centeredSlides ? (x = x + E / 2 + _ / 2 + w,
                            0 === _ && 0 !== I && (x = x - a / 2 - w),
                            0 === I && (x = x - a / 2 - w),
                            Math.abs(x) < .001 && (x = 0),
                            i.roundLengths && (x = Math.floor(x)),
                            C % i.slidesPerGroup == 0 && f.push(x),
                            h.push(x)) : (i.roundLengths && (x = Math.floor(x)),
                            (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 && f.push(x),
                            h.push(x),
                            x = x + E + w),
                            e.virtualSize += E + w,
                            _ = E,
                            C += 1
                        }
                    }
                    if (e.virtualSize = Math.max(e.virtualSize, a) + g,
                    s && l && ("slide" === i.effect || "coverflow" === i.effect) && o.css({
                        width: e.virtualSize + i.spaceBetween + "px"
                    }),
                    i.setWrapperSize)
                        o.css(((O = {})[t("width")] = e.virtualSize + i.spaceBetween + "px",
                        O));
                    if (i.slidesPerColumn > 1)
                        if (e.virtualSize = (E + i.spaceBetween) * S,
                        e.virtualSize = Math.ceil(e.virtualSize / i.slidesPerColumn) - i.spaceBetween,
                        o.css(((T = {})[t("width")] = e.virtualSize + i.spaceBetween + "px",
                        T)),
                        i.centeredSlides) {
                            k = [];
                            for (var X = 0; X < f.length; X += 1) {
                                var J = f[X];
                                i.roundLengths && (J = Math.floor(J)),
                                f[X] < e.virtualSize + f[0] && k.push(J)
                            }
                            f = k
                        }
                    if (!i.centeredSlides) {
                        k = [];
                        for (var Q = 0; Q < f.length; Q += 1) {
                            var ee = f[Q];
                            i.roundLengths && (ee = Math.floor(ee)),
                            f[Q] <= e.virtualSize - a && k.push(ee)
                        }
                        f = k,
                        Math.floor(e.virtualSize - a) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - a)
                    }
                    if (0 === f.length && (f = [0]),
                    0 !== i.spaceBetween) {
                        var te, ne = e.isHorizontal() && s ? "marginLeft" : t("marginRight");
                        d.filter((function(e, t) {
                            return !i.cssMode || t !== d.length - 1
                        }
                        )).css(((te = {})[ne] = w + "px",
                        te))
                    }
                    if (i.centeredSlides && i.centeredSlidesBounds) {
                        var re = 0;
                        m.forEach((function(e) {
                            re += e + (i.spaceBetween ? i.spaceBetween : 0)
                        }
                        ));
                        var ie = (re -= i.spaceBetween) - a;
                        f = f.map((function(e) {
                            return e < 0 ? -v : e > ie ? ie + g : e
                        }
                        ))
                    }
                    if (i.centerInsufficientSlides) {
                        var oe = 0;
                        if (m.forEach((function(e) {
                            oe += e + (i.spaceBetween ? i.spaceBetween : 0)
                        }
                        )),
                        (oe -= i.spaceBetween) < a) {
                            var ae = (a - oe) / 2;
                            f.forEach((function(e, t) {
                                f[t] = e - ae
                            }
                            )),
                            h.forEach((function(e, t) {
                                h[t] = e + ae
                            }
                            ))
                        }
                    }
                    nb(e, {
                        slides: d,
                        snapGrid: f,
                        slidesGrid: h,
                        slidesSizesGrid: m
                    }),
                    p !== u && e.emit("slidesLengthChange"),
                    f.length !== b && (e.params.watchOverflow && e.checkOverflow(),
                    e.emit("snapGridLengthChange")),
                    h.length !== y && e.emit("slidesGridLengthChange"),
                    (i.watchSlidesProgress || i.watchSlidesVisibility) && e.updateSlidesOffset()
                }
            },
            updateAutoHeight: function(e) {
                var t, n = this, r = [], i = 0;
                if ("number" == typeof e ? n.setTransition(e) : !0 === e && n.setTransition(n.params.speed),
                "auto" !== n.params.slidesPerView && n.params.slidesPerView > 1)
                    if (n.params.centeredSlides)
                        n.visibleSlides.each((function(e) {
                            r.push(e)
                        }
                        ));
                    else
                        for (t = 0; t < Math.ceil(n.params.slidesPerView); t += 1) {
                            var o = n.activeIndex + t;
                            if (o > n.slides.length)
                                break;
                            r.push(n.slides.eq(o)[0])
                        }
                else
                    r.push(n.slides.eq(n.activeIndex)[0]);
                for (t = 0; t < r.length; t += 1)
                    if (void 0 !== r[t]) {
                        var a = r[t].offsetHeight;
                        i = a > i ? a : i
                    }
                i && n.$wrapperEl.css("height", i + "px")
            },
            updateSlidesOffset: function() {
                for (var e = this.slides, t = 0; t < e.length; t += 1)
                    e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop
            },
            updateSlidesProgress: function(e) {
                void 0 === e && (e = this && this.translate || 0);
                var t = this
                  , n = t.params
                  , r = t.slides
                  , i = t.rtlTranslate;
                if (0 !== r.length) {
                    void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
                    var o = -e;
                    i && (o = e),
                    r.removeClass(n.slideVisibleClass),
                    t.visibleSlidesIndexes = [],
                    t.visibleSlides = [];
                    for (var a = 0; a < r.length; a += 1) {
                        var s = r[a]
                          , l = (o + (n.centeredSlides ? t.minTranslate() : 0) - s.swiperSlideOffset) / (s.swiperSlideSize + n.spaceBetween);
                        if (n.watchSlidesVisibility || n.centeredSlides && n.autoHeight) {
                            var c = -(o - s.swiperSlideOffset)
                              , u = c + t.slidesSizesGrid[a];
                            (c >= 0 && c < t.size - 1 || u > 1 && u <= t.size || c <= 0 && u >= t.size) && (t.visibleSlides.push(s),
                            t.visibleSlidesIndexes.push(a),
                            r.eq(a).addClass(n.slideVisibleClass))
                        }
                        s.progress = i ? -l : l
                    }
                    t.visibleSlides = Jg(t.visibleSlides)
                }
            },
            updateProgress: function(e) {
                var t = this;
                if (void 0 === e) {
                    var n = t.rtlTranslate ? -1 : 1;
                    e = t && t.translate && t.translate * n || 0
                }
                var r = t.params
                  , i = t.maxTranslate() - t.minTranslate()
                  , o = t.progress
                  , a = t.isBeginning
                  , s = t.isEnd
                  , l = a
                  , c = s;
                0 === i ? (o = 0,
                a = !0,
                s = !0) : (a = (o = (e - t.minTranslate()) / i) <= 0,
                s = o >= 1),
                nb(t, {
                    progress: o,
                    isBeginning: a,
                    isEnd: s
                }),
                (r.watchSlidesProgress || r.watchSlidesVisibility || r.centeredSlides && r.autoHeight) && t.updateSlidesProgress(e),
                a && !l && t.emit("reachBeginning toEdge"),
                s && !c && t.emit("reachEnd toEdge"),
                (l && !a || c && !s) && t.emit("fromEdge"),
                t.emit("progress", o)
            },
            updateSlidesClasses: function() {
                var e, t = this, n = t.slides, r = t.params, i = t.$wrapperEl, o = t.activeIndex, a = t.realIndex, s = t.virtual && r.virtual.enabled;
                n.removeClass(r.slideActiveClass + " " + r.slideNextClass + " " + r.slidePrevClass + " " + r.slideDuplicateActiveClass + " " + r.slideDuplicateNextClass + " " + r.slideDuplicatePrevClass),
                (e = s ? t.$wrapperEl.find("." + r.slideClass + '[data-pwzrswiper-slide-index="' + o + '"]') : n.eq(o)).addClass(r.slideActiveClass),
                r.loop && (e.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + a + '"]').addClass(r.slideDuplicateActiveClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + a + '"]').addClass(r.slideDuplicateActiveClass));
                var l = e.nextAll("." + r.slideClass).eq(0).addClass(r.slideNextClass);
                r.loop && 0 === l.length && (l = n.eq(0)).addClass(r.slideNextClass);
                var c = e.prevAll("." + r.slideClass).eq(0).addClass(r.slidePrevClass);
                r.loop && 0 === c.length && (c = n.eq(-1)).addClass(r.slidePrevClass),
                r.loop && (l.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + l.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + l.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass),
                c.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + c.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + c.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass)),
                t.emitSlidesClasses()
            },
            updateActiveIndex: function(e) {
                var t, n = this, r = n.rtlTranslate ? n.translate : -n.translate, i = n.slidesGrid, o = n.snapGrid, a = n.params, s = n.activeIndex, l = n.realIndex, c = n.snapIndex, u = e;
                if (void 0 === u) {
                    for (var d = 0; d < i.length; d += 1)
                        void 0 !== i[d + 1] ? r >= i[d] && r < i[d + 1] - (i[d + 1] - i[d]) / 2 ? u = d : r >= i[d] && r < i[d + 1] && (u = d + 1) : r >= i[d] && (u = d);
                    a.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0)
                }
                if (o.indexOf(r) >= 0)
                    t = o.indexOf(r);
                else {
                    var p = Math.min(a.slidesPerGroupSkip, u);
                    t = p + Math.floor((u - p) / a.slidesPerGroup)
                }
                if (t >= o.length && (t = o.length - 1),
                u !== s) {
                    var f = parseInt(n.slides.eq(u).attr("data-pwzrswiper-slide-index") || u, 10);
                    nb(n, {
                        snapIndex: t,
                        realIndex: f,
                        previousIndex: s,
                        activeIndex: u
                    }),
                    n.emit("activeIndexChange"),
                    n.emit("snapIndexChange"),
                    l !== f && n.emit("realIndexChange"),
                    (n.initialized || n.params.runCallbacksOnInit) && n.emit("slideChange")
                } else
                    t !== c && (n.snapIndex = t,
                    n.emit("snapIndexChange"))
            },
            updateClickedSlide: function(e) {
                var t, n = this, r = n.params, i = Jg(e.target).closest("." + r.slideClass)[0], o = !1;
                if (i)
                    for (var a = 0; a < n.slides.length; a += 1)
                        if (n.slides[a] === i) {
                            o = !0,
                            t = a;
                            break
                        }
                if (!i || !o)
                    return n.clickedSlide = void 0,
                    void (n.clickedIndex = void 0);
                n.clickedSlide = i,
                n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(Jg(i).attr("data-pwzrswiper-slide-index"), 10) : n.clickedIndex = t,
                r.slideToClickedSlide && void 0 !== n.clickedIndex && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide()
            }
        },
        translate: {
            getTranslate: function(e) {
                void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                var t = this
                  , n = t.params
                  , r = t.rtlTranslate
                  , i = t.translate
                  , o = t.$wrapperEl;
                if (n.virtualTranslate)
                    return r ? -i : i;
                if (n.cssMode)
                    return i;
                var a = function(e, t) {
                    void 0 === t && (t = "x");
                    var n, r, i, o = Dg(), a = o.getComputedStyle(e, null);
                    return o.WebKitCSSMatrix ? ((r = a.transform || a.webkitTransform).split(",").length > 6 && (r = r.split(", ").map((function(e) {
                        return e.replace(",", ".")
                    }
                    )).join(", ")),
                    i = new o.WebKitCSSMatrix("none" === r ? "" : r)) : n = (i = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","),
                    "x" === t && (r = o.WebKitCSSMatrix ? i.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])),
                    "y" === t && (r = o.WebKitCSSMatrix ? i.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])),
                    r || 0
                }(o[0], e);
                return r && (a = -a),
                a || 0
            },
            setTranslate: function(e, t) {
                var n = this
                  , r = n.rtlTranslate
                  , i = n.params
                  , o = n.$wrapperEl
                  , a = n.wrapperEl
                  , s = n.progress
                  , l = 0
                  , c = 0;
                n.isHorizontal() ? l = r ? -e : e : c = e,
                i.roundLengths && (l = Math.floor(l),
                c = Math.floor(c)),
                i.cssMode ? a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -c : i.virtualTranslate || o.transform("translate3d(" + l + "px, " + c + "px, 0px)"),
                n.previousTranslate = n.translate,
                n.translate = n.isHorizontal() ? l : c;
                var u = n.maxTranslate() - n.minTranslate();
                (0 === u ? 0 : (e - n.minTranslate()) / u) !== s && n.updateProgress(e),
                n.emit("setTranslate", n.translate, t)
            },
            minTranslate: function() {
                return -this.snapGrid[0]
            },
            maxTranslate: function() {
                return -this.snapGrid[this.snapGrid.length - 1]
            },
            translateTo: function(e, t, n, r, i) {
                void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === n && (n = !0),
                void 0 === r && (r = !0);
                var o = this
                  , a = o.params
                  , s = o.wrapperEl;
                if (o.animating && a.preventInteractionOnTransition)
                    return !1;
                var l, c = o.minTranslate(), u = o.maxTranslate();
                if (l = r && e > c ? c : r && e < u ? u : e,
                o.updateProgress(l),
                a.cssMode) {
                    var d, p = o.isHorizontal();
                    if (0 === t)
                        s[p ? "scrollLeft" : "scrollTop"] = -l;
                    else if (s.scrollTo)
                        s.scrollTo(((d = {})[p ? "left" : "top"] = -l,
                        d.behavior = "smooth",
                        d));
                    else
                        s[p ? "scrollLeft" : "scrollTop"] = -l;
                    return !0
                }
                return 0 === t ? (o.setTransition(0),
                o.setTranslate(l),
                n && (o.emit("beforeTransitionStart", t, i),
                o.emit("transitionEnd"))) : (o.setTransition(t),
                o.setTranslate(l),
                n && (o.emit("beforeTransitionStart", t, i),
                o.emit("transitionStart")),
                o.animating || (o.animating = !0,
                o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(e) {
                    o && !o.destroyed && e.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                    o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd),
                    o.onTranslateToWrapperTransitionEnd = null,
                    delete o.onTranslateToWrapperTransitionEnd,
                    n && o.emit("transitionEnd"))
                }
                ),
                o.$wrapperEl[0].addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd))),
                !0
            }
        },
        transition: {
            setTransition: function(e, t) {
                var n = this;
                n.params.cssMode || n.$wrapperEl.transition(e),
                n.emit("setTransition", e, t)
            },
            transitionStart: function(e, t) {
                void 0 === e && (e = !0);
                var n = this
                  , r = n.activeIndex
                  , i = n.params
                  , o = n.previousIndex;
                if (!i.cssMode) {
                    i.autoHeight && n.updateAutoHeight();
                    var a = t;
                    if (a || (a = r > o ? "next" : r < o ? "prev" : "reset"),
                    n.emit("transitionStart"),
                    e && r !== o) {
                        if ("reset" === a)
                            return void n.emit("slideResetTransitionStart");
                        n.emit("slideChangeTransitionStart"),
                        "next" === a ? n.emit("slideNextTransitionStart") : n.emit("slidePrevTransitionStart")
                    }
                }
            },
            transitionEnd: function(e, t) {
                void 0 === e && (e = !0);
                var n = this
                  , r = n.activeIndex
                  , i = n.previousIndex
                  , o = n.params;
                if (n.animating = !1,
                !o.cssMode) {
                    n.setTransition(0);
                    var a = t;
                    if (a || (a = r > i ? "next" : r < i ? "prev" : "reset"),
                    n.emit("transitionEnd"),
                    e && r !== i) {
                        if ("reset" === a)
                            return void n.emit("slideResetTransitionEnd");
                        n.emit("slideChangeTransitionEnd"),
                        "next" === a ? n.emit("slideNextTransitionEnd") : n.emit("slidePrevTransitionEnd")
                    }
                }
            }
        },
        slide: {
            slideTo: function(e, t, n, r) {
                if (void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === n && (n = !0),
                "number" != typeof e && "string" != typeof e)
                    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof e + "] given.");
                if ("string" == typeof e) {
                    var i = parseInt(e, 10);
                    if (!isFinite(i))
                        throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + e + "] given.");
                    e = i
                }
                var o = this
                  , a = e;
                a < 0 && (a = 0);
                var s = o.params
                  , l = o.snapGrid
                  , c = o.slidesGrid
                  , u = o.previousIndex
                  , d = o.activeIndex
                  , p = o.rtlTranslate
                  , f = o.wrapperEl;
                if (o.animating && s.preventInteractionOnTransition)
                    return !1;
                var h = Math.min(o.params.slidesPerGroupSkip, a)
                  , m = h + Math.floor((a - h) / o.params.slidesPerGroup);
                m >= l.length && (m = l.length - 1),
                (d || s.initialSlide || 0) === (u || 0) && n && o.emit("beforeSlideChangeStart");
                var v, g = -l[m];
                if (o.updateProgress(g),
                s.normalizeSlideIndex)
                    for (var b = 0; b < c.length; b += 1) {
                        var y = -Math.floor(100 * g)
                          , w = Math.floor(100 * c[b])
                          , x = Math.floor(100 * c[b + 1]);
                        void 0 !== c[b + 1] ? y >= w && y < x - (x - w) / 2 ? a = b : y >= w && y < x && (a = b + 1) : y >= w && (a = b)
                    }
                if (o.initialized && a !== d) {
                    if (!o.allowSlideNext && g < o.translate && g < o.minTranslate())
                        return !1;
                    if (!o.allowSlidePrev && g > o.translate && g > o.maxTranslate() && (d || 0) !== a)
                        return !1
                }
                if (v = a > d ? "next" : a < d ? "prev" : "reset",
                p && -g === o.translate || !p && g === o.translate)
                    return o.updateActiveIndex(a),
                    s.autoHeight && o.updateAutoHeight(),
                    o.updateSlidesClasses(),
                    "slide" !== s.effect && o.setTranslate(g),
                    "reset" !== v && (o.transitionStart(n, v),
                    o.transitionEnd(n, v)),
                    !1;
                if (s.cssMode) {
                    var _, C = o.isHorizontal(), S = -g;
                    if (p && (S = f.scrollWidth - f.offsetWidth - S),
                    0 === t)
                        f[C ? "scrollLeft" : "scrollTop"] = S;
                    else if (f.scrollTo)
                        f.scrollTo(((_ = {})[C ? "left" : "top"] = S,
                        _.behavior = "smooth",
                        _));
                    else
                        f[C ? "scrollLeft" : "scrollTop"] = S;
                    return !0
                }
                return 0 === t ? (o.setTransition(0),
                o.setTranslate(g),
                o.updateActiveIndex(a),
                o.updateSlidesClasses(),
                o.emit("beforeTransitionStart", t, r),
                o.transitionStart(n, v),
                o.transitionEnd(n, v)) : (o.setTransition(t),
                o.setTranslate(g),
                o.updateActiveIndex(a),
                o.updateSlidesClasses(),
                o.emit("beforeTransitionStart", t, r),
                o.transitionStart(n, v),
                o.animating || (o.animating = !0,
                o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(e) {
                    o && !o.destroyed && e.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd),
                    o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd),
                    o.onSlideToWrapperTransitionEnd = null,
                    delete o.onSlideToWrapperTransitionEnd,
                    o.transitionEnd(n, v))
                }
                ),
                o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd),
                o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd))),
                !0
            },
            slideToLoop: function(e, t, n, r) {
                void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === n && (n = !0);
                var i = this
                  , o = e;
                return i.params.loop && (o += i.loopedSlides),
                i.slideTo(o, t, n, r)
            },
            slideNext: function(e, t, n) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0);
                var r = this
                  , i = r.params
                  , o = r.animating
                  , a = r.activeIndex < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup;
                if (i.loop) {
                    if (o && i.loopPreventsSlide)
                        return !1;
                    r.loopFix(),
                    r._clientLeft = r.$wrapperEl[0].clientLeft
                }
                return r.slideTo(r.activeIndex + a, e, t, n)
            },
            slidePrev: function(e, t, n) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0);
                var r = this
                  , i = r.params
                  , o = r.animating
                  , a = r.snapGrid
                  , s = r.slidesGrid
                  , l = r.rtlTranslate;
                if (i.loop) {
                    if (o && i.loopPreventsSlide)
                        return !1;
                    r.loopFix(),
                    r._clientLeft = r.$wrapperEl[0].clientLeft
                }
                function c(e) {
                    return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
                }
                var u, d = c(l ? r.translate : -r.translate), p = a.map((function(e) {
                    return c(e)
                }
                )), f = (a[p.indexOf(d)],
                a[p.indexOf(d) - 1]);
                return void 0 === f && i.cssMode && a.forEach((function(e) {
                    !f && d >= e && (f = e)
                }
                )),
                void 0 !== f && (u = s.indexOf(f)) < 0 && (u = r.activeIndex - 1),
                r.slideTo(u, e, t, n)
            },
            slideReset: function(e, t, n) {
                return void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                this.slideTo(this.activeIndex, e, t, n)
            },
            slideToClosest: function(e, t, n, r) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                void 0 === r && (r = .5);
                var i = this
                  , o = i.activeIndex
                  , a = Math.min(i.params.slidesPerGroupSkip, o)
                  , s = a + Math.floor((o - a) / i.params.slidesPerGroup)
                  , l = i.rtlTranslate ? i.translate : -i.translate;
                if (l >= i.snapGrid[s]) {
                    var c = i.snapGrid[s];
                    l - c > (i.snapGrid[s + 1] - c) * r && (o += i.params.slidesPerGroup)
                } else {
                    var u = i.snapGrid[s - 1];
                    l - u <= (i.snapGrid[s] - u) * r && (o -= i.params.slidesPerGroup)
                }
                return o = Math.max(o, 0),
                o = Math.min(o, i.slidesGrid.length - 1),
                i.slideTo(o, e, t, n)
            },
            slideToClickedSlide: function() {
                var e, t = this, n = t.params, r = t.$wrapperEl, i = "auto" === n.slidesPerView ? t.slidesPerViewDynamic() : n.slidesPerView, o = t.clickedIndex;
                if (n.loop) {
                    if (t.animating)
                        return;
                    e = parseInt(Jg(t.clickedSlide).attr("data-pwzrswiper-slide-index"), 10),
                    n.centeredSlides ? o < t.loopedSlides - i / 2 || o > t.slides.length - t.loopedSlides + i / 2 ? (t.loopFix(),
                    o = r.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")").eq(0).index(),
                    Qg((function() {
                        t.slideTo(o)
                    }
                    ))) : t.slideTo(o) : o > t.slides.length - i ? (t.loopFix(),
                    o = r.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")").eq(0).index(),
                    Qg((function() {
                        t.slideTo(o)
                    }
                    ))) : t.slideTo(o)
                } else
                    t.slideTo(o)
            }
        },
        loop: {
            loopCreate: function() {
                var e = this
                  , t = Ag()
                  , n = e.params
                  , r = e.$wrapperEl;
                r.children("." + n.slideClass + "." + n.slideDuplicateClass).remove();
                var i = r.children("." + n.slideClass);
                if (n.loopFillGroupWithBlank) {
                    var o = n.slidesPerGroup - i.length % n.slidesPerGroup;
                    if (o !== n.slidesPerGroup) {
                        for (var a = 0; a < o; a += 1) {
                            var s = Jg(t.createElement("div")).addClass(n.slideClass + " " + n.slideBlankClass);
                            r.append(s)
                        }
                        i = r.children("." + n.slideClass)
                    }
                }
                "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = i.length),
                e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10)),
                e.loopedSlides += n.loopAdditionalSlides,
                e.loopedSlides > i.length && (e.loopedSlides = i.length);
                var l = []
                  , c = [];
                i.each((function(t, n) {
                    var r = Jg(t);
                    n < e.loopedSlides && c.push(t),
                    n < i.length && n >= i.length - e.loopedSlides && l.push(t),
                    r.attr("data-pwzrswiper-slide-index", n)
                }
                ));
                for (var u = 0; u < c.length; u += 1)
                    r.append(Jg(c[u].cloneNode(!0)).addClass(n.slideDuplicateClass));
                for (var d = l.length - 1; d >= 0; d -= 1)
                    r.prepend(Jg(l[d].cloneNode(!0)).addClass(n.slideDuplicateClass))
            },
            loopFix: function() {
                var e = this;
                e.emit("beforeLoopFix");
                var t, n = e.activeIndex, r = e.slides, i = e.loopedSlides, o = e.allowSlidePrev, a = e.allowSlideNext, s = e.snapGrid, l = e.rtlTranslate;
                e.allowSlidePrev = !0,
                e.allowSlideNext = !0;
                var c = -s[n] - e.getTranslate();
                if (n < i)
                    t = r.length - 3 * i + n,
                    t += i,
                    e.slideTo(t, 0, !1, !0) && 0 !== c && e.setTranslate((l ? -e.translate : e.translate) - c);
                else if (n >= r.length - i) {
                    t = -r.length + n + i,
                    t += i,
                    e.slideTo(t, 0, !1, !0) && 0 !== c && e.setTranslate((l ? -e.translate : e.translate) - c)
                }
                e.allowSlidePrev = o,
                e.allowSlideNext = a,
                e.emit("loopFix")
            },
            loopDestroy: function() {
                var e = this
                  , t = e.$wrapperEl
                  , n = e.params
                  , r = e.slides;
                t.children("." + n.slideClass + "." + n.slideDuplicateClass + ",." + n.slideClass + "." + n.slideBlankClass).remove(),
                r.removeAttr("data-pwzrswiper-slide-index")
            }
        },
        grabCursor: {
            setGrabCursor: function(e) {
                var t = this;
                if (!(t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)) {
                    var n = t.el;
                    n.style.cursor = "move",
                    n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab",
                    n.style.cursor = e ? "-moz-grabbin" : "-moz-grab",
                    n.style.cursor = e ? "grabbing" : "grab"
                }
            },
            unsetGrabCursor: function() {
                var e = this;
                e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.el.style.cursor = "")
            }
        },
        manipulation: {
            appendSlide: function(e) {
                var t = this
                  , n = t.$wrapperEl
                  , r = t.params;
                if (r.loop && t.loopDestroy(),
                "object" == typeof e && "length"in e)
                    for (var i = 0; i < e.length; i += 1)
                        e[i] && n.append(e[i]);
                else
                    n.append(e);
                r.loop && t.loopCreate(),
                r.observer && t.support.observer || t.update()
            },
            prependSlide: function(e) {
                var t = this
                  , n = t.params
                  , r = t.$wrapperEl
                  , i = t.activeIndex;
                n.loop && t.loopDestroy();
                var o = i + 1;
                if ("object" == typeof e && "length"in e) {
                    for (var a = 0; a < e.length; a += 1)
                        e[a] && r.prepend(e[a]);
                    o = i + e.length
                } else
                    r.prepend(e);
                n.loop && t.loopCreate(),
                n.observer && t.support.observer || t.update(),
                t.slideTo(o, 0, !1)
            },
            addSlide: function(e, t) {
                var n = this
                  , r = n.$wrapperEl
                  , i = n.params
                  , o = n.activeIndex;
                i.loop && (o -= n.loopedSlides,
                n.loopDestroy(),
                n.slides = r.children("." + i.slideClass));
                var a = n.slides.length;
                if (e <= 0)
                    n.prependSlide(t);
                else if (e >= a)
                    n.appendSlide(t);
                else {
                    for (var s = o > e ? o + 1 : o, l = [], c = a - 1; c >= e; c -= 1) {
                        var u = n.slides.eq(c);
                        u.remove(),
                        l.unshift(u)
                    }
                    if ("object" == typeof t && "length"in t) {
                        for (var d = 0; d < t.length; d += 1)
                            t[d] && r.append(t[d]);
                        s = o > e ? o + t.length : o
                    } else
                        r.append(t);
                    for (var p = 0; p < l.length; p += 1)
                        r.append(l[p]);
                    i.loop && n.loopCreate(),
                    i.observer && n.support.observer || n.update(),
                    i.loop ? n.slideTo(s + n.loopedSlides, 0, !1) : n.slideTo(s, 0, !1)
                }
            },
            removeSlide: function(e) {
                var t = this
                  , n = t.params
                  , r = t.$wrapperEl
                  , i = t.activeIndex;
                n.loop && (i -= t.loopedSlides,
                t.loopDestroy(),
                t.slides = r.children("." + n.slideClass));
                var o, a = i;
                if ("object" == typeof e && "length"in e) {
                    for (var s = 0; s < e.length; s += 1)
                        o = e[s],
                        t.slides[o] && t.slides.eq(o).remove(),
                        o < a && (a -= 1);
                    a = Math.max(a, 0)
                } else
                    o = e,
                    t.slides[o] && t.slides.eq(o).remove(),
                    o < a && (a -= 1),
                    a = Math.max(a, 0);
                n.loop && t.loopCreate(),
                n.observer && t.support.observer || t.update(),
                n.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1)
            },
            removeAllSlides: function() {
                for (var e = [], t = 0; t < this.slides.length; t += 1)
                    e.push(t);
                this.removeSlide(e)
            }
        },
        events: {
            attachEvents: function() {
                var e = this
                  , t = Ag()
                  , n = e.params
                  , r = e.touchEvents
                  , i = e.el
                  , o = e.wrapperEl
                  , a = e.device
                  , s = e.support;
                e.onTouchStart = db.bind(e),
                e.onTouchMove = pb.bind(e),
                e.onTouchEnd = fb.bind(e),
                n.cssMode && (e.onScroll = vb.bind(e)),
                e.onClick = mb.bind(e);
                var l = !!n.nested;
                if (!s.touch && s.pointerEvents)
                    i.addEventListener(r.start, e.onTouchStart, !1),
                    t.addEventListener(r.move, e.onTouchMove, l),
                    t.addEventListener(r.end, e.onTouchEnd, !1);
                else {
                    if (s.touch) {
                        var c = !("touchstart" !== r.start || !s.passiveListener || !n.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        i.addEventListener(r.start, e.onTouchStart, c),
                        i.addEventListener(r.move, e.onTouchMove, s.passiveListener ? {
                            passive: !1,
                            capture: l
                        } : l),
                        i.addEventListener(r.end, e.onTouchEnd, c),
                        r.cancel && i.addEventListener(r.cancel, e.onTouchEnd, c),
                        gb || (t.addEventListener("touchstart", bb),
                        gb = !0)
                    }
                    (n.simulateTouch && !a.ios && !a.android || n.simulateTouch && !s.touch && a.ios) && (i.addEventListener("mousedown", e.onTouchStart, !1),
                    t.addEventListener("mousemove", e.onTouchMove, l),
                    t.addEventListener("mouseup", e.onTouchEnd, !1))
                }
                (n.preventClicks || n.preventClicksPropagation) && i.addEventListener("click", e.onClick, !0),
                n.cssMode && o.addEventListener("scroll", e.onScroll),
                n.updateOnWindowResize ? e.on(a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", hb, !0) : e.on("observerUpdate", hb, !0)
            },
            detachEvents: function() {
                var e = this
                  , t = Ag()
                  , n = e.params
                  , r = e.touchEvents
                  , i = e.el
                  , o = e.wrapperEl
                  , a = e.device
                  , s = e.support
                  , l = !!n.nested;
                if (!s.touch && s.pointerEvents)
                    i.removeEventListener(r.start, e.onTouchStart, !1),
                    t.removeEventListener(r.move, e.onTouchMove, l),
                    t.removeEventListener(r.end, e.onTouchEnd, !1);
                else {
                    if (s.touch) {
                        var c = !("onTouchStart" !== r.start || !s.passiveListener || !n.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        i.removeEventListener(r.start, e.onTouchStart, c),
                        i.removeEventListener(r.move, e.onTouchMove, l),
                        i.removeEventListener(r.end, e.onTouchEnd, c),
                        r.cancel && i.removeEventListener(r.cancel, e.onTouchEnd, c)
                    }
                    (n.simulateTouch && !a.ios && !a.android || n.simulateTouch && !s.touch && a.ios) && (i.removeEventListener("mousedown", e.onTouchStart, !1),
                    t.removeEventListener("mousemove", e.onTouchMove, l),
                    t.removeEventListener("mouseup", e.onTouchEnd, !1))
                }
                (n.preventClicks || n.preventClicksPropagation) && i.removeEventListener("click", e.onClick, !0),
                n.cssMode && o.removeEventListener("scroll", e.onScroll),
                e.off(a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", hb)
            }
        },
        breakpoints: {
            setBreakpoint: function() {
                var e = this
                  , t = e.activeIndex
                  , n = e.initialized
                  , r = e.loopedSlides
                  , i = void 0 === r ? 0 : r
                  , o = e.params
                  , a = e.$el
                  , s = o.breakpoints;
                if (s && (!s || 0 !== Object.keys(s).length)) {
                    var l = e.getBreakpoint(s, e.params.breakpointsBase, e.el);
                    if (l && e.currentBreakpoint !== l) {
                        var c = l in s ? s[l] : void 0;
                        c && ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach((function(e) {
                            var t = c[e];
                            void 0 !== t && (c[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto")
                        }
                        ));
                        var u = c || e.originalParams
                          , d = o.slidesPerColumn > 1
                          , p = u.slidesPerColumn > 1;
                        d && !p ? (a.removeClass(o.containerModifierClass + "multirow " + o.containerModifierClass + "multirow-column"),
                        e.emitContainerClasses()) : !d && p && (a.addClass(o.containerModifierClass + "multirow"),
                        "column" === u.slidesPerColumnFill && a.addClass(o.containerModifierClass + "multirow-column"),
                        e.emitContainerClasses());
                        var f = u.direction && u.direction !== o.direction
                          , h = o.loop && (u.slidesPerView !== o.slidesPerView || f);
                        f && n && e.changeDirection(),
                        nb(e.params, u),
                        nb(e, {
                            allowTouchMove: e.params.allowTouchMove,
                            allowSlideNext: e.params.allowSlideNext,
                            allowSlidePrev: e.params.allowSlidePrev
                        }),
                        e.currentBreakpoint = l,
                        e.emit("_beforeBreakpoint", u),
                        h && n && (e.loopDestroy(),
                        e.loopCreate(),
                        e.updateSlides(),
                        e.slideTo(t - i + e.loopedSlides, 0, !1)),
                        e.emit("breakpoint", u)
                    }
                }
            },
            getBreakpoint: function(e, t, n) {
                if (void 0 === t && (t = "window"),
                e && ("container" !== t || n)) {
                    var r = !1
                      , i = Dg()
                      , o = "window" === t ? i.innerWidth : n.clientWidth
                      , a = "window" === t ? i.innerHeight : n.clientHeight
                      , s = Object.keys(e).map((function(e) {
                        if ("string" == typeof e && 0 === e.indexOf("@")) {
                            var t = parseFloat(e.substr(1));
                            return {
                                value: a * t,
                                point: e
                            }
                        }
                        return {
                            value: e,
                            point: e
                        }
                    }
                    ));
                    s.sort((function(e, t) {
                        return parseInt(e.value, 10) - parseInt(t.value, 10)
                    }
                    ));
                    for (var l = 0; l < s.length; l += 1) {
                        var c = s[l]
                          , u = c.point;
                        c.value <= o && (r = u)
                    }
                    return r || "max"
                }
            }
        },
        checkOverflow: {
            checkOverflow: function() {
                var e = this
                  , t = e.params
                  , n = e.isLocked
                  , r = e.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e.slides.length - 1) + e.slides[0].offsetWidth * e.slides.length;
                t.slidesOffsetBefore && t.slidesOffsetAfter && r ? e.isLocked = r <= e.size : e.isLocked = 1 === e.snapGrid.length,
                e.allowSlideNext = !e.isLocked,
                e.allowSlidePrev = !e.isLocked,
                n !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
                n && n !== e.isLocked && (e.isEnd = !1,
                e.navigation && e.navigation.update())
            }
        },
        classes: {
            addClasses: function() {
                var e, t, n, r = this, i = r.classNames, o = r.params, a = r.rtl, s = r.$el, l = r.device, c = r.support, u = (e = ["initialized", o.direction, {
                    "pointer-events": c.pointerEvents && !c.touch
                }, {
                    "free-mode": o.freeMode
                }, {
                    autoheight: o.autoHeight
                }, {
                    rtl: a
                }, {
                    multirow: o.slidesPerColumn > 1
                }, {
                    "multirow-column": o.slidesPerColumn > 1 && "column" === o.slidesPerColumnFill
                }, {
                    android: l.android
                }, {
                    ios: l.ios
                }, {
                    "css-mode": o.cssMode
                }],
                t = o.containerModifierClass,
                n = [],
                e.forEach((function(e) {
                    "object" == typeof e ? Object.entries(e).forEach((function(e) {
                        var r = e[0];
                        e[1] && n.push(t + r)
                    }
                    )) : "string" == typeof e && n.push(t + e)
                }
                )),
                n);
                i.push.apply(i, u),
                s.addClass([].concat(i).join(" ")),
                r.emitContainerClasses()
            },
            removeClasses: function() {
                var e = this
                  , t = e.$el
                  , n = e.classNames;
                t.removeClass(n.join(" ")),
                e.emitContainerClasses()
            }
        },
        images: {
            loadImage: function(e, t, n, r, i, o) {
                var a, s = Dg();
                function l() {
                    o && o()
                }
                Jg(e).parent("picture")[0] || e.complete && i ? l() : t ? ((a = new s.Image).onload = l,
                a.onerror = l,
                r && (a.sizes = r),
                n && (a.srcset = n),
                t && (a.src = t)) : l()
            },
            preloadImages: function() {
                var e = this;
                function t() {
                    null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                    e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(),
                    e.emit("imagesReady")))
                }
                e.imagesToLoad = e.$el.find("img");
                for (var n = 0; n < e.imagesToLoad.length; n += 1) {
                    var r = e.imagesToLoad[n];
                    e.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, t)
                }
            }
        }
    }
      , _b = {}
      , Cb = function() {
        function e() {
            for (var t, n, r = arguments.length, i = new Array(r), o = 0; o < r; o++)
                i[o] = arguments[o];
            if (1 === i.length && i[0].constructor && i[0].constructor === Object ? n = i[0] : (t = i[0],
            n = i[1]),
            n || (n = {}),
            n = nb({}, n),
            t && !n.el && (n.el = t),
            n.el && Jg(n.el).length > 1) {
                var a = [];
                return Jg(n.el).each((function(t) {
                    var r = nb({}, n, {
                        el: t
                    });
                    a.push(new e(r))
                }
                )),
                a
            }
            var s = this;
            s.support = ib(),
            s.device = ob({
                userAgent: n.userAgent
            }),
            s.browser = ab(),
            s.eventsListeners = {},
            s.eventsAnyListeners = [],
            void 0 === s.modules && (s.modules = {}),
            Object.keys(s.modules).forEach((function(e) {
                var t = s.modules[e];
                if (t.params) {
                    var r = Object.keys(t.params)[0]
                      , i = t.params[r];
                    if ("object" != typeof i || null === i)
                        return;
                    if (!(r in n) || !("enabled"in i))
                        return;
                    !0 === n[r] && (n[r] = {
                        enabled: !0
                    }),
                    "object" != typeof n[r] || "enabled"in n[r] || (n[r].enabled = !0),
                    n[r] || (n[r] = {
                        enabled: !1
                    })
                }
            }
            ));
            var l, c, u = nb({}, yb);
            return s.useParams(u),
            s.params = nb({}, u, _b, n),
            s.originalParams = nb({}, s.params),
            s.passedParams = nb({}, n),
            s.params && s.params.on && Object.keys(s.params.on).forEach((function(e) {
                s.on(e, s.params.on[e])
            }
            )),
            s.params && s.params.onAny && s.onAny(s.params.onAny),
            s.$ = Jg,
            nb(s, {
                el: t,
                classNames: [],
                slides: Jg(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: function() {
                    return "horizontal" === s.params.direction
                },
                isVertical: function() {
                    return "vertical" === s.params.direction
                },
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: s.params.allowSlideNext,
                allowSlidePrev: s.params.allowSlidePrev,
                touchEvents: (l = ["touchstart", "touchmove", "touchend", "touchcancel"],
                c = ["mousedown", "mousemove", "mouseup"],
                s.support.pointerEvents && (c = ["pointerdown", "pointermove", "pointerup"]),
                s.touchEventsTouch = {
                    start: l[0],
                    move: l[1],
                    end: l[2],
                    cancel: l[3]
                },
                s.touchEventsDesktop = {
                    start: c[0],
                    move: c[1],
                    end: c[2]
                },
                s.support.touch || !s.params.simulateTouch ? s.touchEventsTouch : s.touchEventsDesktop),
                touchEventsData: {
                    isTouched: void 0,
                    isMoved: void 0,
                    allowTouchCallbacks: void 0,
                    touchStartTime: void 0,
                    isScrolling: void 0,
                    currentTranslate: void 0,
                    startTranslate: void 0,
                    allowThresholdMove: void 0,
                    formElements: "input, select, option, textarea, button, video, label",
                    lastClickTime: eb(),
                    clickTimeout: void 0,
                    velocities: [],
                    allowMomentumBounce: void 0,
                    isTouchEvent: void 0,
                    startMoving: void 0
                },
                allowClick: !0,
                allowTouchMove: s.params.allowTouchMove,
                touches: {
                    startX: 0,
                    startY: 0,
                    currentX: 0,
                    currentY: 0,
                    diff: 0
                },
                imagesToLoad: [],
                imagesLoaded: 0
            }),
            s.useModules(),
            s.emit("_swiper"),
            s.params.init && s.init(),
            s
        }
        var t, n, r, i = e.prototype;
        return i.emitContainerClasses = function() {
            var e = this;
            if (e.params._emitClasses && e.el) {
                var t = e.el.className.split(" ").filter((function(t) {
                    return 0 === t.indexOf("pwzrswiper-container") || 0 === t.indexOf(e.params.containerModifierClass)
                }
                ));
                e.emit("_containerClasses", t.join(" "))
            }
        }
        ,
        i.getSlideClasses = function(e) {
            var t = this;
            return e.className.split(" ").filter((function(e) {
                return 0 === e.indexOf("pwzrswiper-slide") || 0 === e.indexOf(t.params.slideClass)
            }
            )).join(" ")
        }
        ,
        i.emitSlidesClasses = function() {
            var e = this;
            if (e.params._emitClasses && e.el) {
                var t = [];
                e.slides.each((function(n) {
                    var r = e.getSlideClasses(n);
                    t.push({
                        slideEl: n,
                        classNames: r
                    }),
                    e.emit("_slideClass", n, r)
                }
                )),
                e.emit("_slideClasses", t)
            }
        }
        ,
        i.slidesPerViewDynamic = function() {
            var e = this
              , t = e.params
              , n = e.slides
              , r = e.slidesGrid
              , i = e.size
              , o = e.activeIndex
              , a = 1;
            if (t.centeredSlides) {
                for (var s, l = n[o].swiperSlideSize, c = o + 1; c < n.length; c += 1)
                    n[c] && !s && (a += 1,
                    (l += n[c].swiperSlideSize) > i && (s = !0));
                for (var u = o - 1; u >= 0; u -= 1)
                    n[u] && !s && (a += 1,
                    (l += n[u].swiperSlideSize) > i && (s = !0))
            } else
                for (var d = o + 1; d < n.length; d += 1)
                    r[d] - r[o] < i && (a += 1);
            return a
        }
        ,
        i.update = function() {
            var e = this;
            if (e && !e.destroyed) {
                var t = e.snapGrid
                  , n = e.params;
                n.breakpoints && e.setBreakpoint(),
                e.updateSize(),
                e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                e.params.freeMode ? (r(),
                e.params.autoHeight && e.updateAutoHeight()) : (("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || r(),
                n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                e.emit("update")
            }
            function r() {
                var t = e.rtlTranslate ? -1 * e.translate : e.translate
                  , n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                e.setTranslate(n),
                e.updateActiveIndex(),
                e.updateSlidesClasses()
            }
        }
        ,
        i.changeDirection = function(e, t) {
            void 0 === t && (t = !0);
            var n = this
              , r = n.params.direction;
            return e || (e = "horizontal" === r ? "vertical" : "horizontal"),
            e === r || "horizontal" !== e && "vertical" !== e || (n.$el.removeClass("" + n.params.containerModifierClass + r).addClass("" + n.params.containerModifierClass + e),
            n.emitContainerClasses(),
            n.params.direction = e,
            n.slides.each((function(t) {
                "vertical" === e ? t.style.width = "" : t.style.height = ""
            }
            )),
            n.emit("changeDirection"),
            t && n.update()),
            n
        }
        ,
        i.mount = function(e) {
            var t = this;
            if (t.mounted)
                return !0;
            var n, r = Jg(e || t.params.el);
            return !!(e = r[0]) && (e.swiper = t,
            e && e.shadowRoot && e.shadowRoot.querySelector ? (n = Jg(e.shadowRoot.querySelector("." + t.params.wrapperClass))).children = function(e) {
                return r.children(e)
            }
            : n = r.children("." + t.params.wrapperClass),
            nb(t, {
                $el: r,
                el: e,
                $wrapperEl: n,
                wrapperEl: n[0],
                mounted: !0,
                rtl: "rtl" === e.dir.toLowerCase() || "rtl" === r.css("direction"),
                rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === r.css("direction")),
                wrongRTL: "-webkit-box" === n.css("display")
            }),
            !0)
        }
        ,
        i.init = function(e) {
            var t = this;
            return t.initialized || !1 === t.mount(e) || (t.emit("beforeInit"),
            t.params.breakpoints && t.setBreakpoint(),
            t.addClasses(),
            t.params.loop && t.loopCreate(),
            t.updateSize(),
            t.updateSlides(),
            t.params.watchOverflow && t.checkOverflow(),
            t.params.grabCursor && t.setGrabCursor(),
            t.params.preloadImages && t.preloadImages(),
            t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit),
            t.attachEvents(),
            t.initialized = !0,
            t.emit("init"),
            t.emit("afterInit")),
            t
        }
        ,
        i.destroy = function(e, t) {
            void 0 === e && (e = !0),
            void 0 === t && (t = !0);
            var n, r = this, i = r.params, o = r.$el, a = r.$wrapperEl, s = r.slides;
            return void 0 === r.params || r.destroyed || (r.emit("beforeDestroy"),
            r.initialized = !1,
            r.detachEvents(),
            i.loop && r.loopDestroy(),
            t && (r.removeClasses(),
            o.removeAttr("style"),
            a.removeAttr("style"),
            s && s.length && s.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-pwzrswiper-slide-index")),
            r.emit("destroy"),
            Object.keys(r.eventsListeners).forEach((function(e) {
                r.off(e)
            }
            )),
            !1 !== e && (r.$el[0].swiper = null,
            n = r,
            Object.keys(n).forEach((function(e) {
                try {
                    n[e] = null
                } catch (e) {}
                try {
                    delete n[e]
                } catch (e) {}
            }
            ))),
            r.destroyed = !0),
            null
        }
        ,
        e.extendDefaults = function(e) {
            nb(_b, e)
        }
        ,
        e.installModule = function(t) {
            e.prototype.modules || (e.prototype.modules = {});
            var n = t.name || Object.keys(e.prototype.modules).length + "_" + eb();
            e.prototype.modules[n] = t
        }
        ,
        e.use = function(t) {
            return Array.isArray(t) ? (t.forEach((function(t) {
                return e.installModule(t)
            }
            )),
            e) : (e.installModule(t),
            e)
        }
        ,
        t = e,
        r = [{
            key: "extendedDefaults",
            get: function() {
                return _b
            }
        }, {
            key: "defaults",
            get: function() {
                return yb
            }
        }],
        (n = null) && wb(t.prototype, n),
        r && wb(t, r),
        e
    }();
    function Sb() {
        return (Sb = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ).apply(this, arguments)
    }
    Object.keys(xb).forEach((function(e) {
        Object.keys(xb[e]).forEach((function(t) {
            Cb.prototype[t] = xb[e][t]
        }
        ))
    }
    )),
    Cb.use([sb, ub]);
    var Eb = {
        handle: function(e) {
            var t = this
              , n = Dg()
              , r = Ag()
              , i = t.rtlTranslate
              , o = e;
            o.originalEvent && (o = o.originalEvent);
            var a = o.keyCode || o.charCode
              , s = t.params.keyboard.pageUpDown
              , l = s && 33 === a
              , c = s && 34 === a
              , u = 37 === a
              , d = 39 === a
              , p = 38 === a
              , f = 40 === a;
            if (!t.allowSlideNext && (t.isHorizontal() && d || t.isVertical() && f || c))
                return !1;
            if (!t.allowSlidePrev && (t.isHorizontal() && u || t.isVertical() && p || l))
                return !1;
            if (!(o.shiftKey || o.altKey || o.ctrlKey || o.metaKey || r.activeElement && r.activeElement.nodeName && ("input" === r.activeElement.nodeName.toLowerCase() || "textarea" === r.activeElement.nodeName.toLowerCase()))) {
                if (t.params.keyboard.onlyInViewport && (l || c || u || d || p || f)) {
                    var h = !1;
                    if (t.$el.parents("." + t.params.slideClass).length > 0 && 0 === t.$el.parents("." + t.params.slideActiveClass).length)
                        return;
                    var m = n.innerWidth
                      , v = n.innerHeight
                      , g = t.$el.offset();
                    i && (g.left -= t.$el[0].scrollLeft);
                    for (var b = [[g.left, g.top], [g.left + t.width, g.top], [g.left, g.top + t.height], [g.left + t.width, g.top + t.height]], y = 0; y < b.length; y += 1) {
                        var w = b[y];
                        if (w[0] >= 0 && w[0] <= m && w[1] >= 0 && w[1] <= v) {
                            if (0 === w[0] && 0 === w[1])
                                continue;
                            h = !0
                        }
                    }
                    if (!h)
                        return
                }
                t.isHorizontal() ? ((l || c || u || d) && (o.preventDefault ? o.preventDefault() : o.returnValue = !1),
                ((c || d) && !i || (l || u) && i) && t.slideNext(),
                ((l || u) && !i || (c || d) && i) && t.slidePrev()) : ((l || c || p || f) && (o.preventDefault ? o.preventDefault() : o.returnValue = !1),
                (c || f) && t.slideNext(),
                (l || p) && t.slidePrev()),
                t.emit("keyPress", a)
            }
        },
        enable: function() {
            var e = this
              , t = Ag();
            e.keyboard.enabled || (Jg(t).on("keydown", e.keyboard.handle),
            e.keyboard.enabled = !0)
        },
        disable: function() {
            var e = this
              , t = Ag();
            e.keyboard.enabled && (Jg(t).off("keydown", e.keyboard.handle),
            e.keyboard.enabled = !1)
        }
    }
      , kb = {
        name: "keyboard",
        params: {
            keyboard: {
                enabled: !1,
                onlyInViewport: !0,
                pageUpDown: !0
            }
        },
        create: function() {
            rb(this, {
                keyboard: Sb({
                    enabled: !1
                }, Eb)
            })
        },
        on: {
            init: function(e) {
                e.params.keyboard.enabled && e.keyboard.enable()
            },
            destroy: function(e) {
                e.keyboard.enabled && e.keyboard.disable()
            }
        }
    };
    function Ob() {
        return (Ob = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ).apply(this, arguments)
    }
    var Tb = {
        update: function() {
            var e = this
              , t = e.params.navigation;
            if (!e.params.loop) {
                var n = e.navigation
                  , r = n.$nextEl
                  , i = n.$prevEl;
                i && i.length > 0 && (e.isBeginning ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass),
                i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
                r && r.length > 0 && (e.isEnd ? r.addClass(t.disabledClass) : r.removeClass(t.disabledClass),
                r[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass))
            }
        },
        onPrevClick: function(e) {
            var t = this;
            e.preventDefault(),
            t.isBeginning && !t.params.loop || t.slidePrev()
        },
        onNextClick: function(e) {
            var t = this;
            e.preventDefault(),
            t.isEnd && !t.params.loop || t.slideNext()
        },
        init: function() {
            var e, t, n = this, r = n.params.navigation;
            (r.nextEl || r.prevEl) && (r.nextEl && (e = Jg(r.nextEl),
            n.params.uniqueNavElements && "string" == typeof r.nextEl && e.length > 1 && 1 === n.$el.find(r.nextEl).length && (e = n.$el.find(r.nextEl))),
            r.prevEl && (t = Jg(r.prevEl),
            n.params.uniqueNavElements && "string" == typeof r.prevEl && t.length > 1 && 1 === n.$el.find(r.prevEl).length && (t = n.$el.find(r.prevEl))),
            e && e.length > 0 && e.on("click", n.navigation.onNextClick),
            t && t.length > 0 && t.on("click", n.navigation.onPrevClick),
            nb(n.navigation, {
                $nextEl: e,
                nextEl: e && e[0],
                $prevEl: t,
                prevEl: t && t[0]
            }))
        },
        destroy: function() {
            var e = this
              , t = e.navigation
              , n = t.$nextEl
              , r = t.$prevEl;
            n && n.length && (n.off("click", e.navigation.onNextClick),
            n.removeClass(e.params.navigation.disabledClass)),
            r && r.length && (r.off("click", e.navigation.onPrevClick),
            r.removeClass(e.params.navigation.disabledClass))
        }
    }
      , Mb = {
        name: "navigation",
        params: {
            navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "pwzrswiper-button-disabled",
                hiddenClass: "pwzrswiper-button-hidden",
                lockClass: "pwzrswiper-button-lock"
            }
        },
        create: function() {
            rb(this, {
                navigation: Ob({}, Tb)
            })
        },
        on: {
            init: function(e) {
                e.navigation.init(),
                e.navigation.update()
            },
            toEdge: function(e) {
                e.navigation.update()
            },
            fromEdge: function(e) {
                e.navigation.update()
            },
            destroy: function(e) {
                e.navigation.destroy()
            },
            click: function(e, t) {
                var n = e.navigation
                  , r = n.$nextEl
                  , i = n.$prevEl
                  , o = t.target;
                if (e.params.navigation.hideOnClick && !Jg(o).is(i) && !Jg(o).is(r)) {
                    if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === o || e.pagination.el.contains(o)))
                        return;
                    var a;
                    r ? a = r.hasClass(e.params.navigation.hiddenClass) : i && (a = i.hasClass(e.params.navigation.hiddenClass)),
                    !0 === a ? e.emit("navigationShow") : e.emit("navigationHide"),
                    r && r.toggleClass(e.params.navigation.hiddenClass),
                    i && i.toggleClass(e.params.navigation.hiddenClass)
                }
            }
        }
    };
    function Rb() {
        return (Rb = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ).apply(this, arguments)
    }
    var Pb = {
        update: function() {
            var e = this
              , t = e.rtl
              , n = e.params.pagination;
            if (n.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var r, i = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, o = e.pagination.$el, a = e.params.loop ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                if (e.params.loop ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > i - 1 - 2 * e.loopedSlides && (r -= i - 2 * e.loopedSlides),
                r > a - 1 && (r -= a),
                r < 0 && "bullets" !== e.params.paginationType && (r = a + r)) : r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0,
                "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0) {
                    var s, l, c, u = e.pagination.bullets;
                    if (n.dynamicBullets && (e.pagination.bulletSize = u.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0),
                    o.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (n.dynamicMainBullets + 4) + "px"),
                    n.dynamicMainBullets > 1 && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += r - e.previousIndex,
                    e.pagination.dynamicBulletIndex > n.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = n.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)),
                    s = r - e.pagination.dynamicBulletIndex,
                    c = ((l = s + (Math.min(u.length, n.dynamicMainBullets) - 1)) + s) / 2),
                    u.removeClass(n.bulletActiveClass + " " + n.bulletActiveClass + "-next " + n.bulletActiveClass + "-next-next " + n.bulletActiveClass + "-prev " + n.bulletActiveClass + "-prev-prev " + n.bulletActiveClass + "-main"),
                    o.length > 1)
                        u.each((function(e) {
                            var t = Jg(e)
                              , i = t.index();
                            i === r && t.addClass(n.bulletActiveClass),
                            n.dynamicBullets && (i >= s && i <= l && t.addClass(n.bulletActiveClass + "-main"),
                            i === s && t.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"),
                            i === l && t.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next"))
                        }
                        ));
                    else {
                        var d = u.eq(r)
                          , p = d.index();
                        if (d.addClass(n.bulletActiveClass),
                        n.dynamicBullets) {
                            for (var f = u.eq(s), h = u.eq(l), m = s; m <= l; m += 1)
                                u.eq(m).addClass(n.bulletActiveClass + "-main");
                            if (e.params.loop)
                                if (p >= u.length - n.dynamicMainBullets) {
                                    for (var v = n.dynamicMainBullets; v >= 0; v -= 1)
                                        u.eq(u.length - v).addClass(n.bulletActiveClass + "-main");
                                    u.eq(u.length - n.dynamicMainBullets - 1).addClass(n.bulletActiveClass + "-prev")
                                } else
                                    f.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"),
                                    h.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next");
                            else
                                f.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"),
                                h.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next")
                        }
                    }
                    if (n.dynamicBullets) {
                        var g = Math.min(u.length, n.dynamicMainBullets + 4)
                          , b = (e.pagination.bulletSize * g - e.pagination.bulletSize) / 2 - c * e.pagination.bulletSize
                          , y = t ? "right" : "left";
                        u.css(e.isHorizontal() ? y : "top", b + "px")
                    }
                }
                if ("fraction" === n.type && (o.find("." + n.currentClass).text(n.formatFractionCurrent(r + 1)),
                o.find("." + n.totalClass).text(n.formatFractionTotal(a))),
                "progressbar" === n.type) {
                    var w;
                    w = n.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
                    var x = (r + 1) / a
                      , _ = 1
                      , C = 1;
                    "horizontal" === w ? _ = x : C = x,
                    o.find("." + n.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + _ + ") scaleY(" + C + ")").transition(e.params.speed)
                }
                "custom" === n.type && n.renderCustom ? (o.html(n.renderCustom(e, r + 1, a)),
                e.emit("paginationRender", o[0])) : e.emit("paginationUpdate", o[0]),
                o[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](n.lockClass)
            }
        },
        render: function() {
            var e = this
              , t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length
                  , r = e.pagination.$el
                  , i = "";
                if ("bullets" === t.type) {
                    var o = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                    e.params.freeMode && !e.params.loop && o > n && (o = n);
                    for (var a = 0; a < o; a += 1)
                        t.renderBullet ? i += t.renderBullet.call(e, a, t.bulletClass) : i += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
                    r.html(i),
                    e.pagination.bullets = r.find("." + t.bulletClass.replace(/ /g, "."))
                }
                "fraction" === t.type && (i = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>',
                r.html(i)),
                "progressbar" === t.type && (i = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>',
                r.html(i)),
                "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0])
            }
        },
        init: function() {
            var e = this
              , t = e.params.pagination;
            if (t.el) {
                var n = Jg(t.el);
                0 !== n.length && (e.params.uniqueNavElements && "string" == typeof t.el && n.length > 1 && (n = e.$el.find(t.el)),
                "bullets" === t.type && t.clickable && n.addClass(t.clickableClass),
                n.addClass(t.modifierClass + t.type),
                "bullets" === t.type && t.dynamicBullets && (n.addClass("" + t.modifierClass + t.type + "-dynamic"),
                e.pagination.dynamicBulletIndex = 0,
                t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass),
                t.clickable && n.on("click", "." + t.bulletClass.replace(/ /g, "."), (function(t) {
                    t.preventDefault();
                    var n = Jg(this).index() * e.params.slidesPerGroup;
                    e.params.loop && (n += e.loopedSlides),
                    e.slideTo(n)
                }
                )),
                nb(e.pagination, {
                    $el: n,
                    el: n[0]
                }))
            }
        },
        destroy: function() {
            var e = this
              , t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var n = e.pagination.$el;
                n.removeClass(t.hiddenClass),
                n.removeClass(t.modifierClass + t.type),
                e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass),
                t.clickable && n.off("click", "." + t.bulletClass.replace(/ /g, "."))
            }
        }
    }
      , Ib = {
        name: "pagination",
        params: {
            pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: function(e) {
                    return e
                },
                formatFractionTotal: function(e) {
                    return e
                },
                bulletClass: "pwzrswiper-pagination-bullet",
                bulletActiveClass: "pwzrswiper-pagination-bullet-active",
                modifierClass: "pwzrswiper-pagination-",
                currentClass: "pwzrswiper-pagination-current",
                totalClass: "pwzrswiper-pagination-total",
                hiddenClass: "pwzrswiper-pagination-hidden",
                progressbarFillClass: "pwzrswiper-pagination-progressbar-fill",
                progressbarOppositeClass: "pwzrswiper-pagination-progressbar-opposite",
                clickableClass: "pwzrswiper-pagination-clickable",
                lockClass: "pwzrswiper-pagination-lock"
            }
        },
        create: function() {
            rb(this, {
                pagination: Rb({
                    dynamicBulletIndex: 0
                }, Pb)
            })
        },
        on: {
            init: function(e) {
                e.pagination.init(),
                e.pagination.render(),
                e.pagination.update()
            },
            activeIndexChange: function(e) {
                (e.params.loop || void 0 === e.snapIndex) && e.pagination.update()
            },
            snapIndexChange: function(e) {
                e.params.loop || e.pagination.update()
            },
            slidesLengthChange: function(e) {
                e.params.loop && (e.pagination.render(),
                e.pagination.update())
            },
            snapGridLengthChange: function(e) {
                e.params.loop || (e.pagination.render(),
                e.pagination.update())
            },
            destroy: function(e) {
                e.pagination.destroy()
            },
            click: function(e, t) {
                var n = t.target;
                if (e.params.pagination.el && e.params.pagination.hideOnClick && e.pagination.$el.length > 0 && !Jg(n).hasClass(e.params.pagination.bulletClass)) {
                    if (e.navigation && (e.navigation.nextEl && n === e.navigation.nextEl || e.navigation.prevEl && n === e.navigation.prevEl))
                        return;
                    !0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass) ? e.emit("paginationShow") : e.emit("paginationHide"),
                    e.pagination.$el.toggleClass(e.params.pagination.hiddenClass)
                }
            }
        }
    };
    function zb() {
        return (zb = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ).apply(this, arguments)
    }
    var Ab = {
        loadInSlide: function(e, t) {
            void 0 === t && (t = !0);
            var n = this
              , r = n.params.lazy;
            if (void 0 !== e && 0 !== n.slides.length) {
                var i = n.virtual && n.params.virtual.enabled ? n.$wrapperEl.children("." + n.params.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]') : n.slides.eq(e)
                  , o = i.find("." + r.elementClass + ":not(." + r.loadedClass + "):not(." + r.loadingClass + ")");
                !i.hasClass(r.elementClass) || i.hasClass(r.loadedClass) || i.hasClass(r.loadingClass) || o.push(i[0]),
                0 !== o.length && o.each((function(e) {
                    var o = Jg(e);
                    o.addClass(r.loadingClass);
                    var a = o.attr("data-background")
                      , s = o.attr("data-src")
                      , l = o.attr("data-srcset")
                      , c = o.attr("data-sizes")
                      , u = o.parent("picture");
                    n.loadImage(o[0], s || a, l, c, !1, (function() {
                        if (null != n && n && (!n || n.params) && !n.destroyed) {
                            if (a ? (o.css("background-image", 'url("' + a + '")'),
                            o.removeAttr("data-background")) : (l && (o.attr("srcset", l),
                            o.removeAttr("data-srcset")),
                            c && (o.attr("sizes", c),
                            o.removeAttr("data-sizes")),
                            u.length && u.children("source").each((function(e) {
                                var t = Jg(e);
                                t.attr("data-srcset") && (t.attr("srcset", t.attr("data-srcset")),
                                t.removeAttr("data-srcset"))
                            }
                            )),
                            s && (o.attr("src", s),
                            o.removeAttr("data-src"))),
                            o.addClass(r.loadedClass).removeClass(r.loadingClass),
                            i.find("." + r.preloaderClass).remove(),
                            n.params.loop && t) {
                                var e = i.attr("data-pwzrswiper-slide-index");
                                if (i.hasClass(n.params.slideDuplicateClass)) {
                                    var d = n.$wrapperEl.children('[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.params.slideDuplicateClass + ")");
                                    n.lazy.loadInSlide(d.index(), !1)
                                } else {
                                    var p = n.$wrapperEl.children("." + n.params.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + e + '"]');
                                    n.lazy.loadInSlide(p.index(), !1)
                                }
                            }
                            n.emit("lazyImageReady", i[0], o[0]),
                            n.params.autoHeight && n.updateAutoHeight()
                        }
                    }
                    )),
                    n.emit("lazyImageLoad", i[0], o[0])
                }
                ))
            }
        },
        load: function() {
            var e = this
              , t = e.$wrapperEl
              , n = e.params
              , r = e.slides
              , i = e.activeIndex
              , o = e.virtual && n.virtual.enabled
              , a = n.lazy
              , s = n.slidesPerView;
            function l(e) {
                if (o) {
                    if (t.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]').length)
                        return !0
                } else if (r[e])
                    return !0;
                return !1
            }
            function c(e) {
                return o ? Jg(e).attr("data-pwzrswiper-slide-index") : Jg(e).index()
            }
            if ("auto" === s && (s = 0),
            e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0),
            e.params.watchSlidesVisibility)
                t.children("." + n.slideVisibleClass).each((function(t) {
                    var n = o ? Jg(t).attr("data-pwzrswiper-slide-index") : Jg(t).index();
                    e.lazy.loadInSlide(n)
                }
                ));
            else if (s > 1)
                for (var u = i; u < i + s; u += 1)
                    l(u) && e.lazy.loadInSlide(u);
            else
                e.lazy.loadInSlide(i);
            if (a.loadPrevNext)
                if (s > 1 || a.loadPrevNextAmount && a.loadPrevNextAmount > 1) {
                    for (var d = a.loadPrevNextAmount, p = s, f = Math.min(i + p + Math.max(d, p), r.length), h = Math.max(i - Math.max(p, d), 0), m = i + s; m < f; m += 1)
                        l(m) && e.lazy.loadInSlide(m);
                    for (var v = h; v < i; v += 1)
                        l(v) && e.lazy.loadInSlide(v)
                } else {
                    var g = t.children("." + n.slideNextClass);
                    g.length > 0 && e.lazy.loadInSlide(c(g));
                    var b = t.children("." + n.slidePrevClass);
                    b.length > 0 && e.lazy.loadInSlide(c(b))
                }
        },
        checkInViewOnLoad: function() {
            var e = Dg()
              , t = this;
            if (t && !t.destroyed) {
                var n = t.params.lazy.scrollingElement ? Jg(t.params.lazy.scrollingElement) : Jg(e)
                  , r = n[0] === e
                  , i = r ? e.innerWidth : n[0].offsetWidth
                  , o = r ? e.innerHeight : n[0].offsetHeight
                  , a = t.$el.offset()
                  , s = !1;
                t.rtlTranslate && (a.left -= t.$el[0].scrollLeft);
                for (var l = [[a.left, a.top], [a.left + t.width, a.top], [a.left, a.top + t.height], [a.left + t.width, a.top + t.height]], c = 0; c < l.length; c += 1) {
                    var u = l[c];
                    if (u[0] >= 0 && u[0] <= i && u[1] >= 0 && u[1] <= o) {
                        if (0 === u[0] && 0 === u[1])
                            continue;
                        s = !0
                    }
                }
                s ? (t.lazy.load(),
                n.off("scroll", t.lazy.checkInViewOnLoad)) : t.lazy.scrollHandlerAttached || (t.lazy.scrollHandlerAttached = !0,
                n.on("scroll", t.lazy.checkInViewOnLoad))
            }
        }
    }
      , Lb = {
        name: "lazy",
        params: {
            lazy: {
                checkInView: !1,
                enabled: !1,
                loadPrevNext: !1,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: !1,
                scrollingElement: "",
                elementClass: "pwzrswiper-lazy",
                loadingClass: "pwzrswiper-lazy-loading",
                loadedClass: "pwzrswiper-lazy-loaded",
                preloaderClass: "pwzrswiper-lazy-preloader"
            }
        },
        create: function() {
            rb(this, {
                lazy: zb({
                    initialImageLoaded: !1
                }, Ab)
            })
        },
        on: {
            beforeInit: function(e) {
                e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1)
            },
            init: function(e) {
                e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && (e.params.lazy.checkInView ? e.lazy.checkInViewOnLoad() : e.lazy.load())
            },
            scroll: function(e) {
                e.params.freeMode && !e.params.freeModeSticky && e.lazy.load()
            },
            "scrollbarDragMove resize _freeModeNoMomentumRelease": function(e) {
                e.params.lazy.enabled && e.lazy.load()
            },
            transitionStart: function(e) {
                e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load()
            },
            transitionEnd: function(e) {
                e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load()
            },
            slideChange: function(e) {
                e.params.lazy.enabled && e.params.cssMode && e.lazy.load()
            }
        }
    };
    function Db() {
        return (Db = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ).apply(this, arguments)
    }
    var Nb = {
        setTranslate: function() {
            for (var e = this, t = e.slides, n = 0; n < t.length; n += 1) {
                var r = e.slides.eq(n)
                  , i = -r[0].swiperSlideOffset;
                e.params.virtualTranslate || (i -= e.translate);
                var o = 0;
                e.isHorizontal() || (o = i,
                i = 0);
                var a = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(r[0].progress), 0) : 1 + Math.min(Math.max(r[0].progress, -1), 0);
                r.css({
                    opacity: a
                }).transform("translate3d(" + i + "px, " + o + "px, 0px)")
            }
        },
        setTransition: function(e) {
            var t = this
              , n = t.slides
              , r = t.$wrapperEl;
            if (n.transition(e),
            t.params.virtualTranslate && 0 !== e) {
                var i = !1;
                n.transitionEnd((function() {
                    if (!i && t && !t.destroyed) {
                        i = !0,
                        t.animating = !1;
                        for (var e = ["webkitTransitionEnd", "transitionend"], n = 0; n < e.length; n += 1)
                            r.trigger(e[n])
                    }
                }
                ))
            }
        }
    }
      , Wb = {
        name: "effect-fade",
        params: {
            fadeEffect: {
                crossFade: !1
            }
        },
        create: function() {
            rb(this, {
                fadeEffect: Db({}, Nb)
            })
        },
        on: {
            beforeInit: function(e) {
                if ("fade" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "fade");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !0
                    };
                    nb(e.params, t),
                    nb(e.originalParams, t)
                }
            },
            setTranslate: function(e) {
                "fade" === e.params.effect && e.fadeEffect.setTranslate()
            },
            setTransition: function(e, t) {
                "fade" === e.params.effect && e.fadeEffect.setTransition(t)
            }
        }
    }
      , Fb = function(e, t) {
        var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        return n ? ir.indexOf(e) <= ir.indexOf(t) : ir.indexOf(e) < ir.indexOf(t)
    }
      , $b = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect
      , Bb = "complete"
      , jb = "canceled";
    function Hb(e, t, n, r, i) {
        e.self === e ? e.scrollTo(t, n) : (r || (e.scrollLeft = t),
        i || (e.scrollTop = n))
    }
    function Vb(e) {
        var t = e._scrollSettings;
        if (t) {
            var n = t.maxSynchronousAlignments
              , r = function(e, t) {
                var n, r, i, o, a, s, l, c = e.align, u = e.target.getBoundingClientRect(), d = c && null != c.left ? c.left : .5, p = c && null != c.top ? c.top : .5, f = c && null != c.leftOffset ? c.leftOffset : 0, h = c && null != c.topOffset ? c.topOffset : 0, m = d, v = p;
                if (e.isWindow(t))
                    s = Math.min(u.width, t.innerWidth),
                    l = Math.min(u.height, t.innerHeight),
                    r = u.left + t.pageXOffset - t.innerWidth * m + s * m,
                    i = u.top + t.pageYOffset - t.innerHeight * v + l * v,
                    i -= h,
                    o = (r -= f) - t.pageXOffset,
                    a = i - t.pageYOffset;
                else {
                    s = u.width,
                    l = u.height,
                    n = t.getBoundingClientRect();
                    var g = u.left - (n.left - t.scrollLeft)
                      , b = u.top - (n.top - t.scrollTop);
                    r = g + s * m - t.clientWidth * m,
                    i = b + l * v - t.clientHeight * v,
                    r -= f,
                    i -= h,
                    r = Math.max(Math.min(r, t.scrollWidth - t.clientWidth), 0),
                    i = Math.max(Math.min(i, t.scrollHeight - t.clientHeight), 0),
                    o = r - t.scrollLeft,
                    a = i - t.scrollTop
                }
                return {
                    x: r,
                    y: i,
                    differenceX: o,
                    differenceY: a
                }
            }(t, e)
              , i = Date.now() - t.startTime
              , o = Math.min(1 / t.time * i, 1);
            if (t.endIterations >= n)
                return Hb(e, r.x, r.y, t.lockX, t.lockY),
                e._scrollSettings = null,
                t.end(Bb);
            var a = 1 - t.ease(o);
            if (Hb(e, r.x - r.differenceX * a, r.y - r.differenceY * a, t.lockX, t.lockY),
            i >= t.time)
                return t.endIterations++,
                Vb(e);
            !function(e) {
                if ("requestAnimationFrame"in window)
                    return window.requestAnimationFrame(e);
                setTimeout(e, 16)
            }(Vb.bind(null, e))
        }
    }
    function qb(e) {
        return e.self === e
    }
    function Ub(e, t, n, r) {
        var i, o = !t._scrollSettings, a = t._scrollSettings, s = Date.now(), l = {
            passive: !0
        };
        function c(e) {
            t._scrollSettings = null,
            t.parentElement && t.parentElement._scrollSettings && t.parentElement._scrollSettings.end(e),
            n.debug && console.log("Scrolling ended with type", e, "for", t),
            r(e),
            i && (t.removeEventListener("touchstart", i, l),
            t.removeEventListener("wheel", i, l))
        }
        a && a.end(jb);
        var u = n.maxSynchronousAlignments;
        null == u && (u = 3),
        t._scrollSettings = {
            startTime: a ? a.startTime : Date.now(),
            endIterations: 0,
            target: e,
            time: n.time + (a ? s - a.startTime : 0),
            ease: n.ease,
            align: n.align,
            isWindow: n.isWindow || qb,
            maxSynchronousAlignments: u,
            end: c,
            lockX: n.lockX,
            lockY: n.lockY
        },
        "cancellable"in n && !n.cancellable || (i = c.bind(null, jb),
        t.addEventListener("touchstart", i, l),
        t.addEventListener("wheel", i, l)),
        o && Vb(t)
    }
    function Gb(e) {
        return "pageXOffset"in e || (e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth) && "hidden" !== getComputedStyle(e).overflow
    }
    function Zb() {
        return !0
    }
    function Kb(e) {
        if (e.assignedSlot)
            return Kb(e.assignedSlot);
        if (e.parentElement)
            return "BODY" === e.parentElement.tagName ? e.parentElement.ownerDocument.defaultView || e.parentElement.ownerDocument.ownerWindow : e.parentElement;
        if (e.getRootNode) {
            var t = e.getRootNode();
            if (11 === t.nodeType)
                return t.host
        }
    }
    var Yb = t((function(e, t, n) {
        if (e) {
            "function" == typeof t && (n = t,
            t = null),
            t || (t = {}),
            t.time = isNaN(t.time) ? 1e3 : t.time,
            t.ease = t.ease || function(e) {
                return 1 - Math.pow(1 - e, e / 2)
            }
            ,
            t.lockX = t.lockX || !1,
            t.lockY = t.lockY || !1,
            t.scrollAllParents = "boolean" != typeof t.scrollAllParents || t.scrollAllParents;
            var r = Kb(e)
              , i = 1
              , o = t.validTarget || Zb
              , a = t.isScrollable;
            for (t.debug && (console.log("About to scroll to", e),
            r || console.error("Target did not have a parent, is it mounted in the DOM?")); r; )
                if (t.debug && console.log("Scrolling parent node", r),
                o(r, i) && (a ? a(r, Gb) : Gb(r)) && (i++,
                Ub(e, r, t, s)),
                r = Kb(r),
                !t.scrollAllParents || !r) {
                    s(Bb);
                    break
                }
        }
        function s(e) {
            --i || n && n(e)
        }
    }
    ));
    var Xb;
    Xb = function(e, t) {
        if (t = t.split(":")[0],
        !(e = +e))
            return !1;
        switch (t) {
        case "http":
        case "ws":
            return 80 !== e;
        case "https":
        case "wss":
            return 443 !== e;
        case "ftp":
            return 21 !== e;
        case "gopher":
            return 70 !== e;
        case "file":
            return !1
        }
        return 0 !== e
    }
    ;
    var Jb = {}
      , Qb = Object.prototype.hasOwnProperty;
    function ey(e) {
        try {
            return decodeURIComponent(e.replace(/\+/g, " "))
        } catch (e) {
            return null
        }
    }
    var ty = function(e, t) {
        t = t || "";
        var n, r, i = [];
        for (r in "string" != typeof t && (t = "?"),
        e)
            if (Qb.call(e, r)) {
                if ((n = e[r]) || null != n && !isNaN(n) || (n = ""),
                r = encodeURIComponent(r),
                n = encodeURIComponent(n),
                null === r || null === n)
                    continue;
                i.push(r + "=" + n)
            }
        return i.length ? t + i.join("&") : ""
    };
    Jb.stringify = ty;
    var ny = function(e) {
        for (var t, n = /([^=?&]+)=?([^&]*)/g, r = {}; t = n.exec(e); ) {
            var i = ey(t[1])
              , o = ey(t[2]);
            null === i || null === o || i in r || (r[i] = o)
        }
        return r
    };
    Jb.parse = ny;
    var ry = Xb
      , iy = Jb
      , oy = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//
      , ay = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
      , sy = new RegExp("^[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]+");
    function ly(e) {
        return (e || "").toString().replace(sy, "")
    }
    var cy = [["#", "hash"], ["?", "query"], function(e) {
        return e.replace("\\", "/")
    }
    , ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d+)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]]
      , uy = {
        hash: 1,
        query: 1
    };
    function dy(t) {
        var n, r = ("undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : {}).location || {}, i = {}, o = typeof (t = t || r);
        if ("blob:" === t.protocol)
            i = new fy(unescape(t.pathname),{});
        else if ("string" === o)
            for (n in i = new fy(t,{}),
            uy)
                delete i[n];
        else if ("object" === o) {
            for (n in t)
                n in uy || (i[n] = t[n]);
            void 0 === i.slashes && (i.slashes = oy.test(t.href))
        }
        return i
    }
    function py(e) {
        e = ly(e);
        var t = ay.exec(e);
        return {
            protocol: t[1] ? t[1].toLowerCase() : "",
            slashes: !!t[2],
            rest: t[3]
        }
    }
    function fy(e, t, n) {
        if (e = ly(e),
        !(this instanceof fy))
            return new fy(e,t,n);
        var r, i, o, a, s, l, c = cy.slice(), u = typeof t, d = this, p = 0;
        for ("object" !== u && "string" !== u && (n = t,
        t = null),
        n && "function" != typeof n && (n = iy.parse),
        t = dy(t),
        r = !(i = py(e || "")).protocol && !i.slashes,
        d.slashes = i.slashes || r && t.slashes,
        d.protocol = i.protocol || t.protocol || "",
        e = i.rest,
        i.slashes || (c[3] = [/(.*)/, "pathname"]); p < c.length; p++)
            "function" != typeof (a = c[p]) ? (o = a[0],
            l = a[1],
            o != o ? d[l] = e : "string" == typeof o ? ~(s = e.indexOf(o)) && ("number" == typeof a[2] ? (d[l] = e.slice(0, s),
            e = e.slice(s + a[2])) : (d[l] = e.slice(s),
            e = e.slice(0, s))) : (s = o.exec(e)) && (d[l] = s[1],
            e = e.slice(0, s.index)),
            d[l] = d[l] || r && a[3] && t[l] || "",
            a[4] && (d[l] = d[l].toLowerCase())) : e = a(e);
        n && (d.query = n(d.query)),
        r && t.slashes && "/" !== d.pathname.charAt(0) && ("" !== d.pathname || "" !== t.pathname) && (d.pathname = function(e, t) {
            if ("" === e)
                return t;
            for (var n = (t || "/").split("/").slice(0, -1).concat(e.split("/")), r = n.length, i = n[r - 1], o = !1, a = 0; r--; )
                "." === n[r] ? n.splice(r, 1) : ".." === n[r] ? (n.splice(r, 1),
                a++) : a && (0 === r && (o = !0),
                n.splice(r, 1),
                a--);
            return o && n.unshift(""),
            "." !== i && ".." !== i || n.push(""),
            n.join("/")
        }(d.pathname, t.pathname)),
        ry(d.port, d.protocol) || (d.host = d.hostname,
        d.port = ""),
        d.username = d.password = "",
        d.auth && (a = d.auth.split(":"),
        d.username = a[0] || "",
        d.password = a[1] || ""),
        d.origin = d.protocol && d.host && "file:" !== d.protocol ? d.protocol + "//" + d.host : "null",
        d.href = d.toString()
    }
    fy.prototype = {
        set: function(e, t, n) {
            var r = this;
            switch (e) {
            case "query":
                "string" == typeof t && t.length && (t = (n || iy.parse)(t)),
                r[e] = t;
                break;
            case "port":
                r[e] = t,
                ry(t, r.protocol) ? t && (r.host = r.hostname + ":" + t) : (r.host = r.hostname,
                r[e] = "");
                break;
            case "hostname":
                r[e] = t,
                r.port && (t += ":" + r.port),
                r.host = t;
                break;
            case "host":
                r[e] = t,
                /:\d+$/.test(t) ? (t = t.split(":"),
                r.port = t.pop(),
                r.hostname = t.join(":")) : (r.hostname = t,
                r.port = "");
                break;
            case "protocol":
                r.protocol = t.toLowerCase(),
                r.slashes = !n;
                break;
            case "pathname":
            case "hash":
                if (t) {
                    var i = "pathname" === e ? "/" : "#";
                    r[e] = t.charAt(0) !== i ? i + t : t
                } else
                    r[e] = t;
                break;
            default:
                r[e] = t
            }
            for (var o = 0; o < cy.length; o++) {
                var a = cy[o];
                a[4] && (r[a[1]] = r[a[1]].toLowerCase())
            }
            return r.origin = r.protocol && r.host && "file:" !== r.protocol ? r.protocol + "//" + r.host : "null",
            r.href = r.toString(),
            r
        },
        toString: function(e) {
            e && "function" == typeof e || (e = iy.stringify);
            var t, n = this, r = n.protocol;
            r && ":" !== r.charAt(r.length - 1) && (r += ":");
            var i = r + (n.slashes ? "//" : "");
            return n.username && (i += n.username,
            n.password && (i += ":" + n.password),
            i += "@"),
            i += n.host + n.pathname,
            (t = "object" == typeof n.query ? e(n.query) : n.query) && (i += "?" !== t.charAt(0) ? "?" + t : t),
            n.hash && (i += n.hash),
            i
        }
    },
    fy.extractProtocol = py,
    fy.location = dy,
    fy.trimLeft = ly,
    fy.qs = iy;
    var hy = t(fy)
      , my = new Error("Element already at target scroll position")
      , vy = new Error("Scroll cancelled")
      , gy = Math.min
      , by = Date.now;
    function yy(e) {
        return function(t, n, r, i) {
            "function" == typeof (r = r || {}) && (i = r,
            r = {}),
            "function" != typeof i && (i = xy);
            var o = by()
              , a = t[e]
              , s = r.ease || wy
              , l = isNaN(r.duration) ? 350 : +r.duration
              , c = !1;
            return a === n ? i(my, t[e]) : requestAnimationFrame((function r(u) {
                if (c)
                    return i(vy, t[e]);
                var d = by()
                  , p = gy(1, (d - o) / l)
                  , f = s(p);
                t[e] = f * (n - a) + a,
                p < 1 ? requestAnimationFrame(r) : requestAnimationFrame((function() {
                    i(null, t[e])
                }
                ))
            }
            )),
            function() {
                c = !0
            }
        }
    }
    function wy(e) {
        return .5 * (1 - Math.cos(Math.PI * e))
    }
    function xy() {}
    var _y = t({
        left: yy("scrollLeft"),
        top: yy("scrollTop")
    });
    function Cy(e, t) {
        return "function" == typeof window.__productWizRioImagesShim2 ? window.__productWizRioImagesShim2(e, t) : function(e, t) {
            if ("string" != typeof e)
                return e;
            if ("string" != typeof t)
                return e;
            try {
                const n = ( () => {
                    try {
                        return new URL(document.baseURI).toString()
                    } catch (e) {}
                    return null
                }
                )()
                  , r = "string" == typeof n ? new URL(e,n) : new URL(e)
                  , i = new URLSearchParams(r.search)
                  , o = t.replace("_crop_center", "").split("x");
                return o[0] && i.set("width", o[0]),
                o[1] && i.set("height", o[1]),
                r.search = i.toString(),
                r.toString()
            } catch (e) {}
            return e
        }(e, t)
    }
    const Sy = ["//pwzimg.b-cdn.net", "//pwzimg.com", "//b.pwzimg.com", "//rio-static-2.b-cdn.net", "//rio-static-2.productwiz.io"]
      , Ey = e => (t=null, n=null, r=!1) => {
        if (null === t && null === n)
            return e;
        if ("string" == typeof e && Sy.find((t => e.indexOf(t) > -1))) {
            return ( (e, t=null, n=null) => {
                try {
                    const r = new URL(e)
                      , i = 5760
                      , o = new URLSearchParams(r.search);
                    if (null !== t) {
                        const e = Math.min(Math.ceil(t), i);
                        o.append("width", `${e}`)
                    }
                    if (null !== n) {
                        const e = Math.min(Math.ceil(n), i);
                        o.append("height", `${e}`)
                    }
                    return `${r.origin}${r.pathname}?${o}`
                } catch (e) {}
                return e
            }
            )(e, t, n)
        }
        const i = ( (e, t=!1) => t ? `${e}_crop_center` : e)(( (e=null, t=null) => {
            const n = 5760;
            if (null === e)
                return `x${Math.min(Math.ceil(t), n)}`;
            if (null === t)
                return `${Math.min(Math.ceil(e), n)}x`;
            return `${Math.min(Math.ceil(e), n)}x${Math.min(Math.ceil(t), n)}`
        }
        )(t, n), r);
        return Cy(e, i)
    }
    ;
    function ky() {
        return window.devicePixelRatio || 1
    }
    const Oy = e => (t, n) => t[e] > n[e] ? 1 : n[e] > t[e] ? -1 : 0
      , Ty = e => (t, n) => t[e] > n[e] ? -1 : n[e] > t[e] ? 1 : 0;
    function My(e, t) {
        const n = Math.ceil(e.scrollLeft)
          , r = Math.ceil(e.scrollTop)
          , i = Math.floor(e.scrollLeft)
          , o = Math.floor(e.scrollTop);
        return {
            start: t ? 0 === o : 0 === i,
            end: t ? e.offsetHeight + r >= e.scrollHeight : e.offsetWidth + n >= e.scrollWidth
        }
    }
    function Ry(e, t, n) {
        return new Promise((r => {
            t ? _y.top(e, e.scrollTop + n * e.clientHeight, ( () => {
                r(My(e, t))
            }
            )) : _y.left(e, e.scrollLeft + n * e.clientWidth, ( () => {
                r(My(e, t))
            }
            ))
        }
        ))
    }
    const Py = JSON.stringify({
        muted: !1,
        autoPlay: !0,
        controls: !0,
        loop: !1,
        autoRotate: !0
    });
    function Iy(e, t, n, r="media") {
        const i = {
            muted: !1,
            autoPlay: !0,
            controls: !0,
            loop: !1,
            autoRotate: !0
        };
        if (Array.isArray(n)) {
            const o = n.find((t => t.id === e));
            if (o && Array.isArray(o[r])) {
                const e = o[r].find((e => e.id === t));
                if (e) {
                    const {id: t, ...n} = e;
                    return {
                        ...i,
                        ...n
                    }
                }
            }
        }
        return i
    }
    const zy = (e, t, n, r=!1) => {
        const i = e.find((e => e.id === n));
        if (i)
            return i;
        const o = (Array.isArray(t) ? t : []).find((e => e.id === n));
        if (o) {
            const t = o.value;
            if ("string" == typeof t) {
                const i = e.find((e => (e => {
                    try {
                        const t = ( () => {
                            try {
                                return new URL(document.baseURI).toString()
                            } catch (e) {}
                            return null
                        }
                        )()
                          , {pathname: n} = "string" == typeof t ? new URL(e,t) : new URL(e)
                          , r = n.lastIndexOf("/");
                        return -1 !== r ? n.substring(r + 1) : n
                    } catch (e) {}
                    return null
                }
                )(e.originalSrc) === t));
                if (i)
                    return console.log(`Fixed invalid image reference of ${n} ${t} to`),
                    console.log(i),
                    r ? {
                        ...i,
                        rescued: !0
                    } : i
            }
        }
        return console.log(`Could not find a match for media ${n}`),
        null
    }
    ;
    function Ay(e) {
        return "left" === e || "right" === e
    }
    function Ly(e) {
        return Math.min(180 * Math.ceil(e / 180), 5760)
    }
    function Dy() {
        const {href: e} = window.location
          , t = hy(e, !0)
          , {variant: n} = t.query;
        return n || null
    }
    function Ny(e) {
        return "number" == typeof e && Number.isFinite(e) ? `${(1 / e * 100).toFixed(3)}%` : "100%"
    }
    function Wy(e, t) {
        if (Array.isArray(t) && t.length > 0) {
            if ("string" == typeof t[0] && e.options.length === t.length)
                return t.map(( (t, n) => ({
                    name: e.options[n].name,
                    value: t
                })))
        }
        return t
    }
    function Fy(e) {
        const t = e.media.concat().sort(Oy("position")).map((e => {
            return (t = function(e) {
                const {media_type: t, aspect_ratio: n, preview_image: r, external_id: i, src: o, host: a, sources: s, id: l, alt: c, width: u} = e
                  , d = {
                    id: `${l}`,
                    type: t,
                    alt: c
                }
                  , p = s || [];
                if ("image" === t)
                    return {
                        ...d,
                        transformedSrc: Ey(o),
                        originalSrc: o,
                        scale: Ny(n),
                        width: u
                    };
                if ("video" === t) {
                    const e = p.filter((e => "video/mp4" === e.mime_type)).sort(( (e, t) => t.height - e.height)).map((e => ({
                        mimeType: e.mime_type,
                        url: e.url
                    })));
                    if (e.length > 0) {
                        const t = [];
                        t.push(e[0]);
                        const i = p.find((e => "application/x-mpegURL" === e.mime_type));
                        return i && t.push({
                            mimeType: i.mime_type,
                            url: i.url
                        }),
                        {
                            ...d,
                            transformedSrc: Ey(r.src),
                            scale: Ny(r.aspect_ratio),
                            sources: t,
                            scaleSources: Ny(n)
                        }
                    }
                }
                if ("external_video" === t && "youtube" === a && "string" == typeof i)
                    return {
                        ...d,
                        transformedSrc: Ey(r.src),
                        scale: Ny(r.aspect_ratio),
                        sources: [i],
                        scaleSources: Ny(n)
                    };
                if ("model" === t) {
                    const e = p.find((e => "glb" === e.format));
                    if (e && "string" == typeof e.url)
                        return {
                            ...d,
                            transformedSrc: Ey(r.src),
                            scale: Ny(r.aspect_ratio),
                            sources: [e.url],
                            scaleSources: Ny(r.aspect_ratio)
                        }
                }
                return null
            }(e)) ? {
                ...t,
                rioSettings: {
                    muted: !1,
                    autoPlay: !0,
                    controls: !0,
                    loop: !1,
                    autoRotate: !0
                }
            } : null;
            var t
        }
        )).filter((e => null !== e))
          , n = e.variants.map((n => ({
            id: `${n.id}`,
            featuredMediaIndex: n.featured_media ? t.findIndex((e => `${n.featured_media.id}` === e.id)) : -1,
            available: n.available,
            options: Wy(e, n.options)
        })));
        return {
            media: t,
            variants: n
        }
    }
    function $y(e) {
        return "numericSelectedBackground" === e ? "rgba(0, 0, 0, 0.75)" : "numericUnselectedBackground" === e ? "rgba(0, 0, 0, 0.2)" : "numericSelectedFill" === e ? "rgba(255, 255, 255, 1)" : "numericUnselectedFill" === e ? "rgba(0, 0, 0, 1)" : "standardSelectedBackground" === e ? "rgba(0, 0, 0, 0.75)" : "standardUnselectedBackground" === e ? "rgba(0, 0, 0, 0.2)" : null
    }
    const By = () => {
        const {html5Player: e, loop: t, ...n} = {
            html5Player: !1,
            autoPlay: !0,
            muted: !1,
            controls: !0,
            loop: !0
        };
        return n
    }
      , jy = (e="rgb(0, 0, 0)") => ({
        style: "solid",
        color: e,
        thickness: 1,
        radius: 0
    })
      , Hy = on.shape({
        autoPlay: on.bool.isRequired,
        autoRotate: on.bool.isRequired,
        controls: on.bool.isRequired,
        loop: on.bool.isRequired,
        muted: on.bool.isRequired
    })
      , Vy = on.exact({
        id: on.string.isRequired,
        gqlId: on.string.isRequired,
        type: on.string.isRequired,
        alt: on.string.isRequired,
        originalSrc: on.string.isRequired,
        transformedSrc: on.func.isRequired,
        source: on.string,
        filename: on.string,
        scale: on.number,
        rioSettings: Hy.isRequired,
        isVariantImage: on.bool
    })
      , qy = (on.shape({
        id: on.string.isRequired,
        title: on.string.isRequired,
        sku: on.string.isRequired,
        media: on.arrayOf(Vy).isRequired,
        variantMediaId: on.string,
        fullTitle: on.string,
        options: on.arrayOf(on.exact({
            name: on.string.isRequired,
            value: on.string.isRequired
        })).isRequired
    }),
    (e, t, n) => "number" != typeof e.thumbnailWidth && "number" != typeof e.thumbnailsPerRow ? new Error(`One of 'thumbnails.thumbnailWidth' or 'thumbnails.thumbnailsPerRow' required by '${n}' component are not numbers`) : e.thumbnailWidth || e.thumbnailsPerRow ? Ay(e.orientation) && e.thumbnailsPerRow && !e.thumbnailWidth && !e.container ? new Error(`Both 'thumbnails.thumbnailWidth' and 'thumbnails.thumbnailsPerRow' is required by '${n}' component.`) : void 0 : new Error(`One of 'thumbnails.thumbnailWidth' or 'thumbnails.thumbnailsPerRow' is required by '${n}' component.`))
      , Uy = on.shape({
        navigation: on.bool.isRequired,
        pagination: on.bool.isRequired,
        clickablePagination: on.bool,
        swipe: on.bool.isRequired,
        keyboard: on.bool,
        vertical: (e, t, n) => {
            if (e.vertical) {
                if (e.magnify)
                    return new Error(`'magnify' cannot be true when 'vertical' is true in '${n}' component.`);
                if (e.thumbnails)
                    return new Error(`'thumbnails' cannot be true when 'vertical' is true in '${n}' component.`)
            }
        }
        ,
        verticalSpacing: on.string,
        verticalHoistVariantImage: on.bool,
        maxHeight: on.string,
        magnify: on.oneOfType([on.oneOf([!1]), on.exact({
            width: on.string,
            height: on.string,
            zoom: on.number
        })]),
        thumbnails: on.oneOfType([on.oneOf([!1]), on.exact({
            orientation: on.oneOf(["bottom", "top", "right", "left"]).isRequired,
            multiRow: (e, t, n) => "boolean" != typeof e.multiRow ? new Error(`'thumbnails.multiRow' is required to be a boolean by '${n}' component.`) : !e.multiRow && Ay(e.orientation) ? new Error(`'thumbnails.muliRow' cannot be false with left or right 'thumbnails.orientation' in '${n}' component.`) : void 0,
            thumbnailWidth: qy,
            thumbnailsPerRow: qy,
            container: (e, t, n) => {
                if (e.container)
                    return "number" != typeof e.container ? new Error(`'thumbnails.container' needs to be a number in '${n}' component.`) : e.container < 0 || e.container > 1 ? new Error(`'thumbnails.container' needs to be between 0.0 and 1.0 (inclusive) in '${n}' component.`) : "number" != typeof e.thumbnailsPerRow ? new Error(`'thumbnails.thumbnailsPerRow' needs to also be set in conjuction with 'thumbnails.container' in '${n}' component.`) : "number" == typeof e.thumbnailWidth ? new Error(`'thumbnails.thumbnailWidth' cannot also be set with 'thumbnails.container' and 'thumbnails.thumbnailsPerRow' in '${n}' component.`) : void 0
            }
            ,
            navigation: on.bool.isRequired,
            verticalOverflow: (e, t, n) => {
                if ("boolean" == typeof e.verticalOverflow)
                    return e.verticalOverflow && !Ay(e.orientation) ? new Error(`'thumbnails.verticalOverflow' cannot be true with top or bottom 'thumbnails.orientation' in '${n}' component.`) : !e.verticalOverflow && e.navigation ? new Error(`'thumbnails.verticalOverflow' cannot be false with 'thumbnails.navigation' also being true in '${n}' component.`) : void 0
            }
        })]),
        lightBox: on.bool.isRequired,
        lightBoxZoom: (e, t, n) => {
            if (e.lightBox && !Number.isFinite(e.lightBoxZoom))
                return new Error(`'lightBoxZoom' is required when 'lightBox' is true in '${n}' component.`)
        }
    })
      , Gy = on.exact({
        id: on.string.isRequired,
        type: on.string.isRequired,
        alt: on.string,
        width: on.number,
        rioSettings: Hy.isRequired,
        transformedSrc: on.func.isRequired,
        originalSrc: on.string,
        scale: on.string,
        sources: on.oneOfType([on.arrayOf(on.string), on.arrayOf(on.shape({
            url: on.string.isRequired,
            mimeType: on.string.isRequired
        }))]),
        scaleSources: on.string
    });
    var Zy, Ky, Yy = {};
    /*! PhotoSwipe - v4.1.3 - 2019-01-08
  * http://photoswipe.com
  * Copyright (c) 2019 Dmitry Semenov;*/
    Zy = Yy,
    Ky = function() {
        return function(e, t, n, r) {
            var i = {
                features: null,
                bind: function(e, t, n, r) {
                    var i = (r ? "remove" : "add") + "EventListener";
                    t = t.split(" ");
                    for (var o = 0; o < t.length; o++)
                        t[o] && e[i](t[o], n, !1)
                },
                isArray: function(e) {
                    return e instanceof Array
                },
                createEl: function(e, t) {
                    var n = document.createElement(t || "div");
                    return e && (n.className = e),
                    n
                },
                getScrollY: function() {
                    var e = window.pageYOffset;
                    return void 0 !== e ? e : document.documentElement.scrollTop
                },
                unbind: function(e, t, n) {
                    i.bind(e, t, n, !0)
                },
                removeClass: function(e, t) {
                    var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
                    e.className = e.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                },
                addClass: function(e, t) {
                    i.hasClass(e, t) || (e.className += (e.className ? " " : "") + t)
                },
                hasClass: function(e, t) {
                    return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
                },
                getChildByClass: function(e, t) {
                    for (var n = e.firstChild; n; ) {
                        if (i.hasClass(n, t))
                            return n;
                        n = n.nextSibling
                    }
                },
                arraySearch: function(e, t, n) {
                    for (var r = e.length; r--; )
                        if (e[r][n] === t)
                            return r;
                    return -1
                },
                extend: function(e, t, n) {
                    for (var r in t)
                        if (t.hasOwnProperty(r)) {
                            if (n && e.hasOwnProperty(r))
                                continue;
                            e[r] = t[r]
                        }
                },
                easing: {
                    sine: {
                        out: function(e) {
                            return Math.sin(e * (Math.PI / 2))
                        },
                        inOut: function(e) {
                            return -(Math.cos(Math.PI * e) - 1) / 2
                        }
                    },
                    cubic: {
                        out: function(e) {
                            return --e * e * e + 1
                        }
                    }
                },
                detectFeatures: function() {
                    if (i.features)
                        return i.features;
                    var e = i.createEl().style
                      , t = ""
                      , n = {};
                    if (n.oldIE = document.all && !document.addEventListener,
                    n.touch = "ontouchstart"in window,
                    window.requestAnimationFrame && (n.raf = window.requestAnimationFrame,
                    n.caf = window.cancelAnimationFrame),
                    n.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled,
                    !n.pointerEvent) {
                        var r = navigator.userAgent;
                        if (/iP(hone|od)/.test(navigator.platform)) {
                            var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            o && o.length > 0 && (o = parseInt(o[1], 10)) >= 1 && o < 8 && (n.isOldIOSPhone = !0)
                        }
                        var a = r.match(/Android\s([0-9\.]*)/)
                          , s = a ? a[1] : 0;
                        (s = parseFloat(s)) >= 1 && (s < 4.4 && (n.isOldAndroid = !0),
                        n.androidVersion = s),
                        n.isMobileOpera = /opera mini|opera mobi/i.test(r)
                    }
                    for (var l, c, u = ["transform", "perspective", "animationName"], d = ["", "webkit", "Moz", "ms", "O"], p = 0; p < 4; p++) {
                        t = d[p];
                        for (var f = 0; f < 3; f++)
                            l = u[f],
                            c = t + (t ? l.charAt(0).toUpperCase() + l.slice(1) : l),
                            !n[l] && c in e && (n[l] = c);
                        t && !n.raf && (t = t.toLowerCase(),
                        n.raf = window[t + "RequestAnimationFrame"],
                        n.raf && (n.caf = window[t + "CancelAnimationFrame"] || window[t + "CancelRequestAnimationFrame"]))
                    }
                    if (!n.raf) {
                        var h = 0;
                        n.raf = function(e) {
                            var t = (new Date).getTime()
                              , n = Math.max(0, 16 - (t - h))
                              , r = window.setTimeout((function() {
                                e(t + n)
                            }
                            ), n);
                            return h = t + n,
                            r
                        }
                        ,
                        n.caf = function(e) {
                            clearTimeout(e)
                        }
                    }
                    return n.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect,
                    i.features = n,
                    n
                }
            };
            i.detectFeatures(),
            i.features.oldIE && (i.bind = function(e, t, n, r) {
                t = t.split(" ");
                for (var i, o = (r ? "detach" : "attach") + "Event", a = function() {
                    n.handleEvent.call(n)
                }, s = 0; s < t.length; s++)
                    if (i = t[s])
                        if ("object" == typeof n && n.handleEvent) {
                            if (r) {
                                if (!n["oldIE" + i])
                                    return !1
                            } else
                                n["oldIE" + i] = a;
                            e[o]("on" + i, n["oldIE" + i])
                        } else
                            e[o]("on" + i, n)
            }
            );
            var o = this
              , a = {
                allowPanToNext: !0,
                spacing: .12,
                bgOpacity: 1,
                mouseUsed: !1,
                loop: !0,
                pinchToClose: !0,
                closeOnScroll: !0,
                closeOnVerticalDrag: !0,
                verticalDragRange: .75,
                hideAnimationDuration: 333,
                showAnimationDuration: 333,
                showHideOpacity: !1,
                focus: !0,
                escKey: !0,
                arrowKeys: !0,
                mainScrollEndFriction: .35,
                panEndFriction: .35,
                isClickableElement: function(e) {
                    return "A" === e.tagName
                },
                getDoubleTapZoom: function(e, t) {
                    return e || t.initialZoomLevel < .7 ? 1 : 1.33
                },
                maxSpreadZoom: 1.33,
                modal: !0,
                scaleMode: "fit"
            };
            i.extend(a, r);
            var s, l, c, u, d, p, f, h, m, v, g, b, y, w, x, _, C, S, E, k, O, T, M, R, P, I, z, A, L, D, N, W, F, $, B, j, H, V, q, U, G, Z, K, Y, X, J, Q, ee, te, ne, re, ie, oe, ae, se, le, ce = {
                x: 0,
                y: 0
            }, ue = {
                x: 0,
                y: 0
            }, de = {
                x: 0,
                y: 0
            }, pe = {}, fe = 0, he = {}, me = {
                x: 0,
                y: 0
            }, ve = 0, ge = !0, be = [], ye = {}, we = !1, xe = function(e, t) {
                i.extend(o, t.publicMethods),
                be.push(e)
            }, _e = function(e) {
                var t = Bt();
                return e > t - 1 ? e - t : e < 0 ? t + e : e
            }, Ce = {}, Se = function(e, t) {
                return Ce[e] || (Ce[e] = []),
                Ce[e].push(t)
            }, Ee = function(e) {
                var t = Ce[e];
                if (t) {
                    var n = Array.prototype.slice.call(arguments);
                    n.shift();
                    for (var r = 0; r < t.length; r++)
                        t[r].apply(o, n)
                }
            }, ke = function() {
                return (new Date).getTime()
            }, Oe = function(e) {
                ae = e,
                o.bg.style.opacity = e * a.bgOpacity
            }, Te = function(e, t, n, r, i) {
                (!we || i && i !== o.currItem) && (r /= i ? i.fitRatio : o.currItem.fitRatio),
                e[T] = b + t + "px, " + n + "px" + y + " scale(" + r + ")"
            }, Me = function(e) {
                te && (e && (v > o.currItem.fitRatio ? we || (Yt(o.currItem, !1, !0),
                we = !0) : we && (Yt(o.currItem),
                we = !1)),
                Te(te, de.x, de.y, v))
            }, Re = function(e) {
                e.container && Te(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e)
            }, Pe = function(e, t) {
                t[T] = b + e + "px, 0px" + y
            }, Ie = function(e, t) {
                if (!a.loop && t) {
                    var n = u + (me.x * fe - e) / me.x
                      , r = Math.round(e - ut.x);
                    (n < 0 && r > 0 || n >= Bt() - 1 && r < 0) && (e = ut.x + r * a.mainScrollEndFriction)
                }
                ut.x = e,
                Pe(e, d)
            }, ze = function(e, t) {
                var n = dt[e] - he[e];
                return ue[e] + ce[e] + n - n * (t / g)
            }, Ae = function(e, t) {
                e.x = t.x,
                e.y = t.y,
                t.id && (e.id = t.id)
            }, Le = function(e) {
                e.x = Math.round(e.x),
                e.y = Math.round(e.y)
            }, De = null, Ne = function() {
                De && (i.unbind(document, "mousemove", Ne),
                i.addClass(e, "pwwp--has_mouse"),
                a.mouseUsed = !0,
                Ee("mouseUsed")),
                De = setTimeout((function() {
                    De = null
                }
                ), 100)
            }, We = function(e, t) {
                var n = Ut(o.currItem, pe, e);
                return t && (ee = n),
                n
            }, Fe = function(e) {
                return e || (e = o.currItem),
                e.initialZoomLevel
            }, $e = function(e) {
                return e || (e = o.currItem),
                e.w > 0 ? a.maxSpreadZoom : 1
            }, Be = function(e, t, n, r) {
                return r === o.currItem.initialZoomLevel ? (n[e] = o.currItem.initialPosition[e],
                !0) : (n[e] = ze(e, r),
                n[e] > t.min[e] ? (n[e] = t.min[e],
                !0) : n[e] < t.max[e] && (n[e] = t.max[e],
                !0))
            }, je = function(e) {
                var t = "";
                a.escKey && 27 === e.keyCode ? t = "close" : a.arrowKeys && (37 === e.keyCode ? t = "prev" : 39 === e.keyCode && (t = "next")),
                t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : e.returnValue = !1,
                o[t]()))
            }, He = function(e) {
                e && (Z || G || ne || H) && (e.preventDefault(),
                e.stopPropagation())
            }, Ve = function() {
                o.setScrollOffset(0, i.getScrollY())
            }, qe = {}, Ue = 0, Ge = function(e) {
                qe[e] && (qe[e].raf && I(qe[e].raf),
                Ue--,
                delete qe[e])
            }, Ze = function(e) {
                qe[e] && Ge(e),
                qe[e] || (Ue++,
                qe[e] = {})
            }, Ke = function() {
                for (var e in qe)
                    qe.hasOwnProperty(e) && Ge(e)
            }, Ye = function(e, t, n, r, i, o, a) {
                var s, l = ke();
                Ze(e);
                var c = function() {
                    if (qe[e]) {
                        if ((s = ke() - l) >= r)
                            return Ge(e),
                            o(n),
                            void (a && a());
                        o((n - t) * i(s / r) + t),
                        qe[e].raf = P(c)
                    }
                };
                c()
            }, Xe = {
                shout: Ee,
                listen: Se,
                viewportSize: pe,
                options: a,
                isMainScrollAnimating: function() {
                    return ne
                },
                getZoomLevel: function() {
                    return v
                },
                getCurrentIndex: function() {
                    return u
                },
                isDragging: function() {
                    return q
                },
                isZooming: function() {
                    return J
                },
                setScrollOffset: function(e, t) {
                    he.x = e,
                    D = he.y = t,
                    Ee("updateScrollOffset", he)
                },
                applyZoomPan: function(e, t, n, r) {
                    de.x = t,
                    de.y = n,
                    v = e,
                    Me(r)
                },
                init: function() {
                    if (!s && !l) {
                        var n;
                        o.framework = i,
                        o.template = e,
                        o.bg = i.getChildByClass(e, "pwwp__bg"),
                        z = e.className,
                        s = !0,
                        N = i.detectFeatures(),
                        P = N.raf,
                        I = N.caf,
                        T = N.transform,
                        L = N.oldIE,
                        o.scrollWrap = i.getChildByClass(e, "pwwp__scroll-wrap"),
                        o.container = i.getChildByClass(o.scrollWrap, "pwwp__container"),
                        d = o.container.style,
                        o.itemHolders = _ = [{
                            el: o.container.children[0],
                            wrap: 0,
                            index: -1
                        }, {
                            el: o.container.children[1],
                            wrap: 0,
                            index: -1
                        }, {
                            el: o.container.children[2],
                            wrap: 0,
                            index: -1
                        }],
                        _[0].el.style.display = _[2].el.style.display = "none",
                        function() {
                            if (T) {
                                var t = N.perspective && !R;
                                return b = "translate" + (t ? "3d(" : "("),
                                void (y = N.perspective ? ", 0px)" : ")")
                            }
                            T = "left",
                            i.addClass(e, "pwwp--ie"),
                            Pe = function(e, t) {
                                t.left = e + "px"
                            }
                            ,
                            Re = function(e) {
                                var t = e.fitRatio > 1 ? 1 : e.fitRatio
                                  , n = e.container.style
                                  , r = t * e.w
                                  , i = t * e.h;
                                n.width = r + "px",
                                n.height = i + "px",
                                n.left = e.initialPosition.x + "px",
                                n.top = e.initialPosition.y + "px"
                            }
                            ,
                            Me = function() {
                                if (te) {
                                    var e = te
                                      , t = o.currItem
                                      , n = t.fitRatio > 1 ? 1 : t.fitRatio
                                      , r = n * t.w
                                      , i = n * t.h;
                                    e.width = r + "px",
                                    e.height = i + "px",
                                    e.left = de.x + "px",
                                    e.top = de.y + "px"
                                }
                            }
                        }(),
                        m = {
                            resize: o.updateSize,
                            orientationchange: function() {
                                clearTimeout(W),
                                W = setTimeout((function() {
                                    pe.x !== o.scrollWrap.clientWidth && o.updateSize()
                                }
                                ), 500)
                            },
                            scroll: Ve,
                            keydown: je,
                            click: He
                        };
                        var r = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
                        for (N.animationName && N.transform && !r || (a.showAnimationDuration = a.hideAnimationDuration = 0),
                        n = 0; n < be.length; n++)
                            o["init" + be[n]]();
                        t && (o.ui = new t(o,i)).init(),
                        Ee("firstUpdate"),
                        u = u || a.index || 0,
                        (isNaN(u) || u < 0 || u >= Bt()) && (u = 0),
                        o.currItem = $t(u),
                        (N.isOldIOSPhone || N.isOldAndroid) && (ge = !1),
                        e.setAttribute("aria-hidden", "false"),
                        a.modal && (ge ? e.style.position = "fixed" : (e.style.position = "absolute",
                        e.style.top = i.getScrollY() + "px")),
                        void 0 === D && (Ee("initialLayout"),
                        D = A = i.getScrollY());
                        var c = "pwwp--open ";
                        for (a.mainClass && (c += a.mainClass + " "),
                        a.showHideOpacity && (c += "pwwp--animate_opacity "),
                        c += R ? "pwwp--touch" : "pwwp--notouch",
                        c += N.animationName ? " pwwp--css_animation" : "",
                        c += N.svg ? " pwwp--svg" : "",
                        i.addClass(e, c),
                        o.updateSize(),
                        p = -1,
                        ve = null,
                        n = 0; n < 3; n++)
                            Pe((n + p) * me.x, _[n].el.style);
                        L || i.bind(o.scrollWrap, h, o),
                        Se("initialZoomInEnd", (function() {
                            o.setContent(_[0], u - 1),
                            o.setContent(_[2], u + 1),
                            _[0].el.style.display = _[2].el.style.display = "block",
                            a.focus && e.focus(),
                            i.bind(document, "keydown", o),
                            N.transform && i.bind(o.scrollWrap, "click", o),
                            a.mouseUsed || i.bind(document, "mousemove", Ne),
                            i.bind(window, "resize scroll orientationchange", o),
                            Ee("bindEvents")
                        }
                        )),
                        o.setContent(_[1], u),
                        o.updateCurrItem(),
                        Ee("afterInit"),
                        ge || (w = setInterval((function() {
                            Ue || q || J || v !== o.currItem.initialZoomLevel || o.updateSize()
                        }
                        ), 1e3)),
                        i.addClass(e, "pwwp--visible")
                    }
                },
                close: function() {
                    s && (s = !1,
                    l = !0,
                    Ee("close"),
                    i.unbind(window, "resize scroll orientationchange", o),
                    i.unbind(window, "scroll", m.scroll),
                    i.unbind(document, "keydown", o),
                    i.unbind(document, "mousemove", Ne),
                    N.transform && i.unbind(o.scrollWrap, "click", o),
                    q && i.unbind(window, f, o),
                    clearTimeout(W),
                    Ee("unbindEvents"),
                    jt(o.currItem, null, !0, o.destroy))
                },
                destroy: function() {
                    Ee("destroy"),
                    Dt && clearTimeout(Dt),
                    e.setAttribute("aria-hidden", "true"),
                    e.className = z,
                    w && clearInterval(w),
                    i.unbind(o.scrollWrap, h, o),
                    i.unbind(window, "scroll", o),
                    ht(),
                    Ke(),
                    Ce = null
                },
                panTo: function(e, t, n) {
                    n || (e > ee.min.x ? e = ee.min.x : e < ee.max.x && (e = ee.max.x),
                    t > ee.min.y ? t = ee.min.y : t < ee.max.y && (t = ee.max.y)),
                    de.x = e,
                    de.y = t,
                    Me()
                },
                handleEvent: function(e) {
                    e = e || window.event,
                    m[e.type] && m[e.type](e)
                },
                goTo: function(e) {
                    var t = (e = _e(e)) - u;
                    ve = t,
                    u = e,
                    o.currItem = $t(u),
                    fe -= t,
                    Ie(me.x * fe),
                    Ke(),
                    ne = !1,
                    o.updateCurrItem()
                },
                next: function() {
                    o.goTo(u + 1)
                },
                prev: function() {
                    o.goTo(u - 1)
                },
                updateCurrZoomItem: function(e) {
                    if (e && Ee("beforeChange", 0),
                    _[1].el.children.length) {
                        var t = _[1].el.children[0];
                        te = i.hasClass(t, "pwwp__zoom-wrap") ? t.style : null
                    } else
                        te = null;
                    ee = o.currItem.bounds,
                    g = v = o.currItem.initialZoomLevel,
                    de.x = ee.center.x,
                    de.y = ee.center.y,
                    e && Ee("afterChange")
                },
                invalidateCurrItems: function() {
                    x = !0;
                    for (var e = 0; e < 3; e++)
                        _[e].item && (_[e].item.needsUpdate = !0)
                },
                updateCurrItem: function(e) {
                    if (0 !== ve) {
                        var t, n = Math.abs(ve);
                        if (!(e && n < 2)) {
                            o.currItem = $t(u),
                            we = !1,
                            Ee("beforeChange", ve),
                            n >= 3 && (p += ve + (ve > 0 ? -3 : 3),
                            n = 3);
                            for (var r = 0; r < n; r++)
                                ve > 0 ? (t = _.shift(),
                                _[2] = t,
                                p++,
                                Pe((p + 2) * me.x, t.el.style),
                                o.setContent(t, u - n + r + 1 + 1)) : (t = _.pop(),
                                _.unshift(t),
                                p--,
                                Pe(p * me.x, t.el.style),
                                o.setContent(t, u + n - r - 1 - 1));
                            if (te && 1 === Math.abs(ve)) {
                                var i = $t(C);
                                i.initialZoomLevel !== v && (Ut(i, pe),
                                Yt(i),
                                Re(i))
                            }
                            ve = 0,
                            o.updateCurrZoomItem(),
                            C = u,
                            Ee("afterChange")
                        }
                    }
                },
                updateSize: function(t) {
                    if (!ge && a.modal) {
                        var n = i.getScrollY();
                        if (D !== n && (e.style.top = n + "px",
                        D = n),
                        !t && ye.x === window.innerWidth && ye.y === window.innerHeight)
                            return;
                        ye.x = window.innerWidth,
                        ye.y = window.innerHeight,
                        e.style.height = ye.y + "px"
                    }
                    if (pe.x = o.scrollWrap.clientWidth,
                    pe.y = o.scrollWrap.clientHeight,
                    Ve(),
                    me.x = pe.x + Math.round(pe.x * a.spacing),
                    me.y = pe.y,
                    Ie(me.x * fe),
                    Ee("beforeResize"),
                    void 0 !== p) {
                        for (var r, s, l, c = 0; c < 3; c++)
                            r = _[c],
                            Pe((c + p) * me.x, r.el.style),
                            l = u + c - 1,
                            a.loop && Bt() > 2 && (l = _e(l)),
                            (s = $t(l)) && (x || s.needsUpdate || !s.bounds) ? (o.cleanSlide(s),
                            o.setContent(r, l),
                            1 === c && (o.currItem = s,
                            o.updateCurrZoomItem(!0)),
                            s.needsUpdate = !1) : -1 === r.index && l >= 0 && o.setContent(r, l),
                            s && s.container && (Ut(s, pe),
                            Yt(s),
                            Re(s));
                        x = !1
                    }
                    g = v = o.currItem.initialZoomLevel,
                    (ee = o.currItem.bounds) && (de.x = ee.center.x,
                    de.y = ee.center.y,
                    Me(!0)),
                    Ee("resize")
                },
                zoomTo: function(e, t, n, r, o) {
                    t && (g = v,
                    dt.x = Math.abs(t.x) - de.x,
                    dt.y = Math.abs(t.y) - de.y,
                    Ae(ue, de));
                    var a = We(e, !1)
                      , s = {};
                    Be("x", a, s, e),
                    Be("y", a, s, e);
                    var l = v
                      , c = de.x
                      , u = de.y;
                    Le(s);
                    var d = function(t) {
                        1 === t ? (v = e,
                        de.x = s.x,
                        de.y = s.y) : (v = (e - l) * t + l,
                        de.x = (s.x - c) * t + c,
                        de.y = (s.y - u) * t + u),
                        o && o(t),
                        Me(1 === t)
                    };
                    n ? Ye("customZoomTo", 0, 1, n, r || i.easing.sine.inOut, d) : d(1)
                }
            }, Je = {}, Qe = {}, et = {}, tt = {}, nt = {}, rt = [], it = {}, ot = [], at = {}, st = 0, lt = {
                x: 0,
                y: 0
            }, ct = 0, ut = {
                x: 0,
                y: 0
            }, dt = {
                x: 0,
                y: 0
            }, pt = {
                x: 0,
                y: 0
            }, ft = function(e, t) {
                return at.x = Math.abs(e.x - t.x),
                at.y = Math.abs(e.y - t.y),
                Math.sqrt(at.x * at.x + at.y * at.y)
            }, ht = function() {
                K && (I(K),
                K = null)
            }, mt = function() {
                q && (K = P(mt),
                Mt())
            }, vt = function(e, t) {
                return !(!e || e === document) && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pwwp__scroll-wrap") > -1) && (t(e) ? e : vt(e.parentNode, t))
            }, gt = {}, bt = function(e, t) {
                return gt.prevent = !vt(e.target, a.isClickableElement),
                Ee("preventDragEvent", e, t, gt),
                gt.prevent
            }, yt = function(e, t) {
                return t.x = e.pageX,
                t.y = e.pageY,
                t.id = e.identifier,
                t
            }, wt = function(e, t, n) {
                n.x = .5 * (e.x + t.x),
                n.y = .5 * (e.y + t.y)
            }, xt = function() {
                var e = de.y - o.currItem.initialPosition.y;
                return 1 - Math.abs(e / (pe.y / 2))
            }, _t = {}, Ct = {}, St = [], Et = function(e) {
                for (; St.length > 0; )
                    St.pop();
                return M ? (le = 0,
                rt.forEach((function(e) {
                    0 === le ? St[0] = e : 1 === le && (St[1] = e),
                    le++
                }
                ))) : e.type.indexOf("touch") > -1 ? e.touches && e.touches.length > 0 && (St[0] = yt(e.touches[0], _t),
                e.touches.length > 1 && (St[1] = yt(e.touches[1], Ct))) : (_t.x = e.pageX,
                _t.y = e.pageY,
                _t.id = "",
                St[0] = _t),
                St
            }, kt = function(e, t) {
                var n, r, i, s, l = de[e] + t[e], c = t[e] > 0, u = ut.x + t.x, d = ut.x - it.x;
                if (n = l > ee.min[e] || l < ee.max[e] ? a.panEndFriction : 1,
                l = de[e] + t[e] * n,
                (a.allowPanToNext || v === o.currItem.initialZoomLevel) && (te ? "h" !== re || "x" !== e || G || (c ? (l > ee.min[e] && (n = a.panEndFriction,
                ee.min[e],
                r = ee.min[e] - ue[e]),
                (r <= 0 || d < 0) && Bt() > 1 ? (s = u,
                d < 0 && u > it.x && (s = it.x)) : ee.min.x !== ee.max.x && (i = l)) : (l < ee.max[e] && (n = a.panEndFriction,
                ee.max[e],
                r = ue[e] - ee.max[e]),
                (r <= 0 || d > 0) && Bt() > 1 ? (s = u,
                d > 0 && u < it.x && (s = it.x)) : ee.min.x !== ee.max.x && (i = l))) : s = u,
                "x" === e))
                    return void 0 !== s && (Ie(s, !0),
                    Y = s !== it.x),
                    ee.min.x !== ee.max.x && (void 0 !== i ? de.x = i : Y || (de.x += t.x * n)),
                    void 0 !== s;
                ne || Y || v > o.currItem.fitRatio && (de[e] += t[e] * n)
            }, Ot = function(e) {
                if (!("mousedown" === e.type && e.button > 0))
                    if (Ft)
                        e.preventDefault();
                    else if (!V || "mousedown" !== e.type) {
                        if (bt(e, !0) && e.preventDefault(),
                        Ee("pointerDown"),
                        M) {
                            var t = i.arraySearch(rt, e.pointerId, "id");
                            t < 0 && (t = rt.length),
                            rt[t] = {
                                x: e.pageX,
                                y: e.pageY,
                                id: e.pointerId
                            }
                        }
                        var n = Et(e)
                          , r = n.length;
                        X = null,
                        Ke(),
                        q && 1 !== r || (q = ie = !0,
                        i.bind(window, f, o),
                        j = se = oe = H = Y = Z = U = G = !1,
                        re = null,
                        Ee("firstTouchStart", n),
                        Ae(ue, de),
                        ce.x = ce.y = 0,
                        Ae(tt, n[0]),
                        Ae(nt, tt),
                        it.x = me.x * fe,
                        ot = [{
                            x: tt.x,
                            y: tt.y
                        }],
                        $ = F = ke(),
                        We(v, !0),
                        ht(),
                        mt()),
                        !J && r > 1 && !ne && !Y && (g = v,
                        G = !1,
                        J = U = !0,
                        ce.y = ce.x = 0,
                        Ae(ue, de),
                        Ae(Je, n[0]),
                        Ae(Qe, n[1]),
                        wt(Je, Qe, pt),
                        dt.x = Math.abs(pt.x) - de.x,
                        dt.y = Math.abs(pt.y) - de.y,
                        Q = ft(Je, Qe))
                    }
            }, Tt = function(e) {
                if (e.preventDefault(),
                M) {
                    var t = i.arraySearch(rt, e.pointerId, "id");
                    if (t > -1) {
                        var n = rt[t];
                        n.x = e.pageX,
                        n.y = e.pageY
                    }
                }
                if (q) {
                    var r = Et(e);
                    if (re || Z || J)
                        X = r;
                    else if (ut.x !== me.x * fe)
                        re = "h";
                    else {
                        var o = Math.abs(r[0].x - tt.x) - Math.abs(r[0].y - tt.y);
                        Math.abs(o) >= 10 && (re = o > 0 ? "h" : "v",
                        X = r)
                    }
                }
            }, Mt = function() {
                if (X) {
                    var e = X.length;
                    if (0 !== e)
                        if (Ae(Je, X[0]),
                        et.x = Je.x - tt.x,
                        et.y = Je.y - tt.y,
                        J && e > 1) {
                            if (tt.x = Je.x,
                            tt.y = Je.y,
                            !et.x && !et.y && function(e, t) {
                                return e.x === t.x && e.y === t.y
                            }(X[1], Qe))
                                return;
                            Ae(Qe, X[1]),
                            G || (G = !0,
                            Ee("zoomGestureStarted"));
                            var t = ft(Je, Qe)
                              , n = At(t);
                            n > o.currItem.initialZoomLevel + o.currItem.initialZoomLevel / 15 && (se = !0);
                            var r = 1
                              , i = Fe()
                              , s = $e();
                            if (n < i)
                                if (a.pinchToClose && !se && g <= o.currItem.initialZoomLevel) {
                                    var l = 1 - (i - n) / (i / 1.2);
                                    Oe(l),
                                    Ee("onPinchClose", l),
                                    oe = !0
                                } else
                                    (r = (i - n) / i) > 1 && (r = 1),
                                    n = i - r * (i / 3);
                            else
                                n > s && ((r = (n - s) / (6 * i)) > 1 && (r = 1),
                                n = s + r * i);
                            r < 0 && (r = 0),
                            wt(Je, Qe, lt),
                            ce.x += lt.x - pt.x,
                            ce.y += lt.y - pt.y,
                            Ae(pt, lt),
                            de.x = ze("x", n),
                            de.y = ze("y", n),
                            j = n > v,
                            v = n,
                            Me()
                        } else {
                            if (!re)
                                return;
                            if (ie && (ie = !1,
                            Math.abs(et.x) >= 10 && (et.x -= X[0].x - nt.x),
                            Math.abs(et.y) >= 10 && (et.y -= X[0].y - nt.y)),
                            tt.x = Je.x,
                            tt.y = Je.y,
                            0 === et.x && 0 === et.y)
                                return;
                            if ("v" === re && a.closeOnVerticalDrag && "fit" === a.scaleMode && v === o.currItem.initialZoomLevel) {
                                ce.y += et.y,
                                de.y += et.y;
                                var c = xt();
                                return H = !0,
                                Ee("onVerticalDrag", c),
                                Oe(c),
                                void Me()
                            }
                            !function(e, t, n) {
                                if (e - $ > 50) {
                                    var r = ot.length > 2 ? ot.shift() : {};
                                    r.x = t,
                                    r.y = n,
                                    ot.push(r),
                                    $ = e
                                }
                            }(ke(), Je.x, Je.y),
                            Z = !0,
                            ee = o.currItem.bounds,
                            kt("x", et) || (kt("y", et),
                            Le(de),
                            Me())
                        }
                }
            }, Rt = function(e) {
                if (N.isOldAndroid) {
                    if (V && "mouseup" === e.type)
                        return;
                    e.type.indexOf("touch") > -1 && (clearTimeout(V),
                    V = setTimeout((function() {
                        V = 0
                    }
                    ), 600))
                }
                var t;
                if (Ee("pointerUp"),
                bt(e, !1) && e.preventDefault(),
                M) {
                    var n = i.arraySearch(rt, e.pointerId, "id");
                    n > -1 && (t = rt.splice(n, 1)[0],
                    navigator.msPointerEnabled ? (t.type = {
                        4: "mouse",
                        2: "touch",
                        3: "pen"
                    }[e.pointerType],
                    t.type || (t.type = e.pointerType || "mouse")) : t.type = e.pointerType || "mouse")
                }
                var r, s = Et(e), l = s.length;
                if ("mouseup" === e.type && (l = 0),
                2 === l)
                    return X = null,
                    !0;
                1 === l && Ae(nt, s[0]),
                0 !== l || re || ne || (t || ("mouseup" === e.type ? t = {
                    x: e.pageX,
                    y: e.pageY,
                    type: "mouse"
                } : e.changedTouches && e.changedTouches[0] && (t = {
                    x: e.changedTouches[0].pageX,
                    y: e.changedTouches[0].pageY,
                    type: "touch"
                })),
                Ee("touchRelease", e, t));
                var c = -1;
                if (0 === l && (q = !1,
                i.unbind(window, f, o),
                ht(),
                J ? c = 0 : -1 !== ct && (c = ke() - ct)),
                ct = 1 === l ? ke() : -1,
                r = -1 !== c && c < 150 ? "zoom" : "swipe",
                J && l < 2 && (J = !1,
                1 === l && (r = "zoomPointerUp"),
                Ee("zoomGestureEnded")),
                X = null,
                Z || G || ne || H)
                    if (Ke(),
                    B || (B = Pt()),
                    B.calculateSwipeSpeed("x"),
                    H)
                        if (xt() < a.verticalDragRange)
                            o.close();
                        else {
                            var u = de.y
                              , d = ae;
                            Ye("verticalDrag", 0, 1, 300, i.easing.cubic.out, (function(e) {
                                de.y = (o.currItem.initialPosition.y - u) * e + u,
                                Oe((1 - d) * e + d),
                                Me()
                            }
                            )),
                            Ee("onVerticalDrag", 1)
                        }
                    else {
                        if ((Y || ne) && 0 === l) {
                            if (zt(r, B))
                                return;
                            r = "zoomPointerUp"
                        }
                        ne || ("swipe" === r ? !Y && v > o.currItem.fitRatio && It(B) : Lt())
                    }
            }, Pt = function() {
                var e, t, n = {
                    lastFlickOffset: {},
                    lastFlickDist: {},
                    lastFlickSpeed: {},
                    slowDownRatio: {},
                    slowDownRatioReverse: {},
                    speedDecelerationRatio: {},
                    speedDecelerationRatioAbs: {},
                    distanceOffset: {},
                    backAnimDestination: {},
                    backAnimStarted: {},
                    calculateSwipeSpeed: function(r) {
                        ot.length > 1 ? (e = ke() - $ + 50,
                        t = ot[ot.length - 2][r]) : (e = ke() - F,
                        t = nt[r]),
                        n.lastFlickOffset[r] = tt[r] - t,
                        n.lastFlickDist[r] = Math.abs(n.lastFlickOffset[r]),
                        n.lastFlickDist[r] > 20 ? n.lastFlickSpeed[r] = n.lastFlickOffset[r] / e : n.lastFlickSpeed[r] = 0,
                        Math.abs(n.lastFlickSpeed[r]) < .1 && (n.lastFlickSpeed[r] = 0),
                        n.slowDownRatio[r] = .95,
                        n.slowDownRatioReverse[r] = 1 - n.slowDownRatio[r],
                        n.speedDecelerationRatio[r] = 1
                    },
                    calculateOverBoundsAnimOffset: function(e, t) {
                        n.backAnimStarted[e] || (de[e] > ee.min[e] ? n.backAnimDestination[e] = ee.min[e] : de[e] < ee.max[e] && (n.backAnimDestination[e] = ee.max[e]),
                        void 0 !== n.backAnimDestination[e] && (n.slowDownRatio[e] = .7,
                        n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e],
                        n.speedDecelerationRatioAbs[e] < .05 && (n.lastFlickSpeed[e] = 0,
                        n.backAnimStarted[e] = !0,
                        Ye("bounceZoomPan" + e, de[e], n.backAnimDestination[e], t || 300, i.easing.sine.out, (function(t) {
                            de[e] = t,
                            Me()
                        }
                        )))))
                    },
                    calculateAnimOffset: function(e) {
                        n.backAnimStarted[e] || (n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - n.slowDownRatioReverse[e] * n.timeDiff / 10),
                        n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]),
                        n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff,
                        de[e] += n.distanceOffset[e])
                    },
                    panAnimLoop: function() {
                        if (qe.zoomPan && (qe.zoomPan.raf = P(n.panAnimLoop),
                        n.now = ke(),
                        n.timeDiff = n.now - n.lastNow,
                        n.lastNow = n.now,
                        n.calculateAnimOffset("x"),
                        n.calculateAnimOffset("y"),
                        Me(),
                        n.calculateOverBoundsAnimOffset("x"),
                        n.calculateOverBoundsAnimOffset("y"),
                        n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05))
                            return de.x = Math.round(de.x),
                            de.y = Math.round(de.y),
                            Me(),
                            void Ge("zoomPan")
                    }
                };
                return n
            }, It = function(e) {
                if (e.calculateSwipeSpeed("y"),
                ee = o.currItem.bounds,
                e.backAnimDestination = {},
                e.backAnimStarted = {},
                Math.abs(e.lastFlickSpeed.x) <= .05 && Math.abs(e.lastFlickSpeed.y) <= .05)
                    return e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0,
                    e.calculateOverBoundsAnimOffset("x"),
                    e.calculateOverBoundsAnimOffset("y"),
                    !0;
                Ze("zoomPan"),
                e.lastNow = ke(),
                e.panAnimLoop()
            }, zt = function(e, t) {
                var n, r, s;
                if (ne || (st = u),
                "swipe" === e) {
                    var l = tt.x - nt.x
                      , c = t.lastFlickDist.x < 10;
                    l > 30 && (c || t.lastFlickOffset.x > 20) ? r = -1 : l < -30 && (c || t.lastFlickOffset.x < -20) && (r = 1)
                }
                r && ((u += r) < 0 ? (u = a.loop ? Bt() - 1 : 0,
                s = !0) : u >= Bt() && (u = a.loop ? 0 : Bt() - 1,
                s = !0),
                s && !a.loop || (ve += r,
                fe -= r,
                n = !0));
                var d, p = me.x * fe, f = Math.abs(p - ut.x);
                return n || p > ut.x == t.lastFlickSpeed.x > 0 ? (d = Math.abs(t.lastFlickSpeed.x) > 0 ? f / Math.abs(t.lastFlickSpeed.x) : 333,
                d = Math.min(d, 400),
                d = Math.max(d, 250)) : d = 333,
                st === u && (n = !1),
                ne = !0,
                Ee("mainScrollAnimStart"),
                Ye("mainScroll", ut.x, p, d, i.easing.cubic.out, Ie, (function() {
                    Ke(),
                    ne = !1,
                    st = -1,
                    (n || st !== u) && o.updateCurrItem(),
                    Ee("mainScrollAnimComplete")
                }
                )),
                n && o.updateCurrItem(!0),
                n
            }, At = function(e) {
                return 1 / Q * e * g
            }, Lt = function() {
                var e = v
                  , t = Fe()
                  , n = $e();
                v < t ? e = t : v > n && (e = n);
                var r, a = ae;
                return oe && !j && !se && v < t ? (o.close(),
                !0) : (oe && (r = function(e) {
                    Oe((1 - a) * e + a)
                }
                ),
                o.zoomTo(e, 0, 200, i.easing.cubic.out, r),
                !0)
            };
            xe("Gestures", {
                publicMethods: {
                    initGestures: function() {
                        var e = function(e, t, n, r, i) {
                            S = e + t,
                            E = e + n,
                            k = e + r,
                            O = i ? e + i : ""
                        };
                        (M = N.pointerEvent) && N.touch && (N.touch = !1),
                        M ? navigator.msPointerEnabled ? e("MSPointer", "Down", "Move", "Up", "Cancel") : e("pointer", "down", "move", "up", "cancel") : N.touch ? (e("touch", "start", "move", "end", "cancel"),
                        R = !0) : e("mouse", "down", "move", "up"),
                        f = E + " " + k + " " + O,
                        h = S,
                        M && !R && (R = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
                        o.likelyTouchDevice = R,
                        m[S] = Ot,
                        m[E] = Tt,
                        m[k] = Rt,
                        O && (m[O] = m[k]),
                        N.touch && (h += " mousedown",
                        f += " mousemove mouseup",
                        m.mousedown = m[S],
                        m.mousemove = m[E],
                        m.mouseup = m[k]),
                        R || (a.allowPanToNext = !1)
                    }
                }
            });
            var Dt, Nt, Wt, Ft, $t, Bt, jt = function(t, n, r, s) {
                var l;
                Dt && clearTimeout(Dt),
                Ft = !0,
                Wt = !0,
                t.initialLayout ? (l = t.initialLayout,
                t.initialLayout = null) : l = a.getThumbBoundsFn && a.getThumbBoundsFn(u);
                var d, p, f = r ? a.hideAnimationDuration : a.showAnimationDuration, h = function() {
                    Ge("initialZoom"),
                    r ? (o.template.removeAttribute("style"),
                    o.bg.removeAttribute("style")) : (Oe(1),
                    n && (n.style.display = "block"),
                    i.addClass(e, "pwwp--animated-in"),
                    Ee("initialZoom" + (r ? "OutEnd" : "InEnd"))),
                    s && s(),
                    Ft = !1
                };
                if (!f || !l || void 0 === l.x)
                    return Ee("initialZoom" + (r ? "Out" : "In")),
                    v = t.initialZoomLevel,
                    Ae(de, t.initialPosition),
                    Me(),
                    e.style.opacity = r ? 0 : 1,
                    Oe(1),
                    void (f ? setTimeout((function() {
                        h()
                    }
                    ), f) : h());
                d = c,
                p = !o.currItem.src || o.currItem.loadError || a.showHideOpacity,
                t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
                r || (v = l.w / t.w,
                de.x = l.x,
                de.y = l.y - A,
                o[p ? "template" : "bg"].style.opacity = .001,
                Me()),
                Ze("initialZoom"),
                r && !d && i.removeClass(e, "pwwp--animated-in"),
                p && (r ? i[(d ? "remove" : "add") + "Class"](e, "pwwp--animate_opacity") : setTimeout((function() {
                    i.addClass(e, "pwwp--animate_opacity")
                }
                ), 30)),
                Dt = setTimeout((function() {
                    if (Ee("initialZoom" + (r ? "Out" : "In")),
                    r) {
                        var n = l.w / t.w
                          , o = {
                            x: de.x,
                            y: de.y
                        }
                          , a = v
                          , s = ae
                          , c = function(t) {
                            1 === t ? (v = n,
                            de.x = l.x,
                            de.y = l.y - D) : (v = (n - a) * t + a,
                            de.x = (l.x - o.x) * t + o.x,
                            de.y = (l.y - D - o.y) * t + o.y),
                            Me(),
                            p ? e.style.opacity = 1 - t : Oe(s - t * s)
                        };
                        d ? Ye("initialZoom", 0, 1, f, i.easing.cubic.out, c, h) : (c(1),
                        Dt = setTimeout(h, f + 20))
                    } else
                        v = t.initialZoomLevel,
                        Ae(de, t.initialPosition),
                        Me(),
                        Oe(1),
                        p ? e.style.opacity = 1 : Oe(1),
                        Dt = setTimeout(h, f + 20)
                }
                ), r ? 25 : 90)
            }, Ht = {}, Vt = [], qt = {
                index: 0,
                errorMsg: '<div class="pwwp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                forceProgressiveLoading: !1,
                preload: [1, 1],
                getNumItemsFn: function() {
                    return Nt.length
                }
            }, Ut = function(e, t, n) {
                if (e.src && !e.loadError) {
                    var r = !n;
                    if (r && (e.vGap || (e.vGap = {
                        top: 0,
                        bottom: 0
                    }),
                    Ee("parseVerticalMargin", e)),
                    Ht.x = t.x,
                    Ht.y = t.y - e.vGap.top - e.vGap.bottom,
                    r) {
                        var i = Ht.x / e.w
                          , o = Ht.y / e.h;
                        e.fitRatio = i < o ? i : o;
                        var s = a.scaleMode;
                        "orig" === s ? n = 1 : "fit" === s && (n = e.fitRatio),
                        n > 1 && (n = 1),
                        e.initialZoomLevel = n,
                        e.bounds || (e.bounds = {
                            center: {
                                x: 0,
                                y: 0
                            },
                            max: {
                                x: 0,
                                y: 0
                            },
                            min: {
                                x: 0,
                                y: 0
                            }
                        })
                    }
                    if (!n)
                        return;
                    return function(e, t, n) {
                        var r = e.bounds;
                        r.center.x = Math.round((Ht.x - t) / 2),
                        r.center.y = Math.round((Ht.y - n) / 2) + e.vGap.top,
                        r.max.x = t > Ht.x ? Math.round(Ht.x - t) : r.center.x,
                        r.max.y = n > Ht.y ? Math.round(Ht.y - n) + e.vGap.top : r.center.y,
                        r.min.x = t > Ht.x ? 0 : r.center.x,
                        r.min.y = n > Ht.y ? e.vGap.top : r.center.y
                    }(e, e.w * n, e.h * n),
                    r && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center),
                    e.bounds
                }
                return e.w = e.h = 0,
                e.initialZoomLevel = e.fitRatio = 1,
                e.bounds = {
                    center: {
                        x: 0,
                        y: 0
                    },
                    max: {
                        x: 0,
                        y: 0
                    },
                    min: {
                        x: 0,
                        y: 0
                    }
                },
                e.initialPosition = e.bounds.center,
                e.bounds
            }, Gt = function(e, t, n, r, i, a) {
                t.loadError || r && (t.imageAppended = !0,
                Yt(t, r, t === o.currItem && we),
                n.appendChild(r),
                a && setTimeout((function() {
                    t && t.loaded && t.placeholder && (t.placeholder.style.display = "none",
                    t.placeholder = null)
                }
                ), 500))
            }, Zt = function(e) {
                e.loading = !0,
                e.loaded = !1;
                var t = e.img = i.createEl("pwwp__img", "img")
                  , n = function() {
                    e.loading = !1,
                    e.loaded = !0,
                    e.loadComplete ? e.loadComplete(e) : e.img = null,
                    t.onload = t.onerror = null,
                    t = null
                };
                return t.onload = n,
                t.onerror = function() {
                    e.loadError = !0,
                    n()
                }
                ,
                t.src = e.src,
                t.alt = e.alt,
                t
            }, Kt = function(e, t) {
                if (e.src && e.loadError && e.container)
                    return t && (e.container.innerHTML = ""),
                    e.container.innerHTML = a.errorMsg.replace("%url%", e.src),
                    !0
            }, Yt = function(e, t, n) {
                if (e.src) {
                    t || (t = e.container.lastChild);
                    var r = n ? e.w : Math.round(e.w * e.fitRatio)
                      , i = n ? e.h : Math.round(e.h * e.fitRatio);
                    e.placeholder && !e.loaded && (e.placeholder.style.width = r + "px",
                    e.placeholder.style.height = i + "px"),
                    t.style.width = r + "px",
                    t.style.height = i + "px"
                }
            }, Xt = function() {
                if (Vt.length) {
                    for (var e, t = 0; t < Vt.length; t++)
                        (e = Vt[t]).holder.index === e.index && Gt(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
                    Vt = []
                }
            };
            xe("Controller", {
                publicMethods: {
                    lazyLoadItem: function(e) {
                        e = _e(e);
                        var t = $t(e);
                        t && (!t.loaded && !t.loading || x) && (Ee("gettingData", e, t),
                        t.src && Zt(t))
                    },
                    initController: function() {
                        i.extend(a, qt, !0),
                        o.items = Nt = n,
                        $t = o.getItemAt,
                        Bt = a.getNumItemsFn,
                        a.loop,
                        Bt() < 3 && (a.loop = !1),
                        Se("beforeChange", (function(e) {
                            var t, n = a.preload, r = null === e || e >= 0, i = Math.min(n[0], Bt()), s = Math.min(n[1], Bt());
                            for (t = 1; t <= (r ? s : i); t++)
                                o.lazyLoadItem(u + t);
                            for (t = 1; t <= (r ? i : s); t++)
                                o.lazyLoadItem(u - t)
                        }
                        )),
                        Se("initialLayout", (function() {
                            o.currItem.initialLayout = a.getThumbBoundsFn && a.getThumbBoundsFn(u)
                        }
                        )),
                        Se("mainScrollAnimComplete", Xt),
                        Se("initialZoomInEnd", Xt),
                        Se("destroy", (function() {
                            for (var e, t = 0; t < Nt.length; t++)
                                (e = Nt[t]).container && (e.container = null),
                                e.placeholder && (e.placeholder = null),
                                e.img && (e.img = null),
                                e.preloader && (e.preloader = null),
                                e.loadError && (e.loaded = e.loadError = !1);
                            Vt = null
                        }
                        ))
                    },
                    getItemAt: function(e) {
                        return e >= 0 && void 0 !== Nt[e] && Nt[e]
                    },
                    allowProgressiveImg: function() {
                        return a.forceProgressiveLoading || !R || a.mouseUsed || screen.width > 1200
                    },
                    setContent: function(e, t) {
                        a.loop && (t = _e(t));
                        var n = o.getItemAt(e.index);
                        n && (n.container = null);
                        var r, l = o.getItemAt(t);
                        if (l) {
                            Ee("gettingData", t, l),
                            e.index = t,
                            e.item = l;
                            var c = l.container = i.createEl("pwwp__zoom-wrap");
                            if (!l.src && l.html && (l.html.tagName ? c.appendChild(l.html) : c.innerHTML = l.html),
                            Kt(l),
                            Ut(l, pe),
                            !l.src || l.loadError || l.loaded)
                                l.src && !l.loadError && ((r = i.createEl("pwwp__img", "img")).style.opacity = 1,
                                r.src = l.src,
                                r.alt = l.alt,
                                Yt(l, r),
                                Gt(0, l, c, r));
                            else {
                                if (l.loadComplete = function(n) {
                                    if (s) {
                                        if (e && e.index === t) {
                                            if (Kt(n, !0))
                                                return n.loadComplete = n.img = null,
                                                Ut(n, pe),
                                                Re(n),
                                                void (e.index === u && o.updateCurrZoomItem());
                                            n.imageAppended ? !Ft && n.placeholder && (n.placeholder.style.display = "none",
                                            n.placeholder = null) : N.transform && (ne || Ft) ? Vt.push({
                                                item: n,
                                                baseDiv: c,
                                                img: n.img,
                                                index: t,
                                                holder: e,
                                                clearPlaceholder: !0
                                            }) : Gt(0, n, c, n.img, 0, !0)
                                        }
                                        n.loadComplete = null,
                                        n.img = null,
                                        Ee("imageLoadComplete", t, n)
                                    }
                                }
                                ,
                                i.features.transform) {
                                    var d = "pwwp__img pwwp__img--placeholder";
                                    d += l.msrc ? "" : " pwwp__img--placeholder--blank";
                                    var p = i.createEl(d, l.msrc ? "img" : "");
                                    l.msrc && (p.src = l.msrc),
                                    p.alt = l.alt,
                                    Yt(l, p),
                                    c.appendChild(p),
                                    l.placeholder = p
                                }
                                l.loading || Zt(l),
                                o.allowProgressiveImg() && (!Wt && N.transform ? Vt.push({
                                    item: l,
                                    baseDiv: c,
                                    img: l.img,
                                    index: t,
                                    holder: e
                                }) : Gt(0, l, c, l.img, 0, !0))
                            }
                            Wt || t !== u ? Re(l) : (te = c.style,
                            jt(l, r || l.img)),
                            e.el.innerHTML = "",
                            e.el.appendChild(c)
                        } else
                            e.el.innerHTML = ""
                    },
                    cleanSlide: function(e) {
                        e.img && (e.img.onload = e.img.onerror = null),
                        e.loaded = e.loading = e.img = e.imageAppended = !1
                    }
                }
            });
            var Jt, Qt, en = {}, tn = function(e, t, n) {
                var r = document.createEvent("CustomEvent")
                  , i = {
                    origEvent: e,
                    target: e.target,
                    releasePoint: t,
                    pointerType: n || "touch"
                };
                r.initCustomEvent("pwwpTap", !0, !0, i),
                e.target.dispatchEvent(r)
            };
            xe("Tap", {
                publicMethods: {
                    initTap: function() {
                        Se("firstTouchStart", o.onTapStart),
                        Se("touchRelease", o.onTapRelease),
                        Se("destroy", (function() {
                            en = {},
                            Jt = null
                        }
                        ))
                    },
                    onTapStart: function(e) {
                        e.length > 1 && (clearTimeout(Jt),
                        Jt = null)
                    },
                    onTapRelease: function(e, t) {
                        var n, r;
                        if (t && !Z && !U && !Ue) {
                            var o = t;
                            if (Jt && (clearTimeout(Jt),
                            Jt = null,
                            n = o,
                            r = en,
                            Math.abs(n.x - r.x) < 25 && Math.abs(n.y - r.y) < 25))
                                return void Ee("doubleTap", o);
                            if ("mouse" === t.type)
                                return void tn(e, t, "mouse");
                            if ("BUTTON" === e.target.tagName.toUpperCase() || i.hasClass(e.target, "pwwp__single-tap"))
                                return void tn(e, t);
                            Ae(en, o),
                            Jt = setTimeout((function() {
                                tn(e, t),
                                Jt = null
                            }
                            ), 300)
                        }
                    }
                }
            }),
            xe("DesktopZoom", {
                publicMethods: {
                    initDesktopZoom: function() {
                        L || (R ? Se("mouseUsed", (function() {
                            o.setupDesktopZoom()
                        }
                        )) : o.setupDesktopZoom(!0))
                    },
                    setupDesktopZoom: function(t) {
                        Qt = {};
                        var n = "wheel mousewheel DOMMouseScroll";
                        Se("bindEvents", (function() {
                            i.bind(e, n, o.handleMouseWheel)
                        }
                        )),
                        Se("unbindEvents", (function() {
                            Qt && i.unbind(e, n, o.handleMouseWheel)
                        }
                        )),
                        o.mouseZoomedIn = !1;
                        var r, a = function() {
                            o.mouseZoomedIn && (i.removeClass(e, "pwwp--zoomed-in"),
                            o.mouseZoomedIn = !1),
                            v < 1 ? i.addClass(e, "pwwp--zoom-allowed") : i.removeClass(e, "pwwp--zoom-allowed"),
                            s()
                        }, s = function() {
                            r && (i.removeClass(e, "pwwp--dragging"),
                            r = !1)
                        };
                        Se("resize", a),
                        Se("afterChange", a),
                        Se("pointerDown", (function() {
                            o.mouseZoomedIn && (r = !0,
                            i.addClass(e, "pwwp--dragging"))
                        }
                        )),
                        Se("pointerUp", s),
                        t || a()
                    },
                    handleMouseWheel: function(e) {
                        if (v <= o.currItem.fitRatio)
                            return a.modal && (!a.closeOnScroll || Ue || q ? e.preventDefault() : T && Math.abs(e.deltaY) > 2 && (c = !0,
                            o.close())),
                            !0;
                        if (e.stopPropagation(),
                        Qt.x = 0,
                        "deltaX"in e)
                            1 === e.deltaMode ? (Qt.x = 18 * e.deltaX,
                            Qt.y = 18 * e.deltaY) : (Qt.x = e.deltaX,
                            Qt.y = e.deltaY);
                        else if ("wheelDelta"in e)
                            e.wheelDeltaX && (Qt.x = -.16 * e.wheelDeltaX),
                            e.wheelDeltaY ? Qt.y = -.16 * e.wheelDeltaY : Qt.y = -.16 * e.wheelDelta;
                        else {
                            if (!("detail"in e))
                                return;
                            Qt.y = e.detail
                        }
                        We(v, !0);
                        var t = de.x - Qt.x
                          , n = de.y - Qt.y;
                        (a.modal || t <= ee.min.x && t >= ee.max.x && n <= ee.min.y && n >= ee.max.y) && e.preventDefault(),
                        o.panTo(t, n)
                    },
                    toggleDesktopZoom: function(t) {
                        t = t || {
                            x: pe.x / 2 + he.x,
                            y: pe.y / 2 + he.y
                        };
                        var n = a.getDoubleTapZoom(!0, o.currItem)
                          , r = v === n;
                        o.mouseZoomedIn = !r,
                        o.zoomTo(r ? o.currItem.initialZoomLevel : n, t, 333),
                        i[(r ? "remove" : "add") + "Class"](e, "pwwp--zoomed-in")
                    }
                }
            });
            var nn, rn, on, an, sn, ln, cn, un, dn, pn, fn, hn, mn = {
                history: !0,
                galleryUID: 1
            }, vn = function() {
                return fn.hash.substring(1)
            }, gn = function() {
                nn && clearTimeout(nn),
                on && clearTimeout(on)
            }, bn = function() {
                var e = vn()
                  , t = {};
                if (e.length < 5)
                    return t;
                var n, r = e.split("&");
                for (n = 0; n < r.length; n++)
                    if (r[n]) {
                        var i = r[n].split("=");
                        i.length < 2 || (t[i[0]] = i[1])
                    }
                if (a.galleryPIDs) {
                    var o = t.pid;
                    for (t.pid = 0,
                    n = 0; n < Nt.length; n++)
                        if (Nt[n].pid === o) {
                            t.pid = n;
                            break
                        }
                } else
                    t.pid = parseInt(t.pid, 10) - 1;
                return t.pid < 0 && (t.pid = 0),
                t
            }, yn = function() {
                if (on && clearTimeout(on),
                Ue || q)
                    on = setTimeout(yn, 500);
                else {
                    an ? clearTimeout(rn) : an = !0;
                    var e = u + 1
                      , t = $t(u);
                    t.hasOwnProperty("pid") && (e = t.pid);
                    var n = cn + "&gid=" + a.galleryUID + "&pid=" + e;
                    un || -1 === fn.hash.indexOf(n) && (pn = !0);
                    var r = fn.href.split("#")[0] + "#" + n;
                    hn ? "#" + n !== window.location.hash && history[un ? "replaceState" : "pushState"]("", document.title, r) : un ? fn.replace(r) : fn.hash = n,
                    un = !0,
                    rn = setTimeout((function() {
                        an = !1
                    }
                    ), 60)
                }
            };
            xe("History", {
                publicMethods: {
                    initHistory: function() {
                        if (i.extend(a, mn, !0),
                        a.history) {
                            fn = window.location,
                            pn = !1,
                            dn = !1,
                            un = !1,
                            cn = vn(),
                            hn = "pushState"in history,
                            cn.indexOf("gid=") > -1 && (cn = (cn = cn.split("&gid=")[0]).split("?gid=")[0]),
                            Se("afterChange", o.updateURL),
                            Se("unbindEvents", (function() {
                                i.unbind(window, "hashchange", o.onHashChange)
                            }
                            ));
                            var e = function() {
                                ln = !0,
                                dn || (pn ? history.back() : cn ? fn.hash = cn : hn ? history.pushState("", document.title, fn.pathname + fn.search) : fn.hash = ""),
                                gn()
                            };
                            Se("unbindEvents", (function() {
                                c && e()
                            }
                            )),
                            Se("destroy", (function() {
                                ln || e()
                            }
                            )),
                            Se("firstUpdate", (function() {
                                u = bn().pid
                            }
                            ));
                            var t = cn.indexOf("pid=");
                            t > -1 && "&" === (cn = cn.substring(0, t)).slice(-1) && (cn = cn.slice(0, -1)),
                            setTimeout((function() {
                                s && i.bind(window, "hashchange", o.onHashChange)
                            }
                            ), 40)
                        }
                    },
                    onHashChange: function() {
                        if (vn() === cn)
                            return dn = !0,
                            void o.close();
                        an || (sn = !0,
                        o.goTo(bn().pid),
                        sn = !1)
                    },
                    updateURL: function() {
                        gn(),
                        sn || (un ? nn = setTimeout(yn, 800) : yn())
                    }
                }
            }),
            i.extend(o, Xe)
        }
    }
    ,
    "object" == typeof Yy ? Yy = Ky() : Zy.PhotoSwipe = Ky();
    var Xy = t(Yy)
      , Jy = {};
    /*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
  * http://photoswipe.com
  * Copyright (c) 2019 Dmitry Semenov;*/
    !function(e, t) {
        "object" == typeof Jy ? Jy = t() : e.PhotoSwipeUI_Default = t()
    }(Jy, (function() {
        return function(e, t) {
            var n, r, i, o, a, s, l, c, u, d, p, f, h, m, v, g, b, y, w = this, x = !1, _ = !0, C = !0, S = {
                barsSize: {
                    top: 44,
                    bottom: "auto"
                },
                closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                timeToIdle: 4e3,
                timeToIdleOutside: 1e3,
                loadingIndicatorDelay: 1e3,
                addCaptionHTMLFn: function(e, t) {
                    return e.title ? (t.children[0].innerHTML = e.title,
                    !0) : (t.children[0].innerHTML = "",
                    !1)
                },
                closeEl: !0,
                captionEl: !0,
                fullscreenEl: !0,
                zoomEl: !0,
                shareEl: !0,
                counterEl: !0,
                arrowEl: !0,
                preloaderEl: !0,
                tapToClose: !1,
                tapToToggleControls: !0,
                clickToCloseNonZoomable: !0,
                shareButtons: [{
                    id: "facebook",
                    label: "Share on Facebook",
                    url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                }, {
                    id: "twitter",
                    label: "Tweet",
                    url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                }, {
                    id: "pinterest",
                    label: "Pin it",
                    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                }, {
                    id: "download",
                    label: "Download image",
                    url: "{{raw_image_url}}",
                    download: !0
                }],
                getImageURLForShare: function() {
                    return e.currItem.src || ""
                },
                getPageURLForShare: function() {
                    return window.location.href
                },
                getTextForShare: function() {
                    return e.currItem.title || ""
                },
                indexIndicatorSep: " / ",
                fitControlsWidth: 1200
            }, E = function(e) {
                if (g)
                    return !0;
                e = e || window.event,
                v.timeToIdle && v.mouseUsed && !u && A();
                for (var n, r, i = (e.target || e.srcElement).getAttribute("class") || "", o = 0; o < W.length; o++)
                    (n = W[o]).onTap && i.indexOf("pwwp__" + n.name) > -1 && (n.onTap(),
                    r = !0);
                if (r) {
                    e.stopPropagation && e.stopPropagation(),
                    g = !0;
                    var a = t.features.isOldAndroid ? 600 : 30;
                    setTimeout((function() {
                        g = !1
                    }
                    ), a)
                }
            }, k = function(e, n, r) {
                t[(r ? "add" : "remove") + "Class"](e, "pwwp__" + n)
            }, O = function() {
                var e = 1 === v.getNumItemsFn();
                e !== m && (k(r, "ui--one-slide", e),
                m = e)
            }, T = function() {
                k(l, "share-modal--hidden", C)
            }, M = function() {
                return (C = !C) ? (t.removeClass(l, "pwwp__share-modal--fade-in"),
                setTimeout((function() {
                    C && T()
                }
                ), 300)) : (T(),
                setTimeout((function() {
                    C || t.addClass(l, "pwwp__share-modal--fade-in")
                }
                ), 30)),
                C || P(),
                !1
            }, R = function(t) {
                var n = (t = t || window.event).target || t.srcElement;
                return e.shout("shareLinkClick", t, n),
                !!n.href && (!!n.hasAttribute("download") || (window.open(n.href, "pwwp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)),
                C || M(),
                !1))
            }, P = function() {
                for (var e, t, n, r, i = "", o = 0; o < v.shareButtons.length; o++)
                    e = v.shareButtons[o],
                    t = v.getImageURLForShare(e),
                    n = v.getPageURLForShare(e),
                    r = v.getTextForShare(e),
                    i += '<a href="' + e.url.replace("{{url}}", encodeURIComponent(n)).replace("{{image_url}}", encodeURIComponent(t)).replace("{{raw_image_url}}", t).replace("{{text}}", encodeURIComponent(r)) + '" target="_blank" class="pwwp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>",
                    v.parseShareButtonOut && (i = v.parseShareButtonOut(e, i));
                l.children[0].innerHTML = i,
                l.children[0].onclick = R
            }, I = function(e) {
                for (var n = 0; n < v.closeElClasses.length; n++)
                    if (t.hasClass(e, "pwwp__" + v.closeElClasses[n]))
                        return !0
            }, z = 0, A = function() {
                clearTimeout(y),
                z = 0,
                u && w.setIdle(!1)
            }, L = function(e) {
                var t = (e = e || window.event).relatedTarget || e.toElement;
                t && "HTML" !== t.nodeName || (clearTimeout(y),
                y = setTimeout((function() {
                    w.setIdle(!0)
                }
                ), v.timeToIdleOutside))
            }, D = function(e) {
                f !== e && (k(p, "preloader--active", !e),
                f = e)
            }, N = function(n) {
                var a = n.vGap;
                if (!e.likelyTouchDevice || v.mouseUsed || screen.width > v.fitControlsWidth) {
                    var s = v.barsSize;
                    if (v.captionEl && "auto" === s.bottom)
                        if (o || ((o = t.createEl("pwwp__caption pwwp__caption--fake")).appendChild(t.createEl("pwwp__caption__center")),
                        r.insertBefore(o, i),
                        t.addClass(r, "pwwp__ui--fit")),
                        v.addCaptionHTMLFn(n, o, !0)) {
                            var l = o.clientHeight;
                            a.bottom = parseInt(l, 10) || 44
                        } else
                            a.bottom = s.top;
                    else
                        a.bottom = "auto" === s.bottom ? 0 : s.bottom;
                    a.top = s.top
                } else
                    a.top = a.bottom = 0
            }, W = [{
                name: "caption",
                option: "captionEl",
                onInit: function(e) {
                    i = e
                }
            }, {
                name: "share-modal",
                option: "shareEl",
                onInit: function(e) {
                    l = e
                },
                onTap: function() {
                    M()
                }
            }, {
                name: "button--share",
                option: "shareEl",
                onInit: function(e) {
                    s = e
                },
                onTap: function() {
                    M()
                }
            }, {
                name: "button--zoom",
                option: "zoomEl",
                onTap: e.toggleDesktopZoom
            }, {
                name: "counter",
                option: "counterEl",
                onInit: function(e) {
                    a = e
                }
            }, {
                name: "button--close",
                option: "closeEl",
                onTap: e.close
            }, {
                name: "button--arrow--left",
                option: "arrowEl",
                onTap: e.prev
            }, {
                name: "button--arrow--right",
                option: "arrowEl",
                onTap: e.next
            }, {
                name: "button--fs",
                option: "fullscreenEl",
                onTap: function() {
                    n.isFullscreen() ? n.exit() : n.enter()
                }
            }, {
                name: "preloader",
                option: "preloaderEl",
                onInit: function(e) {
                    p = e
                }
            }];
            w.init = function() {
                var a;
                t.extend(e.options, S, !0),
                v = e.options,
                r = t.getChildByClass(e.scrollWrap, "pwwp__ui"),
                (d = e.listen)("onVerticalDrag", (function(e) {
                    _ && e < .95 ? w.hideControls() : !_ && e >= .95 && w.showControls()
                }
                )),
                d("onPinchClose", (function(e) {
                    _ && e < .9 ? (w.hideControls(),
                    a = !0) : a && !_ && e > .9 && w.showControls()
                }
                )),
                d("zoomGestureEnded", (function() {
                    (a = !1) && !_ && w.showControls()
                }
                )),
                d("beforeChange", w.update),
                d("doubleTap", (function(t) {
                    var n = e.currItem.initialZoomLevel;
                    e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(v.getDoubleTapZoom(!1, e.currItem), t, 333)
                }
                )),
                d("preventDragEvent", (function(e, t, n) {
                    var r = e.target || e.srcElement;
                    r && r.getAttribute("class") && e.type.indexOf("mouse") > -1 && (r.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(r.tagName)) && (n.prevent = !1)
                }
                )),
                d("bindEvents", (function() {
                    t.bind(r, "pwwpTap click", E),
                    t.bind(e.scrollWrap, "pwwpTap", w.onGlobalTap),
                    e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", w.onMouseOver)
                }
                )),
                d("unbindEvents", (function() {
                    C || M(),
                    b && clearInterval(b),
                    t.unbind(document, "mouseout", L),
                    t.unbind(document, "mousemove", A),
                    t.unbind(r, "pwwpTap click", E),
                    t.unbind(e.scrollWrap, "pwwpTap", w.onGlobalTap),
                    t.unbind(e.scrollWrap, "mouseover", w.onMouseOver),
                    n && (t.unbind(document, n.eventK, w.updateFullscreen),
                    n.isFullscreen() && (v.hideAnimationDuration = 0,
                    n.exit()),
                    n = null)
                }
                )),
                d("destroy", (function() {
                    v.captionEl && (o && r.removeChild(o),
                    t.removeClass(i, "pwwp__caption--empty")),
                    l && (l.children[0].onclick = null),
                    t.removeClass(r, "pwwp__ui--over-close"),
                    t.addClass(r, "pwwp__ui--hidden"),
                    w.setIdle(!1)
                }
                )),
                v.showAnimationDuration || t.removeClass(r, "pwwp__ui--hidden"),
                d("initialZoomIn", (function() {
                    v.showAnimationDuration && t.removeClass(r, "pwwp__ui--hidden")
                }
                )),
                d("initialZoomOut", (function() {
                    t.addClass(r, "pwwp__ui--hidden")
                }
                )),
                d("parseVerticalMargin", N),
                function() {
                    var e, n, i, o = function(r) {
                        if (r)
                            for (var o = r.length, a = 0; a < o; a++) {
                                e = r[a],
                                n = e.className;
                                for (var s = 0; s < W.length; s++)
                                    i = W[s],
                                    n.indexOf("pwwp__" + i.name) > -1 && (v[i.option] ? (t.removeClass(e, "pwwp__element--disabled"),
                                    i.onInit && i.onInit(e)) : t.addClass(e, "pwwp__element--disabled"))
                            }
                    };
                    o(r.children);
                    var a = t.getChildByClass(r, "pwwp__top-bar");
                    a && o(a.children)
                }(),
                v.shareEl && s && l && (C = !0),
                O(),
                v.timeToIdle && d("mouseUsed", (function() {
                    t.bind(document, "mousemove", A),
                    t.bind(document, "mouseout", L),
                    b = setInterval((function() {
                        2 == ++z && w.setIdle(!0)
                    }
                    ), v.timeToIdle / 2)
                }
                )),
                v.fullscreenEl && !t.features.isOldAndroid && (n || (n = w.getFullscreenAPI()),
                n ? (t.bind(document, n.eventK, w.updateFullscreen),
                w.updateFullscreen(),
                t.addClass(e.template, "pwwp--supports-fs")) : t.removeClass(e.template, "pwwp--supports-fs")),
                v.preloaderEl && (D(!0),
                d("beforeChange", (function() {
                    clearTimeout(h),
                    h = setTimeout((function() {
                        e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || e.currItem.img && !e.currItem.img.naturalWidth) && D(!1) : D(!0)
                    }
                    ), v.loadingIndicatorDelay)
                }
                )),
                d("imageLoadComplete", (function(t, n) {
                    e.currItem === n && D(!0)
                }
                )))
            }
            ,
            w.setIdle = function(e) {
                u = e,
                k(r, "ui--idle", e)
            }
            ,
            w.update = function() {
                _ && e.currItem ? (w.updateIndexIndicator(),
                v.captionEl && (v.addCaptionHTMLFn(e.currItem, i),
                k(i, "caption--empty", !e.currItem.title)),
                x = !0) : x = !1,
                C || M(),
                O()
            }
            ,
            w.updateFullscreen = function(r) {
                r && setTimeout((function() {
                    e.setScrollOffset(0, t.getScrollY())
                }
                ), 50),
                t[(n.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pwwp--fs")
            }
            ,
            w.updateIndexIndicator = function() {
                v.counterEl && (a.innerHTML = e.getCurrentIndex() + 1 + v.indexIndicatorSep + v.getNumItemsFn())
            }
            ,
            w.onGlobalTap = function(n) {
                var r = (n = n || window.event).target || n.srcElement;
                if (!g)
                    if (n.detail && "mouse" === n.detail.pointerType) {
                        if (I(r))
                            return void e.close();
                        t.hasClass(r, "pwwp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? v.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint))
                    } else if (v.tapToToggleControls && (_ ? w.hideControls() : w.showControls()),
                    v.tapToClose && (t.hasClass(r, "pwwp__img") || I(r)))
                        return void e.close()
            }
            ,
            w.onMouseOver = function(e) {
                var t = (e = e || window.event).target || e.srcElement;
                k(r, "ui--over-close", I(t))
            }
            ,
            w.hideControls = function() {
                t.addClass(r, "pwwp__ui--hidden"),
                _ = !1
            }
            ,
            w.showControls = function() {
                _ = !0,
                x || w.update(),
                t.removeClass(r, "pwwp__ui--hidden")
            }
            ,
            w.supportsFullscreen = function() {
                var e = document;
                return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen)
            }
            ,
            w.getFullscreenAPI = function() {
                var t, n = document.documentElement, r = "fullscreenchange";
                return n.requestFullscreen ? t = {
                    enterK: "requestFullscreen",
                    exitK: "exitFullscreen",
                    elementK: "fullscreenElement",
                    eventK: r
                } : n.mozRequestFullScreen ? t = {
                    enterK: "mozRequestFullScreen",
                    exitK: "mozCancelFullScreen",
                    elementK: "mozFullScreenElement",
                    eventK: "moz" + r
                } : n.webkitRequestFullscreen ? t = {
                    enterK: "webkitRequestFullscreen",
                    exitK: "webkitExitFullscreen",
                    elementK: "webkitFullscreenElement",
                    eventK: "webkit" + r
                } : n.msRequestFullscreen && (t = {
                    enterK: "msRequestFullscreen",
                    exitK: "msExitFullscreen",
                    elementK: "msFullscreenElement",
                    eventK: "MSFullscreenChange"
                }),
                t && (t.enter = function() {
                    if (c = v.closeOnScroll,
                    v.closeOnScroll = !1,
                    "webkitRequestFullscreen" !== this.enterK)
                        return e.template[this.enterK]();
                    e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
                }
                ,
                t.exit = function() {
                    return v.closeOnScroll = c,
                    document[this.exitK]()
                }
                ,
                t.isFullscreen = function() {
                    return document[this.elementK]
                }
                ),
                t
            }
        }
    }
    ));
    var Qy, ew, tw, nw, rw, iw, ow, aw, sw, lw, cw, uw = t(Jy), dw = !1;
    function pw(e) {
        "string" != typeof e && (e = String(e));
        for (var t = "", n = 0; n < e.length; n++) {
            var r = e[n];
            switch (r) {
            case "<":
                t += "&lt;";
                break;
            case ">":
                t += "&gt;";
                break;
            case '"':
                t += "&quot;";
                break;
            case "&":
                t += "&amp;";
                break;
            default:
                t += r
            }
        }
        return t
    }
    function fw(e) {
        var t = "";
        for (var n in e) {
            var r = e[n];
            null != r && (t && (t += " "),
            t += "-" == n[0] ? n : rw[n] || (rw[n] = n.replace(/([A-Z])/g, "-$1").toLowerCase()),
            t += ": ",
            t += r,
            "number" == typeof r && !1 === ew.test(n) && (t += "px"),
            t += ";")
        }
        return t || void 0
    }
    function hw(e, t) {
        for (var n in t)
            e[n] = t[n];
        return e
    }
    function mw(e, t) {
        return Array.isArray(t) ? t.reduce(mw, e) : null != t && !1 !== t && e.push(t),
        e
    }
    function vw(e, t, n) {
        var r = function e(t, n, r, i, o, a) {
            if (null == t || "boolean" == typeof t)
                return "";
            Array.isArray(t) && (t = V().createElement(V().Fragment, null, t));
            var s = t.type
              , l = t.props
              , c = !1;
            n = n || {};
            var u, d = (r = r || {}).pretty, p = d && "string" == typeof d ? d : "\t";
            if ("object" != typeof t && !s)
                return pw(t);
            if ("function" == typeof s) {
                if (c = !0,
                !r.shallow || !i && !1 !== r.renderRootComponent) {
                    if (s === V().Fragment) {
                        var f = ""
                          , h = [];
                        mw(h, t.props.children);
                        for (var m = 0; m < h.length; m++)
                            f += (m > 0 && d ? "\n" : "") + e(h[m], n, r, !1 !== r.shallowHighOrder, o, a);
                        return f
                    }
                    var v, g = t.__c = {
                        __v: t,
                        context: n,
                        props: t.props,
                        setState: sw,
                        forceUpdate: sw,
                        __h: []
                    };
                    if (V().options.__b && V().options.__b(t),
                    V().options.__r && V().options.__r(t),
                    s.prototype && "function" == typeof s.prototype.render) {
                        var b = s.contextType
                          , y = b && n[b.__c]
                          , w = null != b ? y ? y.props.value : b.__ : n;
                        (g = t.__c = new s(l,w)).__v = t,
                        g._dirty = g.__d = !0,
                        g.props = l,
                        null == g.state && (g.state = {}),
                        null == g._nextState && null == g.__s && (g._nextState = g.__s = g.state),
                        g.context = w,
                        s.getDerivedStateFromProps ? g.state = hw(hw({}, g.state), s.getDerivedStateFromProps(g.props, g.state)) : g.componentWillMount && (g.componentWillMount(),
                        g.state = g._nextState !== g.state ? g._nextState : g.__s !== g.state ? g.__s : g.state),
                        v = g.render(g.props, g.state, g.context)
                    } else {
                        var x = s.contextType
                          , _ = x && n[x.__c]
                          , C = null != x ? _ ? _.props.value : x.__ : n;
                        v = s.call(t.__c, l, C)
                    }
                    return g.getChildContext && (n = hw(hw({}, n), g.getChildContext())),
                    V().options.diffed && V().options.diffed(t),
                    e(v, n, r, !1 !== r.shallowHighOrder, o, a)
                }
                s = (u = s).displayName || u !== Function && u.name || function(e) {
                    var t = (Function.prototype.toString.call(e).match(/^\s*function\s+([^( ]+)/) || "")[1];
                    if (!t) {
                        for (var n = -1, r = ow.length; r--; )
                            if (ow[r] === e) {
                                n = r;
                                break
                            }
                        n < 0 && (n = ow.push(e) - 1),
                        t = "UnnamedComponent" + n
                    }
                    return t
                }(u)
            }
            var S, E, k = "";
            if (l) {
                var O = Object.keys(l);
                r && !0 === r.sortAttributes && O.sort();
                for (var T = 0; T < O.length; T++) {
                    var M = O[T]
                      , R = l[M];
                    if ("children" !== M) {
                        if (!M.match(/[\s\n\\/='"\0<>]/) && (r && r.allAttributes || "key" !== M && "ref" !== M && "__self" !== M && "__source" !== M && "defaultValue" !== M)) {
                            if ("className" === M) {
                                if (l.class)
                                    continue;
                                M = "class"
                            } else
                                o && M.match(/^xlink:?./) && (M = M.toLowerCase().replace(/^xlink:?/, "xlink:"));
                            if ("htmlFor" === M) {
                                if (l.for)
                                    continue;
                                M = "for"
                            }
                            "style" === M && R && "object" == typeof R && (R = fw(R)),
                            "a" === M[0] && "r" === M[1] && "boolean" == typeof R && (R = String(R));
                            var P = r.attributeHook && r.attributeHook(M, R, n, r, c);
                            if (P || "" === P)
                                k += P;
                            else if ("dangerouslySetInnerHTML" === M)
                                E = R && R.__html;
                            else if ("textarea" === s && "value" === M)
                                S = R;
                            else if ((R || 0 === R || "" === R) && "function" != typeof R) {
                                if (!(!0 !== R && "" !== R || (R = M,
                                r && r.xml))) {
                                    k += " " + M;
                                    continue
                                }
                                if ("value" === M) {
                                    if ("select" === s) {
                                        a = R;
                                        continue
                                    }
                                    "option" === s && a == R && (k += " selected")
                                }
                                k += " " + M + '="' + pw(R) + '"'
                            }
                        }
                    } else
                        S = R
                }
            }
            if (d) {
                var I = k.replace(/^\n\s*/, " ");
                I === k || ~I.indexOf("\n") ? d && ~k.indexOf("\n") && (k += "\n") : k = I
            }
            if (k = "<" + s + k + ">",
            String(s).match(/[\s\n\\/='"\0<>]/))
                throw new Error(s + " is not a valid HTML tag name in " + k);
            var z, A = String(s).match(aw) || r.voidElements && String(s).match(r.voidElements), L = [];
            if (E)
                d && nw(E) && (E = "\n" + p + tw(E, p)),
                k += E;
            else if (null != S && mw(z = [], S).length) {
                for (var D = d && ~k.indexOf("\n"), N = !1, W = 0; W < z.length; W++) {
                    var F = z[W];
                    if (null != F && !1 !== F) {
                        var $ = e(F, n, r, !0, "svg" === s || "foreignObject" !== s && o, a);
                        if (d && !D && nw($) && (D = !0),
                        $)
                            if (d) {
                                var B = $.length > 0 && "<" != $[0];
                                N && B ? L[L.length - 1] += $ : L.push($),
                                N = B
                            } else
                                L.push($)
                    }
                }
                if (d && D)
                    for (var j = L.length; j--; )
                        L[j] = "\n" + p + tw(L[j], p)
            }
            if (L.length || E)
                k += L.join("");
            else if (r && r.xml)
                return k.substring(0, k.length - 1) + " />";
            return !A || z || E ? (d && ~k.indexOf("\n") && (k += "\n"),
            k += "</" + s + ">") : k = k.replace(/>$/, " />"),
            k
        }(e, t, n);
        return V().options.__c && V().options.__c(e, cw),
        r
    }
    var gw, bw, yw = {};
    try {
        dw || (dw = !0,
        Qy = {},
        V(),
        ew = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|^--/i,
        tw = function(e, t) {
            return String(e).replace(/(\n+)/g, "$1" + (t || "\t"))
        }
        ,
        nw = function(e, t, n) {
            return String(e).length > (t || 40) || !n && -1 !== String(e).indexOf("\n") || -1 !== String(e).indexOf("<")
        }
        ,
        rw = {},
        iw = {
            shallow: !0
        },
        ow = [],
        aw = /^(area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)$/,
        sw = function() {}
        ,
        vw.render = vw,
        lw = function(e, t) {
            return vw(e, t, iw)
        }
        ,
        cw = [],
        vw.shallowRender = lw,
        r(Qy, "default", (function() {
            return vw
        }
        )),
        r(Qy, "shallowRender", (function() {
            return lw
        }
        )),
        r(Qy, "renderToString", (function() {
            return vw
        }
        )),
        r(Qy, "renderToStaticMarkup", (function() {
            return vw
        }
        )),
        r(Qy, "render", (function() {
            return vw
        }
        )),
        n(Qy)),
        gw = (bw = Qy).default || bw
    } catch (e) {
        throw Error('renderToString() error: missing "preact-render-to-string" dependency.')
    }
    yw = {
        renderToString: gw,
        renderToStaticMarkup: gw
    };
    const ww = ({scale: e, mediaScale: t}) => {
        const n = (e => {
            const t = window.innerHeight / window.innerWidth
              , n = window.innerWidth * e;
            return {
                width: n,
                height: n * t
            }
        }
        )(e)
          , r = Math.min(n.width, n.height / t);
        return {
            width: r,
            height: r * t
        }
    }
    ;
    function xw({maxWidthParam: e, zoom: t, scale: n}) {
        const r = [5760];
        "number" == typeof e && r.push(e);
        const i = Math.min(...r);
        for (let e = 100; e > 0; e -= 1) {
            const {width: r, height: o} = ww({
                scale: t * (e / 100),
                mediaScale: n
            });
            if (r <= i)
                return {
                    width: r,
                    height: o
                }
        }
        return {
            width: i,
            height: i * n
        }
    }
    function _w(e, t, n, r) {
        const {type: i, sources: o, alt: a, scale: s, scaleSources: l, transformedSrc: c, rioSettings: u, ignoreScale: d=!1} = e
          , p = function({scaleSources: e, scaleParam: t, ignoreScale: n}) {
            if (n)
                return null;
            const r = e || t;
            return r ? parseFloat(r) / 100 : null
        }({
            scaleSources: l,
            scaleParam: s,
            ignoreScale: d
        });
        if ("image" === i && null !== p) {
            const r = xw({
                maxWidthParam: e.width,
                zoom: Math.max(n, ky()),
                scale: p
            })
              , i = function({imageSizeScaledWithDPP: e, imageSizeScaled: t}) {
                return e.width > 0 && e.width > t.width ? t.width / e.width : 1
            }({
                imageSizeScaled: xw({
                    maxWidthParam: e.width,
                    zoom: n,
                    scale: p
                }),
                imageSizeScaledWithDPP: r
            });
            return {
                src: c(r.width),
                msrc: t,
                alt: e.alt,
                w: r.width,
                h: r.height,
                maxZoom: i
            }
        }
        const {width: f, height: h} = ww({
            scale: .8,
            mediaScale: null === p ? 1 : p
        });
        if ("video" === i) {
            const e = `video-${mv.v4()}`;
            return {
                rioId: e,
                html: yw.renderToString(lt.createElement($l, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {
                        width: "100%",
                        height: "100%"
                    }
                }, lt.createElement($l, {
                    item: !0,
                    style: {
                        width: f,
                        height: h
                    }
                }, !r && lt.createElement("iframe", {
                    id: e,
                    frameBorder: "0",
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/video-player/index.html?payload=${encodeURIComponent(JSON.stringify({
                        ...u,
                        sources: o,
                        autoPlay: !1,
                        poster: t,
                        baseUri: document.baseURI
                    }))}`,
                    title: a
                }), r && lt.createElement("video", {
                    id: e,
                    controls: u.controls,
                    poster: t,
                    loop: u.loop,
                    autoPlay: !1,
                    muted: u.muted,
                    title: a,
                    playsInline: !0,
                    style: {
                        width: "100%",
                        height: "100%"
                    }
                }, o.map((e => lt.createElement("source", {
                    key: e.url,
                    src: e.url,
                    type: e.mimeType
                })))))))
            }
        }
        if ("external_video" === i) {
            const e = `external-video-${mv.v4()}`;
            return {
                rioId: e,
                html: yw.renderToString(lt.createElement($l, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {
                        width: "100%",
                        height: "100%"
                    }
                }, lt.createElement($l, {
                    item: !0,
                    style: {
                        width: f,
                        height: h
                    }
                }, lt.createElement("iframe", {
                    id: e,
                    frameBorder: "0",
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/yt-player/index.html?payload=${encodeURIComponent(JSON.stringify({
                        source: o[0],
                        muted: u.muted,
                        controls: u.controls,
                        autoPlay: !1,
                        title: a || void 0,
                        baseUri: document.baseURI
                    }))}`,
                    title: a
                }))))
            }
        }
        if ("model" === i) {
            const e = t;
            return {
                html: yw.renderToString(lt.createElement($l, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {
                        width: "100%",
                        height: "100%"
                    }
                }, lt.createElement($l, {
                    item: !0,
                    style: {
                        width: f,
                        height: h
                    }
                }, lt.createElement("iframe", {
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; gyroscope",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/model-viewer/index.html?src=${encodeURIComponent(o[0])}${a ? `&alt=${encodeURIComponent(a)}` : ""}${e ? `&poster=${encodeURIComponent(e)}` : ""}${u.autoRotate ? "&autorotate=true" : ""}&baseUri=${encodeURIComponent(document.baseURI)}`,
                    title: a
                }))))
            }
        }
        return {}
    }
    var Cw = (e, t, n, r, i, o) => {
        const a = (t, a) => {
            const s = (e => {
                const t = e.childNodes
                  , n = [];
                for (let e = 0; e < t.length; e += 1) {
                    const r = t[e];
                    if (1 !== r.nodeType) {
                        n.push(null);
                        continue
                    }
                    const i = Number.parseInt(r.getAttribute("data-index"), 10)
                      , o = r.children[0];
                    "IMG" === o.tagName ? n[i] = o.getAttribute("src") : "DIV" === o.tagName && "VIDEO" === o.getAttribute("data-tagname") || "DIV" === o.tagName && "MODEL" === o.getAttribute("data-tagname") ? n[i] = o.getAttribute("data-poster") : n[i] = null
                }
                return n
            }
            )(a)
              , l = r.map(( (e, t) => _w(e, s[t], i, o)))
              , c = function({media: e, items: t}) {
                const n = []
                  , r = e => {
                    try {
                        e.destroy()
                    } catch {}
                }
                  , i = new MutationObserver(( () => {
                    for (let e = 0; e < t.length; e += 1)
                        if (n[e]) {
                            const [t,i] = n[e];
                            document.body.contains(i) || (r(t),
                            delete n[e])
                        }
                }
                ));
                return i.observe(document.body, {
                    childList: !0,
                    subtree: !0
                }),
                {
                    initVideo: (r, i) => {
                        if (!n[r]) {
                            const o = e[r]
                              , {rioId: a} = t[r];
                            if ("external_video" === o.type && "string" == typeof a) {
                                const e = document.querySelector(`#${a}`)
                                  , t = ( () => {
                                    const t = e.contentWindow;
                                    return {
                                        play: () => {
                                            t.postMessage({
                                                rioOrigin: "video-player",
                                                play: !0
                                            }, "*")
                                        }
                                        ,
                                        pause: () => {
                                            t.postMessage({
                                                rioOrigin: "video-player",
                                                pause: !0
                                            }, "*")
                                        }
                                        ,
                                        destroy: () => {
                                            t.postMessage({
                                                rioOrigin: "video-player",
                                                destroy: !0
                                            }, "*")
                                        }
                                    }
                                }
                                )();
                                n[r] = [t, e]
                            }
                            if ("video" === o.type && "string" == typeof a) {
                                const e = document.querySelector(`#${a}`);
                                if (i)
                                    return void (n[r] = [e, e]);
                                const t = ( () => {
                                    const t = e.contentWindow;
                                    return {
                                        play: () => {
                                            t.postMessage({
                                                play: !0
                                            }, "*")
                                        }
                                        ,
                                        pause: () => {
                                            t.postMessage({
                                                pause: !0
                                            }, "*")
                                        }
                                        ,
                                        destroy: () => {
                                            t.postMessage({
                                                destroy: !0
                                            }, "*")
                                        }
                                    }
                                }
                                )();
                                n[r] = [t, e]
                            }
                        }
                    }
                    ,
                    playVideo: r => {
                        for (let e = 0; e < t.length; e += 1)
                            if (e !== r && n[e]) {
                                const [t] = n[e];
                                try {
                                    t.pause()
                                } catch {}
                            }
                        if (n[r] && e[r].rioSettings.autoPlay) {
                            const [e] = n[r];
                            try {
                                e.play()
                            } catch {}
                        }
                    }
                    ,
                    destroyVideos: () => {
                        i.disconnect();
                        for (let e = 0; e < t.length; e += 1)
                            if (n[e]) {
                                const [t] = n[e];
                                r(t),
                                delete n[e]
                            }
                    }
                }
            }({
                media: r,
                items: l
            })
              , u = {
                closeEl: !0,
                captionEl: !1,
                fullscreenEl: !0,
                shareEl: !1,
                counterEl: !1,
                arrowEl: !0,
                preloaderEl: !0,
                history: !1,
                galleryUID: a.getAttribute("data-pwwp-uid"),
                index: t,
                getDoubleTapZoom: (e, t) => {
                    if (0 === i)
                        return t.initialZoomLevel;
                    const n = "number" == typeof t.maxZoom ? t.maxZoom : 1;
                    return e || t.initialZoomLevel < .7 ? n : 1.5 * n
                }
                ,
                ...0 === i ? {
                    clickToCloseNonZoomable: !0,
                    closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar", "img"],
                    zoomEl: !1
                } : {
                    zoomEl: !0
                }
            }
              , d = new Xy(e.current,uw,l,u);
            d.init(),
            window.productWizRioLightboxOpen = !0,
            d.listen("unbindEvents", ( () => {
                const e = d.getCurrentIndex()
                  , t = n();
                t && t.slideToLoop(e, 0),
                c.destroyVideos(),
                window.productWizRioLightboxOpen = !1
            }
            )),
            d.listen("afterChange", ( () => {
                const e = d.getCurrentIndex();
                c.initVideo(e, o),
                c.playVideo(e)
            }
            ))
        }
        ;
        t.setAttribute("data-pwwp-uid", 1),
        t.onclick = e => {
            const t = (e, n) => e && (n(e) ? e : t(e.parentNode, n))
              , n = e || window.event;
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            const i = n.target || n.srcElement
              , o = t(i, (e => e.tagName && "div" === e.tagName.toLowerCase()));
            if (!o)
                return;
            if (!o.id.startsWith("pwzrswiper-slide"))
                return;
            const s = o.parentNode
              , l = Number.parseInt(o.getAttribute("data-index"), 10);
            return l >= 0 && "image" === r[l].type && a(l, s),
            !1
        }
    }
    ;
    function Sw({swiperWrapperElement: e, getSwiper: t, media: n, lightBoxZoom: r, html5Player: i}) {
        const o = ae(null);
        ie(( () => {
            Cw(o, e, t, n, r, i)
        }
        ), [t, i, r, n, e]);
        const a = e => {
            "Enter" !== e.key && " " !== e.key || e.target.click()
        }
        ;
        return lt.createElement("div", {
            style: {
                position: "absolute",
                zIndex: 2147483647
            }
        }, 0 === r && lt.createElement("style", null, "\n            .pwwp__img {\n              cursor: unset !important;\n            }\n          "), lt.createElement("div", {
            ref: o,
            className: "pwwp",
            tabIndex: "-1",
            role: "dialog",
            "aria-hidden": "true"
        }, lt.createElement("div", {
            id: "pwwp__bg-id",
            className: "pwwp__bg"
        }), lt.createElement("div", {
            className: "pwwp__scroll-wrap"
        }, lt.createElement("div", {
            className: "pwwp__container"
        }, lt.createElement("div", {
            className: "pwwp__item"
        }), lt.createElement("div", {
            className: "pwwp__item"
        }), lt.createElement("div", {
            className: "pwwp__item"
        })), lt.createElement("div", {
            className: "pwwp__ui pwwp__ui--hidden"
        }, lt.createElement("div", {
            className: "pwwp__top-bar"
        }, lt.createElement("div", {
            className: "pwwp__counter"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--close",
            title: "Close (Esc)",
            role: "button",
            tabIndex: 0,
            onKeyPress: a
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--share",
            title: "Share",
            role: "button",
            tabIndex: 0,
            onKeyPress: a
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--fs",
            title: "Toggle fullscreen",
            role: "button",
            tabIndex: 0,
            onKeyPress: a
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--zoom",
            title: "Zoom in/out",
            role: "button",
            tabIndex: 0,
            onKeyPress: a
        }), lt.createElement("div", {
            className: "pwwp__preloader"
        }, lt.createElement("div", {
            className: "pwwp__preloader__icn"
        }, lt.createElement("div", {
            className: "pwwp__preloader__cut"
        }, lt.createElement("div", {
            className: "pwwp__preloader__donut"
        }))))), lt.createElement("div", {
            className: "pwwp__share-modal pwwp__share-modal--hidden pwwp__single-tap"
        }, lt.createElement("div", {
            className: "pwwp__share-tooltip"
        })), lt.createElement("div", {
            className: "pwwp__button pwwp__button--arrow--left",
            title: "Previous (arrow left)",
            role: "button",
            tabIndex: 0,
            onKeyPress: a
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--arrow--right",
            title: "Next (arrow right)",
            role: "button",
            tabIndex: 0,
            onKeyPress: a
        }), lt.createElement("div", {
            className: "pwwp__caption"
        }, lt.createElement("div", {
            className: "pwwp__caption__center"
        }))))))
    }
    Sw.propTypes = {
        swiperWrapperElement: on.object.isRequired,
        getSwiper: on.func.isRequired,
        media: on.arrayOf(Gy).isRequired,
        lightBoxZoom: on.number.isRequired
    };
    let Ew = null;
    function kw({paginationSettings: e}) {
        const t = ji()
          , n = ae(null)
          , {type: r, size: i, spacing: o, standardColors: {selected: a, unselected: s}, numericColors: {selectedBackground: l, unselectedBackground: c, selectedFill: u, unselectedFill: d}, spacingFromImage: p} = e
          , f = "numeric" === r
          , h = f ? 8 * i : 3 * i
          , m = t.spacing(p)
          , v = ( ({width: e, height: t, spacing: n, selectedBackground: r, unselectedBackground: i, selectedFill: o, unselectedFill: a}) => ({
            standard: `\n      .pwzrswiper-pagination-bullet {\n        margin: ${n}px;\n        width: ${e}px;\n        height: ${t}px;\n        background: ${i};\n        opacity: 1;\n      }\n      .pwzrswiper-pagination-bullet-active {\n        background: ${r};\n      }\n    `,
            numeric: `\n      .pwzrswiper-pagination-bullet {\n        outline: none;\n        width: ${e}px;\n        height: ${t}px;\n        text-align: center;\n        line-height: ${e}px;\n        font-size: ${Math.floor(.6 * e)}px;\n        color: ${a};\n        opacity: 1;\n        background: ${i};\n        margin: ${n}px;\n        user-select: none;\n      }\n      .pwzrswiper-pagination-bullet-active {\n        color: ${o};\n        background: ${r};\n      }\n    `
        }))({
            width: h,
            height: h,
            spacing: o,
            selectedBackground: f ? l : a,
            unselectedBackground: f ? c : s,
            selectedFill: u,
            unselectedFill: d
        });
        return lt.createElement(lt.Fragment, null, lt.createElement("style", null, `\n          .pwzrswiper-pagination {\n            z-index: unset !important;\n          }\n          ${v[f ? "numeric" : "standard"]}\n        `), lt.createElement("div", {
            ref: n,
            style: {
                display: "flex",
                justifyContent: "center",
                minHeight: Ew || "initial",
                marginTop: m
            }
        }, lt.createElement(jm, {
            handleHeight: !0,
            onResize: (e, t) => {
                Ew = t;
                const r = n.current;
                r && (r.style.minHeight = "initial")
            }
        }), lt.createElement("div", {
            style: {
                position: "static",
                marginTop: f ? 10 : 5,
                marginBottom: f ? 5 : 2
            },
            className: Ra("pwzrswiper-pagination")
        })))
    }
    function Ow({rootClassName: e, border: t, slideCircular: n}) {
        return ie(( () => {
            if (!t)
                return null;
            const {style: r, color: i, thickness: o, radius: a} = t
              , s = document.createElement("style");
            return s.innerHTML = `\n      .pwzrswiper-slide[data-root="${e}"]:before {\n        content: "";\n        border: ${o}px ${r} ${i};\n        border-radius: ${n ? "50%" : `${a}px`};\n        display: block;\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        box-sizing: border-box;\n        z-index: 1;\n        pointer-events: none;\n      }\n      `,
            document.head.appendChild(s),
            () => {
                document.head.removeChild(s)
            }
        }
        ), []),
        null
    }
    Cb.use([Mb, Ib, Lb, Wb, kb]);
    class Tw extends lt.Component {
        static getPlaceholderImageWidth(e) {
            return Fb("xl", e) ? 900 : Fb("lg", e) ? 720 : Fb("md", e) ? 540 : 360
        }
        static generatePlaceholderImage(e, t) {
            const n = Tw.getPlaceholderImageWidth(t);
            return e.transformedSrc(n)
        }
        static generateResponsiveImage(e, t) {
            return e.transformedSrc(t)
        }
        constructor(e) {
            super(e),
            Pp(this, "querySelector", (e => {
                var t;
                return null === (t = this.rootRef.current) || void 0 === t ? void 0 : t.querySelector(e)
            }
            )),
            Pp(this, "querySelectorAll", (e => {
                var t;
                return null === (t = this.rootRef.current) || void 0 === t ? void 0 : t.querySelectorAll(e)
            }
            )),
            Pp(this, "scrollToSwiperSlide", ( () => {
                const {config: {disableScrollToVariantImageOnVariantChange: e}} = this.props
                  , t = this.querySelector(`#pwzrswiper-slide-${this.selected}`);
                t && !e && window.requestAnimationFrame(( () => {
                    Yb(t, {
                        time: 300
                    })
                }
                ))
            }
            )),
            Pp(this, "mountPhotoSwipe", ( () => {
                const {media: e, config: {lightBox: t, lightBoxZoom: n}} = this.props;
                if (t) {
                    this.photoSwipeId = `photo-swipe-${mv.v4()}`;
                    const t = document.createElement("div");
                    t.id = this.photoSwipeId,
                    document.body.appendChild(t),
                    je(lt.createElement(Sw, {
                        swiperWrapperElement: this.querySelector("#pwzrswiper-wrapper"),
                        getSwiper: () => this.swiper,
                        media: e,
                        lightBoxZoom: n,
                        html5Player: this.html5Player
                    }), t)
                }
            }
            )),
            Pp(this, "destroyPhotoSwipe", ( () => {
                if (this.photoSwipeId) {
                    const e = document.querySelector(`#${this.photoSwipeId}`);
                    e.parentNode.removeChild(e)
                }
            }
            )),
            Pp(this, "getCurrentSlide", ( () => this.swiper.slides[this.swiper.activeIndex])),
            Pp(this, "initVideoPlayers", ( () => {
                const e = ({players: e, all: t, payload: n}) => {
                    e.forEach((e => {
                        const {contentWindow: r} = e;
                        if (t)
                            r.postMessage(n, "*");
                        else {
                            this.getCurrentSlide().contains(e) && r.postMessage(n, "*")
                        }
                    }
                    ))
                }
                  , t = ({players: e, all: t, pause: n, destroy: r, play: i}) => {
                    e.forEach((e => {
                        const r = () => {
                            n && e.pause(),
                            i && e.play()
                        }
                        ;
                        if (t)
                            r();
                        else {
                            this.getCurrentSlide().contains(e) && r()
                        }
                    }
                    ))
                }
                  , {media: n} = this.props;
                for (let r = 0; r < n.length; r += 1) {
                    const i = n[r];
                    "external_video" === i.type && (this.videoPlayers[r] = ( () => {
                        const t = () => this.querySelectorAll(`#pwzrswiper-img-frame-${r}`);
                        return {
                            play: () => {
                                const n = t();
                                e({
                                    players: n,
                                    payload: {
                                        rioOrigin: "video-player",
                                        play: !0
                                    }
                                })
                            }
                            ,
                            pause: () => {
                                const n = t();
                                e({
                                    players: n,
                                    payload: {
                                        rioOrigin: "video-player",
                                        pause: !0
                                    },
                                    all: !0
                                })
                            }
                            ,
                            destroy: () => {
                                const n = t();
                                e({
                                    players: n,
                                    payload: {
                                        rioOrigin: "video-player",
                                        destroy: !0
                                    },
                                    all: !0
                                })
                            }
                        }
                    }
                    )()),
                    "video" === i.type && (this.html5Player ? this.videoPlayers[r] = ( () => {
                        const e = () => this.querySelectorAll(`#pwzrswiper-img-${r}`);
                        return {
                            play: () => {
                                const n = e();
                                t({
                                    players: n,
                                    play: !0
                                })
                            }
                            ,
                            pause: () => {
                                const n = e();
                                t({
                                    players: n,
                                    pause: !0,
                                    all: !0
                                })
                            }
                            ,
                            destroy: () => {
                                const n = e();
                                t({
                                    players: n,
                                    destroy: !0,
                                    all: !0
                                })
                            }
                        }
                    }
                    )() : this.videoPlayers[r] = ( () => {
                        const t = () => this.querySelectorAll(`#pwzrswiper-img-frame-${r}`);
                        return {
                            play: () => {
                                const n = t();
                                e({
                                    players: n,
                                    payload: {
                                        play: !0
                                    }
                                })
                            }
                            ,
                            pause: () => {
                                const n = t();
                                e({
                                    players: n,
                                    payload: {
                                        pause: !0
                                    },
                                    all: !0
                                })
                            }
                            ,
                            destroy: () => {
                                const n = t();
                                e({
                                    players: n,
                                    payload: {
                                        destroy: !0
                                    },
                                    all: !0
                                })
                            }
                        }
                    }
                    )())
                }
            }
            )),
            Pp(this, "destroyVideoPlayers", ( () => {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1)
                    this.videoPlayers[t] && this.videoPlayers[t].destroy()
            }
            )),
            Pp(this, "mountVideos", ( () => {
                this.videoPlayers = [],
                this.initVideoPlayers()
            }
            )),
            Pp(this, "destroyVideos", ( () => {
                this.destroyVideoPlayers(),
                delete this.videoPlayers
            }
            )),
            Pp(this, "getRioMediaSettings", ( (e, t) => function(e) {
                return Py === JSON.stringify(e)
            }(t) ? this.calculateRioMediaSettings(e) : t)),
            Pp(this, "playVideo", ( () => {
                if (window.productWizRioLightboxOpen)
                    return;
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1)
                    t !== this.selected && this.videoPlayers[t] && this.videoPlayers[t].pause();
                if (this.videoPlayers[this.selected]) {
                    const {rioSettings: t, type: n} = e[this.selected];
                    this.getRioMediaSettings(n, t).autoPlay && this.videoPlayers[this.selected].play()
                }
            }
            )),
            Pp(this, "mountSwiper", ( () => {
                const {onSlideChange: e, config: {pagination: t, navigation: n, keyboard: r, maxHeight: i, preloadNextImage: o, slideTransition: a}, config: s} = this.props
                  , l = (e, t) => s[e] ? {
                    [t]: s[e]
                } : {}
                  , {paginationSettings: c} = this;
                this.swiper = new Cb(this.querySelector(".pwzrswiper-container"),{
                    init: !1,
                    initialSlide: this.selected,
                    resizeObserver: !0,
                    autoHeight: !0,
                    allowTouchMove: !0,
                    preloadImages: !1,
                    simulateTouch: !1,
                    lazy: !0,
                    keyboard: {
                        enabled: "boolean" == typeof r && r,
                        onlyInViewport: !1
                    },
                    pagination: !!t && {
                        el: this.querySelector(".pwzrswiper-pagination"),
                        clickable: c.clickable,
                        renderBullet: function(e, t) {
                            return "numeric" === c.type ? `<span tabindex="-1" class="${t}">${e + 1}</span>` : `<span tabindex="-1" class="${t}"></span>`
                        }
                    },
                    ...l("slideTransition", "effect"),
                    ...l("simulateTouch", "simulateTouch"),
                    ...l("slideLoopInfinite", "loop"),
                    ...o ? {
                        lazy: {
                            loadPrevNext: !0
                        }
                    } : {},
                    ..."fade" === a ? {
                        fadeEffect: {
                            crossFade: !0
                        }
                    } : {}
                }),
                this.swiper.on("slideChange", ( () => {
                    this.selected = this.swiper.realIndex,
                    this.updateSwiperContainerWidth(),
                    e(this.selected),
                    this.initOrReinitDriftIfNeeded(),
                    this.playVideo()
                }
                )),
                this.swiper.on("slideChangeTransitionStart", ( () => {
                    "string" == typeof i && this.swiper.update()
                }
                ))
            }
            )),
            Pp(this, "getSwiperContainerWrapperWidth", ( () => {
                const e = this.rootRef.current;
                return e && "number" == typeof e.clientWidth && e.clientWidth > 0 ? e.clientWidth : null
            }
            )),
            Pp(this, "getMaxHeightRatio", (e => "width" === e || "square" === e ? 1 : "short" === e ? 3 / 4 : "tall" === e ? 7 / 6 : null)),
            Pp(this, "getSwiperContainerMaxWidth", ( () => {
                const {media: e, config: {maxHeight: t}} = this.props;
                if ("string" == typeof t) {
                    const n = parseFloat(this.getScale(e[this.selected]));
                    if (Number.isFinite(n)) {
                        const e = this.getMaxHeightRatio(t);
                        if ("number" == typeof e) {
                            const t = 1e4 * e / n;
                            if (Number.isFinite(t)) {
                                const e = t.toFixed(3);
                                if (e < 100) {
                                    const t = this.getSwiperContainerWrapperWidth();
                                    return "number" == typeof t ? `${Math.floor(t * (e / 100))}px` : `${e}%`
                                }
                            }
                        }
                        if (t.endsWith("px")) {
                            const e = parseFloat(t);
                            if (Number.isFinite(e))
                                return `${Math.floor(100 * e / Math.ceil(n))}px`
                        }
                    }
                }
                return "100%"
            }
            )),
            Pp(this, "updateSwiperContainerWidth", ( () => {
                if (this.swiper) {
                    const e = this.querySelector(".pwzrswiper-container");
                    if (e) {
                        const t = this.getSwiperContainerWidth();
                        t !== this.swiperContainerWidth && (e.style.width = t,
                        this.swiperContainerWidth = t)
                    }
                }
            }
            )),
            Pp(this, "getSwiperContainerWidth", ( () => `min(100%, ${this.getSwiperContainerMaxWidth()})`)),
            Pp(this, "getInitialSwiperContainerWidth", ( () => {
                const e = this.getSwiperContainerWidth();
                return this.swiperContainerWidth = e,
                e
            }
            )),
            Pp(this, "destroySwiper", ( () => {
                if (this.swiper)
                    try {
                        this.swiper.destroy()
                    } catch {}
                delete this.swiper
            }
            )),
            Pp(this, "initOrReinitDriftIfNeeded", ( () => {
                const {config: {magnify: e}, media: t} = this.props;
                if (!e)
                    return;
                this.destroyDrift(),
                this.driftIds = [];
                const n = (xg || (xg = !0,
                Sg()),
                yg).default;
                for (let e = 0; e < t.length; e += 1) {
                    if ("image" !== t[e].type)
                        continue;
                    const r = this.querySelectorAll(`#pwzrswiper-img-${e}`)
                      , i = this.querySelectorAll(`#pwzrswiper-slide-${e}`);
                    r.forEach(( (e, t) => {
                        const r = `pwzrdrift-${mv.v4()}`;
                        this[r] = new n(e,{
                            inlineContainer: i[t],
                            inlinePane: !0,
                            containInline: !0,
                            injectBaseStyles: !1,
                            handleTouch: !0,
                            zoomFactor: this.getMagnifyZoom()
                        }),
                        this.driftIds.push(r)
                    }
                    ))
                }
            }
            )),
            Pp(this, "destroyDrift", ( () => {
                Array.isArray(this.driftIds) && (this.driftIds.forEach((e => {
                    const t = this[e];
                    t && (t.destroy(),
                    delete this[e])
                }
                )),
                delete this.driftIds)
            }
            )),
            Pp(this, "updateResponsiveImages", ( () => {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1) {
                    const n = e[t]
                      , r = this.querySelectorAll(`#pwzrswiper-img-${t}`);
                    for (const e of r) {
                        const t = Tw.generateResponsiveImage(n, this.responsiveImageWidth)
                          , r = Tw.generateResponsiveImage(n, Ly(this.containerWidth * Math.max(ky(), this.getMagnifyZoom())));
                        "video" === n.type ? e.setAttribute("poster", t) : "image" === n.type && ("string" == typeof e.className && (e.className = e.className.replace("pwzrswiper-lazy-loaded", "")),
                        e.setAttribute(this.swiper ? "data-src" : "src", t),
                        e.setAttribute("data-zoom", r))
                    }
                }
            }
            )),
            Pp(this, "getMagnifyZoom", ( () => {
                const {config: {magnify: e}} = this.props;
                return e && e.zoom || 3
            }
            )),
            Pp(this, "getScale", (e => e.scaleSources || e.scale)),
            Pp(this, "updateScaling", (e => {
                for (let t = 0; t < e.length; t += 1) {
                    const n = e[t]
                      , r = this.querySelectorAll(`#pwzrswiper-slide-${t}`)
                      , i = this.getScale(n);
                    for (const e of r)
                        e.style.paddingBottom = i
                }
            }
            ));
            const {selected: t, config: {paginationSettings: n}, mediaDefaults: r} = e
              , {video: i, externalVideo: o, model: a} = r || {};
            this.selected = t,
            this.rootRef = lt.createRef(),
            this.rootClassName = `rio-${mv.v4()}`,
            this.paginationSettings = {
                type: "standard",
                clickable: !1,
                size: 3,
                spacing: 3,
                spacingFromImage: 0,
                standardColors: {
                    selected: $y("standardSelectedBackground"),
                    unselected: $y("standardUnselectedBackground")
                },
                numericColors: {
                    selectedBackground: $y("numericSelectedBackground"),
                    unselectedBackground: $y("numericUnselectedBackground"),
                    selectedFill: $y("numericSelectedFill"),
                    unselectedFill: $y("numericUnselectedFill")
                },
                ...n || {}
            };
            const s = {
                video: {
                    muted: !1,
                    autoPlay: !0,
                    controls: !0,
                    loop: !1,
                    autoRotate: !0,
                    ...{
                        html5Player: !1,
                        autoPlay: !0,
                        muted: !1,
                        controls: !0,
                        loop: !0,
                        ...i || {}
                    }
                },
                externalVideo: {
                    muted: !1,
                    autoPlay: !0,
                    controls: !0,
                    loop: !1,
                    autoRotate: !0,
                    ...{
                        ...By(),
                        ...o || {}
                    }
                },
                model: {
                    muted: !1,
                    autoPlay: !0,
                    controls: !0,
                    loop: !1,
                    autoRotate: !0,
                    ...{
                        autoRotate: !0,
                        ...a || {}
                    }
                }
            };
            this.html5Player = s.video.html5Player,
            this.calculateRioMediaSettings = e => "external_video" === e ? s.externalVideo : "model" === e ? s.model : s.video
        }
        componentDidMount() {
            const {scrollIntoViewOnMount: e, config: {vertical: t}} = this.props;
            t || this.mountSwiper(),
            this.mountPhotoSwipe(),
            this.initOrReinitDriftIfNeeded(),
            this.mountVideos(),
            e && this.scrollToSwiperSlide()
        }
        shouldComponentUpdate(e) {
            const {selected: t} = e;
            return this.selected !== t && (this.swiper ? this.swiper.slideToLoop(t) : (this.selected = t,
            this.scrollToSwiperSlide())),
            !1
        }
        componentWillUnmount() {
            this.destroyVideos(),
            this.destroyDrift(),
            this.destroySwiper(),
            this.destroyPhotoSwipe()
        }
        render() {
            const {media: e, classes: t, width: n, config: {pagination: r, navigation: i, navigationSettings: o, magnify: a, lightBox: s, vertical: l, verticalSpacing: c, verticalType: u, border: d, slideCircular: p}} = this.props
              , f = l ? {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap"
            } : {}
              , h = l ? {} : {
                width: this.getInitialSwiperContainerWidth(),
                ...a ? {
                    [a.width && "full" !== a.width && "--magnify-width"]: a.width,
                    [a.height && "full" !== a.height && "--magnify-height"]: a.height
                } : {}
            }
              , m = 1 === e.length
              , v = () => {
                if (d) {
                    const {radius: e} = d;
                    return {
                        borderRadius: p ? "50%" : `${e}px`,
                        overflow: "hidden"
                    }
                }
                return {}
            }
              , g = ( () => {
                const e = {
                    type: "oval",
                    size: 5,
                    fill: "rgba(255, 255, 255, 1)",
                    background: "rgba(0, 0, 0, 0.4)",
                    ...o || {}
                }
                  , {widthPx: t, heightPx: n, borderRadius: r, svgSize: i} = ( () => {
                    const t = 8 * e.size
                      , n = () => t - (4 / 3 * e.size + 8 / 3)
                      , r = () => t - (8 / 3 * e.size + 16 / 3)
                      , i = `${t}px`
                      , {type: o} = e;
                    return "circle" === o ? {
                        widthPx: i,
                        heightPx: i,
                        borderRadius: "50%",
                        svgSize: r()
                    } : "square" === o ? {
                        widthPx: i,
                        heightPx: i,
                        borderRadius: "3px",
                        svgSize: r()
                    } : "rectangle" === o ? {
                        widthPx: t / 1.6 + "px",
                        heightPx: i,
                        borderRadius: "3px",
                        svgSize: n()
                    } : {
                        widthPx: i,
                        heightPx: 1.4 * t + "px",
                        borderRadius: "50%",
                        svgSize: n()
                    }
                }
                )();
                return {
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: t,
                    height: n,
                    zIndex: 1,
                    borderRadius: r,
                    fill: e.fill,
                    backgroundColor: e.background,
                    svgSize: i
                }
            }
            )();
            return lt.createElement("div", {
                ref: this.rootRef,
                id: "pwzrswiper-container-wrapper"
            }, lt.createElement(Ow, {
                slideCircular: p,
                border: d,
                rootClassName: this.rootClassName
            }), !l && lt.createElement(jm, {
                handleWidth: !0,
                skipOnMount: !0,
                onResize: () => {
                    this.updateSwiperContainerWidth()
                }
            }), lt.createElement("div", {
                style: {
                    position: "relative"
                }
            }, lt.createElement("div", {
                className: Ra("pwzrswiper-container", l ? null : t.containerHidden),
                style: h
            }, lt.createElement(jm, {
                handleWidth: !0,
                handleHeight: !0,
                onResize: (r, i) => {
                    const o = () => {
                        this.containerWidth = r;
                        const e = Ly(r * ky());
                        this.responsiveImageWidth !== e && (this.responsiveImageWidth = Math.max(e, Tw.getPlaceholderImageWidth(n)),
                        this.updateResponsiveImages())
                    }
                    ;
                    if (!l && (this.swiper || this.mountSwiper(),
                    !this.swiper.initialized)) {
                        const n = this.querySelector(".pwzrswiper-container");
                        n.className = n.className.replace(t.containerHidden, t.containerVisible),
                        o(),
                        this.swiper.init(),
                        this.updateScaling(e),
                        this.updateSwiperContainerWidth()
                    }
                    o(),
                    this.swiper && this.swiper.update()
                }
            }), lt.createElement("div", {
                id: "pwzrswiper-wrapper",
                className: "pwzrswiper-wrapper",
                style: f
            }, e.map(( (e, r) => {
                const i = Tw.generatePlaceholderImage(e, n)
                  , {id: o, alt: d, type: p, sources: f, rioSettings: h} = e
                  , g = this.getRioMediaSettings(p, h)
                  , b = (l || r === this.selected) && g.muted && g.autoPlay
                  , y = Number.parseInt(c, 10) || 0;
                return lt.createElement("div", {
                    id: `pwzrswiper-slide-${r}`,
                    className: "pwzrswiper-slide",
                    "data-root": this.rootClassName,
                    "data-index": r,
                    style: {
                        cursor: s && "image" === p ? "pointer" : "default",
                        paddingBottom: ( () => {
                            if (!l)
                                return r === this.selected ? this.getScale(e) : void 0;
                            if (!m) {
                                const t = () => {
                                    const t = Number.parseFloat(this.getScale(e)) / 100 * (y / 2);
                                    return `calc((${this.getScale(e)} / 2) - ${t}px)`
                                }
                                ;
                                if ("two-columns" === u)
                                    return t();
                                if ("two-columns-main" === u && r > 0)
                                    return t()
                            }
                            return this.getScale(e)
                        }
                        )(),
                        marginBottom: ( () => {
                            if (l)
                                return `${y}px`
                        }
                        )(),
                        width: ( () => {
                            if (l) {
                                if (!m) {
                                    const e = () => `calc(50% - ${y / 2}px)`;
                                    if ("two-columns" === u)
                                        return e();
                                    if ("two-columns-main" === u && r > 0)
                                        return e()
                                }
                                return "100%"
                            }
                        }
                        )(),
                        marginRight: ( () => {
                            if (l && !m) {
                                if ("two-columns" === u && r % 2 == 0)
                                    return `${y}px`;
                                if ("two-columns-main" === u && r % 2 != 0)
                                    return `${y}px`
                            }
                        }
                        )(),
                        ...v()
                    },
                    key: o
                }, "video" === p && !this.html5Player && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: Ra("pwzrswiper-lazy", t.slideExternalVideo),
                    "data-tagname": "VIDEO",
                    "data-poster": i
                }, lt.createElement("iframe", {
                    id: `pwzrswiper-img-frame-${r}`,
                    className: t.slideExternalVideoIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/video-player/index.html?payload=${encodeURIComponent(JSON.stringify({
                        ...g,
                        autoPlay: b,
                        sources: f,
                        poster: i,
                        baseUri: document.baseURI
                    }))}`,
                    title: d
                })), "video" === p && this.html5Player && lt.createElement("video", {
                    id: `pwzrswiper-img-${r}`,
                    className: Ra("pwzrswiper-lazy", t.slideVideo),
                    controls: g.controls,
                    poster: i,
                    loop: g.loop,
                    autoPlay: b,
                    muted: g.muted,
                    title: d,
                    playsInline: !0
                }, f.map((e => lt.createElement("source", {
                    key: e.url,
                    src: e.url,
                    type: e.mimeType
                })))), "model" === p && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: Ra("pwzrswiper-lazy", t.slideModel),
                    "data-tagname": "MODEL",
                    "data-poster": i
                }, lt.createElement("iframe", {
                    className: t.slideModelIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; gyroscope",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/model-viewer/index.html?src=${encodeURIComponent(f[0])}${d ? `&alt=${encodeURIComponent(d)}` : ""}&poster=${encodeURIComponent(i)}${g.autoRotate ? "&autorotate=true" : ""}&baseUri=${encodeURIComponent(document.baseURI)}`,
                    title: d
                })), "external_video" === p && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: Ra("pwzrswiper-lazy", t.slideExternalVideo)
                }, lt.createElement("iframe", {
                    id: `pwzrswiper-img-frame-${r}`,
                    className: t.slideExternalVideoIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/yt-player/index.html?payload=${encodeURIComponent(JSON.stringify({
                        source: f[0],
                        muted: g.muted,
                        controls: g.controls,
                        autoPlay: b,
                        title: d || void 0,
                        baseUri: document.baseURI
                    }))}`,
                    title: d
                })), "image" === p && lt.createElement("img", {
                    id: `pwzrswiper-img-${r}`,
                    className: Ra("pwzrswiper-lazy", t.slideImg),
                    src: i,
                    alt: d
                }), a && "image" === p && lt.createElement(jm, {
                    handleWidth: !0,
                    handleHeight: !0,
                    onResize: () => {
                        const e = this.querySelectorAll(`#pwzrswiper-slide-${r}`);
                        for (const t of e) {
                            const {style: e, clientHeight: n, clientWidth: r} = t;
                            "full" === a.width && (e.setProperty("--magnify-width", `${r}px`),
                            e.setProperty("--magnify-width-full", "yes")),
                            "full" === a.height && (e.setProperty("--magnify-height", `${n}px`),
                            e.setProperty("--magnify-height-full", "yes"))
                        }
                    }
                }))
            }
            )))), !l && i && e.length > 1 && lt.createElement(lt.Fragment, null, lt.createElement("style", null, "\n                  .pwzrswiper-button-disabled {\n                    opacity: 0.35;\n                    cursor: auto;\n                    pointer-events: none;\n                  }\n                "), lt.createElement("div", {
                style: g,
                className: Ra("pwzrswiper-btn-next", t.arrowRight),
                onClick: () => {
                    const t = this.selected + 1 > e.length - 1 ? 0 : this.selected + 1;
                    this.swiper.slideToLoop(t)
                }
                ,
                onKeyPress: e => {
                    "Enter" !== e.key && " " !== e.key || e.target.click()
                }
                ,
                "aria-label": "Next slide",
                tabIndex: "0",
                role: "button"
            }, lt.createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: g.svgSize,
                height: g.svgSize,
                viewBox: "0 0 20 20"
            }, lt.createElement("path", {
                d: "M5.377 19.523a.675.675 0 010-.955L13.945 10 5.377 1.432a.675.675 0 11.955-.955l8.815 8.816a1 1 0 010 1.414l-8.815 8.816a.675.675 0 01-.955 0z"
            }))), lt.createElement("div", {
                style: g,
                className: Ra("pwzrswiper-btn-prev", t.arrowLeft),
                onClick: () => {
                    const t = this.selected - 1 < 0 ? e.length - 1 : this.selected - 1;
                    this.swiper.slideToLoop(t)
                }
                ,
                onKeyPress: e => {
                    "Enter" !== e.key && " " !== e.key || e.target.click()
                }
                ,
                "aria-label": "Previous slide",
                tabIndex: "0",
                role: "button"
            }, lt.createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: g.svgSize,
                height: g.svgSize,
                viewBox: "0 0 20 20"
            }, lt.createElement("path", {
                d: "M14.477.477a.675.675 0 010 .955L5.91 10l8.568 8.568a.675.675 0 11-.954.955l-8.816-8.816a1 1 0 010-1.414L13.523.477a.675.675 0 01.954 0z"
            }))))), !l && r && e.length > 1 && lt.createElement(kw, {
                paginationSettings: this.paginationSettings
            }))
        }
    }
    Tw.propTypes = {
        config: Uy.isRequired,
        onSlideChange: on.func.isRequired,
        selected: on.number.isRequired,
        width: on.string.isRequired,
        media: on.arrayOf(Gy).isRequired,
        scrollIntoViewOnMount: on.bool.isRequired,
        classes: on.exact({
            slideImg: on.string.isRequired,
            slideModel: on.string.isRequired,
            slideModelIframe: on.string.isRequired,
            slideExternalVideo: on.string.isRequired,
            slideExternalVideoIframe: on.string.isRequired,
            slideVideo: on.string.isRequired,
            arrow: on.string.isRequired,
            arrowRight: on.string.isRequired,
            arrowLeft: on.string.isRequired,
            containerVisible: on.string.isRequired,
            containerHidden: on.string.isRequired
        }).isRequired
    };
    var Mw = function() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
        return function(e) {
            var n = t.reduceRight((function(e, t) {
                return t(e)
            }
            ), e);
            return ja(n, e)
        }
    }(Rg({
        containerVisible: {
            opacity: 1,
            transition: "opacity 0.2s ease-in-out"
        },
        containerHidden: {
            opacity: 0
        },
        slideImg: {
            position: "absolute",
            width: "100%",
            height: "auto",
            maxWidth: "none"
        },
        slideModel: {
            position: "absolute",
            width: "100%",
            height: "100%",
            maxWidth: "none"
        },
        slideModelIframe: {
            width: "100%",
            height: "100%"
        },
        slideExternalVideo: {
            position: "absolute",
            width: "100%",
            height: "100%",
            maxWidth: "none"
        },
        slideExternalVideoIframe: {
            width: "100%",
            height: "100%"
        },
        arrowRight: {
            right: "5px"
        },
        arrowLeft: {
            left: "5px"
        },
        slideVideo: {
            position: "absolute",
            width: "100%",
            height: "auto",
            maxWidth: "none"
        }
    }), function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return function(t) {
            var n = e.withTheme
              , r = void 0 !== n && n
              , i = e.noSSR
              , o = void 0 !== i && i
              , a = e.initialWidth;
            function s(e) {
                var n = Za()
                  , i = e.theme || n
                  , s = Er({
                    theme: i,
                    name: "PwzrWithWidth",
                    props: Vt({}, e)
                })
                  , l = s.initialWidth
                  , c = s.width
                  , u = jt(s, ["initialWidth", "width"])
                  , d = lt.useState(!1)
                  , p = d[0]
                  , f = d[1];
                $b((function() {
                    f(!0)
                }
                ), []);
                var h = yo(i.breakpoints.keys).reverse().reduce((function(e, t) {
                    var n = qd(i.breakpoints.up(t));
                    return !e && n ? t : e
                }
                ), null)
                  , m = Vt({
                    width: c || (p || o ? h : void 0) || l || a
                }, r ? {
                    theme: i
                } : {}, {}, u);
                return void 0 === m.width ? null : lt.createElement(t, m)
            }
            return ja(s, t),
            s
        }
    }())(Tw);
    function Rw() {
        return lt.createElement("svg", {
            riocandrag: "true",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20"
        }, lt.createElement("path", {
            fill: "#212b36",
            d: "M3.2 0h13.6A3.2 3.2 0 0120 3.2v13.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 16.8V3.2A3.2 3.2 0 013.2 0z",
            opacity: ".9"
        }), lt.createElement("path", {
            fill: "#c4cdd5",
            d: "M8.277 12.927V7.07l4.649 2.927-4.649 2.93zm-.134-7.235a.595.595 0 00-.32-.092c-.344 0-.623.292-.623.653v7.492c0 .119.03.235.089.337.177.309.56.41.855.224l5.954-3.747a.638.638 0 00.214-.224.673.673 0 00-.214-.897L8.144 5.691z"
        }))
    }
    function Pw() {
        return lt.createElement("svg", {
            riocandrag: "true",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20"
        }, lt.createElement("path", {
            fill: "#212b36",
            d: "M3.2 0h13.6A3.2 3.2 0 0120 3.2v13.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 16.8V3.2A3.2 3.2 0 013.2 0z",
            opacity: ".9"
        }), lt.createElement("path", {
            fill: "#c4cdd5",
            d: "M14.139 7.816l-3.877-2.149a.54.54 0 00-.523 0L5.862 7.816a.496.496 0 00-.261.435v4.298c0 .179.1.345.261.435l3.877 2.149a.54.54 0 00.523 0l3.877-2.149a.496.496 0 00.261-.435V8.251c0-.179-.1-.345-.261-.435zM10 6.682l2.831 1.569L10 9.82 7.169 8.251 10 6.682zM6.646 9.12l2.831 1.569v3.139l-2.831-1.57V9.119zm3.877 4.709V10.69l2.831-1.569v3.138l-2.831 1.57z"
        }))
    }
    const Iw = Mh(( () => ({
        thumbnailImage: {
            width: "100%",
            height: "100%"
        },
        thumbnailPlay: {
            position: "absolute",
            top: "4px",
            right: "2px",
            width: "26px",
            height: "26px"
        },
        thumbnailButton: {
            position: "relative",
            boxSizing: "border-box"
        }
    })));
    const zw = lt.forwardRef(( ({config: {thumbnails: {thumbnailWidth: e, thumbnailsPerRow: t, orientation: n, multiRow: r, spacing: i, fit: o, borderSelected: a, borderUnselected: s}, pagination: l}, media: c, onThumbnailSelected: u, selected: d, swiperKey: p, onThumbnailsScrolled: f, onThumbnailsResized: h, isDefaultMedia: m}, v) => {
        const g = Iw()
          , b = Boolean(e)
          , y = Ay(n)
          , [w,x] = ne(b ? e : 0)
          , _ = ae(p)
          , C = ae(!m)
          , S = ce((e => {
            if (e) {
                if (_.current !== p && (C.current = !0,
                _.current = p),
                C.current)
                    return void (C.current = !1);
                window.requestAnimationFrame(( () => {
                    Yb(e, {
                        time: 100,
                        lockX: y,
                        lockY: !y,
                        scrollAllParents: !1
                    }, ( () => {
                        f()
                    }
                    ))
                }
                ))
            }
        }
        ), [y, f, p])
          , E = Za().spacing("number" == typeof i ? i : 1)
          , k = "contain" === o || "cover" === o
          , O = le(( () => {
            const e = {
                ...jy(null),
                ...a || {}
            };
            return {
                border: `${e.thickness}px ${e.style} ${e.color || "var(--rio-thumbnail-selection-color, rgb(0, 0, 0))"}`,
                borderRadius: `${e.radius}px`,
                overflow: "hidden"
            }
        }
        ), [a])
          , T = le(( () => {
            const e = {
                style: "solid",
                color: null,
                thickness: 1,
                radius: 0,
                ...s || {}
            };
            return {
                border: `${e.thickness}px ${e.style} ${e.color || "transparent"}`,
                borderRadius: `${e.radius}px`,
                overflow: "hidden"
            }
        }
        ), [s]);
        return lt.createElement($l, {
            onScroll: () => {
                f()
            }
            ,
            ref: v,
            container: !0,
            direction: "row",
            justify: r ? "center" : void 0,
            alignItems: "center",
            wrap: r ? "wrap" : "nowrap",
            style: {
                overflow: "auto"
            },
            className: "rio-hide-scrollbar"
        }, lt.createElement(jm, {
            key: p,
            handleWidth: !y,
            handleHeight: y,
            refreshMode: "debounce",
            refreshRate: 250,
            onResize: () => {
                h()
            }
        }), !b && lt.createElement(jm, {
            handleWidth: !0,
            onResize: e => {
                const n = e / t;
                x(Math.ceil(n))
            }
        }), w > 0 && c.map(( ({transformedSrc: e, id: t, alt: n, scale: i, type: a}, s) => {
            const {width: l, height: p, widthInner: f, heightInner: h} = function({thumbnailWidth: e, scale: t, square: n, spacing: r}) {
                const i = e
                  , o = e * (parseFloat(t) / 100)
                  , a = e - r
                  , s = a * (parseFloat(t) / 100);
                return {
                    width: i,
                    height: n ? i : o,
                    widthInner: a,
                    heightInner: n ? a : s
                }
            }({
                thumbnailWidth: w,
                scale: i,
                spacing: E,
                square: k
            })
              , m = Ly(w * ky())
              , v = !r && !y
              , b = 0 === s
              , x = s === c.length - 1
              , _ = b || x
              , C = !y && _ && !r
              , M = y && _
              , R = C ? l - (l - f) / 2 : l
              , P = M ? p - (p - h) / 2 : p
              , I = x ? "flex-end" : "flex-start";
            return lt.createElement($l, {
                item: !0,
                container: !0,
                ref: s === d ? S : void 0,
                key: t,
                style: {
                    minWidth: R,
                    minHeight: P,
                    width: R,
                    height: P,
                    ...v && b ? {
                        marginLeft: "auto"
                    } : {},
                    ...v && x ? {
                        marginRight: "auto"
                    } : {}
                },
                alignItems: M ? I : "center",
                justify: C ? I : "center"
            }, lt.createElement("div", {
                role: "button",
                onClick: () => {
                    u(s)
                }
                ,
                onKeyPress: e => {
                    "Enter" !== e.key && " " !== e.key || u(s)
                }
                ,
                tabIndex: "0",
                className: g.thumbnailButton,
                style: {
                    width: f,
                    height: h,
                    ...s === d ? O : T
                }
            }, lt.createElement("img", {
                src: e(m),
                alt: n,
                className: g.thumbnailImage,
                style: {
                    ..."contain" === o || "cover" === o ? {
                        objectFit: o
                    } : {}
                }
            }), ("video" === a || "external_video" === a) && lt.createElement("div", {
                className: g.thumbnailPlay
            }, lt.createElement(Rw, null)), "model" === a && lt.createElement("div", {
                className: g.thumbnailPlay
            }, lt.createElement(Pw, null))))
        }
        )))
    }
    ));
    zw.propTypes = {
        config: Uy.isRequired,
        media: on.arrayOf(Gy).isRequired,
        selected: on.number.isRequired,
        swiperKey: on.string.isRequired,
        onThumbnailSelected: on.func.isRequired,
        onThumbnailsScrolled: on.func.isRequired,
        onThumbnailsResized: on.func.isRequired,
        isDefaultMedia: on.bool.isRequired
    };
    const Aw = Mh(( () => ({
        root: {
            display: "flex"
        },
        thumbnailsContainer: {
            display: "flex"
        }
    })));
    function Lw(e) {
        if ("bottom" === e)
            return "column-reverse";
        if ("top" === e)
            return "column";
        if ("right" === e)
            return "row-reverse";
        if ("left" === e)
            return "row";
        throw Error(`Unknown thumbnail orientation '${e}'`)
    }
    function Dw({isLrOrien: e, thumbnails: t}) {
        return e && t.verticalOverflow ? 0 : "auto"
    }
    function Nw({isLrOrien: e, thumbnails: t}) {
        return e ? t.container ? 100 * t.container + "%" : t.thumbnailWidth * t.thumbnailsPerRow + "px" : null
    }
    function Ww({media: e, config: t, selected: n, onSelectedChanged: r, swiperKey: i, isDefaultMedia: o, scrollIntoViewOnMount: a, mediaDefaults: s}) {
        const l = Ah()
          , c = Aw()
          , {thumbnails: u} = t
          , d = !!u && Ay(u.orientation)
          , p = e.length > 1 && u
          , f = !!p && Ay(p.orientation)
          , h = null == p ? void 0 : p.spacingFromImage
          , m = l.spacing("number" == typeof h ? h : 1)
          , [v,g] = ne(Dw({
            isLrOrien: d,
            thumbnails: u
        }))
          , [b,y] = ne(Nw({
            isLrOrien: d,
            thumbnails: u
        }))
          , [w,x] = ne(!1)
          , [_,C] = ne(!1)
          , [S,E] = ne(mv.v4());
        ie(( () => {
            g(Dw({
                isLrOrien: d,
                thumbnails: u
            })),
            y(Nw({
                isLrOrien: d,
                thumbnails: u
            })),
            E(mv.v4())
        }
        ), [f, p]);
        const [k,O] = ne("100%")
          , T = ae(null)
          , M = ce(( () => {
            if (!p.navigation)
                return;
            const e = T.current;
            if (e) {
                const t = My(e, f);
                C(!t.start),
                x(!t.end)
            }
        }
        ), [f, p])
          , R = p ? {
            flexDirection: Lw(p.orientation)
        } : {
            flexDirection: "column"
        }
          , P = le(( () => {
            const e = {
                fill: "rgba(255, 255, 255, 1)",
                background: "rgba(0, 0, 0, 0.5)",
                size: 5,
                ...(null == p ? void 0 : p.navigationSettings) || {}
            }
              , t = `${l.spacing(e.size)}px`;
            return {
                color: e.fill,
                backgroundColor: e.background,
                width: t,
                height: t
            }
        }
        ), [l, p]);
        return lt.createElement("div", {
            className: c.root,
            style: R
        }, lt.createElement(jm, {
            handleWidth: !0,
            key: S,
            onResize: e => {
                let t = b;
                f && p.container && (t = `${Math.floor(e * p.container)}px`,
                y(t));
                const n = `${Math.floor(e)}px`;
                O("string" == typeof t ? `calc(${n} - ${p ? `${t} - ${m}px` : "0px"})` : n)
            }
        }), p && lt.createElement("div", {
            style: f ? {
                overflowY: "auto",
                overflowX: "hidden",
                flexDirection: "column",
                alignItems: "center",
                width: b,
                height: v,
                ["margin" + ("left" === p.orientation ? "Right" : "Left")]: m,
                position: "relative",
                boxSizing: "border-box"
            } : {
                flexDirection: "row",
                marginTop: m,
                position: "relative",
                alignItems: "center"
            },
            className: Ra("rio-hide-scrollbar", c.thumbnailsContainer)
        }, 0 !== v && p.navigation && _ && lt.createElement(jl, {
            component: "div",
            role: "button",
            size: "small",
            onClick: async () => {
                const e = await Ry(T.current, f, -1);
                C(!e.start),
                x(!e.end)
            }
            ,
            "aria-label": "Scroll thumbnails left",
            style: {
                ...P,
                position: "absolute",
                zIndex: 2,
                [!f && "left"]: 0,
                [f && "top"]: 0
            }
        }, f && lt.createElement(hv, {
            style: {
                fontSize: P.width
            }
        }), !f && lt.createElement(Qm, {
            style: {
                fontSize: P.width
            }
        })), lt.createElement(zw, {
            ref: T,
            swiperKey: i,
            config: t,
            media: e,
            selected: n,
            onThumbnailSelected: e => {
                r(e)
            }
            ,
            onThumbnailsScrolled: M,
            onThumbnailsResized: () => {
                M()
            }
            ,
            isDefaultMedia: o
        }), 0 !== v && p.navigation && w && lt.createElement(jl, {
            component: "div",
            role: "button",
            size: "small",
            onClick: async () => {
                const e = await Ry(T.current, f, 1);
                C(!e.start),
                x(!e.end)
            }
            ,
            "aria-label": "Scroll thumbnails right",
            style: {
                ...P,
                position: "absolute",
                zIndex: 2,
                [!f && "right"]: 0,
                [f && "bottom"]: 0
            }
        }, f && lt.createElement(cv, {
            style: {
                fontSize: P.width
            }
        }), !f && lt.createElement(iv, {
            style: {
                fontSize: P.width
            }
        }))), lt.createElement("div", {
            style: f ? {
                flex: 1,
                overflow: "hidden"
            } : void 0
        }, lt.createElement("div", {
            style: {
                maxWidth: k
            }
        }, lt.createElement(Mw, {
            key: i,
            config: t,
            media: e,
            selected: n,
            onSlideChange: e => {
                r(e)
            }
            ,
            scrollIntoViewOnMount: a,
            mediaDefaults: s
        }), f && p.verticalOverflow && lt.createElement(jm, {
            handleHeight: !0,
            key: S,
            onResize: (e, t) => {
                g(t)
            }
        }))))
    }
    function Fw(e, t, n, r) {
        const i = n || Dy();
        if (i)
            if (e) {
                const e = t.variants.find((e => e.id === i));
                if (e && e.featuredMediaIndex > -1)
                    return e.featuredMediaIndex
            } else {
                const e = t.findIndex((e => e.variant === i));
                if (e > -1)
                    return e
            }
        if (e) {
            if (r)
                return 0;
            const e = t.variants.find((e => !0 === e.available));
            if (e && e.featuredMediaIndex > -1)
                return e.featuredMediaIndex;
            if (t.variants.length > 0) {
                const e = t.variants[0];
                if (e.featuredMediaIndex > -1)
                    return e.featuredMediaIndex
            }
        } else {
            const e = t.findIndex((e => !0 === e.available));
            if (e > -1)
                return e
        }
        return 0
    }
    Ww.propTypes = {
        config: Uy.isRequired,
        media: on.arrayOf(Gy).isRequired,
        selected: on.number.isRequired,
        onSelectedChanged: on.func.isRequired,
        swiperKey: on.string.isRequired,
        isDefaultMedia: on.bool.isRequired,
        scrollIntoViewOnMount: on.bool.isRequired
    },
    (Gd || (Gd = !0,
    Zd()),
    Ud)();
    var $w, Bw, jw = !1;
    function Hw(e, t, n) {
        e.addEventListener(t, n)
    }
    function Vw(e, t, n) {
        e.removeEventListener(t, n)
    }
    function qw(e) {
        let t = null;
        for (let n = 0; n < document.forms.length; n++) {
            const r = document.forms[n].getAttribute("action");
            r && r.indexOf("/cart/add") >= 0 && (t || (t = Bw(e)),
            Hw(document.forms[n], "change", t))
        }
        return t
    }
    function Uw(e) {
        for (let t = 0; t < document.forms.length; t++) {
            const n = document.forms[t].getAttribute("action");
            n && n.indexOf("/cart/add") >= 0 && Vw(document.forms[t], "change", e)
        }
    }
    function Gw() {
        Bw = e => t => {
            !function(e, t) {
                try {
                    let n;
                    if (!(n = e.id.options && e.id.options[e.id.selectedIndex] ? e.id.options[e.id.selectedIndex] : e.id))
                        return;
                    t(n.value)
                } catch (e) {
                    console.warn(`[productwiz-rio] Error in trackViewedProductVariant: ${e.message}`)
                }
            }((t = t || window.event).currentTarget, e)
        }
        ,
        r($w = {}, "addListeners", (function() {
            return qw
        }
        )),
        r($w, "removeListeners", (function() {
            return Uw
        }
        ))
    }
    function Zw() {
        return jw || (jw = !0,
        Gw()),
        $w
    }
    var Kw, Yw = !1;
    function Xw(e) {
        const t = document.querySelector(".rio-current-variant");
        if (t) {
            console.log("rio: rio-current-variant-found");
            const n = t => {
                console.log(`rio: change to variant ${t.target.value}`),
                e(`${t.target.value}`)
            }
            ;
            return t.addEventListener("change", n),
            n
        }
        return console.log("rio: rio-current-variant not found"),
        null
    }
    function Jw(e) {
        const t = document.querySelector(".rio-current-variant");
        t && t.removeEventListener("change", e)
    }
    function Qw() {
        return Yw || (Yw = !0,
        r(Kw = {}, "addListeners", (function() {
            return Xw
        }
        )),
        r(Kw, "removeListeners", (function() {
            return Jw
        }
        ))),
        Kw
    }
    function ex({isDefaultMedia: e, mediaParam: t, useFormListener: n, useManualListener: r, setSelectedVariant: i, setSelectedMedia: o, selectedVariant: a, setMediaKey: s, skipGalleryIndexReset: l}) {
        const c = ae(null)
          , u = ce((n => {
            const r = Fw(e, t, n);
            if (i(r),
            !e) {
                if (!function(e, t, n) {
                    const {media: r} = e[t]
                      , {media: i} = e[n];
                    if (Array.isArray(r) && Array.isArray(i)) {
                        const e = r.map((e => e.id))
                          , t = i.map((e => e.id));
                        if (e.length !== t.length)
                            return !1;
                        for (let n = 0; n < e.length; n += 1)
                            if (e[n] !== t[n])
                                return !1;
                        return !0
                    }
                    return !1
                }(t, a, r)) {
                    l || o(0);
                    const {variant: e} = t[r];
                    s(e)
                }
            }
        }
        ), [e, t, a, s, o, i, l]);
        ie(( () => {
            c.current = u
        }
        ), [u]),
        ie(( () => {
            const e = ( ({useFormListener: e, useManualListener: t, handleLocationChangeRef: n}) => {
                if (e || t) {
                    const {addListeners: t} = e ? Zw() : Qw();
                    return t((e => {
                        n.current && n.current(e)
                    }
                    ))
                }
                const r = () => {
                    n.current && n.current()
                }
                ;
                return window.addEventListener("locationchange", r),
                r
            }
            )({
                useFormListener: n,
                useManualListener: r,
                handleLocationChangeRef: c
            });
            return () => {
                e && ( ({useFormListener: e, useManualListener: t, event: n}) => {
                    if (e || t) {
                        const {removeListeners: t} = e ? Zw() : Qw();
                        t(n)
                    } else
                        window.removeEventListener("locationchange", n)
                }
                )({
                    useFormListener: n,
                    useManualListener: r,
                    event: e
                })
            }
        }
        ), [n, r])
    }
    function tx({media: e, mobileConfig: t, desktopConfig: n, breakpoint: r, useFormListener: i, useManualListener: o, mediaDefaults: a, disableNavigationWithMedia: s, onGalleryIndexChange: l, initialSelection: c, changeVariantOnVariantImageSelection: u}) {
        const d = "object" == typeof e.media && "object" == typeof e.variants
          , p = qd(`(min-width:${"none" === r ? "0px" : r})`, {
            noSsr: !0
        })
          , f = function({isDefaultMedia: e, mediaParam: t, config: n, disableNavigationWithMedia: r}) {
            if (r)
                return n;
            if (!1 !== n.thumbnails)
                return n;
            const i = e => "video" === e.type || "external_video" === e.type || "model" === e.type;
            if (e) {
                for (const e of t.media)
                    if (i(e))
                        return {
                            ...n,
                            navigation: !0
                        }
            } else
                for (const e of t)
                    for (const t of e.media)
                        if (i(t))
                            return {
                                ...n,
                                navigation: !0
                            };
            return n
        }({
            isDefaultMedia: d,
            mediaParam: e,
            config: p ? n : t,
            disableNavigationWithMedia: s
        })
          , {disableVariantImageSelectionOnPageLoad: h, vertical: m} = f
          , v = le(( () => Fw(d, e, void 0, h)), [h, c, d, e])
          , [g,b] = ne(v)
          , [y,w] = ne(0)
          , [x,_] = ne(d ? null : e[g].variant)
          , C = !!f.vertical && !!f.verticalHoistVariantImages;
        let S, E, k, O;
        const T = p ? "desktop" : "mobile";
        if (d)
            S = T,
            C ? (E = `${T}-${g}`,
            k = [e.media[g], ...e.media.filter(( (e, t) => t !== g))],
            O = 0) : (E = T,
            k = e.media,
            O = g);
        else {
            S = T,
            E = `${x}-${T}`,
            k = e[g].media,
            O = y
        }
        const M = function({verticalHoistVariantImages: e, selectedVariant: t, isDefaultMedia: n}) {
            const r = ae(null);
            return ie(( () => {
                r.current = t
            }
            ), [t]),
            !!n && !!e && "number" == typeof r.current && r.current !== t
        }({
            verticalHoistVariantImages: C,
            selectedVariant: g,
            isDefaultMedia: d
        })
          , {setSelectedVariant: R, changeProductOptions: P} = function({changeVariantOnVariantImageSelection: e, setSelectedVariant: t, mediaParam: n, useFormListener: r, useManualListener: i, isDefaultMedia: o, vertical: a}) {
            if (!o || !e || "undefined" == typeof __productWizRioOptions || a)
                return {
                    setSelectedVariant: t
                };
            const s = ae(0)
              , l = ae(0)
              , c = ae(-1)
              , u = ce((e => {
                Date.now() - s.current < 200 ? console.log("Change occured within last 200ms -- ignoring") : (l.current = Date.now(),
                t(e))
            }
            ), [t])
              , d = ce(( () => {
                if (i) {
                    const e = document.querySelector(".rio-current-variant");
                    if (e && e.value)
                        return e.value
                }
                if (r) {
                    const e = document.querySelectorAll('form[action="/cart/add"] input[name="id"], form[action="/cart/add"] select[name="id"]');
                    for (const t of e)
                        if (t.value)
                            return t.value
                }
                const e = Dy();
                if (e)
                    return e;
                if (__productWizRioOptions.initialSelectedVariantId)
                    return __productWizRioOptions.initialSelectedVariantId;
                const t = n.variants.find((e => e.available));
                return t ? t.id : n.variants.length > 0 ? n.variants[0].id : null
            }
            ), [n, r, i])
              , p = ce(( () => {
                if ("undefined" == typeof __productWizRioVariantImages)
                    return [];
                if (null === __productWizRioVariantImages)
                    return [];
                try {
                    const e = __productWizRioVariantImages.mapping.map((e => {
                        const t = e.media.map((e => n.media.findIndex((t => e === t.id))))
                          , r = n.variants.find((t => t.id === e.id));
                        return {
                            id: e.id,
                            featuredMediaIndexes: t,
                            variant: r
                        }
                    }
                    ))
                      , t = [];
                    for (const n of e)
                        if (n.variant)
                            for (const e of n.featuredMediaIndexes)
                                e > -1 && t.push({
                                    id: n.id,
                                    featuredMediaIndex: e,
                                    options: n.variant.options
                                });
                    return t
                } catch (e) {
                    console.log("Failed to generate variants of variant image"),
                    console.log(e)
                }
                return []
            }
            ), [n]);
            return {
                setSelectedVariant: u,
                changeProductOptions: ce((async e => {
                    if (c.current === e)
                        return void console.log("Current index and last index are the same, skipping change");
                    if (c.current = e,
                    -1 === e || Date.now() - l.current < 100)
                        return void console.log("Change occured within last 100ms -- ignoring");
                    console.log("Change product options");
                    const t = [...p(), ...n.variants].filter((t => t.featuredMediaIndex === e));
                    if (t.length < 1)
                        return;
                    const r = d();
                    if (!r)
                        return;
                    if (t.find((e => e.id === r)))
                        return;
                    const i = n.variants.find((e => e.id === r))
                      , o = t.map((e => ({
                        ...e,
                        diff: Object.keys(Yd.diff(i.options, e.options)).length
                    })));
                    o.sort(Oy("diff"));
                    const a = o[0]
                      , u = {
                        ...a,
                        options: a.options.map((e => ({
                            id: e.name,
                            value: e.value
                        })))
                    };
                    s.current = Date.now(),
                    await __productWizRioOptions.change(u)
                }
                ), [d, p, n])
            }
        }({
            setSelectedVariant: b,
            mediaParam: e,
            useFormListener: i,
            useManualListener: o,
            isDefaultMedia: d,
            changeVariantOnVariantImageSelection: u,
            vertical: m
        });
        return ex({
            isDefaultMedia: d,
            mediaParam: e,
            useFormListener: i,
            useManualListener: o,
            setSelectedVariant: R,
            setSelectedMedia: w,
            selectedVariant: g,
            setMediaKey: _,
            skipGalleryIndexReset: !1
        }),
        lt.createElement(Ww, {
            key: S,
            swiperKey: E,
            media: k,
            config: f,
            selected: O,
            onSelectedChanged: e => {
                d ? (b(e),
                "function" == typeof P && P(e)) : w(e)
            }
            ,
            scrollIntoViewOnMount: M,
            isDefaultMedia: d,
            mediaDefaults: a
        })
    }
    function nx({media: e, mobileConfig: t, desktopConfig: n, mobileDesktopConfig: r, breakpoint: i, useFormListener: o, useManualListener: a, mediaDefaults: s, disableNavigationWithMedia: l, onGalleryIndexChange: c, initialSelection: u, changeVariantOnVariantImageSelection: d}) {
        const p = !!r
          , f = p ? "none" : i
          , h = p ? r : t
          , m = p ? r : n;
        return lt.createElement(tx, {
            media: e,
            mobileConfig: h,
            desktopConfig: m,
            breakpoint: f,
            useFormListener: o,
            useManualListener: a,
            mediaDefaults: s,
            disableNavigationWithMedia: l,
            onGalleryIndexChange: c,
            initialSelection: u,
            changeVariantOnVariantImageSelection: d
        })
    }
    function rx({product: e, productRio: t, mediaSettings: n, imageFilenames: r}) {
        return e && !t ? Fy(e) : function(e, t, n, r) {
            const i = Fy(e)
              , o = i.variants.map((e => {
                const o = []
                  , a = t.find((t => t.id === e.id));
                return a && a.media.forEach((e => {
                    const t = zy(i.media, r, e);
                    t && o.push({
                        ...t,
                        rioSettings: Iy(a.id, e, n)
                    })
                }
                )),
                o.length < 1 && o.push(...i.media),
                {
                    variant: e.id,
                    available: e.available,
                    media: o
                }
            }
            ));
            return o.length < 1 ? i : o
        }(e, t, n, r)
    }
    function ix({children: e}) {
        {
            const t = Sr({
                overrides: {
                    PwzrSvgIcon: {
                        root: {
                            width: "35px",
                            height: "35px"
                        }
                    }
                }
            });
            return lt.createElement(Va, {
                theme: t
            }, e)
        }
    }
    function ox({rio: e, onGalleryIndexChange: t, initialSelection: n}) {
        const {product: r, productRio: i, mediaSettings: o, imageFilenames: a, useFormListener: s, useManualListener: l, config: {mobile: c, desktop: u, mobileDesktop: d, breakpoint: p, lightBoxBackgroundColor: f, thumbnailSelectionColor: h, video: m, externalVideo: v, model: g, disableNavigationWithMedia: b, changeVariantOnVariantImageSelection: y}} = e
          , w = rx({
            product: r,
            productRio: i,
            mediaSettings: o,
            imageFilenames: a
        });
        return lt.createElement("div", {
            style: {
                width: "100%",
                height: "auto",
                textAlign: "left",
                userSelect: "none",
                msUserSelect: "none",
                MozUserSelect: "none",
                WebkitUserSelect: "none",
                direction: "ltr"
            }
        }, lt.createElement("style", null, `\n            :root {\n              --rio-lightbox-background-color: ${f || "rgb(0, 0, 0)"};\n              --rio-thumbnail-selection-color: ${h || "rgb(0, 0, 0)"};\n            }\n          `), lt.createElement(ix, null, lt.createElement(nx, {
            media: w,
            mobileConfig: c,
            desktopConfig: u,
            mobileDesktopConfig: d,
            breakpoint: p,
            useFormListener: "boolean" == typeof s && s,
            useManualListener: "boolean" == typeof l && l,
            mediaDefaults: {
                video: m,
                externalVideo: v,
                model: g
            },
            disableNavigationWithMedia: b,
            onGalleryIndexChange: t,
            initialSelection: n,
            changeVariantOnVariantImageSelection: y
        })))
    }
    nx.defaultProps = {
        useFormListener: !1,
        useManualListener: !1
    },
    nx.propTypes = {
        breakpoint: on.string.isRequired,
        useFormListener: on.bool,
        useManualListener: on.bool,
        mobileConfig: Uy.isRequired,
        desktopConfig: Uy.isRequired,
        media: on.oneOfType([on.arrayOf(on.exact({
            variant: on.string.isRequired,
            available: on.bool.isRequired,
            media: on.arrayOf(Gy).isRequired
        })), on.exact({
            media: on.arrayOf(Gy).isRequired,
            variants: on.arrayOf(on.exact({
                id: on.string.isRequired,
                featuredMediaIndex: on.number.isRequired,
                available: on.bool.isRequired
            })).isRequired
        })]).isRequired
    };
    var ax = {}
      , sx = mp;
    Object.defineProperty(ax, "__esModule", {
        value: !0
    });
    var lx = void 0;
    ax.default = lx;
    var cx = sx(f);
    lx = (0,
    sx(Gm).default)(cx.default.createElement("path", {
        d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    }), "Edit"),
    ax.default = lx;
    var ux, dx = t(ax), px = !1;
    function fx() {
        ux = function() {
            var t = this
              , n = {
                exports: this
            }
              , r = "__lodash_hash_undefined__"
              , i = 9007199254740991
              , o = "[object Arguments]"
              , a = "[object Function]"
              , s = "[object Object]"
              , l = /^\[object .+?Constructor\]$/
              , c = /^(?:0|[1-9]\d*)$/
              , u = {};
            u["[object Float32Array]"] = u["[object Float64Array]"] = u["[object Int8Array]"] = u["[object Int16Array]"] = u["[object Int32Array]"] = u["[object Uint8Array]"] = u["[object Uint8ClampedArray]"] = u["[object Uint16Array]"] = u["[object Uint32Array]"] = !0,
            u[o] = u["[object Array]"] = u["[object ArrayBuffer]"] = u["[object Boolean]"] = u["[object DataView]"] = u["[object Date]"] = u["[object Error]"] = u[a] = u["[object Map]"] = u["[object Number]"] = u[s] = u["[object RegExp]"] = u["[object Set]"] = u["[object String]"] = u["[object WeakMap]"] = !1;
            var d = "object" == typeof e && e && e.Object === Object && e
              , p = "object" == typeof self && self && self.Object === Object && self
              , f = d || p || Function("return this")()
              , h = "object" == typeof t && t && !t.nodeType && t
              , m = h && "object" == typeof n && n && !n.nodeType && n
              , v = m && m.exports === h
              , g = v && d.process
              , b = function() {
                try {
                    var e = m && m.require && m.require("util").types;
                    return e || g && g.binding && g.binding("util")
                } catch (e) {}
            }()
              , y = b && b.isTypedArray;
            function w(e, t, n) {
                switch (n.length) {
                case 0:
                    return e.call(t);
                case 1:
                    return e.call(t, n[0]);
                case 2:
                    return e.call(t, n[0], n[1]);
                case 3:
                    return e.call(t, n[0], n[1], n[2])
                }
                return e.apply(t, n)
            }
            var x, _, C, S = Array.prototype, E = Function.prototype, k = Object.prototype, O = f["__core-js_shared__"], T = E.toString, M = k.hasOwnProperty, R = (x = /[^.]+$/.exec(O && O.keys && O.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "", P = k.toString, I = T.call(Object), z = RegExp("^" + T.call(M).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), A = v ? f.Buffer : void 0, L = f.Symbol, D = f.Uint8Array, N = A ? A.allocUnsafe : void 0, W = (_ = Object.getPrototypeOf,
            C = Object,
            function(e) {
                return _(C(e))
            }
            ), F = Object.create, $ = k.propertyIsEnumerable, B = S.splice, j = L ? L.toStringTag : void 0, H = function() {
                try {
                    var e = he(Object, "defineProperty");
                    return e({}, "", {}),
                    e
                } catch (e) {}
            }(), V = A ? A.isBuffer : void 0, q = Math.max, U = Date.now, G = he(f, "Map"), Z = he(Object, "create"), K = function() {
                function e() {}
                return function(t) {
                    if (!ke(t))
                        return {};
                    if (F)
                        return F(t);
                    e.prototype = t;
                    var n = new e;
                    return e.prototype = void 0,
                    n
                }
            }();
            function Y(e) {
                var t = -1
                  , n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n; ) {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }
            function X(e) {
                var t = -1
                  , n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n; ) {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }
            function J(e) {
                var t = -1
                  , n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n; ) {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }
            function Q(e) {
                var t = this.__data__ = new X(e);
                this.size = t.size
            }
            function ee(e, t) {
                var n = xe(e)
                  , r = !n && we(e)
                  , i = !n && !r && Ce(e)
                  , o = !n && !r && !i && Te(e)
                  , a = n || r || i || o
                  , s = a ? function(e, t) {
                    for (var n = -1, r = Array(e); ++n < e; )
                        r[n] = t(n);
                    return r
                }(e.length, String) : []
                  , l = s.length;
                for (var c in e)
                    !t && !M.call(e, c) || a && ("length" == c || i && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || me(c, l)) || s.push(c);
                return s
            }
            function te(e, t, n) {
                (void 0 !== n && !ye(e[t], n) || void 0 === n && !(t in e)) && ie(e, t, n)
            }
            function ne(e, t, n) {
                var r = e[t];
                M.call(e, t) && ye(r, n) && (void 0 !== n || t in e) || ie(e, t, n)
            }
            function re(e, t) {
                for (var n = e.length; n--; )
                    if (ye(e[n][0], t))
                        return n;
                return -1
            }
            function ie(e, t, n) {
                "__proto__" == t && H ? H(e, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: n,
                    writable: !0
                }) : e[t] = n
            }
            Y.prototype.clear = function() {
                this.__data__ = Z ? Z(null) : {},
                this.size = 0
            }
            ,
            Y.prototype.delete = function(e) {
                var t = this.has(e) && delete this.__data__[e];
                return this.size -= t ? 1 : 0,
                t
            }
            ,
            Y.prototype.get = function(e) {
                var t = this.__data__;
                if (Z) {
                    var n = t[e];
                    return n === r ? void 0 : n
                }
                return M.call(t, e) ? t[e] : void 0
            }
            ,
            Y.prototype.has = function(e) {
                var t = this.__data__;
                return Z ? void 0 !== t[e] : M.call(t, e)
            }
            ,
            Y.prototype.set = function(e, t) {
                var n = this.__data__;
                return this.size += this.has(e) ? 0 : 1,
                n[e] = Z && void 0 === t ? r : t,
                this
            }
            ,
            X.prototype.clear = function() {
                this.__data__ = [],
                this.size = 0
            }
            ,
            X.prototype.delete = function(e) {
                var t = this.__data__
                  , n = re(t, e);
                return !(n < 0) && (n == t.length - 1 ? t.pop() : B.call(t, n, 1),
                --this.size,
                !0)
            }
            ,
            X.prototype.get = function(e) {
                var t = this.__data__
                  , n = re(t, e);
                return n < 0 ? void 0 : t[n][1]
            }
            ,
            X.prototype.has = function(e) {
                return re(this.__data__, e) > -1
            }
            ,
            X.prototype.set = function(e, t) {
                var n = this.__data__
                  , r = re(n, e);
                return r < 0 ? (++this.size,
                n.push([e, t])) : n[r][1] = t,
                this
            }
            ,
            J.prototype.clear = function() {
                this.size = 0,
                this.__data__ = {
                    hash: new Y,
                    map: new (G || X),
                    string: new Y
                }
            }
            ,
            J.prototype.delete = function(e) {
                var t = fe(this, e).delete(e);
                return this.size -= t ? 1 : 0,
                t
            }
            ,
            J.prototype.get = function(e) {
                return fe(this, e).get(e)
            }
            ,
            J.prototype.has = function(e) {
                return fe(this, e).has(e)
            }
            ,
            J.prototype.set = function(e, t) {
                var n = fe(this, e)
                  , r = n.size;
                return n.set(e, t),
                this.size += n.size == r ? 0 : 1,
                this
            }
            ,
            Q.prototype.clear = function() {
                this.__data__ = new X,
                this.size = 0
            }
            ,
            Q.prototype.delete = function(e) {
                var t = this.__data__
                  , n = t.delete(e);
                return this.size = t.size,
                n
            }
            ,
            Q.prototype.get = function(e) {
                return this.__data__.get(e)
            }
            ,
            Q.prototype.has = function(e) {
                return this.__data__.has(e)
            }
            ,
            Q.prototype.set = function(e, t) {
                var n = this.__data__;
                if (n instanceof X) {
                    var r = n.__data__;
                    if (!G || r.length < 199)
                        return r.push([e, t]),
                        this.size = ++n.size,
                        this;
                    n = this.__data__ = new J(r)
                }
                return n.set(e, t),
                this.size = n.size,
                this
            }
            ;
            var oe, ae = function(e, t, n) {
                for (var r = -1, i = Object(e), o = n(e), a = o.length; a--; ) {
                    var s = o[oe ? a : ++r];
                    if (!1 === t(i[s], s, i))
                        break
                }
                return e
            };
            function se(e) {
                return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : j && j in Object(e) ? function(e) {
                    var t = M.call(e, j)
                      , n = e[j];
                    try {
                        e[j] = void 0;
                        var r = !0
                    } catch (e) {}
                    var i = P.call(e);
                    r && (t ? e[j] = n : delete e[j]);
                    return i
                }(e) : function(e) {
                    return P.call(e)
                }(e)
            }
            function le(e) {
                return Oe(e) && se(e) == o
            }
            function ce(e) {
                return !(!ke(e) || function(e) {
                    return !!R && R in e
                }(e)) && (Se(e) ? z : l).test(function(e) {
                    if (null != e) {
                        try {
                            return T.call(e)
                        } catch (e) {}
                        try {
                            return e + ""
                        } catch (e) {}
                    }
                    return ""
                }(e))
            }
            function ue(e) {
                if (!ke(e))
                    return function(e) {
                        var t = [];
                        if (null != e)
                            for (var n in Object(e))
                                t.push(n);
                        return t
                    }(e);
                var t = ve(e)
                  , n = [];
                for (var r in e)
                    ("constructor" != r || !t && M.call(e, r)) && n.push(r);
                return n
            }
            function de(e, t, n, r, i) {
                e !== t && ae(t, (function(o, a) {
                    if (i || (i = new Q),
                    ke(o))
                        !function(e, t, n, r, i, o, a) {
                            var l = ge(e, n)
                              , c = ge(t, n)
                              , u = a.get(c);
                            if (u)
                                return void te(e, n, u);
                            var d = o ? o(l, c, n + "", e, t, a) : void 0
                              , p = void 0 === d;
                            if (p) {
                                var f = xe(c)
                                  , h = !f && Ce(c)
                                  , m = !f && !h && Te(c);
                                d = c,
                                f || h || m ? xe(l) ? d = l : Oe(w = l) && _e(w) ? d = function(e, t) {
                                    var n = -1
                                      , r = e.length;
                                    t || (t = Array(r));
                                    for (; ++n < r; )
                                        t[n] = e[n];
                                    return t
                                }(l) : h ? (p = !1,
                                d = function(e, t) {
                                    if (t)
                                        return e.slice();
                                    var n = e.length
                                      , r = N ? N(n) : new e.constructor(n);
                                    return e.copy(r),
                                    r
                                }(c, !0)) : m ? (p = !1,
                                v = c,
                                g = !0 ? (b = v.buffer,
                                y = new b.constructor(b.byteLength),
                                new D(y).set(new D(b)),
                                y) : v.buffer,
                                d = new v.constructor(g,v.byteOffset,v.length)) : d = [] : function(e) {
                                    if (!Oe(e) || se(e) != s)
                                        return !1;
                                    var t = W(e);
                                    if (null === t)
                                        return !0;
                                    var n = M.call(t, "constructor") && t.constructor;
                                    return "function" == typeof n && n instanceof n && T.call(n) == I
                                }(c) || we(c) ? (d = l,
                                we(l) ? d = function(e) {
                                    return function(e, t, n, r) {
                                        var i = !n;
                                        n || (n = {});
                                        var o = -1
                                          , a = t.length;
                                        for (; ++o < a; ) {
                                            var s = t[o]
                                              , l = r ? r(n[s], e[s], s, n, e) : void 0;
                                            void 0 === l && (l = e[s]),
                                            i ? ie(n, s, l) : ne(n, s, l)
                                        }
                                        return n
                                    }(e, Me(e))
                                }(l) : ke(l) && !Se(l) || (d = function(e) {
                                    return "function" != typeof e.constructor || ve(e) ? {} : K(W(e))
                                }(c))) : p = !1
                            }
                            var v, g, b, y;
                            var w;
                            p && (a.set(c, d),
                            i(d, c, r, o, a),
                            a.delete(c));
                            te(e, n, d)
                        }(e, t, a, n, de, r, i);
                    else {
                        var l = r ? r(ge(e, a), o, a + "", e, t, i) : void 0;
                        void 0 === l && (l = o),
                        te(e, a, l)
                    }
                }
                ), Me)
            }
            function pe(e, t) {
                return be(function(e, t, n) {
                    return t = q(void 0 === t ? e.length - 1 : t, 0),
                    function() {
                        for (var r = arguments, i = -1, o = q(r.length - t, 0), a = Array(o); ++i < o; )
                            a[i] = r[t + i];
                        i = -1;
                        for (var s = Array(t + 1); ++i < t; )
                            s[i] = r[i];
                        return s[t] = n(a),
                        w(e, this, s)
                    }
                }(e, t, Ie), e + "")
            }
            function fe(e, t) {
                var n, r, i = e.__data__;
                return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map
            }
            function he(e, t) {
                var n = function(e, t) {
                    return null == e ? void 0 : e[t]
                }(e, t);
                return ce(n) ? n : void 0
            }
            function me(e, t) {
                var n = typeof e;
                return !!(t = null == t ? i : t) && ("number" == n || "symbol" != n && c.test(e)) && e > -1 && e % 1 == 0 && e < t
            }
            function ve(e) {
                var t = e && e.constructor;
                return e === ("function" == typeof t && t.prototype || k)
            }
            function ge(e, t) {
                if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t)
                    return e[t]
            }
            var be = function(e) {
                var t = 0
                  , n = 0;
                return function() {
                    var r = U()
                      , i = 16 - (r - n);
                    if (n = r,
                    i > 0) {
                        if (++t >= 800)
                            return arguments[0]
                    } else
                        t = 0;
                    return e.apply(void 0, arguments)
                }
            }(H ? function(e, t) {
                return H(e, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: (n = t,
                    function() {
                        return n
                    }
                    ),
                    writable: !0
                });
                var n
            }
            : Ie);
            function ye(e, t) {
                return e === t || e != e && t != t
            }
            var we = le(function() {
                return arguments
            }()) ? le : function(e) {
                return Oe(e) && M.call(e, "callee") && !$.call(e, "callee")
            }
              , xe = Array.isArray;
            function _e(e) {
                return null != e && Ee(e.length) && !Se(e)
            }
            var Ce = V || function() {
                return !1
            }
            ;
            function Se(e) {
                if (!ke(e))
                    return !1;
                var t = se(e);
                return t == a || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t
            }
            function Ee(e) {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= i
            }
            function ke(e) {
                var t = typeof e;
                return null != e && ("object" == t || "function" == t)
            }
            function Oe(e) {
                return null != e && "object" == typeof e
            }
            var Te = y ? function(e) {
                return function(t) {
                    return e(t)
                }
            }(y) : function(e) {
                return Oe(e) && Ee(e.length) && !!u[se(e)]
            }
            ;
            function Me(e) {
                return _e(e) ? ee(e, !0) : ue(e)
            }
            var Re, Pe = (Re = function(e, t, n) {
                de(e, t, n)
            }
            ,
            pe((function(e, t) {
                var n = -1
                  , r = t.length
                  , i = r > 1 ? t[r - 1] : void 0
                  , o = r > 2 ? t[2] : void 0;
                for (i = Re.length > 3 && "function" == typeof i ? (r--,
                i) : void 0,
                o && function(e, t, n) {
                    if (!ke(n))
                        return !1;
                    var r = typeof t;
                    return !!("number" == r ? _e(n) && me(t, n.length) : "string" == r && t in n) && ye(n[t], e)
                }(t[0], t[1], o) && (i = r < 3 ? void 0 : i,
                r = 1),
                e = Object(e); ++n < r; ) {
                    var a = t[n];
                    a && Re(e, a, n, i)
                }
                return e
            }
            )));
            function Ie(e) {
                return e
            }
            return n.exports = Pe,
            n.exports
        }
        .call({})
    }
    function hx() {
        return px || (px = !0,
        fx()),
        ux
    }
    let mx;
    function vx(e) {
        return "lightbox-background-color" === e || "thumbnail-selection-color" === e ? "rgb(0, 0, 0)" : "border-colors-double" === e ? "rgb(255, 255, 255)" : "border-colors-selected" === e ? "rgb(50, 50, 50)" : "border-colors-unselected" === e ? "rgb(220, 220, 220)" : "border-colors-hovering" === e ? "rgb(100, 100, 100)" : "border-colors-outOfStockCrossOut" === e ? "rgb(25, 25, 25)" : "tooltip-background-color" === e ? "rgba(97, 97, 97)" : "swatch-selected-background-color" === e ? null : "swatch-background-color" === e ? "rgb(255, 255, 255)" : "alert-background-color" === e ? "rgb(237, 247, 237)" : "tooltip-text-color" === e || "unselected-background-color" === e ? "rgb(255, 255, 255)" : "unselected-text-color" === e ? "rgb(0, 0, 0)" : "select-background-color" === e ? "rgb(255, 255, 255)" : "select-text-color" === e || "selected-background-color" === e ? "rgb(0, 0, 0)" : "selected-text-color" === e ? "rgb(255, 255, 255)" : e.endsWith("-background-color") || e.endsWith("-border-color") ? null : "rgb(0, 0, 0)"
    }
    function gx(e) {
        return "swatch-text-size" === e || "swatch-title-text-size" === e ? 14 : "title-text-size" === e ? 18 : "subtitle-text-size" === e ? 16 : "alert-text-size" === e ? 18 : "tooltip-text-size" === e || "selected-text-size" === e ? 14 : "select-text-size" === e ? 16 : "unselected-text-size" === e ? 14 : 18
    }
    function bx(e) {
        return "tooltip-text-padding" === e ? [8, 8, 4, 4] : "swatch-title-text-padding" === e ? [3, 3, 2, 2] : "swatch-text-padding" === e ? [0, 0, 0, 0] : [5, 5, 2, 5]
    }
    function yx(e) {
        return "swatch-title-margin" === e ? [0, 0, 2, 2] : [0, 0, 5, 5]
    }
    function wx(e) {
        return "border-thickness-double" === e ? 3 : 1
    }
    function xx(e) {
        return "border-radius-px" === e ? 4 : 18
    }
    function _x() {
        return {
            title: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: vx("title-text-color"),
                textSize: gx("title-text-size"),
                textPadding: bx("title-text-padding"),
                backgroundColor: null,
                borderColor: vx("title-border-color"),
                borderStyle: "solid",
                borderThickness: wx("title-border-thickness"),
                borderRadius: xx("title-border-radius"),
                position: ["above", 1],
                margin: yx("title-margin"),
                maxWidthEnabled: !1
            },
            subtitle: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: vx("subtitle-text-color"),
                textSize: gx("subtitle-text-size"),
                textPadding: bx("subtitle-text-padding"),
                backgroundColor: null,
                borderColor: vx("subtitle-border-color"),
                borderStyle: "solid",
                borderThickness: wx("subtitle-border-thickness"),
                borderRadius: xx("subtitle-border-radius"),
                position: ["below", 1],
                margin: yx("subtitle-margin"),
                maxWidthEnabled: !1
            },
            alert: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: vx("alert-text-color"),
                textSize: gx("alert-text-size"),
                textPadding: bx("alert-text-padding"),
                backgroundColor: vx("alert-background-color"),
                borderColor: vx("alert-border-color"),
                borderStyle: "solid",
                borderThickness: wx("alert-border-thickness"),
                borderRadius: xx("alert-border-radius"),
                position: ["above", 1],
                margin: yx("alert-margin"),
                maxWidthEnabled: !1
            }
        }
    }
    function Cx() {
        return {
            type: "button",
            buttonType: "square",
            size: 48,
            spacing: 1,
            horizontalCarousel: !1,
            centered: !1,
            title: {
                enabled: !0,
                useThemeSettings: !0,
                displaySelectedOptionValue: !1,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: vx("swatch-title-text-color"),
                textSize: gx("swatch-title-text-size"),
                textPadding: bx("swatch-title-text-padding"),
                textAlign: "left",
                backgroundColor: null,
                borderColor: vx("swatch-title-border-color"),
                borderStyle: "solid",
                borderThickness: wx("swatch-title-border-thickness"),
                borderRadius: xx("swatch-title-border-radius"),
                position: ["above"],
                margin: yx("swatch-title-margin")
            },
            border: "round",
            borderStyle: "solid",
            borderThickness: wx("border-thickness"),
            borderRadius: xx("border-radius"),
            borderRadiusPx: xx("border-radius-px"),
            borderSelectedColor: vx("border-colors-selected"),
            borderUnselectedColor: vx("border-colors-unselected"),
            borderHoverColor: vx("border-colors-hovering"),
            borderOutOfStockCrossOutColor: vx("border-colors-outOfStockCrossOut"),
            borderDouble: !1,
            borderDoubleColor: vx("border-colors-double"),
            borderDoubleThickness: wx("border-thickness-double"),
            outOfStock: {
                style: "cross-out",
                tooltip: !1
            },
            hideUnavailable: !1,
            unselected: {
                backgroundColor: vx("unselected-background-color"),
                textBold: !1,
                textUppercase: !1,
                textColor: vx("unselected-text-color"),
                textSize: gx("unselected-text-size")
            },
            selected: {
                backgroundColor: vx("selected-background-color"),
                textBold: !1,
                textUppercase: !1,
                textColor: vx("selected-text-color"),
                textSize: gx("selected-text-size")
            },
            select: {
                variant: "outlined",
                minWidth: 120,
                fullWidth: !1,
                darkMenu: !1,
                textSize: gx("select-text-size"),
                textBold: !1,
                textUppercase: !1,
                textColor: vx("select-text-color"),
                backgroundColor: vx("select-background-color"),
                outerText: _x()
            }
        }
    }
    function Sx() {
        return {
            text: null,
            textBold: !1,
            textUppercase: !1,
            textColor: vx("swatch-text-color"),
            textSize: gx("swatch-text-size"),
            textPadding: bx("swatch-text-padding"),
            backgroundImage: null,
            backgroundVariantImagePosition: "center",
            backgroundPosition: "left",
            backgroundSize: 100,
            backgroundSizePx: 24,
            backgroundBorderRadius: 18,
            backgroundType: "one-solid",
            backgroundColor: vx("swatch-background-color"),
            backgroundColor2: vx("swatch-background-color"),
            backgroundColor3: vx("swatch-background-color"),
            backgroundColor4: vx("swatch-background-color"),
            selectedBackgroundColor: vx("swatch-selected-background-color"),
            ..._x(),
            tooltip: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: vx("tooltip-text-color"),
                textSize: gx("tooltip-text-size"),
                textPadding: bx("tooltip-text-padding"),
                backgroundColor: vx("tooltip-background-color"),
                position: ["below"],
                optionValueImage: !1,
                optionValueImagePosition: ["below"],
                optionValueImageFit: "crop",
                optionValueImageSizePx: 100,
                optionValueImageTextAlign: "left",
                optionValueImageSpacing: 2,
                optionValueImageRadius: 0
            }
        }
    }
    function Ex(e, t) {
        const n = Array.isArray(t) ? t : [];
        return e.map((e => {
            const t = n.findIndex((t => t.id === e))
              , r = t > -1 ? n[t] : void 0;
            return {
                id: e,
                name: e,
                config: mx(Sx(), r ? r.config : {})
            }
        }
        ))
    }
    function kx(e, t) {
        return t.options.map(( (t, n) => n > e.options.length - 1 ? null : {
            id: e.options[n].name,
            value: t
        })).filter((e => !!e))
    }
    function Ox(e, t, n=null) {
        const r = t[e]
          , i = !(!r.enabled || !r.text);
        if (!n)
            return [i];
        const [o,a] = r.position;
        return [i && o === n, a]
    }
    mx = hx();
    const Tx = ["title", "subtitle", "alert"];
    function Mx(e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        var n = ""
          , r = /\{\{\s*(\w+)\s*\}\}/
          , i = t || "${{amount}}";
        function o(e, t, n, r) {
            if (n = n || ",",
            r = r || ".",
            isNaN(e) || null === e)
                return 0;
            var i = (e = (e / 100).toFixed(t)).split(".");
            return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (i[1] ? r + i[1] : "")
        }
        switch (i.match(r)[1]) {
        case "amount":
            n = o(e, 2);
            break;
        case "amount_no_decimals":
            n = o(e, 0);
            break;
        case "amount_with_comma_separator":
            n = o(e, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            n = o(e, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            n = o(e, 0, " ");
            break;
        case "amount_with_apostrophe_separator":
            n = o(e, 2, "'")
        }
        return i.replace(r, n)
    }
    const Rx = lt.createContext("product-options")
      , Px = lt.createContext("product");
    lt.createContext("options"),
    lt.createContext("group-products-as-swatch");
    const Ix = {
        "one-solid": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0.176H120V120.176H0z"></path></svg>',
        "two-columns": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M60 0H120V120H60z"></path></svg>',
        "two-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 60H180V180H120z" transform="rotate(90 120 60)"></path></svg>',
        "two-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 0H120V120H0z"></path><path fill="%COLOR1%" d="M0 0l120 120V0H0z"></path></svg>',
        "two-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 120H120V240H0z" transform="rotate(-90 0 120)"></path><path fill="%COLOR1%" d="M0 120L120 0H0v120z"></path></svg>',
        "three-column": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M40 0H120V120H40z"></path><path fill="%COLOR3%" d="M80 0H120V120H80z"></path></svg>',
        "three-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 40H200V160H120z" transform="rotate(90 120 40)"></path><path fill="%COLOR3%" d="M120 80H160V200H120z" transform="rotate(90 120 80)"></path></svg>',
        "three-triangles": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M60 0H120V120H60z"></path><path fill="%COLOR3%" d="M60 60l60 60H0l60-60z"></path></svg>',
        "three-triangles-circle": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 0H240V60H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR3%" d="M120 120H0V93.846L60 60l60 34.872V120z"></path></svg>',
        "three-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 0H120V120H0z"></path><path fill="%COLOR1%" d="M40 0l80 80V0H40z"></path><path fill="%COLOR3%" d="M80 120L0 40v80h80z"></path></svg>',
        "three-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR3%" d="M120 40l-80 80h80V40z"></path><path fill="%COLOR1%" d="M0 80L80 0H0v80z"></path></svg>',
        "four-triangles": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M0 0l120 120V0H0z"></path><path fill="%COLOR3%" d="M120 0L0 120h120V0z"></path><path fill="%COLOR4%" d="M60 60l60 60H0l60-60z"></path></svg>',
        "four-squares": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V119.008H0z"></path><path fill="%COLOR2%" d="M60 0H120V119.008H60z"></path><path fill="%COLOR3%" d="M120 60.496H179.504V180.496H120z" transform="rotate(90 120 60.496)"></path><path fill="%COLOR4%" d="M0 60.496H60V119.999H0z"></path></svg>',
        "four-columns": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M30 0H120V120H30z"></path><path fill="%COLOR3%" d="M60 0H120V120H60z"></path><path fill="%COLOR4%" d="M90 0H120V120H90z"></path></svg>',
        "four-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 30H210V150H120z" transform="rotate(90 120 30)"></path><path fill="%COLOR3%" d="M120 60H180V180H120z" transform="rotate(90 120 60)"></path><path fill="%COLOR4%" d="M120 90H150V210H120z" transform="rotate(90 120 90)"></path></svg>',
        "four-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" fill-rule="evenodd" d="M120 120V60L60 0H0v120h120z" clip-rule="evenodd"></path><path fill="%COLOR3%" d="M120 120L0 0v120h120z"></path><path fill="%COLOR4%" d="M60 120L0 60v60h60z"></path></svg>',
        "four-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" fill-rule="evenodd" d="M0 0v120h120V0H60L0 60V0z" clip-rule="evenodd"></path><path fill="%COLOR3%" d="M120 0L0 120h120V0z"></path><path fill="%COLOR4%" d="M120 60l-60 60h60V60z"></path></svg>'
    };
    Ga((e => ({
        button: {
            width: 50,
            height: 50,
            filter: "brightness(1.1)",
            cursor: "pointer"
        },
        buttonSelected: {
            outline: "solid 2px"
        },
        buttonHovering: {
            filter: "brightness(1.3)"
        }
    })));
    const zx = lt.createContext("assets");
    function Ax(e, t) {
        return void 0 === window.__productWizRioOptions && (window.__productWizRioOptions = {}),
        void 0 === window.__productWizRioOptions.cbs && (window.__productWizRioOptions.cbs = {}),
        window.__productWizRioOptions.cbs[e] = t,
        () => {
            delete window.__productWizRioOptions.cbs[e]
        }
    }
    function Lx(e) {
        const t = document.createElement("div");
        return t.innerHTML = e,
        t.innerText
    }
    function Dx(e) {
        const t = function() {
            if (window.__productWizRio && window.__productWizRioProductOptionsSettings && window.__productWizRioProductOptionsSettings.productOptionsCenteredOnMobile) {
                const {config: {breakpoint: e}} = window.__productWizRio;
                return e
            }
            return "none"
        }()
          , n = qd(`(min-width:${"none" === t ? "0px" : t})`, {
            noSsr: !0
        });
        return "none" === t ? e.centered : !n || e.centered
    }
    function Nx(e, t, n) {
        if ("string" != typeof e)
            return null;
        let r = e;
        return null !== t && (r = r.replace(/%P%/g, Mx(t < 0 ? 0 : t, function() {
            var e;
            const t = null === (e = window.__productWizRio) || void 0 === e ? void 0 : e.moneyFormat;
            return "string" == typeof t ? t : null
        }()))),
        "string" == typeof n && (r = r.replace(/%N%/g, n)),
        r
    }
    function Wx({selected: e, hovering: t, borderSelectedColor: n, borderUnselectedColor: r, borderHoverColor: i}) {
        const o = e ? n : t ? i : r;
        return o || "transparent"
    }
    const Fx = Ga(( () => ({
        tooltip: {
            backgroundColor: "var(--rio-tooltip-background-color)",
            color: "var(--rio-tooltip-text-color)",
            boxShadow: "none",
            fontSize: "var(--rio-tooltip-text-size)",
            padding: "var(--rio-tooltip-padding)"
        },
        arrow: {
            color: "var(--rio-tooltip-background-color)"
        }
    })));
    function $x({aspectRatio: e, width: t, url: n, variantImagePosition: r="center"}) {
        const i = ky()
          , {url: o, aspectRatio: a} = function({url: e, variantImagePosition: t, aspectRatio: n}) {
            if (Array.isArray(e) && Array.isArray(n) && e.length === n.length)
                throw new Error("Url should not be array on storefront");
            return {
                url: e,
                aspectRatio: n || 1
            }
        }({
            url: n,
            variantImagePosition: r,
            aspectRatio: e
        })
          , s = i * t
          , l = e => ({
            url: `url(${e})`,
            width: t,
            aspectRatio: a
        })
          , c = Ey(o);
        return l(a > 1 ? c(void 0, s) : c(s, void 0))
    }
    function Bx({outOfStockTooltip: e, value: t, children: n, available: r, name: i, price: o}) {
        Fx();
        const a = le(( () => `rio-tooltip-${mv.v4()}`), [])
          , {config: {backgroundImage: s, backgroundVariantImagePosition: l, tooltip: {enabled: c, text: u, textSize: d, textBold: p, textUppercase: f, textColor: h, textPadding: m, backgroundColor: v, position: [g], optionValueImage: b, optionValueImagePosition: [y], optionValueImageFit: w, optionValueImageSizePx: x, optionValueImageTextAlign: _, optionValueImageSpacing: C, optionValueImageRadius: S}}} = t
          , E = le(( () => {
            const e = "center";
            return b && s && "string" == typeof s.id && s.id.startsWith("variant-image://") ? l : e
        }
        ), [s, l, b])
          , k = le(( () => {
            if (!b || !s)
                return;
            const {aspectRatio: e, url: t} = s
              , n = x
              , {width: r, aspectRatio: i, url: o} = $x({
                aspectRatio: e,
                width: n,
                url: t,
                variantImagePosition: E
            });
            return {
                url: o,
                width: r,
                height: "natural" === w ? r / i : r
            }
        }
        ), [s, E, b, w, x])
          , O = e && !r
          , T = !(!u || !c)
          , M = T || O || c && !!k
          , R = le(( () => function() {
            const e = window.__productWizRioProductOptionsSettings;
            return "object" == typeof e && null !== e && "string" == typeof e.outOfStockI18n ? e.outOfStockI18n : "Out of stock"
        }()), [])
          , P = T && O ? `${u} - ${R}` : O ? R : T ? u : null
          , I = le(( () => k && "left" !== _ ? "center" === _ ? "center" : "flex-end" : "flex-start"), [k, _]);
        ie(( () => {
            const e = `\n        .${a}-tooltip {\n          background-color: ${v};\n          box-shadow: none;\n          padding: ${m[2]}px ${m[1]}px ${m[3]}px ${m[0]}px;\n          max-width: unset;\n        }\n        .${a}-tooltip .rio-tooltip-text {\n          color: ${h};\n          font-size: ${d}px;\n          font-weight: ${p ? "bold" : "normal"};\n          text-transform: ${f ? "uppercase" : "none"};\n          ${k ? "max-width: unset;" : ""}\n        }\n        .${a}-arrow {\n          color: ${v};\n        }\n      `
              , t = document.createElement("style");
            return t.textContent = e,
            document.head.appendChild(t),
            () => {
                document.head.removeChild(t)
            }
        }
        ), [v, p, f, h, m, d, a, k]);
        const z = lt.createElement(lt.Fragment, null, k && lt.createElement($l, {
            item: !0
        }, lt.createElement("div", {
            style: {
                width: k.width,
                height: k.height,
                marginBottom: "above" === y && "string" == typeof P ? C : 0,
                marginTop: "below" === y && "string" == typeof P ? C : 0,
                backgroundImage: k.url,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: E,
                borderRadius: `${S}px`
            }
        }, lt.createElement("div", null))));
        return M ? lt.createElement(Vd, {
            classes: {
                tooltip: `${a}-tooltip`,
                arrow: `${a}-arrow`
            },
            title: lt.createElement($l, {
                container: !0,
                direction: "column",
                spacing: 0,
                alignItems: I
            }, "above" === y && z, "string" == typeof P && lt.createElement($l, {
                item: !0
            }, lt.createElement("span", {
                className: "rio-tooltip-text",
                dangerouslySetInnerHTML: {
                    __html: Lx(Nx(P, o, i))
                }
            })), "below" === y && z),
            arrow: !0,
            placement: "above" === g ? "top" : "bottom",
            enterTouchDelay: 0,
            leaveTouchDelay: 1500
        }, n) : n
    }
    function jx({text: e, config: t, size: n}) {
        const {textBold: r, textUppercase: i, textSize: o, textColor: a, backgroundColor: s, textPadding: [l,c,u,d], borderStyle: p, borderColor: f, borderRadius: h, borderThickness: m, margin: [,,v,g], position: [b], useThemeSettings: y, maxWidthEnabled: w} = t;
        return lt.createElement($l, {
            item: !0,
            container: !0,
            direction: "column"
        }, "below" === b && lt.createElement(As, {
            height: v
        }), lt.createElement($l, {
            item: !0
        }, lt.createElement("div", {
            className: y ? "rio-product-option-title" : void 0,
            style: y ? {} : {
                ...w && (null == n ? void 0 : n.width) > 0 ? {
                    maxWidth: n.width,
                    textAlign: "center",
                    wordBreak: "break-word"
                } : {},
                lineHeight: 1,
                fontSize: o,
                fontWeight: r ? "bold" : void 0,
                textTransform: i ? "uppercase" : "none",
                color: a,
                background: s,
                paddingLeft: l,
                paddingRight: c,
                paddingTop: u,
                paddingBottom: d,
                ...f || s ? {
                    ...f ? {
                        borderColor: f,
                        borderStyle: `${p}`,
                        borderWidth: `${m}px`
                    } : {},
                    borderRadius: `${h}%`
                } : {}
            },
            dangerouslySetInnerHTML: "string" == typeof e ? {
                __html: Lx(e)
            } : void 0
        }, "string" != typeof e ? e : void 0)), "above" === b && lt.createElement(As, {
            height: g
        }))
    }
    const Hx = lt.createContext("spacing");
    function Vx({placeholderKey: e, placeholderCellKey: t}) {
        const [n,r] = ue(Hx);
        return lt.createElement(jm, {
            handleHeight: !0,
            onResize: (i, o) => {
                const a = [...(n[e] || []).filter((e => e.id !== t)), {
                    id: t,
                    height: o
                }];
                r({
                    ...n,
                    [e]: a
                })
            }
        })
    }
    function qx({placeholderKey: e, placeholderCellKey: t, outerTextId: n, config: r, price: i, name: o, size: a}) {
        const s = function(e) {
            const [t] = ue(Hx)
              , n = t[e];
            if (Array.isArray(n))
                return Math.max(...n.map((e => e.height)))
        }(e);
        if ("placeholder" === n)
            return lt.createElement("div", {
                style: {
                    height: s
                }
            });
        const l = r[n]
          , {text: c} = l;
        return lt.createElement("div", {
            style: {
                height: s
            }
        }, lt.createElement($l, {
            container: !0,
            style: {
                height: "100%"
            },
            alignItems: "center"
        }, lt.createElement($l, {
            item: !0
        }, lt.createElement(Vx, {
            placeholderKey: e,
            placeholderCellKey: t
        }), lt.createElement(jx, {
            text: Nx(c, i, o),
            config: l,
            size: a
        }))))
    }
    function Ux({hide: e, title: t, selectedOptionName: n, config: r}) {
        const {textAlign: i, displaySelectedOptionValue: o, enabled: a, text: s} = r
          , l = Dx(r)
          , c = le(( () => l || "center" === i ? {
            justify: "center"
        } : "right" === i ? {
            direction: "row-reverse"
        } : {
            direction: "row"
        }), [l, i])
          , u = le(( () => {
            let e;
            return e = s ? Nx(s, null, t) : t,
            lt.createElement(lt.Fragment, null, e, o && n && lt.createElement(lt.Fragment, null, ": ", lt.createElement("span", {
                className: "rio-product-option-title-option-value"
            }, n)))
        }
        ), [o, n, s, t]);
        return !a || e ? null : lt.createElement($l, xp({
            container: !0
        }, c), lt.createElement($l, {
            item: !0
        }, lt.createElement(jx, {
            text: u,
            config: r
        })))
    }
    function Gx({type: e, buttonType: t, buttonWidth: n, backgroundType: r, backgroundImage: i, backgroundVariantImagePosition: o, backgroundSize: a, size: s, color1: l, color2: c, color3: u, color4: d}) {
        return le(( () => {
            if ("button" === e)
                return;
            const p = "fit-text" === t ? n : s;
            if (0 === p)
                return;
            const f = 100 === a ? "cover" : `${a}% auto`;
            if (!i && "swatch" === e && "one-solid" !== r) {
                return {
                    backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(function({id: e, size: t, color1: n, color2: r, color3: i, color4: o}) {
                        const a = Ix[e];
                        return ("string" == typeof a ? a : Ix["one-solid"]).replace(/%SIZE%/g, `${t}px`).replace(/%COLOR1%/g, n).replace(/%COLOR2%/g, r).replace(/%COLOR3%/g, i).replace(/%COLOR4%/g, o)
                    }({
                        id: r,
                        size: p,
                        color1: l,
                        color2: c,
                        color3: u,
                        color4: d
                    }))}')`,
                    backgroundSize: f,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }
            }
            if (!i)
                return;
            const {url: h} = $x({
                aspectRatio: i.aspectRatio,
                width: p,
                url: i.url,
                variantImagePosition: o
            });
            return {
                backgroundImage: h,
                backgroundRepeat: "no-repeat",
                ..."string" == typeof i.id && i.id.startsWith("variant-image://") ? {
                    backgroundPosition: o,
                    backgroundSize: "cover"
                } : {
                    backgroundPosition: "center",
                    backgroundSize: f
                }
            }
        }
        ), [e, t, n, s, i, o, r, a, l, c, u, d])
    }
    function Zx({backgroundImage: e, size: t, borderRadius: n, borderDouble: r, borderDoubleThickness: i, borderDoubleColor: o, backgroundVariantImagePosition: a}) {
        const s = le(( () => `rio-button-icon-border-double-${mv.v4()}`), [])
          , l = le(( () => "string" == typeof e.id && e.id.startsWith("variant-image://") ? a : "center"), [e, a])
          , {url: c} = $x({
            aspectRatio: e.aspectRatio,
            width: t,
            url: e.url,
            variantImagePosition: l
        });
        return lt.createElement("div", {
            className: r ? s : void 0,
            style: {
                width: t,
                height: t,
                backgroundImage: c,
                backgroundSize: "cover",
                borderRadius: `${n}%`,
                backgroundPosition: l,
                backgroundRepeat: "no-repeat",
                position: "relative"
            }
        }, r && lt.createElement("style", null, `\n            .${s}:before {\n              content: "";\n              border: ${i}px solid ${o};\n              border-radius: ${n}%;\n              display: block;\n              position: absolute;\n              top: -1px;\n              left: -1px;\n              width: ${t + 2}px;\n              height: ${t + 2}px;\n            }\n          `))
    }
    function Kx({index: e, prices: t, available: n, outOfStockStyle: r, hideUnavailable: i}) {
        if (n[e])
            return !1;
        const o = t[e] > -1;
        return !("hide" !== r || !o) || !(!i || o)
    }
    function Yx({id: e, outOfStockStyle: t, available: n, selected: r, onChange: i, values: o, hideUnavailable: a, prices: s}) {
        ie(( () => {
            if ("hide" !== t && !a)
                return;
            if (-1 === r)
                return;
            if (!Kx({
                index: r,
                prices: s,
                available: n,
                outOfStockStyle: t,
                hideUnavailable: a
            }))
                return;
            let l = r
              , c = r
              , u = !1;
            for (; u ? l += 1 : c -= 1,
            !(c < 0 && l > o.length - 1); ) {
                const e = u ? l : c;
                if (e >= 0 && e <= o.length - 1 && !Kx({
                    index: e,
                    prices: s,
                    available: n,
                    outOfStockStyle: t,
                    hideUnavailable: a
                })) {
                    u = e;
                    break
                }
                u = !u
            }
            "number" == typeof u && r !== u && (console.log(`Rio: Changing ${e} option to ${o[u].id} because of hidden out of stock`),
            i(e, o[u].id))
        }
        ), [n, r])
    }
    function Xx({index: e, position: t, outerTextIndex: n, outerTextId: r, config: i, price: o, name: a, size: s}) {
        if (!r)
            return null;
        const l = `${t}-${n}`
          , c = `${e}-${n}`;
        return lt.createElement(qx, {
            placeholderKey: l,
            placeholderCellKey: c,
            outerTextId: r,
            config: i,
            price: o,
            name: a,
            size: s
        })
    }
    function Jx({value: e, index: t, size: n, type: r, buttonType: i, border: o, borderThickness: a, borderRadius: s, borderRadiusPx: l, borderSelectedColor: c, borderUnselectedColor: u, borderHoverColor: d, borderOutOfStockCrossOutColor: p, borderDouble: f, borderDoubleColor: h, borderDoubleThickness: m, outOfStock: v, selected: g, available: b, setSelected: y, hovering: w, setHovering: x, price: _, outerTextMatrices: C, selectedConfig: S, unselectedConfig: E, horizontalCarousel: k, onNavigationScrolled: O, initialScroll: T, scp: M, scpSelected: R, setScpSelected: P}) {
        const {id: I, name: z, config: A, gps: L, url: D, config: {backgroundImage: N, backgroundColor: W, backgroundColor2: F, backgroundColor3: $, backgroundColor4: B, selectedBackgroundColor: j, backgroundType: H, backgroundVariantImagePosition: V, backgroundPosition: q, backgroundSize: U, backgroundSizePx: G, backgroundBorderRadius: Z, text: K, textPadding: Y}} = e
          , [X,J] = ne({
            width: 0,
            height: 0
        })
          , {width: Q, height: ee} = X
          , te = Gx({
            type: r,
            buttonType: i,
            buttonWidth: Q,
            backgroundType: H,
            backgroundSize: U,
            backgroundVariantImagePosition: V,
            backgroundImage: N,
            size: n,
            color1: W,
            color2: F,
            color3: $,
            color4: B
        })
          , re = le(( () => "swatch" === r && "one-solid" === H && null !== j ? j : null), [H, j, r])
          , oe = le(( () => t === g), [t, g])
          , ae = ce((e => "button" === r ? (oe ? S : E)[e] : A[e]), [r, A, oe, S, E])
          , se = le(( () => "button" === r ? "fit-text" : i), [i, r])
          , ue = le(( () => ae("backgroundColor")), [ae])
          , de = le(( () => ae("textColor")), [ae])
          , pe = le(( () => ae("textSize")), [ae])
          , fe = le(( () => ae("textBold")), [ae])
          , he = le(( () => ae("textUppercase")), [ae])
          , me = le(( () => "button" === r ? e.name : K), [K, r, e.name])
          , ve = le(( () => {
            if ("swatch" === r && "fit-text" === se || "button" === r) {
                const [e,t,n,r] = Y;
                return {
                    paddingLeft: e,
                    paddingRight: t,
                    paddingTop: n,
                    paddingBottom: r
                }
            }
            return {}
        }
        ), [se, Y, r])
          , ge = le(( () => `rio-swatch-unavailable-${mv.v4()}`), [])
          , be = le(( () => `rio-swatch-border-double-${mv.v4()}`), [])
          , [ye,we] = ne({
            length: 0,
            radians: 0
        })
          , xe = function({size: e, fitText: t}) {
            return t ? 62 === e ? "medium" : 102 === e ? "large" : "small" : e
        }({
            size: n,
            fitText: "button" === r || "fit-text" === se
        })
          , [_e,Ce] = C
          , Se = "button" === r && N ? lt.createElement(Zx, {
            backgroundImage: N,
            backgroundVariantImagePosition: V,
            borderRadius: Z,
            size: G,
            borderDouble: f,
            borderDoubleThickness: m,
            borderDoubleColor: h
        }) : null
          , Ee = ce((e => {
            const t = {
                label: ve
            };
            return Sr({
                ...e,
                typography: {
                    ...e.typography,
                    button: {
                        ...e.typography.button,
                        fontFamily: null
                    }
                },
                overrides: {
                    ...e.overrides,
                    MuiButton: t,
                    PwzrButton: t
                }
            })
        }
        ), [ve])
          , ke = function(e, t, n, r, i) {
            if ("swatch" === e) {
                if ("circular" === t)
                    return "50%";
                if ("round" === n)
                    return `${r}%`
            }
            if ("button" === e)
                return `${i}px`
        }(r, se, o, s, l);
        ie(( () => {
            const e = Q
              , t = ee
              , n = Math.sqrt(e ** 2 + t ** 2)
              , r = Math.PI / 2 - Math.atan(e / t);
            we({
                length: n,
                radians: r
            })
        }
        ), [a, ee, Q]);
        const Oe = "button" === r || "swatch" === r && "fit-text" === se ? "1.0" : "0.9"
          , Te = ce((e => {
            const t = !M && T.current ? 0 : 100;
            T.current = !1,
            e && window.requestAnimationFrame(( () => {
                Yb(e, {
                    time: t,
                    lockX: !1,
                    lockY: !0,
                    validTarget: e => !(!e || "function" != typeof e.matches || !e.matches(".rio-hide-scrollbar"))
                }, ( () => {
                    O()
                }
                ))
            }
            ))
        }
        ), [O])
          , Me = le(( () => {
            if (k)
                return t === g || M && t === R ? Te : void 0
        }
        ), [k, M, R, g, Te, t])
          , Re = lt.createElement($l, {
            container: !0,
            direction: "column",
            alignItems: "center"
        }, _e[t].map(( (e, n) => lt.createElement(Xx, {
            index: t,
            position: "above",
            key: n,
            outerTextIndex: n,
            outerTextId: e,
            config: A,
            price: _,
            name: z,
            size: X
        }))), lt.createElement("div", null, "cross-out" === v.style && lt.createElement(lt.Fragment, null, lt.createElement("style", null, `\n                .${ge} {\n                  opacity: 0.6;\n                }\n                .${ge}::after {\n                  content: "";\n                  position: absolute;\n                  transform-origin: 0 0;\n                  top: 50%;\n                  left: 50%;\n                  width: ${ye.length}px;\n                  transform: rotate(${ye.radians}rad) scale(${Oe}) translate(-50%, -50%);\n                  border-top: ${a + .5}px solid ${p};\n                }\n            `)), "fade-out" === v.style && lt.createElement("style", null, `\n              .${ge} {\n                opacity: 0.6;\n              }     \n            `), "swatch" === r && f && lt.createElement("style", null, `\n            .${be}:before {\n              content: "";\n              border: ${m}px solid ${h};\n              ${ke ? `border-radius: ${ke};` : ""}\n              display: block;\n              position: absolute;\n              width: calc(100% + 2px);\n              height: calc(100% + 2px);\n            }\n          `), lt.createElement(jm, {
            handleWidth: !0,
            handleHeight: !0,
            onResize: (e, t) => {
                J({
                    width: e,
                    height: t
                })
            }
        }), lt.createElement(Va, {
            theme: Ee
        }, lt.createElement(yl, {
            component: "div",
            role: "button",
            ref: Me,
            onClick: e => {
                M && (e.preventDefault(),
                e.stopPropagation(),
                P(t)),
                L ? window.location.href = D : y(I)
            }
            ,
            onMouseOver: () => {
                x(t)
            }
            ,
            onMouseOut: () => {
                x(-1)
            }
            ,
            className: Ra(b ? void 0 : ge, be),
            "aria-label": I,
            "data-option-value": I,
            size: "string" == typeof xe ? xe : void 0,
            startIcon: "left" === q ? Se : void 0,
            endIcon: "right" === q ? Se : void 0,
            style: {
                position: "relative",
                backgroundColor: re && t === g ? re : ue,
                ...te,
                ..."number" == typeof xe ? {
                    minWidth: xe,
                    width: xe,
                    height: xe
                } : {},
                outline: "none",
                boxSizing: "border-box",
                border: "solid",
                borderWidth: `${a}px`,
                borderRadius: ke,
                borderColor: Wx({
                    selected: t === g,
                    hovering: t === w,
                    borderSelectedColor: c,
                    borderUnselectedColor: u,
                    borderHoverColor: d
                })
            }
        }, lt.createElement("span", {
            style: {
                fontSize: pe,
                color: de,
                fontWeight: fe ? "bold" : "normal",
                textTransform: he ? "uppercase" : "none"
            },
            dangerouslySetInnerHTML: {
                __html: me ? Lx(Nx(me, _, z)) : " "
            }
        })))), Ce[t].map(( (e, n) => lt.createElement(Xx, {
            index: t,
            position: "below",
            key: n,
            outerTextIndex: n,
            outerTextId: e,
            config: A,
            price: _,
            name: z,
            size: X
        }))));
        return lt.createElement($l, {
            key: I,
            item: !0
        }, lt.createElement(Bx, {
            outOfStockTooltip: v.tooltip,
            available: b,
            value: e,
            name: z,
            price: _
        }, Re))
    }
    const Qx = Ga((e => ({
        inputLabel: {
            marginBottom: e.spacing(.5)
        },
        helperText: {
            marginTop: e.spacing(.5)
        },
        items: {
            padding: e.spacing(.5)
        },
        navigationRoot: {
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            width: "41px",
            height: "41px",
            margin: "auto",
            bottom: 0,
            top: 0,
            zIndex: 1,
            position: "absolute",
            "&:hover": {
                color: "white",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                "@media (hover: none)": {
                    backgroundColor: "rgba(0, 0, 0, 0.5)"
                }
            }
        }
    })));
    function e_({children: e, option: t, selected: n}) {
        const {name: r, config: {type: i, horizontalCarousel: o, centered: a, title: s, select: {fullWidth: l}}, values: c} = t
          , u = le(( () => "select" !== i ? a && !o ? "center" : void 0 : a ? "center" : void 0), [a, o, i])
          , d = le(( () => "select" !== i ? o ? void 0 : "fit-content" : l ? void 0 : "fit-content"), [o, l, i])
          , p = le(( () => ({
            title: r,
            config: s,
            selectedOptionName: n > -1 ? c[n].name : void 0
        })), [r, n, s, c])
          , f = ne({});
        return lt.createElement(Hx.Provider, {
            value: f
        }, lt.createElement($l, {
            item: !0,
            container: !0,
            justify: u
        }, lt.createElement($l, {
            container: !0,
            wrap: "nowrap",
            direction: "column",
            style: {
                position: "relative",
                alignItems: u
            },
            className: "fit-content" === d ? "rio-width-fit-content" : void 0
        }, lt.createElement(Ux, xp({
            hide: "above" !== s.position[0]
        }, p)), lt.createElement("div", {
            style: {
                position: "relative"
            }
        }, e), lt.createElement(Ux, xp({
            hide: "below" !== s.position[0]
        }, p)))))
    }
    function t_({option: e, onChange: t, selected: n, available: r, prices: i, scp: o}) {
        const {id: a, values: s, config: {size: l, spacing: c, centered: u, horizontalCarousel: d, type: p, buttonType: f, border: h, borderThickness: m, borderRadius: v, borderRadiusPx: g, borderSelectedColor: b, borderUnselectedColor: y, borderHoverColor: w, borderOutOfStockCrossOutColor: x, borderDouble: _, borderDoubleColor: C, borderDoubleThickness: S, outOfStock: E, hideUnavailable: k, selected: O, unselected: T}} = e
          , M = Qx()
          , [R,P] = ne(-1)
          , I = ce((e => {
            t(a, e)
        }
        ), [a, t]);
        ie(( () => {
            if (o)
                return () => {}
                ;
            return Ax(a, I)
        }
        ), [a, o, I]),
        Yx({
            id: a,
            outOfStockStyle: E.style,
            available: r,
            selected: n,
            onChange: t,
            hideUnavailable: k,
            values: s,
            prices: i
        });
        const z = le(( () => ["above", "below"].map((e => function({position: e, optionValues: t}) {
            const n = t.map((t => Tx.map((n => {
                const [r,i] = Ox(n, t.config, e);
                return {
                    enabled: r,
                    id: n,
                    priority: i
                }
            }
            )).sort(Ty("priority")).map(( ({enabled: e, id: t}) => e ? t : null))));
            if (n.length > 0)
                for (let e = 0; e < n[0].length; e += 1) {
                    let t = !0;
                    for (let r = 0; r < n.length; r += 1)
                        n[r][e] && (t = !1);
                    if (!t)
                        for (let t = 0; t < n.length; t += 1)
                            n[t][e] || (n[t][e] = "placeholder")
                }
            return n
        }({
            position: e,
            optionValues: s
        })))), [s])
          , A = ae(null)
          , [L,D] = ne(!1)
          , [N,W] = ne(!1)
          , F = ae(!0)
          , $ = ce(( () => {
            if (!d)
                return;
            const e = A.current;
            if (e) {
                const t = My(e, !1);
                W(!t.start),
                D(!t.end)
            }
        }
        ), [d])
          , [B,j] = ne(-1)
          , H = s.map(( (e, t) => {
            const {id: a} = e;
            return [Kx({
                index: t,
                prices: i,
                available: r,
                outOfStockStyle: E.style,
                hideUnavailable: k
            }), a, lt.createElement(Jx, {
                value: e,
                values: s,
                type: p,
                buttonType: f,
                size: l,
                index: t,
                available: r[t],
                price: i[t],
                border: h,
                borderThickness: m,
                borderRadius: v,
                borderRadiusPx: g,
                borderSelectedColor: b,
                borderUnselectedColor: y,
                borderHoverColor: w,
                borderOutOfStockCrossOutColor: x,
                borderDouble: _,
                borderDoubleColor: C,
                borderDoubleThickness: S,
                outOfStock: E,
                selected: n,
                setSelected: I,
                hovering: R,
                setHovering: P,
                outerTextMatrices: z,
                selectedConfig: O,
                unselectedConfig: T,
                horizontalCarousel: d,
                onNavigationScrolled: $,
                initialScroll: F,
                scp: o,
                scpSelected: B,
                setScpSelected: j
            })]
        }
        ))
          , V = !H.find(( ([e]) => !e))
          , q = Za()
          , U = q.spacing(1)
          , G = q.spacing(c)
          , Z = le(( () => function() {
            const e = {
                fill: "rgba(255, 255, 255, 1)",
                background: "rgba(0, 0, 0, 0.5)"
            };
            return window.__productWizRio && window.__productWizRioProductOptionsSettings && window.__productWizRioProductOptionsSettings.productOptionsArrows ? {
                ...e,
                ...window.__productWizRioProductOptionsSettings.productOptionsArrows
            } : e
        }()), []);
        return V ? null : lt.createElement(e_, {
            option: e,
            selected: n
        }, d && lt.createElement(jm, {
            handleWidth: !0,
            refreshMode: "debounce",
            refreshRate: 250,
            onResize: () => {
                $()
            }
        }), d && N && lt.createElement(jl, {
            component: "div",
            role: "button",
            size: "small",
            classes: {
                root: M.navigationRoot
            },
            onClick: async e => {
                o && (e.preventDefault(),
                e.stopPropagation());
                const t = await Ry(A.current, !1, -1);
                W(!t.start),
                D(!t.end)
            }
            ,
            "aria-label": `Scroll ${a} left`,
            style: {
                left: 0,
                color: Z.fill,
                backgroundColor: Z.background
            }
        }, lt.createElement(Qm, {
            fontSize: "large"
        })), lt.createElement($l, {
            ref: A,
            item: !0,
            container: !0,
            direction: "row",
            "aria-label": a,
            "data-option": a,
            "data-option-type": p,
            wrap: d ? "nowrap" : void 0,
            justify: !d && u ? "center" : void 0,
            style: {
                overflowX: "auto",
                alignItems: "center"
            },
            onScroll: d ? () => {
                $()
            }
            : void 0,
            spacing: d ? void 0 : c,
            className: Ra("rio-hide-scrollbar", M.items, !d && "rio-width-fit-content")
        }, H.map(( ([e,t,n], r, i) => e ? lt.createElement(lt.Fragment, {
            key: t
        }) : lt.createElement($l, {
            item: !0,
            key: t,
            style: {
                paddingRight: d ? r !== i.length - 1 ? G : U : void 0
            }
        }, n))), d && L && lt.createElement(jl, {
            component: "div",
            role: "button",
            size: "small",
            classes: {
                root: M.navigationRoot
            },
            onClick: async e => {
                o && (e.preventDefault(),
                e.stopPropagation());
                const t = await Ry(A.current, !1, 1);
                W(!t.start),
                D(!t.end)
            }
            ,
            "aria-label": `Scroll ${a} right`,
            style: {
                right: 0,
                color: Z.fill,
                backgroundColor: Z.background
            }
        }, lt.createElement(iv, {
            fontSize: "large"
        }))))
    }
    function n_({option: e, selected: t, setSelected: n, available: r, prices: i, scp: o}) {
        const {id: a, values: s, config: {type: l, centered: c, select: {backgroundColor: u, textColor: d, textSize: p, textBold: f, textUppercase: h, fullWidth: m, darkMenu: v, variant: g, outerText: b, minWidth: y}, hideUnavailable: w, outOfStock: {style: x}, borderUnselectedColor: _, borderSelectedColor: C, borderHoverColor: S, borderThickness: E, borderRadiusPx: k, borderDouble: O, borderDoubleThickness: T, borderDoubleColor: M}} = e
          , R = _ || "transparent"
          , P = C || "transparent"
          , I = S || "transparent"
          , z = ce((e => Tx.map((t => {
            const [n,r] = Ox(t, b, e);
            return {
                id: t,
                priority: r,
                enabled: n
            }
        }
        )).sort(Ty("priority")).filter((e => e.enabled)).map((e => e.id))), [b])
          , A = le(( () => z("above")), [z])
          , L = le(( () => z("below")), [z])
          , D = ce((e => {
            if (!r[e] && "none" !== x) {
                if ("cross-out" === x)
                    return {
                        textDecoration: "line-through"
                    };
                if ("fade-out" === x)
                    return {
                        opacity: .5
                    }
            }
            return {}
        }
        ), [r, x])
          , N = ce((e => {
            const t = {
                root: {
                    "& $notchedOutline": {
                        borderColor: R,
                        borderWidth: E
                    },
                    "&:hover $notchedOutline": {
                        borderColor: I,
                        borderWidth: E
                    },
                    "&$focused $notchedOutline": {
                        borderColor: P,
                        borderWidth: E
                    }
                }
            }
              , n = {
                underline: {
                    "&::before": {
                        borderBottom: `${E}px solid ${R}`
                    },
                    "&::after": {
                        borderBottom: `${E}px solid ${P}`
                    },
                    "&:hover:not($disabled):not($error):not($focused):before": {
                        borderBottom: `${E}px solid ${I}`
                    }
                }
            }
              , r = {
                root: {
                    fontFamily: null,
                    lineHeight: 1.2
                }
            }
              , i = {
                root: {
                    "&:focus": {
                        backgroundColor: "transparent !important"
                    }
                },
                icon: {
                    color: d,
                    width: "24px",
                    height: "24px"
                }
            }
              , o = {
                root: {
                    fontSize: "16px",
                    fontFamily: null
                }
            };
            return Sr({
                ...e,
                palette: {
                    type: v ? "dark" : "light"
                },
                overrides: {
                    ...e.overrides,
                    MuiOutlinedInput: t,
                    MuiInput: n,
                    MuiInputBase: r,
                    MuiSelect: i,
                    MuiMenuItem: o,
                    PwzrOutlinedInput: t,
                    PwzrInput: n,
                    PwzrInputBase: r,
                    PwzrSelect: i,
                    PwzrMenuItem: o
                }
            })
        }
        ), [I, P, E, R, v, d])
          , W = s.map(( (e, t) => {
            if (Kx({
                index: t,
                prices: i,
                available: r,
                outOfStockStyle: x,
                hideUnavailable: w
            }))
                return [!0, lt.createElement(lt.Fragment, {
                    key: e.id
                })];
            const {config: {backgroundImage: n, backgroundVariantImagePosition: o, backgroundSizePx: a, backgroundBorderRadius: s, backgroundPosition: l}} = e
              , c = n ? lt.createElement(Zx, {
                backgroundImage: n,
                backgroundVariantImagePosition: o,
                borderRadius: s,
                size: a,
                borderDouble: O,
                borderDoubleThickness: T,
                borderDoubleColor: M
            }) : null;
            return [!1, lt.createElement(Xl, {
                key: e.id,
                value: t,
                style: D(t),
                "aria-label": e.id,
                "data-option-value": e.id
            }, lt.createElement($l, {
                container: !0,
                direction: "row",
                wrap: "nowrap",
                alignItems: "center"
            }, c && "left" === l && lt.createElement($l, {
                item: !0
            }, lt.createElement($l, {
                container: !0,
                wrap: "nowrap"
            }, c, lt.createElement(As, {
                mr: 1
            }))), lt.createElement($l, {
                item: !0,
                xs: !0,
                style: {
                    whiteSpace: "normal",
                    wordBreak: "break-word"
                }
            }, e.name), c && "right" === l && lt.createElement($l, {
                item: !0
            }, lt.createElement($l, {
                container: !0,
                wrap: "nowrap"
            }, lt.createElement(As, {
                ml: 1
            }), c)))), r[t]]
        }
        ));
        ie(( () => {
            if (o)
                return () => {}
                ;
            return Ax(a, n)
        }
        ), [a, o, n]);
        const F = ce(( () => {
            if (t < 0)
                return;
            return W[t][2] ? void 0 : "cross-out" === x ? "line-through" : void 0
        }
        ), [x, t, W]);
        return !W.find(( ([e]) => !e)) ? null : lt.createElement(e_, {
            option: e,
            selected: t
        }, lt.createElement($l, {
            item: !0,
            container: !0,
            direction: "column",
            alignItems: "flex-start",
            style: {
                width: c && !m ? "auto" : void 0
            }
        }, A.map(( (e, t) => lt.createElement(Xx, {
            index: 0,
            position: "above",
            key: t,
            outerTextIndex: t,
            outerTextId: e,
            config: b
        }))), lt.createElement(Va, {
            theme: N
        }, lt.createElement(mu, {
            variant: g,
            value: t,
            fullWidth: m,
            onChange: e => {
                const t = s[e.target.value]
                  , {gps: r, url: i} = t;
                r ? window.location.href = i : n(t.id)
            }
            ,
            MenuProps: {
                disableScrollLock: !0,
                autoFocus: !1
            },
            inputProps: {
                "aria-label": a
            },
            style: {
                backgroundColor: u,
                fontWeight: f ? "bold" : "normal",
                textTransform: h ? "uppercase" : "none",
                textDecoration: F(),
                color: d,
                fontSize: `${p}px`,
                marginTop: 5,
                marginLeft: 5,
                marginBottom: 5,
                minWidth: m ? void 0 : y,
                borderRadius: k
            },
            "data-option": a,
            "data-option-type": l
        }, W.map(( ([,e]) => e)))), L.map(( (e, t) => lt.createElement(Xx, {
            index: 0,
            position: "below",
            key: t,
            outerTextIndex: t,
            outerTextId: e,
            config: b
        })))))
    }
    function r_({option: e, selected: t, onChange: n, available: r, prices: i, scp: o}) {
        const {id: a, values: s, config: {outOfStock: {style: l}, hideUnavailable: c}} = e
          , u = ce((e => {
            n(a, e)
        }
        ), [a, n]);
        return Yx({
            id: a,
            outOfStockStyle: l,
            available: r,
            selected: t,
            onChange: n,
            hideUnavailable: c,
            values: s,
            prices: i
        }),
        lt.createElement(n_, {
            option: e,
            selected: t,
            setSelected: u,
            available: r,
            prices: i,
            scp: o
        })
    }
    function i_({option: e, variant: t, onChange: n, selected: r, available: i, prices: o, scp: a}) {
        return "select" !== e.config.type ? lt.createElement(t_, {
            option: e,
            variant: t,
            onChange: n,
            selected: r,
            available: i,
            prices: o,
            scp: a
        }) : lt.createElement(r_, {
            option: e,
            variant: t,
            onChange: n,
            selected: r,
            available: i,
            prices: o,
            scp: a
        })
    }
    function o_({option: e, index: t}) {
        const {selections: n, onChange: r, scp: i} = ue(Rx)
          , o = function({option: e}) {
            const {getAsset: t} = ue(zx)
              , n = Dx(e.config);
            return le(( () => ({
                ...e,
                config: {
                    ...e.config,
                    centered: n
                },
                values: e.values.map((e => {
                    const {config: {backgroundImage: n}} = e;
                    if ("object" == typeof n && null !== n) {
                        const r = t(n);
                        return r ? {
                            ...e,
                            config: {
                                ...e.config,
                                backgroundImage: {
                                    ...e.config.backgroundImage,
                                    ...r
                                }
                            }
                        } : {
                            ...e,
                            config: {
                                ...e.config,
                                backgroundImage: null
                            }
                        }
                    }
                    return e
                }
                ))
            })), [n, t, e])
        }({
            option: e
        })
          , a = ce((e => {
            const t = {
                tooltip: {
                    fontFamily: null,
                    lineHeight: 1.2
                },
                touch: {
                    lineHeight: 1.2
                }
            };
            return Sr({
                ...e,
                overrides: {
                    ...e.overrides,
                    MuiTooltip: t,
                    PwzrTooltip: t
                }
            })
        }
        ), []);
        return lt.createElement(lt.Fragment, {
            key: o.id
        }, lt.createElement(Va, {
            theme: a
        }, lt.createElement(i_, {
            option: o,
            selected: n[t].index,
            available: n[t].available,
            prices: n[t].prices,
            onChange: r,
            scp: i
        })))
    }
    function a_(e, t) {
        var n = lt.memo(lt.forwardRef((function(t, n) {
            return lt.createElement(_l, Vt({
                ref: n
            }, t), e)
        }
        )));
        return n.muiName = _l.muiName,
        n
    }
    var s_ = a_(lt.createElement("path", {
        d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
    }))
      , l_ = a_(lt.createElement("path", {
        d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
    }))
      , c_ = a_(lt.createElement("path", {
        d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }))
      , u_ = a_(lt.createElement("path", {
        d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
    }))
      , d_ = a_(lt.createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))
      , p_ = {
        success: lt.createElement(s_, {
            fontSize: "inherit"
        }),
        warning: lt.createElement(l_, {
            fontSize: "inherit"
        }),
        error: lt.createElement(c_, {
            fontSize: "inherit"
        }),
        info: lt.createElement(u_, {
            fontSize: "inherit"
        })
    }
      , f_ = lt.createElement(d_, {
        fontSize: "small"
    })
      , h_ = lt.forwardRef((function(e, t) {
        var n = e.action
          , r = e.children
          , i = e.classes
          , o = e.className
          , a = e.closeText
          , s = void 0 === a ? "Close" : a
          , l = e.color
          , c = e.icon
          , u = e.iconMapping
          , d = void 0 === u ? p_ : u
          , p = e.onClose
          , f = e.role
          , h = void 0 === f ? "alert" : f
          , m = e.severity
          , v = void 0 === m ? "success" : m
          , g = e.variant
          , b = void 0 === g ? "standard" : g
          , y = jt(e, ["action", "children", "classes", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"]);
        return lt.createElement(xc, Vt({
            role: h,
            square: !0,
            elevation: 0,
            className: Ra(i.root, i["".concat(b).concat(gl(l || v))], o),
            ref: t
        }, y), !1 !== c ? lt.createElement("div", {
            className: i.icon
        }, c || d[v] || p_[v]) : null, lt.createElement("div", {
            className: i.message
        }, r), null != n ? lt.createElement("div", {
            className: i.action
        }, n) : null, null == n && p ? lt.createElement("div", {
            className: i.action
        }, lt.createElement(jl, {
            size: "small",
            "aria-label": s,
            title: s,
            color: "inherit",
            onClick: p
        }, f_)) : null)
    }
    ));
    Ka((function(e) {
        var t = "light" === e.palette.type ? Wt : Ft
          , n = "light" === e.palette.type ? Ft : Wt;
        return {
            root: Vt({}, e.typography.body2, {
                borderRadius: e.shape.borderRadius,
                backgroundColor: "transparent",
                display: "flex",
                padding: "6px 16px"
            }),
            standardSuccess: {
                color: t(e.palette.success.main, .6),
                backgroundColor: n(e.palette.success.main, .9),
                "& $icon": {
                    color: e.palette.success.main
                }
            },
            standardInfo: {
                color: t(e.palette.info.main, .6),
                backgroundColor: n(e.palette.info.main, .9),
                "& $icon": {
                    color: e.palette.info.main
                }
            },
            standardWarning: {
                color: t(e.palette.warning.main, .6),
                backgroundColor: n(e.palette.warning.main, .9),
                "& $icon": {
                    color: e.palette.warning.main
                }
            },
            standardError: {
                color: t(e.palette.error.main, .6),
                backgroundColor: n(e.palette.error.main, .9),
                "& $icon": {
                    color: e.palette.error.main
                }
            },
            outlinedSuccess: {
                color: t(e.palette.success.main, .6),
                border: "1px solid ".concat(e.palette.success.main),
                "& $icon": {
                    color: e.palette.success.main
                }
            },
            outlinedInfo: {
                color: t(e.palette.info.main, .6),
                border: "1px solid ".concat(e.palette.info.main),
                "& $icon": {
                    color: e.palette.info.main
                }
            },
            outlinedWarning: {
                color: t(e.palette.warning.main, .6),
                border: "1px solid ".concat(e.palette.warning.main),
                "& $icon": {
                    color: e.palette.warning.main
                }
            },
            outlinedError: {
                color: t(e.palette.error.main, .6),
                border: "1px solid ".concat(e.palette.error.main),
                "& $icon": {
                    color: e.palette.error.main
                }
            },
            filledSuccess: {
                color: "#fff",
                fontWeight: e.typography.fontWeightMedium,
                backgroundColor: e.palette.success.main
            },
            filledInfo: {
                color: "#fff",
                fontWeight: e.typography.fontWeightMedium,
                backgroundColor: e.palette.info.main
            },
            filledWarning: {
                color: "#fff",
                fontWeight: e.typography.fontWeightMedium,
                backgroundColor: e.palette.warning.main
            },
            filledError: {
                color: "#fff",
                fontWeight: e.typography.fontWeightMedium,
                backgroundColor: e.palette.error.main
            },
            icon: {
                marginRight: 12,
                padding: "7px 0",
                display: "flex",
                fontSize: 22,
                opacity: .9
            },
            message: {
                padding: "8px 0",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            },
            action: {
                display: "flex",
                alignItems: "center",
                marginLeft: "auto",
                paddingLeft: 16,
                marginRight: -8
            }
        }
    }
    ), {
        name: "PwzrAlert"
    })(h_);
    Ka((e => ({
        h7: {
            fontSize: "1.1rem"
        }
    })))(( ({variant: e, classes: t, className: n, ...r}) => React.createElement(Tl, xp({
        className: Ra(t.h7, n),
        variant: "h6"
    }, r))));
    let m_;
    function v_({element: e, children: t, ik: n, it: r, ...i}) {
        const o = e;
        return m_ ? lt.createElement(o, i, lt.createElement(m_, xp({
            i18nKey: n
        }, r), t)) : lt.createElement(o, i, t)
    }
    function g_(e) {
        return lt.createElement(v_, xp({
            element: Vl
        }, e))
    }
    const b_ = Ga(( () => ({
        editContainer: {
            width: "80px",
            marginTop: "24px"
        },
        optionContainer: {
            width: "calc(100% - 80px)"
        },
        edit: {
            backgroundColor: "rgba(94, 109, 191)",
            color: "white",
            "&:hover": {
                backgroundColor: "rgba(94, 109, 191, 0.9)",
                boxShadow: "unset"
            }
        }
    })));
    function y_({editable: e, options: t, optionsToHide: n, spacing: r=1, setEditOption: i}) {
        const o = b_();
        return e ? lt.createElement($l, {
            container: !0,
            direction: "column"
        }, t.map(( (e, n) => lt.createElement(lt.Fragment, {
            key: e.id
        }, lt.createElement($l, {
            item: !0,
            container: !0,
            direction: "row"
        }, lt.createElement($l, {
            item: !0,
            container: !0,
            className: o.editContainer,
            alignItems: "center"
        }, lt.createElement($l, {
            item: !0
        }, lt.createElement($l, {
            container: !0,
            direction: "column",
            alignItems: "center"
        }, lt.createElement($l, {
            item: !0
        }, lt.createElement(jl, {
            onClick: () => {
                i(e)
            }
            ,
            className: o.edit
        }, lt.createElement(dx, {
            color: "inherit"
        }))), lt.createElement($l, {
            item: !0
        }, lt.createElement(g_, {
            component: "button",
            variant: "body1",
            onClick: () => {
                i(e)
            }
            ,
            ik: "productOptionsListEdit"
        }, "Edit"))))), lt.createElement($l, {
            item: !0,
            className: o.optionContainer
        }, lt.createElement(o_, {
            option: e,
            index: n
        }))), n !== t.length - 1 && lt.createElement(As, {
            mb: r
        }))))) : lt.createElement($l, {
            container: !0,
            direction: "column"
        }, t.map(( (e, t) => {
            var i;
            return !!n.find((t => t === e.id)) || !(null == e || null === (i = e.config) || void 0 === i || !i.hide) ? lt.createElement(lt.Fragment, {
                key: e.id
            }) : lt.createElement(lt.Fragment, {
                key: e.id
            }, lt.createElement($l, {
                item: !0,
                container: !0
            }, lt.createElement(o_, {
                option: e,
                index: t
            })), lt.createElement(As, {
                mb: r
            }))
        }
        )))
    }
    let w_;
    function x_(e, t) {
        return e.find((e => {
            if (e.options.length !== t.length)
                return !1;
            for (const n of e.options)
                if (!t.find((e => e.id === n.id && e.value === n.value)))
                    return !1;
            return !0
        }
        ))
    }
    function __(e, t, n) {
        if (e.gps) {
            const t = e.values.findIndex((e => e.id === n));
            return t > -1 ? t : -1
        }
        const r = t.find((t => t.id === e.id));
        if (r) {
            const t = e.values.findIndex((e => e.id === r.value));
            if (t > -1)
                return t
        }
        return 0
    }
    function C_({options: e, variants: t, gpsData: n, gpsSupplementalData: r, productId: i, scp: o}) {
        const a = le(( () => {
            if (!Array.isArray(n) || !Array.isArray(r) || "string" != typeof i || o || Array.isArray(n) && n.length < 1 || Array.isArray(r) && r.length < 1)
                return [];
            try {
                const e = []
                  , t = r
                  , i = n;
                for (const n of i) {
                    const r = t.find((e => e.id === n.id));
                    if (r && Array.isArray(r.selectedProducts)) {
                        const t = n.selectedProducts.map((e => {
                            const t = r.selectedProducts.find((t => e === t[0]));
                            return !1 === t[1] ? null : {
                                id: e,
                                title: t[1],
                                url: t[2],
                                price: t[3],
                                available: t[4],
                                gps: !0
                            }
                        }
                        )).filter((e => !!e));
                        e.push({
                            ...n,
                            selectedProducts: t
                        })
                    }
                }
                return e
            } catch (e) {
                console.log("Error parsing group products as swatches: "),
                console.log(e)
            }
            return []
        }
        ), [n, r, i, o]);
        return le(( () => {
            if (a.length < 1)
                return {
                    options: e,
                    variants: t
                };
            const n = a.filter((e => (Array.isArray(e.selectedProducts) ? e.selectedProducts : []).find((e => e.id === i)))).map((e => {
                try {
                    const t = (e => {
                        if ("string" != typeof e.swatchConfig)
                            return null;
                        const t = JSON.parse(e.swatchConfig);
                        return t.config = w_(Cx(), t.config),
                        t.values = t.values.map((t => {
                            const n = e.selectedProducts.find((e => e.id === t.id));
                            return n ? {
                                ...t,
                                config: w_(Sx(), t.config),
                                gps: !0,
                                url: n.url,
                                name: n.title
                            } : null
                        }
                        )).filter((e => !!e)),
                        t.values.length < 1 ? null : (t.gps = !0,
                        t)
                    }
                    )(e);
                    return t ? {
                        id: e.id,
                        position: e.position,
                        option: t,
                        variants: e.selectedProducts
                    } : null
                } catch (e) {
                    console.log("Error parsing group products as swatches config: "),
                    console.log(e)
                }
                return null
            }
            )).filter((e => !!e))
              , r = [];
            for (const e of n)
                for (const t of e.variants)
                    r.push({
                        ...t,
                        options: [{
                            id: e.id,
                            value: t.id
                        }]
                    });
            const o = e => n.filter((t => t.position === e)).map((e => e.option))
              , s = o("above")
              , l = o("1st-position")
              , c = o("2nd-position")
              , u = o("below")
              , d = t => e[t] ? [e[t]] : [];
            return {
                options: [...s, ...d(0), ...l, ...d(1), ...c, ...d(2), ...u, ...e.slice(3)],
                variants: [...t, ...r]
            }
        }
        ), [a, e, i, t])
    }
    function S_({variants: e, options: t, settings: n, initialSelectedVariantId: r, editable: i=!1, optionsToHide: o=[], onChange: a=( () => {}
    ), selectionType: s="default", setEditOption: l, disableSelection: c, scp: u}) {
        const {productId: d, dataGps: p, dataGpsSupplemental: f} = ue(Px)
          , {options: h, variants: m} = C_({
            gpsData: p,
            gpsSupplementalData: f,
            options: t,
            variants: e,
            productId: d,
            scp: u
        })
          , [v,g] = ne(function(e, t) {
            if ("string" == typeof t) {
                const n = e.find((e => `${e.id}` === t));
                if (n)
                    return n.options
            }
            return (e.find((e => e.available)) || e[0]).options
        }(m, r))
          , b = le(( () => function(e, t=200) {
            let n;
            return function(...r) {
                clearTimeout(n),
                n = setTimeout(( () => e(...r)), t)
            }
        }(a, 100)), [a])
          , y = le(( () => function(e, t, n, r, i, o, a) {
            return t.map((t => {
                var s;
                const l = ( () => {
                    if (t.gps)
                        return t.values.map((e => [{
                            id: t.id,
                            value: e.id
                        }]));
                    const e = n.filter((e => e.id !== t.id));
                    return t.values.map((n => [{
                        id: t.id,
                        value: n.id
                    }, ...e]))
                }
                )().map((n => {
                    const i = x_(e, n);
                    return "default" === r ? i || {
                        available: !1,
                        price: -1
                    } : o ? {
                        price: -1,
                        ...i || {},
                        available: !(!i && !0 === (null == t || null === (a = t.config) || void 0 === a ? void 0 : a.hideUnavailable) || !1 === (null == i ? void 0 : i.available) && "hide" === (null == t || null === (s = t.config) || void 0 === s || null === (l = s.outOfStock) || void 0 === l ? void 0 : l.style))
                    } : {
                        price: -1,
                        ...i || {},
                        available: "always-available" === r
                    };
                    var a, s, l
                }
                ));
                return {
                    id: t.id,
                    index: i && "select" !== (null == t || null === (s = t.config) || void 0 === s ? void 0 : s.type) ? -1 : __(t, n, a),
                    available: l.map((e => e.available)),
                    prices: l.map((e => e.price))
                }
            }
            ))
        }(m, h, v, s, c, u, d)), [m, h, v, s, c, u, d])
          , w = ce(( (e, t) => {
            const n = [...v]
              , r = n.findIndex((t => t.id === e));
            r > -1 && (n[r] = {
                id: e,
                value: t
            }),
            g(n),
            b(n, x_(m, n), {
                id: e,
                value: t
            })
        }
        ), [v, b, m])
          , x = le(( () => ({
            onChange: w,
            selections: y,
            editable: i,
            scp: u
        })), [i, w, y, u]);
        return lt.createElement(Rx.Provider, {
            value: x
        }, lt.createElement(y_, {
            options: h,
            editable: i,
            optionsToHide: o,
            spacing: n.spacing,
            setEditOption: l
        }))
    }
    w_ = hx();
    var E_ = {};
    const k_ = () => {
        throw new Error("Must be server!")
    }
      , O_ = [{
        id: "none",
        name: "None",
        static: !0
    }, {
        id: "partner",
        name: "Partner",
        static: !0
    }, {
        id: "free",
        name: "Free",
        static: !1
    }, {
        id: "starter",
        name: "Starter",
        price: 4.99,
        static: !1
    }, {
        id: "starter",
        name: "Starter",
        price: 3.99,
        static: !1
    }, {
        id: "pro",
        name: "Pro",
        price: 7.99,
        static: !1
    }, {
        id: "pro",
        name: "Pro",
        price: 6.99,
        static: !1
    }]
      , T_ = (e, t=!0) => {
        const n = O_.find((n => !(!t && n.static) && n.id === e));
        if (!n)
            throw Error(`unknown plan id ${e}`);
        return n
    }
      , M_ = e => "none-stacked" === e || ("none-stacked-two-columns" === e || "none-stacked-two-columns-main" === e);
    E_ = {
        getServerPort: k_,
        getServerEndpoint: () => `http://localhost:${k_()}`,
        getSubscriptionPlanByPrice: e => {
            const t = O_.find((t => `${t.price}` === e));
            if (!t)
                throw Error(`unknown plan price ${e}`);
            return t
        }
        ,
        getSubscriptionPlanById: T_,
        delay: e => new Promise((t => setTimeout(t, e))),
        getSubscriptionPlansById: e => O_.filter((t => t.id === e)),
        getSubscriptionPaidPlans: () => [T_("starter"), T_("pro")],
        buildVariantImagesConfig: ({templateConfig: e, customTheme: t, themeSettings: n, settings: {general: r, desktop: i, mobile: o}, logError: a}) => {
            const s = JSON.stringify(e);
            let l = JSON.parse(s);
            const c = (e, t) => {
                const r = l[t]
                  , {thumbnails: {desktop: {horizontal: i, vertical: o}, mobile: {horizontal: a, vertical: s}}} = n
                  , c = () => "bottom" === e.thumbnails ? "carousel" === e.thumbnailsNavigation ? {
                    multiRow: !1,
                    navigation: !0
                } : {
                    multiRow: !0,
                    navigation: !1
                } : "carousel" === e.thumbnailsNavigation ? {
                    verticalOverflow: !0,
                    navigation: !0
                } : {
                    verticalOverflow: !1,
                    navigation: !1
                }
                  , u = "desktop" === t ? i : a
                  , d = "desktop" === t ? o : s;
                if (r.swipe = !0,
                delete r.vertical,
                delete r.verticalSpacing,
                delete r.verticalType,
                delete r.verticalHoistVariantImages,
                "none" === e.thumbnails)
                    r.thumbnails = !1,
                    r.pagination = !0,
                    r.navigation = !1;
                else if ("none-with-navigation" === e.thumbnails)
                    r.thumbnails = !1,
                    r.pagination = !0,
                    r.navigation = !0;
                else if ("bottom" === e.thumbnails) {
                    const e = {
                        ...u,
                        orientation: "bottom",
                        ...c()
                    };
                    r.thumbnails = e,
                    r.pagination = !1,
                    r.navigation = !1
                } else if ("left" === e.thumbnails) {
                    const e = {
                        ...d,
                        orientation: "left",
                        ...c()
                    };
                    r.thumbnails = e,
                    r.pagination = !1,
                    r.navigation = !1
                } else if ("right" === e.thumbnails) {
                    const e = {
                        ...d,
                        orientation: "right",
                        ...c()
                    };
                    r.thumbnails = e,
                    r.pagination = !1,
                    r.navigation = !1
                } else
                    M_(e.thumbnails) && (r.thumbnails = !1,
                    r.pagination = !1,
                    r.navigation = !1,
                    r.vertical = !0,
                    r.verticalSpacing = "15px",
                    "none-stacked-two-columns" === e.thumbnails ? r.verticalType = "two-columns" : "none-stacked-two-columns-main" === e.thumbnails ? (r.verticalHoistVariantImages = !0,
                    r.verticalType = "two-columns-main") : r.verticalType = void 0)
            }
            ;
            if (!t)
                try {
                    c(i, "desktop"),
                    c(o, "mobile")
                } catch (e) {
                    l = JSON.parse(s),
                    a(e)
                }
            return l.desktop.lightBox = !!i.lightBox,
            l.desktop.lightBox && (l.desktop.lightBoxZoom = (null == i ? void 0 : i.zoomAmount) || 2),
            l.desktop.magnify = !!i.magnify && {
                width: "full",
                height: "full",
                zoom: (null == i ? void 0 : i.zoomAmount) || 2
            },
            M_(i.thumbnails) && (l.desktop.magnify = !1),
            l.mobile.lightBox = !!o.lightBox,
            l.mobile.lightBox && (l.mobile.lightBoxZoom = (null == o ? void 0 : o.zoomAmount) || 2),
            l.mobile.magnify = !!o.magnify && {
                width: "full",
                height: "full",
                zoom: (null == o ? void 0 : o.zoomAmount) || 2
            },
            M_(o.thumbnails) && (l.mobile.magnify = !1),
            r && (l.lightBoxBackgroundColor = r.lightBoxBackgroundColor,
            l.thumbnailSelectionColor = r.thumbnailSelectionColor,
            l.changeVariantOnVariantImageSelection = r.changeVariantOnVariantImageSelection),
            l
        }
        ,
        isStackedProductGallery: M_,
        decompressAssets: function(e) {
            const t = e.filter((e => !!e.urlBase))
              , n = e.filter((e => !!e.themeIdBase));
            if (t.length < 1 && n.length < 1)
                return e;
            const r = t.map(( (e, t) => [`{${t}}`, e.url]))
              , i = n.map(( (e, t) => [`{${t}}`, e.id]))
              , o = e.filter((e => !e.urlBase && !e.themeIdBase))
              , a = [];
            for (const e of o) {
                let t = e.url;
                if ("string" == typeof t) {
                    for (const [e,n] of r)
                        t = t.replace(e, n);
                    t = t.replace("{i}", e.id)
                }
                let n = e.themeId;
                if ("string" == typeof n)
                    for (const [e,t] of i)
                        n = n.replace(e, t);
                a.push({
                    ...e,
                    ...void 0 !== t ? {
                        url: t
                    } : {},
                    ...void 0 !== n ? {
                        themeId: n
                    } : {}
                })
            }
            return a
        }
    };
    var R_ = new Error("Element already at target scroll position")
      , P_ = new Error("Scroll cancelled")
      , I_ = Math.min
      , z_ = Date.now;
    function A_(e) {
        return function(t, n, r, i) {
            "function" == typeof (r = r || {}) && (i = r,
            r = {}),
            "function" != typeof i && (i = D_);
            var o = z_()
              , a = t[e]
              , s = r.ease || L_
              , l = isNaN(r.duration) ? 350 : +r.duration
              , c = !1;
            return a === n ? i(R_, t[e]) : requestAnimationFrame((function r(u) {
                if (c)
                    return i(P_, t[e]);
                var d = z_()
                  , p = I_(1, (d - o) / l)
                  , f = s(p);
                t[e] = f * (n - a) + a,
                p < 1 ? requestAnimationFrame(r) : requestAnimationFrame((function() {
                    i(null, t[e])
                }
                ))
            }
            )),
            function() {
                c = !0
            }
        }
    }
    function L_(e) {
        return .5 * (1 - Math.cos(Math.PI * e))
    }
    function D_() {}
    A_("scrollLeft"),
    A_("scrollTop");
    function N_(e, t) {
        return "function" == typeof window.__productWizRioImagesShim2 ? window.__productWizRioImagesShim2(e, t) : function(e, t) {
            if ("string" != typeof e)
                return e;
            if ("string" != typeof t)
                return e;
            try {
                const n = ( () => {
                    try {
                        return new URL(document.baseURI).toString()
                    } catch (e) {}
                    return null
                }
                )()
                  , r = "string" == typeof n ? new URL(e,n) : new URL(e)
                  , i = new URLSearchParams(r.search)
                  , o = t.replace("_crop_center", "").split("x");
                return o[0] && i.set("width", o[0]),
                o[1] && i.set("height", o[1]),
                r.search = i.toString(),
                r.toString()
            } catch (e) {}
            return e
        }(e, t)
    }
    const W_ = (e, t, n) => {
        if (!n)
            return null;
        const r = ( (e, t) => {
            if ("string" == typeof t && t.startsWith("variant-image://")) {
                const [,n] = t.split("variant-image://");
                try {
                    const t = JSON.parse(n)
                      , r = e.find((e => {
                        const n = e.options.find((e => e.name === t.id));
                        return !(!n || n.value !== t.value)
                    }
                    ));
                    if (r)
                        return {
                            url: r.url,
                            aspectRatio: r.aspectRatio
                        }
                } catch (e) {
                    console.log("Unable to find variant image:"),
                    console.log(e)
                }
            }
            return null
        }
        )(e, n.id);
        if (r)
            return r;
        const i = ( (e, t) => {
            if (!Array.isArray(e) || "string" != typeof t)
                return null;
            return e.find((e => e.id === t)) || null
        }
        )(t, n.id);
        return !(!i || "string" != typeof i.url) && i
    }
    ;
    function F_() {
        const e = ({config: e, scp: t}) => {
            const {product: n, options: r, onChange: i, initialSelectedVariantId: o, settings: a} = e
              , [s,l] = ne(mv.v4());
            console.log(`Rio-options render key: ${s}`),
            e.forceUpdate = ce(( () => {
                l(mv.v4())
            }
            ), []);
            const c = le(( () => function(e, t) {
                const n = Array.isArray(t) ? t : [];
                return {
                    options: e.options.map((e => {
                        const {name: t, name: r, values: i} = e
                          , o = n.findIndex((e => e.id === r))
                          , a = o > -1 ? n[o] : void 0;
                        return {
                            id: r,
                            name: t,
                            values: Ex(i, a ? a.values : null),
                            config: mx(Cx(), a ? a.config : {})
                        }
                    }
                    )),
                    variants: Array.isArray(e.variants) ? e.variants.map((t => ({
                        id: t.id,
                        title: t.title,
                        price: t.price,
                        available: t.available,
                        options: kx(e, t)
                    }))) : []
                }
            }(n, r)), [])
              , u = Sr({
                overrides: {
                    PwzrSvgIcon: {
                        root: {
                            width: "35px",
                            height: "35px"
                        }
                    }
                }
            })
              , d = le(( () => {
                if ("undefined" != typeof __productWizRioAssets && Array.isArray(__productWizRioAssets))
                    try {
                        return E_.decompressAssets(__productWizRioAssets)
                    } catch (e) {
                        console.log("Failed to decompress assets:"),
                        console.log(e)
                    }
                return []
            }
            ), [])
              , [p,f] = le(( () => ["undefined" != typeof __productWizRioProductOptionsGroups ? __productWizRioProductOptionsGroups : null, "undefined" != typeof __productWizRioProductOptionsGroupsSupplemental ? __productWizRioProductOptionsGroupsSupplemental : null]), [])
              , h = le(( () => {
                try {
                    const {variants: e, options: t} = n;
                    return e.map((e => {
                        var n, r, i, o;
                        const a = e.options.map(( (e, n) => ({
                            name: t[n].name,
                            value: e
                        })))
                          , s = null === (n = e.featured_media) || void 0 === n || null === (r = n.preview_image) || void 0 === r ? void 0 : r.src
                          , l = null === (i = e.featured_media) || void 0 === i || null === (o = i.preview_image) || void 0 === o ? void 0 : o.aspect_ratio;
                        return "string" == typeof s ? {
                            url: s,
                            options: a,
                            aspectRatio: l
                        } : null
                    }
                    )).filter((e => null !== e))
                } catch (e) {
                    console.log("Failed to obtain variant images:"),
                    console.log(e)
                }
                return []
            }
            ), [])
              , m = ce((e => W_(h, d, e)), [d, h])
              , v = le(( () => t ? {
                disableSelection: !0,
                selectionType: "always-available",
                scp: !0
            } : {
                initialSelectedVariantId: o
            }), [o, t]);
            return ie(( () => {
                if (!window.__productWizRioInjectedBoxSizing) {
                    const e = document.createElement("style");
                    e.textContent = "\n          .rio-options *,\n          .rio-options *::before,\n          .rio-options *::after,\n          .rio-options-scp *,\n          .rio-options-scp *::before,\n          .rio-options-scp *::after {\n            box-sizing: inherit;\n          }\n        ",
                    document.head.appendChild(e),
                    window.__productWizRioInjectedBoxSizing = !0
                }
            }
            ), []),
            lt.createElement(Px.Provider, {
                value: {
                    productId: `${n.id}`,
                    dataGps: p,
                    dataGpsSupplemental: f
                }
            }, lt.createElement(zx.Provider, {
                value: {
                    getAsset: m
                }
            }, lt.createElement(Va, {
                theme: u
            }, lt.createElement(S_, xp({
                key: s,
                variants: c.variants,
                options: c.options,
                settings: a,
                onChange: i
            }, v)))))
        }
        ;
        "undefined" != typeof __productWizRioOptions && (__productWizRioOptions.processRenderQueue = () => {
            const t = [...__productWizRioOptions.renderQueue];
            for (const n of t) {
                const [t,r,i] = n;
                je(lt.createElement(e, {
                    config: r
                }), t, i)
            }
            __productWizRioOptions.renderQueue = __productWizRioOptions.renderQueue.filter((e => !t.includes(e)))
        }
        ,
        __productWizRioOptions.processRenderQueue());
        const t = () => {
            "undefined" != typeof __productWizRioOptionsScp && (__productWizRioOptionsScp.render = t => {
                const [n,r,i] = t;
                je(lt.createElement(e, {
                    config: r,
                    scp: !0
                }), n, i)
            }
            ,
            "function" == typeof __productWizRioOptionsScp.onLoad && __productWizRioOptionsScp.onLoad(),
            __productWizRioOptionsScp.formatMoney = Mx,
            __productWizRioOptionsScp.getSizedImageUrl = N_)
        }
        ;
        "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", t) : t()
    }
    (function() {
        var e = {
            exports: this
        };
        return this.__esModule = !0,
        window.__productWizRioJsInit ? (console.log("Rio JS has already been init!"),
        e.exports) : (window.__productWizRioJsInit = !0,
        function() {
            if ("undefined" != typeof __productWizRio) {
                const {enabled: e} = __productWizRio;
                if (e)
                    if ("undefined" != typeof __productWizRioViV2 && __productWizRioViV2)
                        console.log("Variant images in V2 mode"),
                        __productWizRio.processRenderQueue = () => {
                            const e = [...__productWizRio.renderQueue];
                            for (const t of e) {
                                const [e,n] = t;
                                je(lt.createElement(ox, {
                                    rio: __productWizRio
                                }), e, n)
                            }
                            __productWizRio.renderQueue = __productWizRio.renderQueue.filter((t => !e.includes(t)))
                        }
                        ,
                        __productWizRio.processRenderQueue();
                    else {
                        const e = async () => {
                            const e = document.querySelector(".rio-media-gallery");
                            e && je(lt.createElement(ox, {
                                rio: __productWizRio
                            }), e)
                        }
                          , {hijackInit: t} = __productWizRio;
                        t ? (console.log("Variant images in V1 override init mode"),
                        __productWizRio.init = e) : (console.log("Variant images in V1 mode"),
                        "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", e) : e())
                    }
            }
        }(),
        F_(),
        e.exports)
    }
    ).call({})
}();
//# sourceMappingURL=index.js.map
